import {
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instanceat14thlj150z as Unit_instance,
  Comparable198qfk8pnblz0 as Comparable,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  Duration5ynfiptaqcrg as Duration,
  printStackTrace18lnx7a39cni as printStackTrace,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  maxOfnpw4mt1rg0hl as maxOf,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  createThis2j2avj17cvnv2 as createThis,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Enum3alwj03lh1n41 as Enum,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  toString14fd7g605f91p as toString_0,
  Char__hashCode_impl_otmys1ewos5t0dm35g as Char__hashCode_impl_otmys,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_1,
  hashCodeq5arwsb9dgti as hashCode,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  joinToString1cxrrlmo0chqs as joinToString,
  booleanArray2jdug9b51huk7 as booleanArray,
  StringBuildermazzzhj6kkai as StringBuilder,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  emptySetcxexqki71qfa as emptySet,
  Long2qws0ah9gnpki as Long,
  isInterface3d6p8outrmvmk as isInterface,
  distinct10qe1scfdvu5k as distinct,
  compareTo3ankvs086tmwq as compareTo,
  Companion_getInstance1krakgr3yg44t as Companion_getInstance_0,
  toLongw1zpgk99d84b as toLong,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  KProperty1ca4yb4wlo496 as KProperty1,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toList3jhuyej2anx2q as toList,
  listOfvhqybd2zx248 as listOf,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashMap1a0ld5kgwhmhv as HashMap,
  lazy2hsh8ze7j6ikd as lazy,
  numberToLong1a4cndvg6c52s as numberToLong,
  println2shhhgwwt4c61 as println,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOf1jh22dvmctj1r as listOf_0,
  Triple1vhi3d0dgpnjb as Triple,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  last1vo29oleiqj36 as last,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getOrNull1go7ef9ldk0df as getOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  emptyList1g2z5xcrvp2zy as emptyList,
  reversed22y3au42jl32b as reversed,
  HashSet2dzve9y63nf0v as HashSet,
  plus310ted5e4i90h as plus,
  joinToStringxqcavsxcmh4q as joinToString_0,
  contains2el4s70rdq4ld as contains,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  Iterable1y3qizuf89iou as Iterable,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  toList383f556t1dixk as toList_0,
  to2cs3ny02qtbcb as to,
  boxApply1qmzdb3dh90hg as boxApply,
  plus1ogy4liedzq5j as plus_0,
  withIndex37cl61h9v5txo as withIndex,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
  until1jbpn0z3f8lbg as until,
  toSet2orjxp16sotqu as toSet,
  split2bvyvnrlcifjv as split,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  numberToDouble210hrknaofnhf as numberToDouble,
  get_indicesc04v40g017hw as get_indices,
  anyToString3ho3k49fc56mj as anyToString,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  copyToArray2j022khrow2yi as copyToArray,
  startsWith1bgirhbedtv2y as startsWith,
  isBlank1dvkhjjvox3p0 as isBlank,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  toShort36kaw0zjdq3ex as toShort,
  contains1tccixv8iwdcq as contains_0,
  EmptyCoroutineContext_getInstance7yleecrz3jzr as EmptyCoroutineContext_getInstance,
  round2mrvepag8eey0 as round,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  mapOf1xd03cq9cnmy8 as mapOf,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  ObservableProperty3aw08lidjfpjm as ObservableProperty,
  Delegates_instance3jf2rsvdhmxzn as Delegates_instance,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  Duration__times_impl_sfuzvp2zkq9ykxbil7d as Duration__times_impl_sfuzvp,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus_1,
  Element2gr7ezmxqaln7 as Element,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  getKClass1s3j9wy1cofik as getKClass,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  KProperty02ce7r476m8633 as KProperty0,
  toSet1glep2u1u9tcb as toSet_0,
  reversednxqwdkac9dn0 as reversed_0,
  toMutableListoiy7juhbnlr7 as toMutableList,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  isNaNymqb93xtq8w8 as isNaN_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Console_getInstance8lqb2pbph5yn as Console_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_1,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  valueOf3aj0dpb8xpu5n as valueOf,
  Level_WARN_getInstance2cg04z8rod8ga as Level_WARN_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  SyncPauseable20rt0nt3umu2s as SyncPauseable,
  Companion_instance2r8kc48nhvjcq as Companion_instance_0,
  FastIdentityMap17d14y8i3m5g7 as FastIdentityMap,
  get2pw1zlgv5zypd as get_0,
  set2vuztm9k7ubgo as set,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref11k43t82thcp3 as Ref,
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  Pool1zbsw0zhvh8ca as Pool,
  containsrsn76oa0puwr as contains_1,
  clear3idbm40uzyume as clear,
  get_size2tttv7g2u748n as get_size,
  FastSmallSet2og2j8v2pz4c7 as FastSmallSet,
  getAndRemove1ksxnnren48mb as getAndRemove,
  get_keyswqddktl7cnu2 as get_keys,
  ReturnablePool3rkgvxsckx2u2 as ReturnablePool,
  TGenQueue2v9j3ju90xgpv as TGenQueue,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Lock5n7hh3dgcidl as Lock,
  Signal3nnez3346azzf as Signal,
  invoke2sf88d1xeuyqh as invoke,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  cancel1amaozv14ic7s as cancel,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  unsupported198cz39rr1ztw as unsupported,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_1,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_getInstance39o54489czp6d as Companion_getInstance_2,
  Os_UNKNOWN_getInstancecnx3cm3i6e2g as Os_UNKNOWN_getInstance,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_3,
  DenoPointerpb0vypijx63v as DenoPointer,
  get_pointerlkbwhoqlhapz as get_pointer,
  get_jsGlobalThis3odmbn60utci as get_jsGlobalThis,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Mixin3lmkm5hum2vdj as Mixin,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  toFastListzo2jtkrx0z5y as toFastList_0,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_4,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_5,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_6,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_7,
  Vector2D378fe5rov8fgw as Vector2D,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  get_scale17gmsnxnqj6j9 as get_scale,
  Matrix43neeu8v4zk4i7 as Matrix4,
  orthow9c0o91bw54n as ortho,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_2,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2,
  Angle2itorpob18n08 as Angle,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_8,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr3nvm3csqkttdd as _FastDuration___get_fastNanoseconds__impl__9kjwbr,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  Companion_instance293l0r179rei7 as Companion_instance_3,
  get_fastNanoseconds1laeiegsk8vcx as get_fastNanoseconds_0,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  toDuration15w5sljvx2ut2 as toDuration_1,
  FastDuration__hashCode_impl_y13la6nym0c1xbwjaa as FastDuration__hashCode_impl_y13la6,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  FastDuration__minus_impl_evs237bt7zqxxnwet as FastDuration__minus_impl_evs237_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  minus2npwq73u0d9yx as minus,
  max1q2oylvn6uire as max,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__plus_impl_q1enab30y5opwsu5po5 as FastDuration__plus_impl_q1enab_0,
  get_fast37cu8s8qwnuyi as get_fast,
  roundMilliseconds3bd2pntxev66o as roundMilliseconds,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  arraycopy52dxe7vhzf14 as arraycopy,
  clonelcrqoxe4ne5i as clone,
  Companion_instancejzamqjlqqs4y as Companion_instance_4,
  _Int8Buffer___init__impl__e20lvcp4p2uvfo996c as _Int8Buffer___init__impl__e20lvc,
  _Int8Buffer___get_buffer__impl__q0gulbq12sgwh1jcvh as _Int8Buffer___get_buffer__impl__q0gulb,
  sliceWithSize2i7i6olf26byj as sliceWithSize,
  Companion_getInstance35xii7iw9kdg2 as Companion_getInstance_9,
  ByteUnits__toString_impl_ox2ku22zb4xrvk9phl9 as ByteUnits__toString_impl_ox2ku2,
  arraycopy3uxsqjlixmnz3 as arraycopy_0,
  Buffer25z94vsj0kb1s as Buffer,
  get_i323p4hlz6j3xys8 as get_i32,
  arraycopy1hsh296f5d0xg as arraycopy_1,
  get_f3218rglfhpgbhzp as get_f32,
  arraycopy3fi6tr79d693r as arraycopy_2,
  get_i83qhdj74rhdyeg as get_i8,
  arraycopyphzg5lpa6gvz as arraycopy_3,
  get_size13scmefs6mbfn as get_size_0,
  allocDirecttfrgytwudkpf as allocDirect,
  sliceBufferpiate0wictoq as sliceBuffer,
  arrayequal25g4om83vd8w1 as arrayequal,
  copyOfnqvdm0sc8lk as copyOf,
  setArrayLEwil75hzlfusu as setArrayLE,
  setInt32178h074gei71f as setInt32,
  getInt32gmg3zyw00v1v as getInt32,
  arraycopy9a0yzbjqwnvw as arraycopy_4,
  Uint16Buffer__set_impl_g0kliu1ltqm2yo4vfb6 as Uint16Buffer__set_impl_g0kliu,
  Float32Buffer__get_impl_659lhu2fcy7ilfo0o6g as Float32Buffer__get_impl_659lhu,
  Float32Buffer__set_impl_34sznedf8x821xo8e0 as Float32Buffer__set_impl_34szne,
  get_u163bxpdbbave1v5 as get_u16,
  setFloat323e0ukqyly1ufv as setFloat32,
  asUShortArrayInt2gfk0h9rafip5 as asUShortArrayInt,
  arraycopy28e1us87mwypg as arraycopy_5,
  arrayadd3erpr00t9k8j as arrayadd,
  arraycopyqmyo4vjwforw as arraycopy_6,
  arrayfill1njpugsfcm512 as arrayfill,
  arrayfill2iqmyqqqfwuaf as arrayfill_0,
  allocNoDirect3dykranmovqsj as allocNoDirect,
  get_arrayUByte9swx7ogt2hf2 as get_arrayUByte,
  get_arrayInt3v8kuk47rixtz as get_arrayInt,
  get_arrayFloat1r0vk858s9phl as get_arrayFloat,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  get_isPowerOfTwoeb2yxu9ww0f7 as get_isPowerOfTwo,
  extract2vhru1ihy4ogl as extract,
  insert52qor1kqho1lpj as insert5,
  insert22yqrzxcpmo55e as insert2,
  insert2fz5125p2hdyd as insert,
  insert42sy0xc4ax89g9 as insert4,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  toIntRound1mv0y8x9hh1p4 as toIntRound,
  toIntRoundjnzmk86x1qp5 as toIntRound_0,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  insert141hi307uxchfzk as insert14,
  ilog23dbvpk38jf7rc as ilog2,
  insert8f3zk23r8x9da as insert8,
  insert32d422lnha9g5r as insert3,
  extractScaledf013fj6eqsu4szwo as extractScaledf01,
  insertScaledf01oj6k04gavkch as insertScaledf01,
  insertm9bp9ll4cml3 as insert_0,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
  nextAlignedTo2788hp7lcoqp as nextAlignedTo,
  setBitsqsmqq5kc486j as setBits,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_10,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2,
  Ratio136tf4z2t0p2d as Ratio,
  interpolate2g7wzskc23f1q as interpolate,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  NullBitmap15b22oyta4usb as NullBitmap,
  MultiBitmapk0zsv2zy1mpk as MultiBitmap,
  ForcedTexId3ivekmtdm8t3u as ForcedTexId,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  FloatBitmap321fufbxi3ys0iu as FloatBitmap32,
  Bitmap82ekc5d8xpcfp2 as Bitmap8,
  NativeImagebqxh3nwkmck as NativeImage,
  _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3 as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8 as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0 as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv3fdqajvftucv7 as _RGBA___get_af__impl__vu36qv,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Companion_instance1sgltfeqg9bxt as Companion_instance_5,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  readBitmap1yhww5yoq3a9l as readBitmap,
  slice2pfxfvku0ybgy as slice,
  Companion_instance1zw3l6m7tnvps as Companion_instance_6,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  get_baseMipmapLevel1ty2cgb5p9xw4 as get_baseMipmapLevel,
  get_maxMipmapLevel13juf70j6ney9 as get_maxMipmapLevel,
  _RGBA___get_value__impl__hhco8vehpblbe3f2y8 as _RGBA___get_value__impl__hhco8v,
  RGBA34obx2i62wcl3 as RGBA,
  HtmlNativeImagenz79853f60h as HtmlNativeImage,
  toHtmlNative1zcg9na83p2te as toHtmlNative,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  get_hex32p4ssq0y1xxx as get_hex,
  fromBase6434uveajlhn2ar as fromBase64,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  Companion_getInstance2vt0vokm4ixbh as Companion_getInstance_11,
  Indenterdf10c5coibyi as Indenter,
  MountableVfs3mmbka3zq5l6i as MountableVfs,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  delay2vwv568c245r8 as delay,
  toVfsr7ir4p66g1my as toVfs,
  launchImmediately11za8mkid9pxu as launchImmediately_0,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  delay1blitpytzu6gr as delay_0,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  cancelChildrennwartoz0yn6c as cancelChildren,
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  cancelAndJoin2j6ktsickm6hy as cancelAndJoin,
  MainScope1gi1r4abhrtmm as MainScope,
} from './kotlinx-coroutines-core.mjs';
import {
  get_immutablepxpdoj6e54ll as get_immutable,
  Companion_instance2i0t7ux7bzoqc as Companion_instance_7,
  RectSlicec5msorw5q4el as RectSlice,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_12,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
} from './korlibs-math-root-korlibs-math.mjs';
import { openAsync37anb1e84urmo as openAsync } from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { InjectorDependency2f8dsqe1kn3nn as InjectorDependency } from './korlibs-inject-root-korlibs-inject.mjs';
import {
  IntTimedCache39ymx9abjz88x as IntTimedCache,
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  Stopwatch1guqi4xl0rpfb as Stopwatch,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  FFILiby83bova0zjfy as FFILib,
  Companion_getInstance2ww1whxsubyyu as Companion_getInstance_13,
  FuncInfocud0a7bce10z as FuncInfo,
  CreateFFIPointernsr7ilwulbub as CreateFFIPointer,
  get_pointer2afz2rc14joly as get_pointer_0,
  CreateFFIMemoryv82e6jbfcdze as CreateFFIMemory,
  set3216gyp8r69gas8 as set32,
  CreateFFIMemory2iekizxdvtyvt as CreateFFIMemory_0,
  setFFIPointerjzarmbova4sm as setFFIPointer,
  getS32284qh8a5ldxzn as getS32,
} from './korlibs-ffi-root-korlibs-ffi-legacy.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class TimedTask {
  constructor(eventLoop, now, time, interval, callback) {
    this.m7t_1 = eventLoop;
    this.n7t_1 = now;
    this.o7t_1 = time;
    this.p7t_1 = interval;
    this.q7t_1 = callback;
  }
  r7t(value) {
    this.n7t_1 = Duration__minus_impl_q5cfm7(value, this.o7t_1);
  }
  s7t() {
    return Duration__plus_impl_yu9v8f(this.n7t_1, this.o7t_1);
  }
  t7t(other) {
    return Duration__compareTo_impl_pchp0f(this.s7t(), other.s7t());
  }
  d(other) {
    return this.t7t(other instanceof TimedTask ? other : THROW_CCE());
  }
  p6() {
    this.p7t_1 = false;
    this.m7t_1.d7u_1.q3y(this);
  }
}
class BaseEventLoop {
  constructor() {
    this.m7u_1 = new Lock();
  }
}
class SyncEventLoop extends BaseEventLoop {
  constructor(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    super();
    this.v7t_1 = immediateRun;
    this.w7t_1 = new SyncPauseable();
    this.x7t_1 = paused$factory(this.w7t_1);
    this.y7t_1 = new Lock();
    this.z7t_1 = true;
    this.a7u_1 = Monotonic_instance.fk();
    var tmp = this;
    tmp.b7u_1 = SyncEventLoop$nowProvider$lambda(this);
    this.c7u_1 = ArrayDeque.ll();
    var tmp_0 = this;
    var tmp_1 = Companion_instance_0;
    tmp_0.d7u_1 = tmp_1.y42(VOID, SyncEventLoop$timedTasks$lambda);
    var tmp_2 = this;
    tmp_2.e7u_1 = SyncEventLoop$uncatchedExceptionHandler$lambda;
    this.f7u_1 = null;
  }
  g7u(task) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.y7t_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.c36();
      try {
        this.c7u_1.pl(task);
        this.y7t_1.g36();
        break $l$block;
      }finally {
        this_0.e36();
      }
    }
  }
  h7u(time, task) {
    return _queueAfter(this, time, false, task);
  }
  p6() {
    var oldImmediateRun = this.v7t_1;
    try {
      this.v7t_1 = true;
      this.i7u();
      this.z7t_1 = false;
    }finally {
      this.v7t_1 = oldImmediateRun;
    }
  }
  j7u(task) {
    if (this.v7t_1)
      return true;
    return Duration__compareTo_impl_pchp0f(_get_now__e6dlkr(this), this.d7u_1.e43().s7t()) >= 0;
  }
  k7u(runTimers) {
    var count = 0;
    while (this.l7u(runTimers)) {
      count = count + 1 | 0;
    }
    return count;
  }
  i7u(runTimers, $super) {
    runTimers = runTimers === VOID ? true : runTimers;
    return $super === VOID ? this.k7u(runTimers) : $super.k7u.call(this, runTimers);
  }
  l7u(runTimers) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.y7t_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.c36();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp;
        if (runTimers) {
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.d7u_1.j1()) {
            tmp_1 = this.j7u(this.d7u_1.e43());
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = this.d7u_1.f43();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
        tmp$ret$2 = tmp;
        break $l$block;
      }finally {
        this_0.e36();
      }
    }
    var timedTask = tmp$ret$2;
    if (!(timedTask == null)) {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
      try {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        timedTask.q7t_1();
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.e7u_1(e);
        } else {
          throw $p;
        }
      }
      if (timedTask.p7t_1 && !this.v7t_1) {
        timedTask.r7t(maxOf(new Duration(Duration__plus_impl_yu9v8f(timedTask.s7t(), timedTask.o7t_1)), new Duration(_get_now__e6dlkr(this))).lk_1);
        this.d7u_1.p3y(timedTask);
      }
    }
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_1 = this.y7t_1;
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_1.c36();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.c7u_1.j1()) {
          tmp_2 = this.c7u_1.ql();
        } else {
          tmp_2 = null;
        }
        tmp$ret$7 = tmp_2;
        break $l$block_0;
      }finally {
        this_1.e36();
      }
    }
    var task = tmp$ret$7;
    // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      if (task == null)
        null;
      else
        task();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.e7u_1(e_0);
      } else {
        throw $p;
      }
    }
    return !(task == null) || !(timedTask == null);
  }
}
class Listener {
  constructor(func, node, base) {
    this.n7u_1 = func;
    this.o7u_1 = node;
    this.p7u_1 = base;
  }
  p6() {
    if (this.o7u_1.r7u_1.g3(this)) {
      __updateChildListenerCount(this.p7u_1, this.o7u_1.q7u_1, -1);
    }
  }
  t7u() {
    this.o7u_1.r7u_1.h(this);
    __updateChildListenerCount(this.p7u_1, this.o7u_1.q7u_1, 1);
  }
}
class ListenerNode {
  constructor(type) {
    this.q7u_1 = type;
    this.r7u_1 = FastArrayList.u28();
    this.s7u_1 = FastArrayList.u28();
  }
}
class EventListener {}
function onEvents(etypes, handler) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (etypes.length === 0) {
    // Inline function 'kotlin.error' call
    var message = 'Must have at least one event type';
    throw IllegalStateException.h5(toString(message));
  }
  var closeable = new CancellableGroup();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < etypes.length) {
    // Inline function 'korlibs.event.EventListener.onEvents.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = etypes[_unary__edvuaz];
    closeable.s21(this.a7v(it, handler));
  }
  return closeable;
}
function dispatch(type, event, result) {
  return this.c7v(type, event, result, true, true);
}
function dispatch$default(type, event, result, $super) {
  result = result === VOID ? null : result;
  return $super === VOID ? this.j7v(type, event, result) : dispatch(type, event, result);
}
function dispatchDown(type, event, result) {
  return this.c7v(type, event, result, false, true);
}
function dispatchUp(type, event, result) {
  return this.c7v(type, event, result, true, false);
}
function dispatch_0(event) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return this.k7v(event.p3m(), event);
}
class BaseEventListener {
  static y7u() {
    var $this = createThis(this);
    $this.u7u_1 = null;
    $this.v7u_1 = null;
    $this.w7u_1 = null;
    $this.x7u_1 = null;
    return $this;
  }
  c28(_set____db54di) {
    this.u7u_1 = _set____db54di;
  }
  d28() {
    return this.u7u_1;
  }
  z7u(other) {
    var tmp0_safe_receiver = this.v7u_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp0_safe_receiver, this, false);
    }
    this.v7u_1 = other;
    var tmp1_safe_receiver = this.v7u_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp1_safe_receiver, this, true);
    }
  }
  a7v(type, handler) {
    if (this.w7u_1 == null)
      this.w7u_1 = FastIdentityMap();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = ensureNotNull(this.w7u_1);
      var res = get_0(this_0, type);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
      var out = new ListenerNode(type);
      set(this_0, type, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    var lists = tmp instanceof ListenerNode ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_1 = new Listener(handler, lists, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
    this_1.t7u();
    return this_1;
  }
  b7v(type) {
    var tmp0_safe_receiver = this.w7u_1;
    var tmp = tmp0_safe_receiver == null ? null : get_0(tmp0_safe_receiver, type);
    return tmp instanceof ListenerNode ? tmp : null;
  }
  c7v(type, event, result, up, down) {
    var eventListenerCount = this.d7v(type);
    if (eventListenerCount <= 0)
      return false;
    if (down) {
      this.e7v(type, event, result);
    }
    var listeners = this.b7v(type);
    var tmp1_safe_receiver = listeners == null ? null : listeners.r7u_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
      var temp = listeners.s7u_1;
      toFastList(tmp1_safe_receiver, temp);
      try {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = temp.s28_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array[_unary__edvuaz].n7u_1(event);
          if (result == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            result.g7v_1 = result.g7v_1 + 1 | 0;
          }
        }
      }finally {
        temp.h3();
      }
    }
    if (up) {
      this.h7v(type, event, result);
    }
    if (result == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
      result.f7v_1 = result.f7v_1 + 1 | 0;
    }
    return event.i7v();
  }
  j7v(type, event, result) {
    return dispatch.call(this, type, event, result);
  }
  l7v(event) {
    return dispatch_0.call(this, event);
  }
  h7v(type, event, result) {
  }
  e7v(type, event, result) {
  }
  d7v(type) {
    var tmp0_safe_receiver = this.x7u_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.getNull' call
      tmp = type == null ? null : get_0(tmp0_safe_receiver, type);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
}
class EventResult {
  constructor(iterationCount, resultCount) {
    iterationCount = iterationCount === VOID ? 0 : iterationCount;
    resultCount = resultCount === VOID ? 0 : resultCount;
    this.f7v_1 = iterationCount;
    this.g7v_1 = resultCount;
  }
  u1w() {
    this.f7v_1 = 0;
    this.g7v_1 = 0;
  }
  toString() {
    return 'EventResult(iterationCount=' + this.f7v_1 + ', resultCount=' + this.g7v_1 + ')';
  }
  hashCode() {
    var result = this.f7v_1;
    result = imul(result, 31) + this.g7v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventResult))
      return false;
    var tmp0_other_with_cast = other instanceof EventResult ? other : THROW_CCE();
    if (!(this.f7v_1 === tmp0_other_with_cast.f7v_1))
      return false;
    if (!(this.g7v_1 === tmp0_other_with_cast.g7v_1))
      return false;
    return true;
  }
}
class Companion {}
class Event {
  constructor() {
    this.s7v_1 = null;
    this.t7v_1 = false;
  }
  u7v(_set____db54di) {
    this.s7v_1 = _set____db54di;
  }
  b7y(reason) {
    throw StopPropagatingException.r7y(reason);
  }
  v7v(_set____db54di) {
    this.t7v_1 = _set____db54di;
  }
  i7v() {
    return this.t7v_1;
  }
}
class TypedEvent extends Event {
  constructor(type) {
    super();
    this.r7v_1 = type;
  }
  p3m() {
    return this.r7v_1;
  }
}
class PauseEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_8);
  }
}
class Companion_0 {}
class ResumeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_9);
  }
}
class Companion_1 {}
class StopEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_10);
  }
}
class Companion_2 {}
class DestroyEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_11);
  }
}
class RenderEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_18();
    super(Companion_getInstance_18());
    this.z7v_1 = true;
    this.a7w_1 = true;
  }
  toString() {
    return 'RenderEvent(update=' + this.z7v_1 + ', render=' + this.a7w_1 + ')';
  }
}
class Companion_3 extends RenderEvent {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
  }
}
class InitEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_19();
    super(Companion_getInstance_19());
  }
}
class Companion_4 extends InitEvent {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class Companion_5 {}
class DisposeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_14);
  }
}
class Companion_6 {}
class FullScreenEvent extends TypedEvent {
  constructor(fullscreen) {
    fullscreen = fullscreen === VOID ? false : fullscreen;
    super(Companion_instance_15);
    this.e7w_1 = fullscreen;
  }
  toString() {
    return 'FullScreenEvent(fullscreen=' + this.e7w_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.e7w_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this.e7w_1 === tmp0_other_with_cast.e7w_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ReshapeEvent extends TypedEvent {
  constructor(x, y, width, height, setPos) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    setPos = setPos === VOID ? true : setPos;
    super(Companion_instance_16);
    this.i7w_1 = x;
    this.j7w_1 = y;
    this.k7w_1 = width;
    this.l7w_1 = height;
    this.m7w_1 = setPos;
  }
  toString() {
    return 'ReshapeEvent(x=' + this.i7w_1 + ', y=' + this.j7w_1 + ', width=' + this.k7w_1 + ', height=' + this.l7w_1 + ', setPos=' + this.m7w_1 + ')';
  }
  hashCode() {
    var result = this.i7w_1;
    result = imul(result, 31) + this.j7w_1 | 0;
    result = imul(result, 31) + this.k7w_1 | 0;
    result = imul(result, 31) + this.l7w_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m7w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this.i7w_1 === tmp0_other_with_cast.i7w_1))
      return false;
    if (!(this.j7w_1 === tmp0_other_with_cast.j7w_1))
      return false;
    if (!(this.k7w_1 === tmp0_other_with_cast.k7w_1))
      return false;
    if (!(this.l7w_1 === tmp0_other_with_cast.l7w_1))
      return false;
    if (!(this.m7w_1 === tmp0_other_with_cast.m7w_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_17 = this;
    this.n7w_1 = values();
  }
}
class Type extends Enum {}
class KeyEvent extends Event {
  constructor(type, id, key, keyCode, character, shift, ctrl, alt, meta, str) {
    type = type === VOID ? Type_UP_getInstance() : type;
    id = id === VOID ? 0 : id;
    key = key === VOID ? Key_UP_getInstance() : key;
    keyCode = keyCode === VOID ? 0 : keyCode;
    character = character === VOID ? _Char___init__impl__6a9atx(0) : character;
    shift = shift === VOID ? false : shift;
    ctrl = ctrl === VOID ? false : ctrl;
    alt = alt === VOID ? false : alt;
    meta = meta === VOID ? false : meta;
    str = str === VOID ? null : str;
    super();
    this.q7w_1 = type;
    this.r7w_1 = id;
    this.s7w_1 = key;
    this.t7w_1 = keyCode;
    this.u7w_1 = character;
    this.v7w_1 = shift;
    this.w7w_1 = ctrl;
    this.x7w_1 = alt;
    this.y7w_1 = meta;
    this.z7w_1 = str;
    this.a7x_1 = Companion_getInstance().mk_1;
  }
  p3m() {
    return this.q7w_1;
  }
  toString() {
    return 'KeyEvent(type=' + toString(this.q7w_1) + ', id=' + this.r7w_1 + ', key=' + this.s7w_1.toString() + ', keyCode=' + this.t7w_1 + ', character=' + toString_0(this.u7w_1) + ', shift=' + this.v7w_1 + ', ctrl=' + this.w7w_1 + ', alt=' + this.x7w_1 + ', meta=' + this.y7w_1 + ', str=' + this.z7w_1 + ')';
  }
  hashCode() {
    var result = this.q7w_1.hashCode();
    result = imul(result, 31) + this.r7w_1 | 0;
    result = imul(result, 31) + this.s7w_1.hashCode() | 0;
    result = imul(result, 31) + this.t7w_1 | 0;
    result = imul(result, 31) + Char__hashCode_impl_otmys(this.u7w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v7w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w7w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x7w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y7w_1) | 0;
    result = imul(result, 31) + (this.z7w_1 == null ? 0 : getStringHashCode(this.z7w_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this.q7w_1.equals(tmp0_other_with_cast.q7w_1))
      return false;
    if (!(this.r7w_1 === tmp0_other_with_cast.r7w_1))
      return false;
    if (!this.s7w_1.equals(tmp0_other_with_cast.s7w_1))
      return false;
    if (!(this.t7w_1 === tmp0_other_with_cast.t7w_1))
      return false;
    if (!(this.u7w_1 === tmp0_other_with_cast.u7w_1))
      return false;
    if (!(this.v7w_1 === tmp0_other_with_cast.v7w_1))
      return false;
    if (!(this.w7w_1 === tmp0_other_with_cast.w7w_1))
      return false;
    if (!(this.x7w_1 === tmp0_other_with_cast.x7w_1))
      return false;
    if (!(this.y7w_1 === tmp0_other_with_cast.y7w_1))
      return false;
    if (!(this.z7w_1 == tmp0_other_with_cast.z7w_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_18 = this;
    this.b7x_1 = values_0();
  }
}
class Type_0 extends Enum {}
class ScrollDeltaMode extends Enum {
  constructor(name, ordinal, scale) {
    super(name, ordinal);
    this.e7x_1 = scale;
  }
}
class MouseEvent extends Event {
  constructor(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, scrollDeltaMode) {
    type = type === VOID ? Type_MOVE_getInstance() : type;
    id = id === VOID ? 0 : id;
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    button = button === VOID ? MouseButton_NONE_getInstance() : button;
    buttons = buttons === VOID ? 0 : buttons;
    scrollDeltaX = scrollDeltaX === VOID ? 0.0 : scrollDeltaX;
    scrollDeltaY = scrollDeltaY === VOID ? 0.0 : scrollDeltaY;
    scrollDeltaZ = scrollDeltaZ === VOID ? 0.0 : scrollDeltaZ;
    isShiftDown = isShiftDown === VOID ? false : isShiftDown;
    isCtrlDown = isCtrlDown === VOID ? false : isCtrlDown;
    isAltDown = isAltDown === VOID ? false : isAltDown;
    isMetaDown = isMetaDown === VOID ? false : isMetaDown;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    scrollDeltaMode = scrollDeltaMode === VOID ? ScrollDeltaMode_LINE_getInstance() : scrollDeltaMode;
    super();
    this.h7x_1 = type;
    this.i7x_1 = id;
    this.j7x_1 = x;
    this.k7x_1 = y;
    this.l7x_1 = button;
    this.m7x_1 = buttons;
    this.n7x_1 = scrollDeltaX;
    this.o7x_1 = scrollDeltaY;
    this.p7x_1 = scrollDeltaZ;
    this.q7x_1 = isShiftDown;
    this.r7x_1 = isCtrlDown;
    this.s7x_1 = isAltDown;
    this.t7x_1 = isMetaDown;
    this.u7x_1 = scaleCoords;
    this.v7x_1 = emulated;
    this.w7x_1 = scrollDeltaMode;
    this.x7x_1 = null;
    var tmp = this;
    tmp.y7x_1 = MouseEvent$requestLock$lambda;
  }
  p3m() {
    return this.h7x_1;
  }
  z7x(other) {
    this.h7x_1 = other.h7x_1;
    this.i7x_1 = other.i7x_1;
    this.j7x_1 = other.j7x_1;
    this.k7x_1 = other.k7x_1;
    this.l7x_1 = other.l7x_1;
    this.m7x_1 = other.m7x_1;
    this.n7x_1 = other.n7x_1;
    this.o7x_1 = other.o7x_1;
    this.p7x_1 = other.p7x_1;
    this.q7x_1 = other.q7x_1;
    this.r7x_1 = other.r7x_1;
    this.s7x_1 = other.s7x_1;
    this.t7x_1 = other.t7x_1;
    this.u7x_1 = other.u7x_1;
    this.v7x_1 = other.v7x_1;
    this.w7x_1 = other.w7x_1;
  }
  a7y(mode, x, y, z) {
    this.w7x_1 = mode;
    this.n7x_1 = x;
    this.o7x_1 = y;
    this.p7x_1 = z;
  }
  toString() {
    return 'MouseEvent(type=' + toString(this.h7x_1) + ', id=' + this.i7x_1 + ', x=' + this.j7x_1 + ', y=' + this.k7x_1 + ', button=' + this.l7x_1.toString() + ', buttons=' + this.m7x_1 + ', scrollDeltaX=' + this.n7x_1 + ', scrollDeltaY=' + this.o7x_1 + ', scrollDeltaZ=' + this.p7x_1 + ', isShiftDown=' + this.q7x_1 + ', isCtrlDown=' + this.r7x_1 + ', isAltDown=' + this.s7x_1 + ', isMetaDown=' + this.t7x_1 + ', scaleCoords=' + this.u7x_1 + ', emulated=' + this.v7x_1 + ', scrollDeltaMode=' + this.w7x_1.toString() + ')';
  }
  hashCode() {
    var result = this.h7x_1.hashCode();
    result = imul(result, 31) + this.i7x_1 | 0;
    result = imul(result, 31) + this.j7x_1 | 0;
    result = imul(result, 31) + this.k7x_1 | 0;
    result = imul(result, 31) + this.l7x_1.hashCode() | 0;
    result = imul(result, 31) + this.m7x_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.n7x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o7x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p7x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q7x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r7x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s7x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t7x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u7x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v7x_1) | 0;
    result = imul(result, 31) + this.w7x_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent))
      return false;
    var tmp0_other_with_cast = other instanceof MouseEvent ? other : THROW_CCE();
    if (!this.h7x_1.equals(tmp0_other_with_cast.h7x_1))
      return false;
    if (!(this.i7x_1 === tmp0_other_with_cast.i7x_1))
      return false;
    if (!(this.j7x_1 === tmp0_other_with_cast.j7x_1))
      return false;
    if (!(this.k7x_1 === tmp0_other_with_cast.k7x_1))
      return false;
    if (!this.l7x_1.equals(tmp0_other_with_cast.l7x_1))
      return false;
    if (!(this.m7x_1 === tmp0_other_with_cast.m7x_1))
      return false;
    if (!equals(this.n7x_1, tmp0_other_with_cast.n7x_1))
      return false;
    if (!equals(this.o7x_1, tmp0_other_with_cast.o7x_1))
      return false;
    if (!equals(this.p7x_1, tmp0_other_with_cast.p7x_1))
      return false;
    if (!(this.q7x_1 === tmp0_other_with_cast.q7x_1))
      return false;
    if (!(this.r7x_1 === tmp0_other_with_cast.r7x_1))
      return false;
    if (!(this.s7x_1 === tmp0_other_with_cast.s7x_1))
      return false;
    if (!(this.t7x_1 === tmp0_other_with_cast.t7x_1))
      return false;
    if (!(this.u7x_1 === tmp0_other_with_cast.u7x_1))
      return false;
    if (!(this.v7x_1 === tmp0_other_with_cast.v7x_1))
      return false;
    if (!this.w7x_1.equals(tmp0_other_with_cast.w7x_1))
      return false;
    return true;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_19 = this;
    this.c7y_1 = values_1();
  }
}
class Type_1 extends Enum {}
class GestureEvent extends Event {
  constructor(type, id, amountX, amountY) {
    type = type === VOID ? Type_MAGNIFY_getInstance() : type;
    id = id === VOID ? 0 : id;
    amountX = amountX === VOID ? 0.0 : amountX;
    amountY = amountY === VOID ? 0.0 : amountY;
    super();
    this.f7y_1 = type;
    this.g7y_1 = id;
    this.h7y_1 = amountX;
    this.i7y_1 = amountY;
  }
  p3m() {
    return this.f7y_1;
  }
  toString() {
    return 'GestureEvent(type=' + toString(this.f7y_1) + ', id=' + this.g7y_1 + ', amountX=' + this.h7y_1 + ', amountY=' + this.i7y_1 + ')';
  }
  hashCode() {
    var result = this.f7y_1.hashCode();
    result = imul(result, 31) + this.g7y_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.h7y_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i7y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GestureEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GestureEvent ? other : THROW_CCE();
    if (!this.f7y_1.equals(tmp0_other_with_cast.f7y_1))
      return false;
    if (!(this.g7y_1 === tmp0_other_with_cast.g7y_1))
      return false;
    if (!equals(this.h7y_1, tmp0_other_with_cast.h7y_1))
      return false;
    if (!equals(this.i7y_1, tmp0_other_with_cast.i7y_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_20 = this;
    this.j7y_1 = values_2();
  }
}
class Type_2 extends Enum {}
class DropFileEvent extends Event {
  constructor(type, files) {
    type = type === VOID ? Type_START_getInstance() : type;
    files = files === VOID ? null : files;
    super();
    this.m7y_1 = type;
    this.n7y_1 = files;
  }
  p3m() {
    return this.m7y_1;
  }
  toString() {
    return 'DropFileEvent(type=' + toString(this.m7y_1) + ', files=' + toString_1(this.n7y_1) + ')';
  }
  hashCode() {
    var result = this.m7y_1.hashCode();
    result = imul(result, 31) + (this.n7y_1 == null ? 0 : hashCode(this.n7y_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this.m7y_1.equals(tmp0_other_with_cast.m7y_1))
      return false;
    if (!equals(this.n7y_1, tmp0_other_with_cast.n7y_1))
      return false;
    return true;
  }
}
class StopPropagatingException extends Exception {
  static r7y(reason) {
    reason = reason === VOID ? null : reason;
    var $this = this.oe();
    captureStack($this, $this.q7y_1);
    $this.p7y_1 = reason;
    return $this;
  }
}
class Status extends Enum {}
class Kind extends Enum {}
class Companion_12 {
  constructor() {
    Companion_instance_21 = this;
    this.s7y_1 = new Touch(-1);
  }
}
class Touch {
  constructor(index, id, p, force, status, kind, button) {
    Companion_getInstance_27();
    index = index === VOID ? -1 : index;
    id = id === VOID ? -1 : id;
    p = p === VOID ? Companion_getInstance_4().t3i_1 : p;
    force = force === VOID ? 1.0 : force;
    status = status === VOID ? Status_KEEP_getInstance() : status;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    this.t7y_1 = new Mixin();
    this.u7y_1 = index;
    this.v7y_1 = id;
    this.w7y_1 = p;
    this.x7y_1 = force;
    this.y7y_1 = status;
    this.z7y_1 = kind;
    this.a7z_1 = button;
  }
  b6h() {
    return this.w7y_1.r3i_1;
  }
  c6h() {
    return this.w7y_1.s3i_1;
  }
  a2f() {
    return !this.y7y_1.equals(Status_REMOVE_getInstance());
  }
  b7z(other) {
    this.v7y_1 = other.v7y_1;
    this.w7y_1 = other.w7y_1;
    this.x7y_1 = other.x7y_1;
    this.y7y_1 = other.y7y_1;
    this.z7y_1 = other.z7y_1;
    this.a7z_1 = other.a7z_1;
  }
  hashCode() {
    return this.u7y_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Touch) {
      tmp = this.u7y_1 === other.u7y_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'Touch(index=' + this.u7y_1 + ', id=' + this.v7y_1 + ', p=' + this.w7y_1.toString() + ', force=' + this.x7y_1 + ', status=' + this.y7y_1.toString() + ', kind=' + this.z7y_1.toString() + ', button=' + this.a7z_1.toString() + ')';
  }
  c28(value) {
    this.t7y_1.c28(value);
  }
  d28() {
    return this.t7y_1.d28();
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_22 = this;
    this.c7z_1 = values_3();
  }
}
class Type_3 extends Enum {}
class Companion_14 {
  constructor() {
    this.d7z_1 = 10;
  }
}
class TouchEvent extends Event {
  constructor(type, screen, currentTime, scaleCoords, emulated) {
    type = type === VOID ? Type_START_getInstance_0() : type;
    screen = screen === VOID ? 0 : screen;
    currentTime = currentTime === VOID ? Companion_getInstance_8().i35_1 : currentTime;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    super();
    this.g7z_1 = type;
    this.h7z_1 = screen;
    this.i7z_1 = currentTime;
    this.j7z_1 = scaleCoords;
    this.k7z_1 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_instance_23.d7z_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new Touch(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.l7z_1 = tmp_2;
    this.m7z_1 = FastArrayList.u28();
    this.n7z_1 = FastArrayList.u28();
    this.o7z_1 = FastIntMap();
  }
  p3m() {
    return this.g7z_1;
  }
  p7z() {
    return this.m7z_1;
  }
  q7z() {
    return this.p7z().g1();
  }
  r7z(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.o7z_1.get(id);
  }
  toString() {
    var tmp = toString(this.g7z_1);
    var tmp_0 = this.q7z();
    var tmp_1 = this.p7z();
    return 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString(tmp_1, ', ', VOID, VOID, VOID, VOID, TouchEvent$toString$lambda) + ')';
  }
  s7z(type) {
    this.g7z_1 = type;
    this.i7z_1 = Companion_getInstance_8().m35();
    this.m7z_1.h3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.o7z_1.clear();
  }
  t7z() {
    this.n7z_1.h3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.p7z();
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.event.TouchEvent.endFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.h1(_unary__edvuaz);
      if (it.a2f()) {
        this.n7z_1.h(it);
      }
    }
  }
  u7z(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.o7z_1.get(id);
    return tmp0_elvis_lhs == null ? this.v7z(id) : tmp0_elvis_lhs;
  }
  v7z(id) {
    var touch = this.l7z_1[this.m7z_1.g1()];
    touch.v7y_1 = id;
    this.m7z_1.h(touch);
    // Inline function 'korlibs.datastructure.set' call
    var this_0 = this.o7z_1;
    var key = touch.v7y_1;
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, touch);
    return touch;
  }
  w7z(id, p, status, force, kind, button) {
    var touch = this.u7z(id);
    touch.w7y_1 = p;
    touch.y7y_1 = status;
    touch.x7y_1 = force;
    touch.z7y_1 = kind;
    touch.a7z_1 = button;
  }
  x7z(id, p, status, force, kind, button, $super) {
    status = status === VOID ? Status_KEEP_getInstance() : status;
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.w7z(id, p, status, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.w7z.call(this, id, p, status, force, kind, button);
    }
    return tmp;
  }
  y7z(touch) {
    this.w7z(touch.v7y_1, touch.w7y_1, touch.y7y_1, touch.x7y_1, touch.z7y_1, touch.a7z_1);
  }
  z7z(other) {
    this.g7z_1 = other.g7z_1;
    this.h7z_1 = other.h7z_1;
    this.i7z_1 = other.i7z_1;
    this.j7z_1 = other.j7z_1;
    this.k7z_1 = other.k7z_1;
    var inductionVariable = 0;
    var last = Companion_instance_23.d7z_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.l7z_1[n].b7z(other.l7z_1[n]);
      }
       while (inductionVariable < last);
    this.m7z_1.h3();
    this.n7z_1.h3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.o7z_1.clear();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = other.p7z();
    var n_0 = 0;
    while (n_0 < this_0.g1()) {
      // Inline function 'korlibs.event.TouchEvent.copyFrom.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var otherTouch = this_0.h1(_unary__edvuaz);
      var touch = this.l7z_1[otherTouch.u7y_1];
      this.m7z_1.h(touch);
      if (touch.a2f()) {
        this.n7z_1.h(touch);
      }
      // Inline function 'korlibs.datastructure.set' call
      var this_1 = this.o7z_1;
      var key = touch.v7y_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_1.set(key, touch);
    }
  }
  a80() {
    return this.g7z_1.equals(Type_START_getInstance_0());
  }
  b80() {
    return this.g7z_1.equals(Type_END_getInstance_0());
  }
  hashCode() {
    var result = this.g7z_1.hashCode();
    result = imul(result, 31) + this.h7z_1 | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.i7z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j7z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k7z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchEvent ? other : THROW_CCE();
    if (!this.g7z_1.equals(tmp0_other_with_cast.g7z_1))
      return false;
    if (!(this.h7z_1 === tmp0_other_with_cast.h7z_1))
      return false;
    if (!equals(this.i7z_1, tmp0_other_with_cast.i7z_1))
      return false;
    if (!(this.j7z_1 === tmp0_other_with_cast.j7z_1))
      return false;
    if (!(this.k7z_1 === tmp0_other_with_cast.k7z_1))
      return false;
    return true;
  }
}
class Mode extends Enum {}
class TouchBuilder {
  constructor() {
    this.c80_1 = new TouchEvent();
    this.d80_1 = new TouchEvent();
    this.e80_1 = Mode_JS_getInstance();
  }
  f80(type, scaleCoords) {
    this.d80_1.j7z_1 = scaleCoords;
    this.d80_1.s7z(type);
    if (this.e80_1.p3_1 === 2) {
      this.d80_1.z7z(this.c80_1);
      this.d80_1.g7z_1 = type;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var this_0 = this.d80_1.m7z_1;
      var n = 0;
      var m = 0;
      while (n < this_0.g1()) {
        if (m >= 0 && !(m === n)) {
          this_0.i3(m, this_0.h1(n));
        }
        // Inline function 'korlibs.event.TouchBuilder.startFrame.<anonymous>' call
        var it = this_0.h1(n);
        var tmp;
        if (it.a2f()) {
          it.y7y_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          // Inline function 'korlibs.datastructure.remove' call
          var this_1 = this.d80_1.o7z_1;
          var key = it.v7y_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_1.delete(key);
          tmp = true;
        }
        if (tmp) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.g1() > m) {
        this_0.j3(this_0.g1() - 1 | 0);
      }
    }
  }
  g80() {
    switch (this.e80_1.p3_1) {
      case 0:
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var this_0 = this.c80_1.p7z();
        var n = 0;
        while (n < this_0.g1()) {
          // Inline function 'korlibs.event.TouchBuilder.endFrame.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var oldTouch = this_0.h1(_unary__edvuaz);
          if (this.d80_1.r7z(oldTouch.v7y_1) == null) {
            if (oldTouch.a2f()) {
              oldTouch.y7y_1 = Status_REMOVE_getInstance();
              this.d80_1.y7z(oldTouch);
            }
          }
        }

        break;
      case 2:
        break;
      default:
        break;
    }
    this.d80_1.t7z();
    this.c80_1.z7z(this.d80_1);
    return this.d80_1;
  }
  h80(id, p, force, kind, button) {
    var touch = this.d80_1.u7z(id);
    touch.w7y_1 = p;
    touch.x7y_1 = force;
    touch.z7y_1 = kind;
    touch.a7z_1 = button;
    if (this.e80_1.p3_1 === 2) {
      var tmp = touch;
      switch (this.d80_1.g7z_1.p3_1) {
        case 0:
          tmp.y7y_1 = Status_ADD_getInstance();
          break;
        case 1:
          tmp.y7y_1 = Status_REMOVE_getInstance();
          break;
        default:
          tmp.y7y_1 = Status_KEEP_getInstance();
          break;
      }
    } else {
      var oldTouch = this.c80_1.r7z(id);
      touch.y7y_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  }
  i80(id, p, force, kind, button, $super) {
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.h80(id, p, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.h80.call(this, id, p, force, kind, button);
    }
    return tmp;
  }
}
class GamepadInfoEmitter {
  constructor(dispatcher) {
    this.j80_1 = dispatcher;
    this.k80_1 = booleanArray(4);
    this.l80_1 = new GamePadUpdateEvent();
    this.m80_1 = new GamePadConnectionEvent();
    this.n80_1 = IntArrayList.l3w();
  }
  o80() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.l80_1.s80_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateStart.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0[_unary__edvuaz].u80_1 = false;
    }
    this.l80_1.r80_1 = 0;
  }
  a81(info) {
    var _receiver__tnumb7 = this.l80_1;
    var _unary__edvuaz = _receiver__tnumb7.r80_1;
    _receiver__tnumb7.r80_1 = _unary__edvuaz + 1 | 0;
    var index = _unary__edvuaz;
    var pad = this.l80_1.s80_1[index];
    pad.b81(info);
    pad.u80_1 = true;
    pad.t80_1 = index;
  }
  c81(out) {
    out.h3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.l80_1.s80_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0[_unary__edvuaz];
      if (!(this.k80_1[it.t80_1] === it.u80_1)) {
        this.k80_1[it.t80_1] = it.u80_1;
        out.r3w(it.t80_1);
        if (!it.u80_1) {
          it.v80_1 = null;
        }
        // Inline function 'kotlin.apply' call
        var this_1 = this.m80_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>.<anonymous>' call
        this_1.f81_1 = Companion_getInstance_32().i81(it.u80_1);
        this_1.g81_1 = it.t80_1;
        this.j80_1.l7v(this_1);
      }
    }
    this.j80_1.l7v(this.l80_1);
    return out;
  }
}
class BatteryStatus extends Enum {}
class Companion_15 {
  constructor() {
    this.j81_1 = 'Wireless Controller';
    this.k81_1 = 4;
    this.l81_1 = 0.075;
  }
  m81(value, margin, apply) {
    var tmp;
    if (apply) {
      // Inline function 'kotlin.math.absoluteValue' call
      tmp = Math.abs(value) < margin;
    } else {
      tmp = false;
    }
    if (tmp)
      return 0.0;
    return value;
  }
  n81(value, margin, apply, $super) {
    margin = margin === VOID ? 0.075 : margin;
    apply = apply === VOID ? true : apply;
    return $super === VOID ? this.m81(value, margin, apply) : $super.m81.call(this, value, margin, apply);
  }
}
class GamepadInfo {
  constructor(index, connected, name, rawButtons, batteryLevel, name2, batteryStatus) {
    index = index === VOID ? 0 : index;
    connected = connected === VOID ? false : connected;
    name = name === VOID ? null : name;
    rawButtons = rawButtons === VOID ? new Float32Array(32) : rawButtons;
    batteryLevel = batteryLevel === VOID ? 1.0 : batteryLevel;
    name2 = name2 === VOID ? Companion_instance_24.j81_1 : name2;
    batteryStatus = batteryStatus === VOID ? BatteryStatus_UNKNOWN_getInstance() : batteryStatus;
    this.t80_1 = index;
    this.u80_1 = connected;
    this.v80_1 = name;
    this.w80_1 = rawButtons;
    this.x80_1 = batteryLevel;
    this.y80_1 = name2;
    this.z80_1 = batteryStatus;
  }
  o81() {
    var tmp0_elvis_lhs = this.v80_1;
    return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' - ' + this.y80_1;
  }
  b81(that) {
    this.t80_1 = that.t80_1;
    this.v80_1 = that.v80_1;
    this.y80_1 = that.y80_1;
    this.u80_1 = that.u80_1;
    this.x80_1 = that.x80_1;
    this.z80_1 = that.z80_1;
    var tmp = that.w80_1;
    var tmp_0 = this.w80_1;
    // Inline function 'kotlin.math.min' call
    var a = this.w80_1.length;
    var b = that.w80_1.length;
    var tmp$ret$0 = Math.min(a, b);
    arraycopy(tmp, 0, tmp_0, 0, tmp$ret$0);
  }
  p81(button) {
    return this.w80_1[button.s81()];
  }
  t81(includeButtons) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.GamepadInfo.toStringEx.<anonymous>' call
    this_0.gc('Gamepad[' + this.t80_1 + '][' + this.o81() + ']');
    if (includeButtons) {
      this_0.gc('[');
      var count = 0;
      var indexedObject = values_5();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var value = this.p81(button);
        if (!(value === 0.0)) {
          if (count > 0) {
            this_0.gc(',');
          }
          this_0.gc(button.toString() + '=' + get_niceStr(value));
          count = count + 1 | 0;
        }
      }
      this_0.gc(']');
    }
    return this_0.toString();
  }
  u81(includeButtons, $super) {
    includeButtons = includeButtons === VOID ? true : includeButtons;
    return $super === VOID ? this.t81(includeButtons) : $super.t81.call(this, includeButtons);
  }
  toString() {
    return this.t81(false);
  }
}
class Companion_16 {}
class GamePadUpdateEvent extends Event {
  constructor(gamepadsLength, gamepads) {
    gamepadsLength = gamepadsLength === VOID ? 0 : gamepadsLength;
    var tmp;
    if (gamepads === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(4), null);
      while (tmp_0 < 4) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = new GamepadInfo(tmp_2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = gamepads;
    }
    gamepads = tmp;
    super();
    this.r80_1 = gamepadsLength;
    this.s80_1 = gamepads;
  }
  p3m() {
    return Companion_instance_25;
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.s80_1;
    var destination = ArrayList.z();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      if (element.u80_1) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      var tmp$ret$3 = item.u81();
      destination_0.h(tmp$ret$3);
    }
    return 'GamePadUpdateEvent(' + toString(destination_0) + ')';
  }
  hashCode() {
    var result = this.r80_1;
    result = imul(result, 31) + hashCode(this.s80_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this.r80_1 === tmp0_other_with_cast.r80_1))
      return false;
    if (!equals(this.s80_1, tmp0_other_with_cast.s80_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_26 = this;
    this.h81_1 = values_4();
  }
  i81(connected) {
    return connected ? Type_CONNECTED_getInstance() : Type_DISCONNECTED_getInstance();
  }
}
class Type_4 extends Enum {}
class GamePadConnectionEvent extends Event {
  constructor(type, gamepad) {
    type = type === VOID ? Type_CONNECTED_getInstance() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    super();
    this.f81_1 = type;
    this.g81_1 = gamepad;
  }
  p3m() {
    return this.f81_1;
  }
  toString() {
    return 'GamePadConnectionEvent(type=' + toString(this.f81_1) + ', gamepad=' + this.g81_1 + ')';
  }
  hashCode() {
    var result = this.f81_1.hashCode();
    result = imul(result, 31) + this.g81_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this.f81_1.equals(tmp0_other_with_cast.f81_1))
      return false;
    if (!(this.g81_1 === tmp0_other_with_cast.g81_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_27 = this;
    this.v81_1 = values_5();
    this.w81_1 = 32;
  }
}
class GameButton extends Enum {
  s81() {
    return this.p3_1;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_28 = this;
    this.x81_1 = Key_UNKNOWN_getInstance().p3_1 + 1 | 0;
    this.y81_1 = Key_ENTER_getInstance();
    this.z81_1 = Key_N0_getInstance();
    this.a82_1 = Key_N1_getInstance();
    this.b82_1 = Key_N2_getInstance();
    this.c82_1 = Key_N3_getInstance();
    this.d82_1 = Key_N4_getInstance();
    this.e82_1 = Key_N5_getInstance();
    this.f82_1 = Key_N6_getInstance();
    this.g82_1 = Key_N7_getInstance();
    this.h82_1 = Key_N8_getInstance();
    this.i82_1 = Key_N9_getInstance();
  }
  j82() {
    return Key_CONTROL_getInstance();
  }
  k82() {
    return Key_CONTROL_getInstance();
  }
  l82() {
    return Key_SHIFT_getInstance();
  }
  m82() {
    return Key_SHIFT_getInstance();
  }
  n82() {
    return Key_ALT_getInstance();
  }
  o82() {
    return Key_ALT_getInstance();
  }
  p82() {
    return Key_SUPER_getInstance();
  }
  q82() {
    return Key_SUPER_getInstance();
  }
}
class Key extends Enum {
  t82() {
    switch (this.p3_1) {
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
        return true;
      default:
        return false;
    }
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_29 = this;
    this.u82_1 = MouseButton_NONE_getInstance().p3_1 + 1 | 0;
    this.v82_1 = values_6();
  }
  h1(id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.v82_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= id ? id <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[id];
    } else {
      // Inline function 'korlibs.event.Companion.get.<anonymous>' call
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  }
}
class MouseButton extends Enum {
  constructor(name, ordinal, id, bits) {
    bits = bits === VOID ? 1 << id : bits;
    super(name, ordinal);
    this.y82_1 = id;
    this.z82_1 = bits;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_30 = this;
    this.a83_1 = Companion_getInstance_1().g26('AG');
    this.b83_1 = 96.0;
  }
}
class AGFeatures {}
function get_parentFeatures() {
  return null;
}
function get_isUniformBuffersSupported() {
  var tmp0_safe_receiver = this.c84();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d84();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function get_isVertexArraysSupported() {
  var tmp0_safe_receiver = this.c84();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e84();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
class AG {
  static g83() {
    Companion_getInstance_36();
    var $this = createThis(this);
    $this.c83_1 = new Mixin();
    $this.d83_1 = AGFrameBuffer.u83(true);
    $this.e83_1 = 0;
    $this.f83_1 = new AGStats();
    return $this;
  }
  v83() {
    return this.d83_1;
  }
  w83() {
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_36().a83_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      this_0.r46(level, this);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_36().a83_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.q46(level_0)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      var tmp$ret$2 = 'AG.contextLost()';
      this_1.r46(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    this.e83_1 = this.e83_1 + 1 | 0;
  }
  x83() {
    return this.y83(AGFinish_instance);
  }
  z83() {
    return Unit_instance;
  }
  t7z() {
    return Unit_instance;
  }
  y83(command) {
    return Unit_instance;
  }
  a84(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    return this.y83(new AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil));
  }
  b84(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    return this.y83(new AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances));
  }
  c28(value) {
    this.c83_1.c28(value);
  }
  d28() {
    return this.c83_1.d28();
  }
}
class Immutable {
  constructor(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.o85_1 = parentFeatures;
    this.p85_1 = graphicExtensions;
    this.q85_1 = isInstancedSupported;
    this.r85_1 = isUniformBuffersSupported;
    this.s85_1 = isVertexArraysSupported;
    this.t85_1 = isStorageMultisampleSupported;
    this.u85_1 = isFloatTextureSupported;
  }
  c84() {
    return this.o85_1;
  }
  d84() {
    return this.r85_1;
  }
  e84() {
    return this.s85_1;
  }
  toString() {
    return 'Immutable(parentFeatures=' + toString_1(this.o85_1) + ', graphicExtensions=' + toString(this.p85_1) + ', isInstancedSupported=' + this.q85_1 + ', isUniformBuffersSupported=' + this.r85_1 + ', isVertexArraysSupported=' + this.s85_1 + ', isStorageMultisampleSupported=' + this.t85_1 + ', isFloatTextureSupported=' + this.u85_1 + ')';
  }
  hashCode() {
    var result = this.o85_1 == null ? 0 : hashCode(this.o85_1);
    result = imul(result, 31) + hashCode(this.p85_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q85_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r85_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s85_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t85_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u85_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable))
      return false;
    var tmp0_other_with_cast = other instanceof Immutable ? other : THROW_CCE();
    if (!equals(this.o85_1, tmp0_other_with_cast.o85_1))
      return false;
    if (!equals(this.p85_1, tmp0_other_with_cast.p85_1))
      return false;
    if (!(this.q85_1 === tmp0_other_with_cast.q85_1))
      return false;
    if (!(this.r85_1 === tmp0_other_with_cast.r85_1))
      return false;
    if (!(this.s85_1 === tmp0_other_with_cast.s85_1))
      return false;
    if (!(this.t85_1 === tmp0_other_with_cast.t85_1))
      return false;
    if (!(this.u85_1 === tmp0_other_with_cast.u85_1))
      return false;
    return true;
  }
}
class AGObject {
  constructor() {
    this.c86_1 = null;
    this.d86_1 = -1;
    this.e86_1 = -2;
    this.f86_1 = -1;
  }
  k86() {
    this.g86();
    this.e86_1 = this.f86_1 - 1 | 0;
  }
  g86() {
    this.f86_1 = this.f86_1 + 1 | 0;
  }
  p6() {
    var tmp0_safe_receiver = this.c86_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k89();
    }
    this.c86_1 = null;
  }
}
class AGBuffer extends AGObject {
  constructor() {
    super();
    this.b86_1 = null;
  }
  h86(data, offset, length) {
    return upload(this, _Int8Buffer___get_buffer__impl__q0gulb(_Int8Buffer___init__impl__e20lvc(data, offset, length)), false);
  }
  i86(data, offset, length) {
    return upload(this, sliceWithSize(data, offset, length), true);
  }
  j86(data) {
    return upload(this, data, true);
  }
  toString() {
    var tmp0_safe_receiver = this.b86_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p2c();
    return 'AGBuffer(' + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + ')';
  }
}
class Companion_22 {
  constructor() {
    this.q84_1 = 8;
  }
  r84() {
    return AGTextureUnits.n86();
  }
}
class AGTextureUnits {
  static o86(textures, infos) {
    var $this = createThis(this);
    $this.l86_1 = textures;
    $this.m86_1 = infos;
    return $this;
  }
  static n86(size) {
    size = size === VOID ? Companion_instance_31.q84_1 : size;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    return this.o86(tmp$ret$0, _AGTextureUnitInfoArray___init__impl__c77rdb_0(size));
  }
  g1() {
    return this.l86_1.length;
  }
  p86(index, texture, info) {
    this.l86_1[index] = texture;
    AGTextureUnitInfoArray__set_impl_s95rfh(this.m86_1, index, info);
  }
  q86(sampler, texture, info) {
    this.p86(sampler.c87_1, texture, info);
  }
  h3() {
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.p86(n, null, Companion_getInstance_39().f87_1);
      }
       while (inductionVariable < last);
  }
  z27() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.l86_1.slice();
    return AGTextureUnits.o86(tmp$ret$1, AGTextureUnitInfoArray__copyOf_impl_z2w8z3(this.m86_1));
  }
  toString() {
    return 'AGTextureUnits(textures=' + toString(this.l86_1) + ', infos=' + AGTextureUnitInfoArray__toString_impl_kr9cgh(this.m86_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.l86_1);
    result = imul(result, 31) + AGTextureUnitInfoArray__hashCode_impl_siosps(this.m86_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGTextureUnits))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnits ? other : THROW_CCE();
    if (!equals(this.l86_1, tmp0_other_with_cast.l86_1))
      return false;
    if (!equals(this.m86_1, tmp0_other_with_cast.m86_1))
      return false;
    return true;
  }
}
class Companion_23 {
  constructor() {
    this.g87_1 = 128;
    this.h87_1 = 128;
  }
}
class AGFrameBuffer {
  static i87(base, id) {
    id = id === VOID ? -1 : id;
    var $this = createThis(this);
    $this.h83_1 = base;
    $this.i83_1 = id;
    $this.j83_1 = 1;
    $this.k83_1 = true;
    $this.l83_1 = true;
    $this.m83_1 = 0;
    $this.n83_1 = 0;
    $this.o83_1 = 128;
    $this.p83_1 = 128;
    $this.q83_1 = 128;
    $this.r83_1 = 128;
    $this.s83_1 = RectangleInt.w3r();
    $this.t83_1 = null;
    return $this;
  }
  static u83(isMain, id) {
    isMain = isMain === VOID ? false : isMain;
    id = id === VOID ? -1 : id;
    return this.i87(new AGFrameBufferBase(isMain), id);
  }
  j87() {
    return this.h83_1.j87();
  }
  r87() {
    return this.h83_1.o87_1;
  }
  s87() {
    return this.h83_1.p87_1;
  }
  n85() {
    return AGFrameBufferInfo__withHasStencil_impl_nbaemo(AGFrameBufferInfo__withHasDepth_impl_fjgbiv(AGFrameBufferInfo__withSamples_impl_83818f(AGFrameBufferInfo__withBounds_impl_sg0n3x(_AGFrameBufferInfo___init__impl__dbxiro(new Long(0, 0)), this.m83_1, this.n83_1, this.o83_1, this.p83_1), this.j83_1), this.l83_1), this.k83_1);
  }
  t87(width, height) {
    return this.u87(0, 0, width, height);
  }
  v87(x, y, width, height, fullWidth, fullHeight) {
    if (this.m83_1 === x && this.n83_1 === y && this.o83_1 === width && this.p83_1 === height && this.q83_1 === fullWidth && this.r83_1 === fullHeight)
      return true;
    this.s87().k88(NullBitmap.r5n(width, height));
    this.h83_1.q87_1 = Companion_getInstance_9().o2e(imul(imul(fullWidth, fullHeight), 8));
    this.m83_1 = x;
    this.n83_1 = y;
    this.o83_1 = width;
    this.p83_1 = height;
    this.q83_1 = fullWidth;
    this.r83_1 = fullHeight;
    markAsDirty(this);
    return false;
  }
  u87(x, y, width, height, fullWidth, fullHeight, $super) {
    fullWidth = fullWidth === VOID ? width : fullWidth;
    fullHeight = fullHeight === VOID ? height : fullHeight;
    return $super === VOID ? this.v87(x, y, width, height, fullWidth, fullHeight) : $super.v87.call(this, x, y, width, height, fullWidth, fullHeight);
  }
  p6() {
    this.h83_1.p6();
  }
  l88(samples) {
    if (this.j83_1 === samples)
      return Unit_instance;
    this.j83_1 = samples;
    markAsDirty(this);
  }
  m88(hasDepth, hasStencil) {
    if (this.l83_1 === hasDepth && this.k83_1 === hasStencil)
      return Unit_instance;
    this.l83_1 = hasDepth;
    this.k83_1 = hasStencil;
    markAsDirty(this);
  }
  toString() {
    return 'AGFrameBuffer(' + (this.r87() ? 'main' : '' + this.i83_1) + ', ' + this.o83_1 + ', ' + this.p83_1 + ')';
  }
}
class AGTexture extends AGObject {
  constructor(targetKind) {
    targetKind = targetKind === VOID ? Companion_getInstance_50().n88_1 : targetKind;
    super();
    this.a88_1 = targetKind;
    this.b88_1 = Companion_getInstance_1().g26('AGTexture');
    this.c88_1 = false;
    this.d88_1 = false;
    this.e88_1 = null;
    this.f88_1 = null;
    this.g88_1 = null;
    this.h88_1 = false;
    this.i88_1 = null;
    this.j88_1 = Companion_getInstance_9().p2e(new Long(0, 0));
  }
  r88() {
    var tmp0_safe_receiver = this.i88_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v5k();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.AGTexture.<get-implForcedTexTarget>.<anonymous>' call
      tmp = fromGl(Companion_getInstance_50(), tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp2_elvis_lhs;
    if ((tmp_1 == null ? null : new AGTextureTargetKind(tmp_1)) == null) {
      tmp_0 = this.a88_1;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  }
  f3u() {
    var tmp0_safe_receiver = this.g88_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r56_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  g3u() {
    var tmp0_safe_receiver = this.g88_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s56_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  t88() {
    var tmp = this.g88_1;
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof MultiBitmap) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h89_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g1();
    return tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
  }
  i89(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    if (bmp == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      checkBitmaps(this, bmp);
    }
    var tmp = this;
    tmp.i88_1 = (bmp == null ? true : isInterface(bmp, ForcedTexId)) ? bmp : null;
    this.g88_1 = bmp;
    this.j88_1 = Companion_getInstance_9().o2e(imul(imul(imul(this.f3u(), this.g3u()), this.t88()), 4));
    this.g86();
    this.d88_1 = mipmaps;
    this.e88_1 = baseMipmapLevel;
    this.f88_1 = maxMipmapLevel;
    return this;
  }
  k88(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel, $super) {
    mipmaps = mipmaps === VOID ? false : mipmaps;
    baseMipmapLevel = baseMipmapLevel === VOID ? null : baseMipmapLevel;
    maxMipmapLevel = maxMipmapLevel === VOID ? null : maxMipmapLevel;
    return $super === VOID ? this.i89(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) : $super.i89.call(this, bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  j89(bitmap, requestMipmaps) {
    var tmp1_elvis_lhs = bitmap == null ? null : bitmap.r56_1;
    var width = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = bitmap == null ? null : bitmap.s56_1;
    var height = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    return requestMipmaps && get_isPowerOfTwo(width) && get_isPowerOfTwo(height);
  }
  toString() {
    return 'AGTexture(size=' + this.f3u() + ',' + this.g3u() + ')';
  }
}
class AGFrameBufferBase extends AGObject {
  constructor(isMain) {
    super();
    this.o87_1 = isMain;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new AGTexture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGFrameBufferBase.tex.<anonymous>' call
    this_0.c88_1 = true;
    tmp.p87_1 = this_0;
    this.q87_1 = Companion_getInstance_9().o2e(0);
  }
  j87() {
    return !this.o87_1;
  }
  p6() {
    this.p87_1.p6();
  }
  toString() {
    return 'AGFrameBufferBase(isMain=' + this.o87_1 + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_33 = this;
    this.e87_1 = _AGTextureUnitInfo___init__impl__s1tthu(-1);
    this.f87_1 = AGTextureUnitInfo__withKind_impl_aa0b04(AGTextureUnitInfo__withWrap_impl_akwb6y(AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(_AGTextureUnitInfo___init__impl__s1tthu(0), true, true), Companion_getInstance_51().m89_1), Companion_getInstance_50().n88_1);
  }
  l89(data) {
    return _AGTextureUnitInfo___init__impl__s1tthu(data);
  }
  p89(wrap, linear, trilinear) {
    return AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(AGTextureUnitInfo__withWrap_impl_akwb6y(_AGTextureUnitInfo___init__impl__s1tthu(0), wrap), linear, trilinear);
  }
  q89(wrap, linear, trilinear, $super) {
    wrap = wrap === VOID ? Companion_getInstance_51().m89_1 : wrap;
    linear = linear === VOID ? true : linear;
    trilinear = trilinear === VOID ? linear : trilinear;
    return $super === VOID ? this.p89(wrap, linear, trilinear) : $super.p89.call(this, new AGWrapMode(wrap), linear, trilinear).r89_1;
  }
}
class AGNativeObject {}
class BufferCache {
  constructor() {
    this.s89_1 = FastIdentityMap();
  }
  u1w() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.s89_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.reset.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).u1w();
    }
  }
  b8a() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.s89_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.uploadUpdatedBuffers.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).c8a();
    }
  }
  d8a(block) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.s89_1;
      var res = get_0(this_0, block);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.BufferCache.get.<anonymous>' call
      var out = new UniformBlockBuffer(block);
      set(this_0, block, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    return tmp instanceof UniformBlockBuffer ? tmp : THROW_CCE();
  }
}
class AGProgramWithUniforms {
  constructor(program, bufferCache) {
    bufferCache = bufferCache === VOID ? new BufferCache() : bufferCache;
    this.e8a_1 = program;
    this.f8a_1 = bufferCache;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.e8a_1.r8a_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformLayouts.<anonymous>' call
      var tmp$ret$0 = item.l8b_1;
      destination.h(tmp$ret$0);
    }
    tmp.g8a_1 = distinct(destination);
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.g8a_1.b1();
      if (!iterator.c1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
      var maxValue = iterator.d1().n8b_1 + 1 | 0;
      while (iterator.c1()) {
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
        var v = iterator.d1().n8b_1 + 1 | 0;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.h8a_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var tmp_2 = 0;
    var tmp_3 = this.h8a_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocks.<anonymous>' call
    var _iterator__ex2g4s = this.g8a_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var layout = _iterator__ex2g4s.d1();
      tmp_4[layout.n8b_1] = layout;
    }
    tmp_1.i8a_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this.i8a_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_8 = fillArrayVal(Array(tmp_7), null);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      var tmp0_safe_receiver = this.i8a_1[tmp_9];
      var tmp_10;
      if (tmp0_safe_receiver == null) {
        tmp_10 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocksData.<anonymous>' call
        tmp_10 = this.f8a_1.d8a(tmp0_safe_receiver);
      }
      tmp_8[tmp_9] = tmp_10;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5.j8a_1 = tmp_8;
    var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = this.i8a_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var tmp0_safe_receiver_0 = this.j8a_1[tmp_15];
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.t89_1;
      var tmp_16;
      if (tmp1_safe_receiver == null) {
        tmp_16 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.agUniformBlockDatas.<anonymous>' call
        tmp_16 = new UniformBlockBuffer(tmp1_safe_receiver);
      }
      tmp_14[tmp_15] = tmp_16;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.k8a_1 = tmp_14;
    var tmp_17 = this;
    var tmp_18 = 0;
    var tmp_19 = this.i8a_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_20 = fillArrayVal(Array(tmp_19), null);
    while (tmp_18 < tmp_19) {
      var tmp_21 = tmp_18;
      var tmp0_safe_receiver_1 = this.j8a_1[tmp_21];
      tmp_20[tmp_21] = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.u89_1;
      tmp_18 = tmp_18 + 1 | 0;
    }
    tmp_17.l8a_1 = tmp_20;
    var tmp_22 = this;
    var tmp_23 = 0;
    var tmp_24 = this.i8a_1.length;
    var tmp_25 = new Int32Array(tmp_24);
    while (tmp_23 < tmp_24) {
      tmp_25[tmp_23] = 0;
      tmp_23 = tmp_23 + 1 | 0;
    }
    tmp_22.m8a_1 = tmp_25;
  }
  r8b() {
    var inductionVariable = 0;
    var last = this.m8a_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = this.j8a_1[n];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s8b();
        this.m8a_1[n] = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.m8a_1.slice();
    return new UniformBlocksBuffersRef(this.k8a_1, this.l8a_1, tmp$ret$1);
  }
}
class AGVertexArrayObject {
  static w8b(list, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    var $this = createThis(this);
    $this.t8b_1 = new Mixin();
    $this.u8b_1 = list;
    $this.v8b_1 = isDynamic;
    return $this;
  }
  static x8b(datas, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    return this.w8b(fastArrayListOf(datas.slice()), isDynamic);
  }
  toString() {
    return 'AGVertexArrayObject(list=' + this.u8b_1.toString() + ', isDynamic=' + this.v8b_1 + ')';
  }
  hashCode() {
    var result = this.u8b_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.v8b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexArrayObject))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexArrayObject ? other : THROW_CCE();
    if (!this.u8b_1.equals(tmp0_other_with_cast.u8b_1))
      return false;
    if (!(this.v8b_1 === tmp0_other_with_cast.v8b_1))
      return false;
    return true;
  }
  c28(value) {
    this.t8b_1.c28(value);
  }
  d28() {
    return this.t8b_1.d28();
  }
}
class AGVertexData {
  constructor(layout, buffer, baseOffset) {
    layout = layout === VOID ? ProgramLayout.g8c([]) : layout;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    this.h8c_1 = layout;
    this.i8c_1 = buffer;
    this.j8c_1 = baseOffset;
  }
  toString() {
    return 'AGVertexData(layout=' + this.h8c_1.toString() + ', buffer=' + this.i8c_1.toString() + ', baseOffset=' + this.j8c_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.h8c_1);
    result = imul(result, 31) + hashCode(this.i8c_1) | 0;
    result = imul(result, 31) + this.j8c_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexData))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexData ? other : THROW_CCE();
    if (!equals(this.h8c_1, tmp0_other_with_cast.h8c_1))
      return false;
    if (!equals(this.i8c_1, tmp0_other_with_cast.i8c_1))
      return false;
    if (!(this.j8c_1 === tmp0_other_with_cast.j8c_1))
      return false;
    return true;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_34 = this;
    this.k8c_1 = _AGDrawType___init__impl__emm6mb(0);
    this.l8c_1 = _AGDrawType___init__impl__emm6mb(1);
    this.m8c_1 = _AGDrawType___init__impl__emm6mb(2);
    this.n8c_1 = _AGDrawType___init__impl__emm6mb(3);
    this.o8c_1 = _AGDrawType___init__impl__emm6mb(4);
    this.p8c_1 = _AGDrawType___init__impl__emm6mb(5);
    this.q8c_1 = _AGDrawType___init__impl__emm6mb(6);
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_35 = this;
    this.f84_1 = _AGIndexType___init__impl__yqnmb7(0);
    this.g84_1 = _AGIndexType___init__impl__yqnmb7(1);
    this.h84_1 = _AGIndexType___init__impl__yqnmb7(2);
    this.i84_1 = _AGIndexType___init__impl__yqnmb7(3);
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_36 = this;
    this.j84_1 = _AGBlending___init__impl__upt3bq(-1);
    this.k84_1 = Companion_getInstance_42().f8d(Companion_getInstance_52().x8c_1, Companion_getInstance_52().e8d_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().e8d_1);
    this.l84_1 = Companion_getInstance_42().f8d(Companion_getInstance_52().c8d_1, Companion_getInstance_52().a8d_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().a8d_1);
    this.m84_1 = Companion_getInstance_42().g8d(Companion_getInstance_52().x8c_1, Companion_getInstance_52().a8d_1);
    this.n84_1 = Companion_getInstance_42().f8d(Companion_getInstance_52().c8d_1, Companion_getInstance_52().v8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1);
    this.o84_1 = Companion_getInstance_42().f8d(Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1);
  }
  h8d(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    return AGBlending__withEQ_impl_e9gm04(AGBlending__withDST_impl_y1hpet(AGBlending__withSRC_impl_hh0mjq(_AGBlending___init__impl__upt3bq(0), srcRGB, srcA), dstRGB, dstA), eqRGB, eqA);
  }
  f8d(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $super) {
    srcA = srcA === VOID ? srcRGB : srcA;
    dstA = dstA === VOID ? dstRGB : dstA;
    eqRGB = eqRGB === VOID ? Companion_getInstance_53().i8d_1 : eqRGB;
    eqA = eqA === VOID ? eqRGB : eqA;
    return $super === VOID ? this.h8d(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) : $super.h8d.call(this, new AGBlendFactor(srcRGB), new AGBlendFactor(dstRGB), new AGBlendFactor(srcA), new AGBlendFactor(dstA), new AGBlendEquation(eqRGB), new AGBlendEquation(eqA)).r8c_1;
  }
  l8d(src, dst, eq) {
    return AGBlending__withEQ$default_impl_iltiw7(AGBlending__withDST$default_impl_leu6qg(AGBlending__withSRC$default_impl_uuu5hz(_AGBlending___init__impl__upt3bq(0), src), dst), eq);
  }
  g8d(src, dst, eq, $super) {
    eq = eq === VOID ? Companion_getInstance_53().i8d_1 : eq;
    return $super === VOID ? this.l8d(src, dst, eq) : $super.l8d.call(this, new AGBlendFactor(src), new AGBlendFactor(dst), new AGBlendEquation(eq)).r8c_1;
  }
}
class AGBlending {
  constructor(data) {
    Companion_getInstance_42();
    this.r8c_1 = data;
  }
  toString() {
    return AGBlending__toString_impl_d5hic6(this.r8c_1);
  }
  hashCode() {
    return AGBlending__hashCode_impl_ywnf51(this.r8c_1);
  }
  equals(other) {
    return AGBlending__equals_impl_rp3dmf(this.r8c_1, other);
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_37 = this;
    this.e85_1 = AGScissor.q8d(0, 0, 0, 0);
    this.f85_1 = Companion_getInstance_43().p3q(-2147483648, -2147483648, 2147483647, 2147483647);
    this.g85_1 = Companion_getInstance_43().p3q(-32766, -32766, 2147483647, 2147483647);
    this.h85_1 = Companion_getInstance_43().p3q(-32767, -32767, 2147483647, 2147483647);
  }
  p3q(left, top, right, bottom) {
    return AGScissor.q8d(left, top, right - left | 0, bottom - top | 0);
  }
  r8d(left, top, right, bottom) {
    return AGScissor.s8d(left, top, right - left, bottom - top);
  }
  t8d(rect) {
    if (rect == null)
      return this.h85_1;
    if (rect.g3j())
      return this.h85_1;
    return AGScissor.u8d(rect.b3j_1, rect.c3j_1, rect.d3j_1, rect.e3j_1);
  }
}
class AGScissor {
  static v8d(_left, _top, _right, _bottom) {
    Companion_getInstance_43();
    var $this = createThis(this);
    $this.m8d_1 = _left;
    $this.n8d_1 = _top;
    $this.o8d_1 = _right;
    $this.p8d_1 = _bottom;
    return $this;
  }
  g3j() {
    return this.equals(Companion_getInstance_43().h85_1);
  }
  static q8d(x, y, width, height) {
    Companion_getInstance_43();
    return this.v8d(toShortClamped(x), toShortClamped(y), toShortClamped(x + width | 0), toShortClamped(y + height | 0));
  }
  static s8d(x, y, width, height) {
    Companion_getInstance_43();
    return this.q8d(toIntRound(x), toIntRound(y), toIntRound(width), toIntRound(height));
  }
  static u8d(x, y, width, height) {
    Companion_getInstance_43();
    return this.q8d(toIntRound_0(x), toIntRound_0(y), toIntRound_0(width), toIntRound_0(height));
  }
  i3j() {
    return this.m8d_1;
  }
  d3q() {
    return this.n8d_1;
  }
  j3j() {
    return this.o8d_1;
  }
  c3q() {
    return this.p8d_1;
  }
  b6h() {
    return this.i3j();
  }
  c6h() {
    return this.d3q();
  }
  f3u() {
    return this.j3j() - this.i3j() | 0;
  }
  g3u() {
    return this.c3q() - this.d3q() | 0;
  }
  toString() {
    if (this.equals(Companion_getInstance_43().h85_1))
      return 'null';
    return 'Scissor(x=' + this.b6h() + ', y=' + this.c6h() + ', width=' + this.f3u() + ', height=' + this.g3u() + ')';
  }
  w8d() {
    return this.g3j() ? Companion_getInstance_5().o3j() : Companion_getInstance_5().k3q(this.b6h(), this.c6h(), this.f3u(), this.g3u());
  }
  x8d() {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.w8d();
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.graphics.AGScissor.toRectOrNull.<anonymous>' call
    if (this_0.h3j()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  hashCode() {
    var result = this.m8d_1;
    result = imul(result, 31) + this.n8d_1 | 0;
    result = imul(result, 31) + this.o8d_1 | 0;
    result = imul(result, 31) + this.p8d_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGScissor))
      return false;
    var tmp0_other_with_cast = other instanceof AGScissor ? other : THROW_CCE();
    if (!(this.m8d_1 === tmp0_other_with_cast.m8d_1))
      return false;
    if (!(this.n8d_1 === tmp0_other_with_cast.n8d_1))
      return false;
    if (!(this.o8d_1 === tmp0_other_with_cast.o8d_1))
      return false;
    if (!(this.p8d_1 === tmp0_other_with_cast.p8d_1))
      return false;
    return true;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_38 = this;
    this.z8d_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(0, 0);
    this.a8e_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(-1, 0);
  }
}
class AGFinish {}
class AGClear {
  constructor(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil) {
    this.b8e_1 = frameBuffer;
    this.c8e_1 = frameBufferInfo;
    this.d8e_1 = color;
    this.e8e_1 = depth;
    this.f8e_1 = stencil;
    this.g8e_1 = clearColor;
    this.h8e_1 = clearDepth;
    this.i8e_1 = clearStencil;
  }
  toString() {
    return 'AGClear(frameBuffer=' + this.b8e_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.c8e_1) + ', color=' + RGBA__toString_impl_4lw6dp(this.d8e_1) + ', depth=' + this.e8e_1 + ', stencil=' + this.f8e_1 + ', clearColor=' + this.g8e_1 + ', clearDepth=' + this.h8e_1 + ', clearStencil=' + this.i8e_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.b8e_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.c8e_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.d8e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e8e_1) | 0;
    result = imul(result, 31) + this.f8e_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g8e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h8e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i8e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGClear))
      return false;
    var tmp0_other_with_cast = other instanceof AGClear ? other : THROW_CCE();
    if (!equals(this.b8e_1, tmp0_other_with_cast.b8e_1))
      return false;
    if (!equals(this.c8e_1, tmp0_other_with_cast.c8e_1))
      return false;
    if (!(this.d8e_1 === tmp0_other_with_cast.d8e_1))
      return false;
    if (!equals(this.e8e_1, tmp0_other_with_cast.e8e_1))
      return false;
    if (!(this.f8e_1 === tmp0_other_with_cast.f8e_1))
      return false;
    if (!(this.g8e_1 === tmp0_other_with_cast.g8e_1))
      return false;
    if (!(this.h8e_1 === tmp0_other_with_cast.h8e_1))
      return false;
    if (!(this.i8e_1 === tmp0_other_with_cast.i8e_1))
      return false;
    return true;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_39 = this;
    this.s84_1 = _AGStencilReference___init__impl__rta8vg(new Long(-1, -1));
    this.t84_1 = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(AGStencilReference__withReferenceValue$default_impl_2trj0v(_AGStencilReference___init__impl__rta8vg(new Long(0, 0)), 0), 255), 255);
  }
}
class AGStencilReference {
  constructor(data) {
    Companion_getInstance_45();
    this.j8e_1 = data;
  }
  toString() {
    return AGStencilReference__toString_impl_qu5r8s(this.j8e_1);
  }
  hashCode() {
    return AGStencilReference__hashCode_impl_52zufx(this.j8e_1);
  }
  equals(other) {
    return AGStencilReference__equals_impl_kj05j(this.j8e_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_40 = this;
    this.u84_1 = _AGStencilOpFunc___init__impl__t3f62q(-1);
    this.v84_1 = AGStencilOpFunc__withAction$default_impl_jx9cm1(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(_AGStencilOpFunc___init__impl__t3f62q(0), false), Companion_getInstance_56().n8e_1), Companion_getInstance_55().a8f_1, Companion_getInstance_55().a8f_1, Companion_getInstance_55().a8f_1);
  }
}
class AGStencilOpFunc {
  constructor(data) {
    Companion_getInstance_46();
    this.d8f_1 = data;
  }
  toString() {
    return AGStencilOpFunc__toString_impl_pl8quy(this.d8f_1);
  }
  hashCode() {
    return AGStencilOpFunc__hashCode_impl_nopebb(this.d8f_1);
  }
  equals(other) {
    return AGStencilOpFunc__equals_impl_y44i4z(this.d8f_1, other);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_41 = this;
    this.w84_1 = _AGColorMask___init__impl__j38ai8(-1);
    this.x84_1 = _AGColorMask___init__impl__j38ai8_1();
    this.y84_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.z84_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.a85_1 = _AGColorMask___init__impl__j38ai8_0(true, true, true, false);
    this.b85_1 = _AGColorMask___init__impl__j38ai8_1(false);
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_42 = this;
    this.c85_1 = _AGDepthAndFrontFace___init__impl__ra8x65(-2);
    this.d85_1 = AGDepthAndFrontFace__withFrontFace_impl_mwk87t(AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs(AGDepthAndFrontFace__withDepthMask_impl_610nhs(AGDepthAndFrontFace__withDepth_impl_wsx82k(_AGDepthAndFrontFace___init__impl__ra8x65(0), 0.0, 1.0), true), Companion_getInstance_56().n8e_1), Companion_getInstance_57().g8f_1);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_43 = this;
    this.i85_1 = _AGCullFace___init__impl__ckmjdg(-1);
    this.j85_1 = _AGCullFace___init__impl__ckmjdg(0);
    this.k85_1 = _AGCullFace___init__impl__ckmjdg(1);
    this.l85_1 = _AGCullFace___init__impl__ckmjdg(2);
    this.m85_1 = _AGCullFace___init__impl__ckmjdg(3);
  }
}
class AGBatch {
  constructor(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances) {
    vertexData = vertexData === VOID ? AGVertexArrayObject.x8b([new AGVertexData()], true) : vertexData;
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_41().h84_1 : indexType;
    program = program === VOID ? DefaultShaders_getInstance().c8g_1 : program;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_58().p84_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_31.r84() : textureUnits;
    blending = blending === VOID ? Companion_getInstance_42().l84_1 : blending;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_46().v84_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_45().t84_1 : stencilRef;
    colorMask = colorMask === VOID ? Companion_getInstance_47().y84_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_48().d85_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_43().h85_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_49().j85_1 : cullFace;
    drawType = drawType === VOID ? Companion_getInstance_40().o8c_1 : drawType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    vertexCount = vertexCount === VOID ? 0 : vertexCount;
    instances = instances === VOID ? 1 : instances;
    this.e8g_1 = frameBuffer;
    this.f8g_1 = frameBufferInfo;
    this.g8g_1 = vertexData;
    this.h8g_1 = indices;
    this.i8g_1 = indexType;
    this.j8g_1 = program;
    this.k8g_1 = uniformBlocks;
    this.l8g_1 = textureUnits;
    this.m8g_1 = blending;
    this.n8g_1 = stencilOpFunc;
    this.o8g_1 = stencilRef;
    this.p8g_1 = colorMask;
    this.q8g_1 = depthAndFrontFace;
    this.r8g_1 = scissor;
    this.s8g_1 = cullFace;
    this.t8g_1 = drawType;
    this.u8g_1 = drawOffset;
    this.v8g_1 = vertexCount;
    this.w8g_1 = instances;
  }
  w85(ag) {
    ag.b84(this.e8g_1, this.f8g_1, this.g8g_1, this.j8g_1, this.t8g_1, this.v8g_1, this.h8g_1, this.i8g_1, this.u8g_1, this.m8g_1, this.k8g_1, this.l8g_1, this.o8g_1, this.n8g_1, this.p8g_1, this.q8g_1, this.r8g_1, this.s8g_1, this.w8g_1);
  }
  toString() {
    return 'AGBatch(frameBuffer=' + this.e8g_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.f8g_1) + ', vertexData=' + this.g8g_1.toString() + ', indices=' + toString_1(this.h8g_1) + ', indexType=' + AGIndexType__toString_impl_hjqwm3(this.i8g_1) + ', program=' + this.j8g_1.toString() + ', uniformBlocks=' + toString(this.k8g_1) + ', textureUnits=' + this.l8g_1.toString() + ', blending=' + AGBlending__toString_impl_d5hic6(this.m8g_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.n8g_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.o8g_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.p8g_1) + ', depthAndFrontFace=' + AGDepthAndFrontFace__toString_impl_c305m3(this.q8g_1) + ', scissor=' + this.r8g_1.toString() + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.s8g_1) + ', drawType=' + AGDrawType__toString_impl_eonaeb(this.t8g_1) + ', drawOffset=' + this.u8g_1 + ', vertexCount=' + this.v8g_1 + ', instances=' + this.w8g_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.e8g_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.f8g_1) | 0;
    result = imul(result, 31) + this.g8g_1.hashCode() | 0;
    result = imul(result, 31) + (this.h8g_1 == null ? 0 : hashCode(this.h8g_1)) | 0;
    result = imul(result, 31) + AGIndexType__hashCode_impl_47f06s(this.i8g_1) | 0;
    result = imul(result, 31) + this.j8g_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.k8g_1) | 0;
    result = imul(result, 31) + this.l8g_1.hashCode() | 0;
    result = imul(result, 31) + AGBlending__hashCode_impl_ywnf51(this.m8g_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.n8g_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.o8g_1) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.p8g_1) | 0;
    result = imul(result, 31) + AGDepthAndFrontFace__hashCode_impl_xu62ey(this.q8g_1) | 0;
    result = imul(result, 31) + this.r8g_1.hashCode() | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.s8g_1) | 0;
    result = imul(result, 31) + AGDrawType__hashCode_impl_ylaury(this.t8g_1) | 0;
    result = imul(result, 31) + this.u8g_1 | 0;
    result = imul(result, 31) + this.v8g_1 | 0;
    result = imul(result, 31) + this.w8g_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGBatch ? other : THROW_CCE();
    if (!equals(this.e8g_1, tmp0_other_with_cast.e8g_1))
      return false;
    if (!equals(this.f8g_1, tmp0_other_with_cast.f8g_1))
      return false;
    if (!this.g8g_1.equals(tmp0_other_with_cast.g8g_1))
      return false;
    if (!equals(this.h8g_1, tmp0_other_with_cast.h8g_1))
      return false;
    if (!(this.i8g_1 === tmp0_other_with_cast.i8g_1))
      return false;
    if (!this.j8g_1.equals(tmp0_other_with_cast.j8g_1))
      return false;
    if (!equals(this.k8g_1, tmp0_other_with_cast.k8g_1))
      return false;
    if (!this.l8g_1.equals(tmp0_other_with_cast.l8g_1))
      return false;
    if (!(this.m8g_1 === tmp0_other_with_cast.m8g_1))
      return false;
    if (!(this.n8g_1 === tmp0_other_with_cast.n8g_1))
      return false;
    if (!equals(this.o8g_1, tmp0_other_with_cast.o8g_1))
      return false;
    if (!(this.p8g_1 === tmp0_other_with_cast.p8g_1))
      return false;
    if (!(this.q8g_1 === tmp0_other_with_cast.q8g_1))
      return false;
    if (!this.r8g_1.equals(tmp0_other_with_cast.r8g_1))
      return false;
    if (!(this.s8g_1 === tmp0_other_with_cast.s8g_1))
      return false;
    if (!(this.t8g_1 === tmp0_other_with_cast.t8g_1))
      return false;
    if (!(this.u8g_1 === tmp0_other_with_cast.u8g_1))
      return false;
    if (!(this.v8g_1 === tmp0_other_with_cast.v8g_1))
      return false;
    if (!(this.w8g_1 === tmp0_other_with_cast.w8g_1))
      return false;
    return true;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_44 = this;
    this.n88_1 = _AGTextureTargetKind___init__impl__4zdmch(0);
    this.o88_1 = _AGTextureTargetKind___init__impl__4zdmch(1);
    this.p88_1 = _AGTextureTargetKind___init__impl__4zdmch(2);
    this.q88_1 = _AGTextureTargetKind___init__impl__4zdmch(3);
  }
}
class AGTextureTargetKind {
  constructor(ordinal) {
    Companion_getInstance_50();
    this.s88_1 = ordinal;
  }
  toString() {
    return AGTextureTargetKind__toString_impl_68648p(this.s88_1);
  }
  hashCode() {
    return AGTextureTargetKind__hashCode_impl_rzc11k(this.s88_1);
  }
  equals(other) {
    return AGTextureTargetKind__equals_impl_q2tams(this.s88_1, other);
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_45 = this;
    this.m89_1 = _AGWrapMode___init__impl__x5wmya(0);
    this.n89_1 = _AGWrapMode___init__impl__x5wmya(1);
    this.o89_1 = _AGWrapMode___init__impl__x5wmya(2);
  }
}
class AGWrapMode {
  constructor(ordinal) {
    Companion_getInstance_51();
    this.x8g_1 = ordinal;
  }
  toString() {
    return AGWrapMode__toString_impl_8bjnw2(this.x8g_1);
  }
  hashCode() {
    return AGWrapMode__hashCode_impl_u2pkox(this.x8g_1);
  }
  equals(other) {
    return AGWrapMode__equals_impl_4aw0kl(this.x8g_1, other);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_46 = this;
    this.v8c_1 = _AGBlendFactor___init__impl__iqtmxr(0);
    this.w8c_1 = _AGBlendFactor___init__impl__iqtmxr(1);
    this.x8c_1 = _AGBlendFactor___init__impl__iqtmxr(2);
    this.y8c_1 = _AGBlendFactor___init__impl__iqtmxr(3);
    this.z8c_1 = _AGBlendFactor___init__impl__iqtmxr(4);
    this.a8d_1 = _AGBlendFactor___init__impl__iqtmxr(5);
    this.b8d_1 = _AGBlendFactor___init__impl__iqtmxr(6);
    this.c8d_1 = _AGBlendFactor___init__impl__iqtmxr(7);
    this.d8d_1 = _AGBlendFactor___init__impl__iqtmxr(8);
    this.e8d_1 = _AGBlendFactor___init__impl__iqtmxr(9);
  }
}
class AGBlendFactor {
  constructor(ordinal) {
    Companion_getInstance_52();
    this.y8g_1 = ordinal;
  }
  toString() {
    return AGBlendFactor__toString_impl_1hr6m1(this.y8g_1);
  }
  hashCode() {
    return AGBlendFactor__hashCode_impl_n8x3ew(this.y8g_1);
  }
  equals(other) {
    return AGBlendFactor__equals_impl_dlauac(this.y8g_1, other);
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_47 = this;
    this.i8d_1 = _AGBlendEquation___init__impl__fpv7c2(0);
    this.j8d_1 = _AGBlendEquation___init__impl__fpv7c2(1);
    this.k8d_1 = _AGBlendEquation___init__impl__fpv7c2(2);
  }
}
class AGBlendEquation {
  constructor(ordinal) {
    Companion_getInstance_53();
    this.z8g_1 = ordinal;
  }
  toString() {
    return AGBlendEquation__toString_impl_5t2sx6(this.z8g_1);
  }
  hashCode() {
    return AGBlendEquation__hashCode_impl_fy33vp(this.z8g_1);
  }
  equals(other) {
    return AGBlendEquation__equals_impl_yykk3b(this.z8g_1, other);
  }
}
class Companion_39 {
  a8h() {
    return _AGSize___init__impl__h9blcq(-2);
  }
  y8d(width, height) {
    return AGSize__with_impl_qn6qww(_AGSize___init__impl__h9blcq(0), width, height);
  }
}
class Companion_40 {
  constructor() {
    Companion_instance_49 = this;
    this.v8e_1 = _AGStencilOp___init__impl__llpkv6(0);
    this.w8e_1 = _AGStencilOp___init__impl__llpkv6(1);
    this.x8e_1 = _AGStencilOp___init__impl__llpkv6(2);
    this.y8e_1 = _AGStencilOp___init__impl__llpkv6(3);
    this.z8e_1 = _AGStencilOp___init__impl__llpkv6(4);
    this.a8f_1 = _AGStencilOp___init__impl__llpkv6(5);
    this.b8f_1 = _AGStencilOp___init__impl__llpkv6(6);
    this.c8f_1 = _AGStencilOp___init__impl__llpkv6(7);
  }
}
class AGStencilOp {
  constructor(ordinal) {
    Companion_getInstance_55();
    this.b8h_1 = ordinal;
  }
  toString() {
    return AGStencilOp__toString_impl_1dm6fq(this.b8h_1);
  }
  hashCode() {
    return AGStencilOp__hashCode_impl_n4s38l(this.b8h_1);
  }
  equals(other) {
    return AGStencilOp__equals_impl_rq4p55(this.b8h_1, other);
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_50 = this;
    this.n8e_1 = _AGCompareMode___init__impl__j8kqbb(0);
    this.o8e_1 = _AGCompareMode___init__impl__j8kqbb(1);
    this.p8e_1 = _AGCompareMode___init__impl__j8kqbb(2);
    this.q8e_1 = _AGCompareMode___init__impl__j8kqbb(3);
    this.r8e_1 = _AGCompareMode___init__impl__j8kqbb(4);
    this.s8e_1 = _AGCompareMode___init__impl__j8kqbb(5);
    this.t8e_1 = _AGCompareMode___init__impl__j8kqbb(6);
    this.u8e_1 = _AGCompareMode___init__impl__j8kqbb(7);
  }
}
class AGCompareMode {
  constructor(ordinal) {
    Companion_getInstance_56();
    this.c8h_1 = ordinal;
  }
  toString() {
    return AGCompareMode__toString_impl_gs33a9(this.c8h_1);
  }
  hashCode() {
    return AGCompareMode__hashCode_impl_whv1w0(this.c8h_1);
  }
  equals(other) {
    return AGCompareMode__equals_impl_rbniy4(this.c8h_1, other);
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_51 = this;
    this.g8f_1 = _AGFrontFace___init__impl__vsm7rb(0);
    this.h8f_1 = _AGFrontFace___init__impl__vsm7rb(1);
    this.i8f_1 = _AGFrontFace___init__impl__vsm7rb(2);
  }
}
class AGMultiBatch {
  constructor(list) {
    this.v85_1 = list;
  }
  w85(ag) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.v85_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.graphics.AGMultiBatch.execute.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.h1(_unary__edvuaz).w85(ag);
    }
  }
  toString() {
    return 'AGMultiBatch(list=' + toString(this.v85_1) + ')';
  }
  hashCode() {
    return hashCode(this.v85_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGMultiBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGMultiBatch ? other : THROW_CCE();
    if (!equals(this.v85_1, tmp0_other_with_cast.v85_1))
      return false;
    return true;
  }
}
class AGConfig {
  constructor(antialiasHint) {
    antialiasHint = antialiasHint === VOID ? true : antialiasHint;
    this.d8h_1 = antialiasHint;
  }
  toString() {
    return 'AGConfig(antialiasHint=' + this.d8h_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.d8h_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this.d8h_1 === tmp0_other_with_cast.d8h_1))
      return false;
    return true;
  }
}
class AGBufferKind extends Enum {}
class AGStats {
  constructor(texturesCount, texturesMemory, buffersCount, buffersMemory, frameBuffersCount, frameBuffersMemory, texturesCreated, texturesDeleted, programCount) {
    texturesCount = texturesCount === VOID ? 0 : texturesCount;
    texturesMemory = texturesMemory === VOID ? Companion_getInstance_9().o2e(0) : texturesMemory;
    buffersCount = buffersCount === VOID ? 0 : buffersCount;
    buffersMemory = buffersMemory === VOID ? Companion_getInstance_9().o2e(0) : buffersMemory;
    frameBuffersCount = frameBuffersCount === VOID ? 0 : frameBuffersCount;
    frameBuffersMemory = frameBuffersMemory === VOID ? Companion_getInstance_9().o2e(0) : frameBuffersMemory;
    texturesCreated = texturesCreated === VOID ? 0 : texturesCreated;
    texturesDeleted = texturesDeleted === VOID ? 0 : texturesDeleted;
    programCount = programCount === VOID ? 0 : programCount;
    this.e8h_1 = texturesCount;
    this.f8h_1 = texturesMemory;
    this.g8h_1 = buffersCount;
    this.h8h_1 = buffersMemory;
    this.i8h_1 = frameBuffersCount;
    this.j8h_1 = frameBuffersMemory;
    this.k8h_1 = texturesCreated;
    this.l8h_1 = texturesDeleted;
    this.m8h_1 = programCount;
  }
  toString() {
    return 'AGStats(textures[' + this.e8h_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.f8h_1) + ', buffers[' + this.g8h_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.h8h_1) + ', frameBuffers[' + this.i8h_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.j8h_1) + ', programs[' + this.m8h_1 + '])';
  }
}
class UniformBlock {
  constructor(fixedLocation) {
    this.n8b_1 = fixedLocation;
    this.o8b_1 = new UBLayoutBuilder();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.p8b_1 = ArrayList.z();
    this.q8b_1 = 0;
  }
  q3() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
  g8i() {
    return this.p8b_1;
  }
  h8i() {
    return this.o8b_1.g1();
  }
  i8i() {
    return nextMultipleOf(this.h8i(), 256);
  }
  j8i() {
    return this.g8i().g1();
  }
  k8i(name) {
    return this.l8i(name, VarType_Mat4_getInstance(), 64, 16);
  }
  t8h(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.k8i(name) : $super.k8i.call(this, name);
  }
  l8i(name, type, size, align) {
    var tmp = this.o8b_1.b8x(size, align);
    var _unary__edvuaz = this.q8b_1;
    this.q8b_1 = _unary__edvuaz + 1 | 0;
    return new Gen(this, name, tmp, _unary__edvuaz, type, 1, size, align);
  }
  toString() {
    return 'UniformBlock[' + get_portableSimpleName(getKClassFromExpression(this)) + '][' + joinToString(this.g8i(), ', ') + ', fixedLocation=' + this.n8b_1 + ']';
  }
}
class ProjViewUB extends UniformBlock {
  constructor() {
    ProjViewUB_instance = null;
    super(0);
    ProjViewUB_instance = this;
    this.r8h_1 = this.t8h().d8i(this, u_ProjMat$factory());
    this.s8h_1 = this.t8h().d8i(this, u_ViewMat$factory());
  }
  e8i() {
    return this.r8h_1.np(this, u_ProjMat$factory_0());
  }
  f8i() {
    return this.s8h_1.np(this, u_ViewMat$factory_0());
  }
}
class DefaultShaders {
  constructor() {
    DefaultShaders_instance = this;
    this.j8f_1 = Sampler_0(1, SamplerVarType_Sampler2D_getInstance()).o8i(this, u_Tex$factory());
    this.k8f_1 = Sampler_0(2, SamplerVarType_Sampler2D_getInstance()).o8i(this, u_TexEx$factory());
    this.l8f_1 = Attribute.f8j('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance(), 0);
    this.m8f_1 = Attribute.f8j('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance(), 1);
    this.n8f_1 = Attribute.f8j('a_Col', VarType_UByte4_getInstance(), true, Precision_LOW_getInstance(), 2);
    this.o8f_1 = Varying.r8j('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    this.p8f_1 = Varying.r8j('v_Col', VarType_Float4_getInstance());
    this.q8f_1 = Temp.d8k(0, VarType_Float4_getInstance());
    this.r8f_1 = Temp.d8k(1, VarType_Float4_getInstance());
    this.s8f_1 = Temp.d8k(2, VarType_Mat2_getInstance());
    this.t8f_1 = ProgramLayout.g8c([this.l8f_1, this.m8f_1, this.n8f_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.graphics.DefaultShaders.VERTEX_DEFAULT.<anonymous>' call
    builder.l8k(builder.h8k(), builder.i8k());
    builder.l8k(builder.m8k(), builder.n8k());
    builder.l8k(builder.o8k(), builder.p8k(builder.p8k(builder.e8i(), builder.f8i()), builder.s8k([builder.q8k(), builder.r8k(0.0), builder.r8k(1.0)])));
    tmp.u8f_1 = VertexShader(builder.t8k());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.g8k();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.DefaultShaders.MERGE_ALPHA_PROGRAM.<anonymous>' call
    var coords = this_0.u8k(this_0.h8k(), 'xy');
    this_0.l8k(this_0.o8k(), this_0.p8k(this_0.w8k(this_0.v8k(), coords), this_0.y8k(this_0.w8k(DefaultShaders_getInstance().x8k(), coords))));
    var tmp$ret$2 = FragmentShader(this_0.t8k());
    tmp_0.v8f_1 = new Program(this.u8f_1, tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_DEBUG.<anonymous>' call
    builder_0.l8k(builder_0.o8k(), builder_0.s8k([builder_0.r8k(1.0), builder_0.r8k(1.0), builder_0.r8k(0.0), builder_0.r8k(1.0)]));
    tmp_1.w8f_1 = FragmentShader(builder_0.t8k());
    var tmp_2 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_1 = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_SOLID_COLOR.<anonymous>' call
    builder_1.l8k(builder_1.o8k(), builder_1.m8k());
    tmp_2.x8f_1 = FragmentShader(builder_1.t8k());
    var tmp_3 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_2 = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE.<anonymous>' call
    builder_2.l8k(builder_2.o8k(), builder_2.p8k(builder_2.u8k(builder_2.w8k(builder_2.v8k(), builder_2.u8k(builder_2.h8k(), 'xy')), 'rgba'), builder_2.m8k()));
    var tmp$ret$5 = FragmentShader(builder_2.t8k());
    tmp_3.y8f_1 = new Program(this.u8f_1, tmp$ret$5, 'PROGRAM_TINTED_TEXTURE');
    var tmp_4 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_3 = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE_PREMULT.<anonymous>' call
    builder_3.l8k(builder_3.z8k(), builder_3.w8k(builder_3.v8k(), builder_3.u8k(builder_3.h8k(), 'xy')));
    builder_3.l8k(builder_3.u8k(builder_3.z8k(), 'rgb'), builder_3.a8l(builder_3.u8k(builder_3.z8k(), 'rgb'), builder_3.u8k(builder_3.z8k(), 'a')));
    builder_3.l8k(builder_3.o8k(), builder_3.p8k(builder_3.u8k(builder_3.z8k(), 'rgba'), builder_3.m8k()));
    var tmp$ret$6 = FragmentShader(builder_3.t8k());
    tmp_4.z8f_1 = new Program(this.u8f_1, tmp$ret$6, 'PROGRAM_TINTED_TEXTURE');
    this.a8g_1 = new Program(this.u8f_1, this.x8f_1, 'PROGRAM_SOLID_COLOR');
    this.b8g_1 = ProgramLayout.g8c([this.l8f_1]);
    var tmp_5 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_4 = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_4.l8k(builder_4.o8k(), builder_4.s8k([builder_4.q8k(), builder_4.r8k(0.0), builder_4.r8k(1.0)]));
    var tmp_6 = VertexShader(builder_4.t8k());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_5 = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_5.l8k(builder_5.o8k(), builder_5.s8k([builder_5.r8k(1.0), builder_5.r8k(0.0), builder_5.r8k(0.0), builder_5.r8k(1.0)]));
    var tmp$ret$8 = FragmentShader(builder_5.t8k());
    tmp_5.c8g_1 = new Program(tmp_6, tmp$ret$8, 'PROGRAM_DEBUG');
    var tmp_7 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_6 = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_6.l8k(builder_6.o8k(), builder_6.p8k(builder_6.p8k(builder_6.e8i(), builder_6.f8i()), builder_6.s8k([builder_6.q8k(), builder_6.r8k(0.0), builder_6.r8k(1.0)])));
    var tmp_8 = VertexShader(builder_6.t8k());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_7 = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_7.l8k(builder_7.o8k(), builder_7.s8k([builder_7.r8k(1.0), builder_7.r8k(0.0), builder_7.r8k(0.0), builder_7.r8k(1.0)]));
    var tmp$ret$10 = FragmentShader(builder_7.t8k());
    tmp_7.d8g_1 = new Program(tmp_8, tmp$ret$10, 'PROGRAM_DEBUG_WITH_PROJ');
  }
  v8k() {
    return this.j8f_1.np(this, u_Tex$factory_0());
  }
  x8k() {
    return this.k8f_1.np(this, u_TexEx$factory_0());
  }
  e8i() {
    return ProjViewUB_getInstance().e8i().m8b_1;
  }
  f8i() {
    return ProjViewUB_getInstance().f8i().m8b_1;
  }
}
class VarTypeAccessor {}
function get_Float1() {
  return VarType_Float1_getInstance();
}
function get_Float2() {
  return VarType_Float2_getInstance();
}
function get_Float4() {
  return VarType_Float4_getInstance();
}
class ExpressionBuilder {}
function get_out() {
  return Output_getInstance();
}
function texture2D(sampler, coord) {
  return Func.m96('texture2D', [sampler, coord], VarType_Float4_getInstance());
}
function TERNARY(cond, otrue, ofalse) {
  return Ternary.y95(cond, otrue, ofalse);
}
function abs(v) {
  return Func.m96('abs', [v], v.p3m());
}
function clamp(v, min, max) {
  return Func.m96('clamp', [v, min, max], v.p3m());
}
function min(a, b) {
  return Func.m96('min', [a, b], a.p3m());
}
function max_0(a, b) {
  return Func.m96('max', [a, b], a.p3m());
}
function fwidth(a) {
  return Func.m96('fwidth', [a], a.p3m());
}
function mix(a, b, step) {
  return Func.m96('mix', [a, b, step], a.p3m());
}
function length(a) {
  return Func.m96('length', [a], VarType_Float1_getInstance());
}
function get_lit(_this__u8e3s4) {
  return FloatLiteral.c96(_this__u8e3s4);
}
function vec4(ops) {
  return Vector.d96(VarType_Float4_getInstance(), ops);
}
function get_1(_this__u8e3s4, swizzle) {
  return Swizzle.e96(_this__u8e3s4, swizzle);
}
function get_x(_this__u8e3s4) {
  return this.u8k(_this__u8e3s4, 'x');
}
function get_y(_this__u8e3s4) {
  return this.u8k(_this__u8e3s4, 'y');
}
function get_a(_this__u8e3s4) {
  return this.u8k(_this__u8e3s4, 'w');
}
function unaryMinus(_this__u8e3s4) {
  return Unop.a96('-', _this__u8e3s4);
}
function minus_0(_this__u8e3s4, that) {
  return Binop.b96(_this__u8e3s4, '-', that);
}
function plus_2(_this__u8e3s4, that) {
  return Binop.b96(_this__u8e3s4, '+', that);
}
function times(_this__u8e3s4, that) {
  return Binop.b96(_this__u8e3s4, '*', that);
}
function div(_this__u8e3s4, that) {
  return Binop.b96(_this__u8e3s4, '/', that);
}
function eq(_this__u8e3s4, that) {
  return Binop.b96(_this__u8e3s4, '==', that);
}
function le(_this__u8e3s4, that) {
  return Binop.b96(_this__u8e3s4, '<=', that);
}
function gt(_this__u8e3s4, that) {
  return Binop.b96(_this__u8e3s4, '>', that);
}
function minus_1(_this__u8e3s4, that) {
  return this.y8l(this.r8k(_this__u8e3s4), that);
}
function plus_3(_this__u8e3s4, that) {
  return this.z8l(this.r8k(_this__u8e3s4), that);
}
function times_0(_this__u8e3s4, that) {
  return this.p8k(this.r8k(_this__u8e3s4), that);
}
function plus_4(_this__u8e3s4, that) {
  return this.z8l(_this__u8e3s4, this.r8k(that));
}
function gt_0(_this__u8e3s4, that) {
  return this.c8m(_this__u8e3s4, this.r8k(that));
}
class Builder {
  static b8l(context) {
    context = context === VOID ? new BuilderContext() : context;
    var $this = createThis(this);
    $this.j8k_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.k8k_1 = ArrayList.z();
    return $this;
  }
  static t94(parent) {
    return this.b8l(parent.j8k_1);
  }
  c8l() {
    return Builder.t94(this);
  }
  d8l() {
    return FuncBuilder.s94(this);
  }
  e8l() {
    return new Stms(toList(this.k8k_1));
  }
  f8l() {
    var funcs = LinkedHashMap.wc();
    (new Program$Builder$_funcs$1(funcs)).x95(this.k8k_1);
    var _iterator__ex2g4s = this.j8k_1.p96_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var func = _iterator__ex2g4s.d1();
      // Inline function 'kotlin.collections.set' call
      var key = func.y91_1;
      funcs.k3(key, func);
    }
    return toList(funcs.n3());
  }
  t8k() {
    return to(this.e8l(), this.f8l());
  }
  g8l(name, rettype, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.d8l();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var funcBuild = this_0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = funcBuild.q94_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
      var tmp$ret$1 = to(item.d8p_1, item.p3m());
      destination.h(tmp$ret$1);
    }
    var this_2 = new FuncDecl(name, rettype, destination, funcBuild.e8l());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.j8k_1.p96_1.h(this_2);
    return this_2;
  }
  h8l(p0, dummy, returns, block) {
    var tmp = listOf(p0);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda(block));
  }
  i8l(p0, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.h8l(p0, dummy, returns, block);
    } else {
      var tmp_0 = $super.h8l;
      tmp = tmp_0.call(this, p0, Unit_instance, returns, block);
    }
    return tmp;
  }
  j8l(p0, p1, dummy, returns, block) {
    var tmp = listOf_0([p0, p1]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_0(block));
  }
  k8l(p0, p1, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.j8l(p0, p1, dummy, returns, block);
    } else {
      var tmp_0 = $super.j8l;
      tmp = tmp_0.call(this, p0, p1, Unit_instance, returns, block);
    }
    return tmp;
  }
  l8l(p0, p1, p2, dummy, returns, block) {
    var tmp = listOf_0([p0, p1, p2]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_1(block));
  }
  m8l(p0, p1, p2, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.l8l(p0, p1, p2, dummy, returns, block);
    } else {
      var tmp_0 = $super.l8l;
      tmp = tmp_0.call(this, p0, p1, p2, Unit_instance, returns, block);
    }
    return tmp;
  }
  n8l(type) {
    var _receiver__tnumb7 = this.j8k_1;
    var _unary__edvuaz = _receiver__tnumb7.q96_1;
    _receiver__tnumb7.q96_1 = _unary__edvuaz + 1 | 0;
    return Temp.d8k(_unary__edvuaz, type);
  }
  g95(initialValue) {
    var temp = this.n8l(initialValue.p3m());
    this.l8k(temp, initialValue);
    return temp;
  }
  o8l(_this__u8e3s4, p0) {
    return CustomFunc.n96(_this__u8e3s4, listOf(p0));
  }
  p8l(_this__u8e3s4, p0, p1, p2) {
    return CustomFunc.n96(_this__u8e3s4, listOf_0([p0, p1, p2]));
  }
  q8l(_this__u8e3s4, callback) {
    var body = this.c8l();
    callback(body);
    _this__u8e3s4.l93_1 = body.e8l();
  }
  r8l(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else if ((max - min | 0) <= 1) {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.a8m(ref, this.r8k(min));
      var body = this.c8l();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.e8l());
      // Inline function 'kotlin.collections.plusAssign' call
      this.k8k_1.h(stmIf);
      var tmp = stmIf;
      this.q8l(tmp, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda(block, max));
    } else {
      var middle = (min + max | 0) / 2 | 0;
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond_0 = this.b8m(ref, this.r8k(middle));
      var body_0 = this.c8l();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      body_0.r8l(ref, min, middle, block);
      var stmIf_0 = new If(cond_0, body_0.e8l());
      // Inline function 'kotlin.collections.plusAssign' call
      this.k8k_1.h(stmIf_0);
      var tmp_0 = stmIf_0;
      this.q8l(tmp_0, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0(ref, middle, max, block));
    }
  }
  l8k(target, expr) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.k8k_1;
    var element = new Set(target, expr);
    this_0.h(element);
  }
  s8l() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.k8k_1;
    var element = Discard_getInstance();
    this_0.h(element);
  }
  t8l(operand) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.k8k_1;
    var element = new Return(operand);
    this_0.h(element);
  }
}
class IDefaultShaders {}
function get_u_Tex() {
  return DefaultShaders_getInstance().v8k();
}
function get_u_ProjMat() {
  return DefaultShaders_getInstance().e8i();
}
function get_u_ViewMat() {
  return DefaultShaders_getInstance().f8i();
}
function get_a_Pos() {
  return DefaultShaders_getInstance().l8f_1;
}
function get_a_Tex() {
  return DefaultShaders_getInstance().m8f_1;
}
function get_a_Col() {
  return DefaultShaders_getInstance().n8f_1;
}
function get_v_Tex() {
  return DefaultShaders_getInstance().o8f_1;
}
function get_v_Col() {
  return DefaultShaders_getInstance().p8f_1;
}
function get_t_Temp0() {
  return DefaultShaders_getInstance().q8f_1;
}
class ProgramBuilderDefault extends Builder {
  static g8k() {
    return this.b8l();
  }
}
class GLVAO {
  constructor(vao, glId, contextVersion) {
    glId = glId === VOID ? -1 : glId;
    contextVersion = contextVersion === VOID ? -1 : contextVersion;
    this.d8m_1 = vao;
    this.e8m_1 = glId;
    this.f8m_1 = contextVersion;
  }
}
class ShaderException extends RuntimeException {
  static q8m(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    var $this = this.bb('Error Compiling Shader : ' + debugName + ' type=' + type + ' : ' + get_hex(errorInt) + " : '" + error + "' : source='" + str + "', shaderReturnInt=" + shaderReturnInt + ', gl.versionInt=' + get_versionInt(gl) + ", gl.versionString='" + get_versionString(gl) + "', gl=" + toString(gl));
    captureStack($this, $this.p8m_1);
    $this.i8m_1 = str;
    $this.j8m_1 = error;
    $this.k8m_1 = errorInt;
    $this.l8m_1 = gl;
    $this.m8m_1 = debugName;
    $this.n8m_1 = type;
    $this.o8m_1 = shaderReturnInt;
    return $this;
  }
}
class TextureUnitParams {
  constructor(index) {
    this.r8p_1 = index;
    this.s8p_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.t8p_1 = -1;
    this.u8p_1 = -1;
    this.v8p_1 = -1;
    this.w8p_1 = -1;
  }
  u1w() {
    this.s8p_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.t8p_1 = -1;
    this.u8p_1 = -1;
    this.v8p_1 = -1;
    this.w8p_1 = -1;
  }
}
class AGOpengl extends AG {
  static f8s(gl, context) {
    context = context === VOID ? null : context;
    var $this = this.g83();
    $this.v8m_1 = gl;
    $this.w8m_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.linkedSetOf' call
    tmp.x8m_1 = LinkedHashSet.r1();
    $this.y8m_1 = new GLGlobalState($this.v8m_1, $this);
    $this.z8m_1 = HashMap.a9();
    $this.a8n_1 = null;
    var tmp_0 = $this;
    tmp_0.b8n_1 = lazy(AGOpengl$glslConfig$delegate$lambda($this));
    $this.c8n_1 = null;
    $this.d8n_1 = Companion_getInstance_42().j84_1;
    $this.e8n_1 = Companion_getInstance_49().i85_1;
    $this.f8n_1 = Companion_getInstance_46().u84_1;
    $this.g8n_1 = Companion_getInstance_45().s84_1;
    $this.h8n_1 = Companion_getInstance_47().w84_1;
    $this.i8n_1 = Companion_getInstance_48().c85_1;
    $this.j8n_1 = null;
    $this.k8n_1 = AGTextureUnits.n86();
    $this.l8n_1 = new Int32Array($this.k8n_1.g1());
    $this.m8n_1 = 0;
    $this.n8n_1 = Companion_getInstance_43().g85_1;
    $this.o8n_1 = -1;
    $this.p8n_1 = -1;
    $this.q8n_1 = get_ENABLE_VERTEX_ARRAY_OBJECTS();
    $this.r8n_1 = Ref();
    $this.s8n_1 = Buffer.o2c(36);
    var tmp_1 = $this;
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(32), null);
    while (tmp_2 < 32) {
      var tmp_4 = tmp_2;
      tmp_3[tmp_4] = new TextureUnitParams(tmp_4);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.t8n_1 = tmp_3;
    $this.u8n_1 = allocDirect(Companion_instance_4, 0);
    $this.v8n_1 = 7;
    $this.w8n_1 = 0;
    $this.x8n_1 = Companion_instance_48.a8h();
    $this.y8n_1 = -1;
    $this.z8n_1 = new Long(-1, -1);
    $this.a8o_1 = null;
    return $this;
  }
  static g8s(context) {
    return this.f8s(context.i8s_1, context);
  }
  c84() {
    return this.v8m_1;
  }
  w83() {
    var gl = this.v8m_1;
    super.w83();
    gl.k8s();
    gl.l8s();
    this.z8m_1.h3();
    resetObjects(this);
    this.o8n_1 = -1;
    this.p8n_1 = -1;
    this.q8n_1 = true;
  }
  a84(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    var gl = this.v8m_1;
    this.m8s(frameBuffer, frameBufferInfo);
    this.n8s(scissor, frameBuffer, frameBufferInfo);
    var mask = 0;
    if (clearColor) {
      this.o8s(Companion_getInstance_47().z84_1);
      gl.p8s(_RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
      mask = mask | 16384;
    }
    if (clearDepth) {
      gl.q8s(true);
      gl.r8s(depth);
      mask = mask | 256;
    }
    if (clearStencil) {
      this.f8n_1 = Companion_getInstance_46().u84_1;
      gl.s8s(-1);
      gl.t8s(stencil);
      mask = mask | 1024;
    }
    gl.q1s(mask);
  }
  b84(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    var gl = this.v8m_1;
    this.m8s(frameBuffer, frameBufferInfo);
    this.n8s(scissor, frameBuffer, frameBufferInfo);
    var tmp1_safe_receiver = this.c8n_1;
    if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u8b_1, vertexData.u8b_1)) {
      var tmp0_safe_receiver = this.c8n_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.u8s(tmp0_safe_receiver);
      }
      this.c8n_1 = vertexData;
      this.v8s(vertexData);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vertexData.u8b_1.s28_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.i8c_1, AGBufferKind_VERTEX_getInstance(), true);
      }
    }
    useProgram(this, program);
    this.w8s(uniformBlocks, textureUnits, program, frameBuffer);
    if (!(this.d8n_1 === blending)) {
      this.d8n_1 = blending;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = _AGBlending___get_enabled__impl__s7igz6(blending);
      if (gl.z8s(3042, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        gl.x8s(toGl(_AGBlending___get_eqRGB__impl__7pv8oi(blending)), toGl(_AGBlending___get_eqA__impl__2j4ray(blending)));
        gl.y8s(toGl_0(_AGBlending___get_srcRGB__impl__jvh03e(blending)), toGl_0(_AGBlending___get_dstRGB__impl__nz9ogp(blending)), toGl_0(_AGBlending___get_srcA__impl__ftmwxe(blending)), toGl_0(_AGBlending___get_dstA__impl__l7q6tv(blending)));
      }
    }
    this.a8t(depthAndFrontFace);
    this.o8s(colorMask);
    if (!(this.e8n_1 === cullFace)) {
      this.e8n_1 = cullFace;
      this.b8t(cullFace);
    }
    if (!(this.f8n_1 === stencilOpFunc) || !equals(this.g8n_1, stencilRef)) {
      this.f8n_1 = stencilOpFunc;
      this.g8n_1 = stencilRef;
      if (_AGStencilOpFunc___get_enabled__impl__hxq8wy(stencilOpFunc)) {
        gl.d8t(2960);
        if (_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc) === _AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc) && _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef) === _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef) && _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef) === _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef)) {
          gl.f8t(toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
        } else {
          gl.e8t(1028, toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
          gl.e8t(1029, toGl_1(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc)), _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef), _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef));
        }
        if (_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc) && _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc) && _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc) === _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)) {
          gl.h8t(toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
        } else {
          gl.g8t(1028, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
          gl.g8t(1029, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)));
        }
        if (_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef) === _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef)) {
          gl.s8s(_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
        } else {
          gl.i8t(1028, _AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
          gl.i8t(1029, _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef));
        }
      } else {
        gl.c8t(2960);
        gl.s8s(0);
      }
    }
    if (indices == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
      bindBuffer$default(this, indices, AGBufferKind_INDEX_getInstance());
    }
    var indexType_0 = !(indices == null) ? indexType : Companion_getInstance_41().f84_1;
    if (!(indexType_0 === Companion_getInstance_41().f84_1))
      if (!(instances === 1)) {
        gl.m8t(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset, instances);
      } else {
        gl.l8t(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset);
      }
     else if (!(instances === 1)) {
      gl.k8t(toGl_3(drawType), drawOffset, vertexCount, instances);
    } else {
      gl.j8t(toGl_3(drawType), drawOffset, vertexCount);
    }
  }
  g8o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b8n_1;
    glslConfig$factory();
    return this_0.w1();
  }
  z83() {
    var gl = this.v8m_1;
    var tmp0_safe_receiver = this.w8m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.n8t();
    }
    gl.o8t(this.e83_1);
    resetObjects(this);
    this.m8n_1 = getIntegerv(gl, 36006);
    gl.q8r(33984);
    if (_GLVariant___get_supportTextureLevel__impl__3yeu62(gl.r8r())) {
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.p8r(3553, 33084, 0);
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.p8r(3553, 33085, 0);
    }
  }
  t7z() {
    var tmp0_safe_receiver = this.c8n_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.u8s(tmp0_safe_receiver);
    }
    this.c8n_1 = null;
    this.m8s(this.v83().h83_1, this.v83().n85());
    var tmp1_safe_receiver = this.w8m_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p8t();
    }
  }
  x83() {
    var tmp0_safe_receiver = this.c8n_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.u8s(tmp0_safe_receiver);
    }
    this.c8n_1 = null;
    this.v8m_1.gd();
    deletePendingObjects(this);
  }
  b8t(face) {
    if (this.v8m_1.z8s(2884, _AGCullFace___get_ordinal__impl__jd1wps(face) > _AGCullFace___get_ordinal__impl__jd1wps(Companion_getInstance_49().j85_1))) {
      this.v8m_1.q8t(toGl_5(face));
    }
  }
  q8q(_this__u8e3s4, block) {
    if (!(_this__u8e3s4.e86_1 === _this__u8e3s4.f86_1)) {
      _this__u8e3s4.e86_1 = _this__u8e3s4.f86_1;
      block(_this__u8e3s4);
    }
  }
  u8s(vao) {
    if (this.q8n_1 && this.v8m_1.e84()) {
      this.v8m_1.t8t(0);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.u8b_1.s28_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        // Inline function 'korlibs.graphics.shader.attributes' call
        var this_0 = array[_unary__edvuaz].h8c_1.y8b_1;
        var n_0 = 0;
        while (n_0 < this_0.g1()) {
          // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>.<anonymous>' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          var att = this_0.h1(_unary__edvuaz_0);
          if (att.c8j_1) {
            var loc = att.e8j_1;
            if (loc >= 0) {
              if (!(att.d8j_1 === 0)) {
                this.v8m_1.r8t(loc, 0);
              }
              this.v8m_1.s8t(loc);
            }
          }
        }
      }
    }
  }
  v8s(vao) {
    var gl = this.v8m_1;
    if (this.q8n_1 && gl.e84()) {
      var vaoGl = get_gl(vao);
      if (vao.v8b_1) {
        if (!(this.p8n_1 === this.e83_1)) {
          this.o8n_1 = genVertexArray(gl);
          this.p8n_1 = this.e83_1;
          if (this.o8n_1 <= 0)
            this.q8n_1 = false;
        }
        gl.t8t(this.o8n_1);
        this.u8t(vao);
      } else {
        if (!(vaoGl.f8m_1 === this.e83_1)) {
          vaoGl.f8m_1 = this.e83_1;
          vaoGl.e8m_1 = genVertexArray(gl);
          if (vaoGl.e8m_1 <= 0)
            this.q8n_1 = false;
          gl.t8t(vaoGl.e8m_1);
          this.u8t(vao);
        }
        gl.t8t(vaoGl.e8m_1);
        this.v8t(vao, this.q8n_1);
      }
    } else {
      this.u8t(vao);
    }
  }
  v8t(vao, updateBuffersOnly) {
    var gl = this.v8m_1;
    if (updateBuffersOnly) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.u8b_1.s28_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.i8c_1, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.r8n_1);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = vao.u8b_1.s28_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry_0 = array_0[_unary__edvuaz_0];
      var vertices = entry_0.i8c_1;
      var vertexLayout = entry_0.h8c_1;
      // Inline function 'korlibs.graphics.shader.attributes' call
      var vattrs = vertexLayout.y8b_1;
      // Inline function 'korlibs.graphics.shader.attributePositions' call
      var vattrspos = vertexLayout.d8c_1;
      bindBuffer$default(this, vertices, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.r8n_1);
      var totalSize = vertexLayout.f8c_1;
      var inductionVariable = 0;
      var last = vattrspos.g1() - 1 | 0;
      if (inductionVariable <= last)
        $l$loop: do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var att = vattrs.h1(n_1);
          if (!att.c8j_1)
            continue $l$loop;
          var off = vattrspos.h1(n_1);
          var loc = att.e8j_1;
          var glElementType = toGl_7(att.p3m());
          var elementCount = att.p3m().b8r_1;
          if (loc >= 0) {
            gl.w8t(loc);
            gl.x8t(loc, elementCount, glElementType, att.b8j_1, totalSize, numberToLong(entry_0.j8c_1).w3(toLong(off)));
            if (!(att.d8j_1 === 0)) {
              gl.r8t(loc, att.d8j_1);
            }
          }
        }
         while (inductionVariable <= last);
    }
  }
  u8t(vao, updateBuffersOnly, $super) {
    updateBuffersOnly = updateBuffersOnly === VOID ? false : updateBuffersOnly;
    var tmp;
    if ($super === VOID) {
      this.v8t(vao, updateBuffersOnly);
      tmp = Unit_instance;
    } else {
      tmp = $super.v8t.call(this, vao, updateBuffersOnly);
    }
    return tmp;
  }
  w8s(uniformBlocks, textureUnits, program, frameBuffer) {
    var tmp0_elvis_lhs = this.j8n_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var glProgram = tmp;
    // Inline function 'korlibs.graphics.AGTextureUnits.fastForEach' call
    var inductionVariable = 0;
    var last = textureUnits.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
        var tex = textureUnits.l86_1[n];
        var info = AGTextureUnitInfoArray__get_impl_xhvpef(textureUnits.m86_1, n);
        var tex_0 = tex;
        if (equals(frameBuffer.p87_1, tex_0)) {
          tex_0 = null;
        }
        var tmp0_safe_receiver = tex_0;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f86_1;
        var texVersion = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        if (!(this.k8n_1.l86_1[n] === tex_0) || !(AGTextureUnitInfoArray__get_impl_xhvpef(this.k8n_1.m86_1, n) === info) || !(this.l8n_1[n] === texVersion)) {
          this.k8n_1.p86(n, tex_0, info);
          this.l8n_1[n] = texVersion;
          selectTextureUnit(this, n);
          if (!(tex_0 == null)) {
            var wrap = _AGTextureUnitInfo___get_wrap__impl__dwp6l(info);
            var linear = _AGTextureUnitInfo___get_linear__impl__jak6ny(info);
            var trilinear = _AGTextureUnitInfo___get_trilinear__impl__hxtqfb(info);
            this.y8t(tex_0, _AGTextureUnitInfo___get_kind__impl__6xtjoz(info));
            textureUnitParameters(this, tex_0.r88(), wrap, this.z8t(tex_0, linear, trilinear), this.a8u(tex_0, linear, trilinear), _AGTextureTargetKind___get_dims__impl__k3cmhd(tex_0.r88()));
          } else {
            this.y8t(null, Companion_getInstance_50().n88_1);
          }
        }
      }
       while (inductionVariable < last);
    var glProgramInfo = glProgram.l8o_1;
    // Inline function 'korlibs.graphics.shader.UniformBlocksBuffersRef.fastForEachBlock' call
    var inductionVariable_0 = 0;
    var last_0 = uniformBlocks.g1();
    if (inductionVariable_0 < last_0)
      $l$loop: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp0_elvis_lhs_0 = uniformBlocks.b8u_1[n_0];
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var block = tmp_0;
        $l$block: {
          // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
          var buffer = uniformBlocks.c8u_1[n_0];
          var valueIndex = uniformBlocks.d8u_1[n_0];
          if (glProgram.l8o_1.r8o_1.q8p()) {
            var buffer_0 = bindBuffer$default(this, buffer, AGBufferKind_UNIFORM_getInstance());
            var tmp1_elvis_lhs_0 = buffer_0 == null ? null : buffer_0.n8q_1;
            this.v8m_1.e8u(35345, block.t89_1.n8b_1, tmp1_elvis_lhs_0 == null ? -1 : tmp1_elvis_lhs_0, imul(valueIndex, block.w89_1), block.w89_1);
            break $l$block;
          }
          var tmp2_elvis_lhs = glProgramInfo.u8o_1[block.t89_1.n8b_1];
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            var message = "Can't find uniform at " + block.t89_1.n8b_1 + ' for program ' + program.toString() + ' for block ' + block.toString();
            throw IllegalStateException.h5(toString(message));
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var ref = tmp_1;
          var bufferMem = ensureNotNull(ensureNotNull(buffer).b86_1);
          var currentMem = ref.g8u_1;
          var ublock = ref.f8u_1;
          if (valueIndex >= 0) {
            if (!arrayequal(bufferMem, valueIndex, currentMem, 0, ublock.i8i())) {
              arraycopy_0(bufferMem, imul(ublock.i8i(), valueIndex), currentMem, 0, ublock.i8i());
              // Inline function 'korlibs.datastructure.iterators.fastForEach' call
              var this_0 = ublock.g8i();
              var n_1 = 0;
              while (n_1 < this_0.g1()) {
                // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>.<anonymous>' call
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var uniform = this_0.h1(_unary__edvuaz);
                writeUniform(this, uniform.m8b_1, glProgramInfo, sliceBuffer(currentMem, uniform.j8b_1, uniform.j8b_1 + uniform.x8q_1 | 0), 'blockUniformSet');
              }
            }
          } else {
            println('ERROR block: ' + block.t89_1.toString() + ' has an invalid valueIndex=' + valueIndex);
          }
        }
      }
       while (inductionVariable_0 < last_0);
  }
  z8t(_this__u8e3s4, linear, trilinear) {
    var tmp;
    if ((_this__u8e3s4 == null ? null : _this__u8e3s4.h88_1) === true) {
      tmp = linear ? trilinear ? 9987 : 9985 : trilinear ? 9986 : 9984;
    } else {
      tmp = linear ? 9729 : 9728;
    }
    return tmp;
  }
  a8u(_this__u8e3s4, linear, trilinear) {
    return linear ? 9729 : 9728;
  }
  j8u(scissor, frameBuffer, frameBufferInfo) {
    return scissor.equals(Companion_getInstance_43().h85_1) || scissor.equals(Companion_getInstance_43().f85_1) ? scissor : frameBuffer.o87_1 ? Companion_getInstance_43().p3q(scissor.i3j(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.c3q() | 0, scissor.j3j(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.d3q() | 0) : scissor;
  }
  y8t(tex, target) {
    var gl = this.v8m_1;
    var glTex = tex == null ? null : _get_gl__ndc1ty_1(tex, this);
    var tmp = toGl_8(target);
    var tmp2_elvis_lhs = glTex == null ? null : glTex.b8s_1;
    gl.k8u(tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var texBitmap = tex == null ? null : tex.g88_1;
    if (!(glTex == null) && !(texBitmap == null)) {
      if (!(glTex.c8s_1 === texBitmap.a57_1) || !(glTex.d8s_1 === this.e83_1)) {
        glTex.c8s_1 = texBitmap.a57_1;
        glTex.d8s_1 = this.e83_1;
        tex.k86();
      }
      this.q8q(tex, AGOpengl$textureBind$lambda(tex, target, gl, this, glTex));
    }
  }
  m8s(frameBuffer, info) {
    var gl = this.v8m_1;
    if (!(this.x8n_1 === _AGFrameBufferInfo___get_size__impl__uw80y4(info))) {
      gl.l8u(_AGFrameBufferInfo___get_x__impl__6dzfjj(info), _AGFrameBufferInfo___get_y__impl__mfn1io(info), _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
    }
    if (frameBuffer.o87_1) {
      if (!(this.y8n_1 === this.m8n_1)) {
        this.y8n_1 = this.m8n_1;
        gl.m8u(36160, this.m8n_1);
      }
      return Unit_instance;
    }
    var fb = _get_gl__ndc1ty_0(frameBuffer, this);
    var tex = fb.p8u_1.p87_1;
    var doMsaa = false;
    if (!equals(fb.s8u_1, info)) {
      fb.s8u_1 = info;
      var internalFormat = _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 34041 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36168 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 6402 : 0;
      var texTarget = doMsaa ? 37120 : 3553;
      tex.g88_1 = NullBitmap.r5n(_AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info), false);
      // Inline function 'korlibs.graphics.gl.AGOpengl.selectTextureUnitTemp' call
      var index = this.v8n_1;
      var old = selectTextureUnit(this, index);
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.bindFrameBuffer.<anonymous>' call
        this.y8t(tex, Companion_getInstance_50().n88_1);
        textureUnitParameters(this, Companion_getInstance_50().n88_1, Companion_getInstance_51().m89_1, 9729, 9729, 2);
      }finally {
        if (true) {
          this.y8t(null, Companion_getInstance_50().n88_1);
        }
        selectTextureUnit(this, old);
      }
      gl.t8u(36161, fb.q8u_1);
      if (!(internalFormat === 0)) {
        gl.u8u(36161, internalFormat, _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
      }
      gl.t8u(36161, 0);
      gl.m8u(36160, fb.r8u_1);
      gl.v8u(36160, 36064, 3553, _get_gl__ndc1ty_1(fb.p8u_1.p87_1, this).b8s_1, 0);
      if (!(internalFormat === 0)) {
        gl.w8u(36160, _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 33306 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36128 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 36096 : 0, 36161, fb.q8u_1);
      } else {
        gl.w8u(36160, 36128, 36161, 0);
        gl.w8u(36160, 36096, 36161, 0);
      }
    }
    if (!(this.y8n_1 === fb.r8u_1)) {
      this.y8n_1 = fb.r8u_1;
      gl.m8u(36160, fb.r8u_1);
    }
  }
  a8t(renderState) {
    var gl = this.v8m_1;
    if (!(this.i8n_1 === renderState)) {
      this.i8n_1 = renderState;
      gl.x8u(toGl_10(_AGDepthAndFrontFace___get_frontFace__impl__w07k4s(renderState)));
      gl.q8s(_AGDepthAndFrontFace___get_depthMask__impl__ouijn(renderState));
      gl.y8u(_AGDepthAndFrontFace___get_depthNear__impl__cir3a1(renderState), _AGDepthAndFrontFace___get_depthFar__impl__g0cno8(renderState));
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState) === Companion_getInstance_56().n8e_1);
      if (gl.z8s(2929, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setDepthAndFrontFace.<anonymous>' call
        gl.z8u(toGl_1(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState)));
      }
    }
  }
  o8s(colorMask) {
    var gl = this.v8m_1;
    if (!(this.h8n_1 === colorMask)) {
      this.h8n_1 = colorMask;
      gl.a8v(_AGColorMask___get_red__impl__opo1fo(colorMask), _AGColorMask___get_green__impl__d3m1w2(colorMask), _AGColorMask___get_blue__impl__42l0s1(colorMask), _AGColorMask___get_alpha__impl__xmrqzb(colorMask));
    }
  }
  n8s(scissor, frameBuffer, frameBufferInfo) {
    var gl = this.v8m_1;
    var scissor_0 = this.j8u(scissor, frameBuffer, frameBufferInfo);
    if (!this.n8n_1.equals(scissor_0)) {
      this.n8n_1 = scissor_0;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !scissor_0.equals(Companion_getInstance_43().h85_1);
      if (gl.z8s(3089, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setScissorState.<anonymous>' call
        gl.b8v(scissor_0.b6h(), scissor_0.c6h(), scissor_0.f3u(), scissor_0.g3u());
      }
    }
  }
}
class GLGlobalState {
  constructor(gl, ag) {
    this.x8p_1 = gl;
    this.y8p_1 = ag;
    this.z8p_1 = atomic$int$1(0);
    this.a8q_1 = atomic$int$1(0);
    this.b8q_1 = atomic$ref$1(0.0);
    this.c8q_1 = atomic$int$1(0);
    this.d8q_1 = atomic$int$1(0);
    this.e8q_1 = atomic$ref$1(0.0);
    this.f8q_1 = new Lock();
    this.g8q_1 = fastArrayListOf([]);
  }
}
class GLBaseObject {
  constructor(globalState) {
    this.h8q_1 = globalState;
    this.i8q_1 = this.h8q_1.x8p_1;
  }
  j8q() {
  }
  k89() {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.h8q_1.f8q_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.c36();
      try {
        this.h8q_1.g8q_1.h(this);
        break $l$block;
      }finally {
        this_0.e36();
      }
    }
  }
}
class GLBaseProgram extends GLBaseObject {
  constructor(globalState, programInfo) {
    super(globalState);
    this.l8o_1 = programInfo;
  }
  j8q() {
    this.l8o_1.c8v(this.i8q_1);
  }
  m8o() {
    this.l8o_1.d8v(this.i8q_1);
  }
}
class GLBuffer extends GLBaseObject {
  constructor(state) {
    super(state);
    this.n8q_1 = genBuffer(this.i8q_1);
    this.o8q_1 = -1;
    this.p8q_1 = 0.0;
    this.h8q_1.c8q_1.atomicfu$incrementAndGet();
  }
  s8r(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.h8q_1.e8q_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLBuffer.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.p8q_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.p8q_1 = value;
  }
  j8q() {
    this.h8q_1.d8q_1.atomicfu$incrementAndGet();
    deleteBuffer(this.i8q_1, this.n8q_1);
    this.n8q_1 = -1;
    this.o8q_1 = -1;
  }
  toString() {
    return 'GLBuffer(' + this.n8q_1 + ')';
  }
}
class GLTexture extends GLBaseObject {
  constructor(state) {
    super(state);
    this.b8s_1 = genTexture(this.i8q_1);
    this.c8s_1 = -2;
    this.d8s_1 = -2;
    this.e8s_1 = 0.0;
    this.h8q_1.z8p_1.atomicfu$incrementAndGet();
  }
  s8r(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.h8q_1.b8q_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLTexture.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.e8s_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.e8s_1 = value;
  }
  j8q() {
    this.h8q_1.a8q_1.atomicfu$incrementAndGet();
    deleteTexture(this.i8q_1, this.b8s_1);
    this.b8s_1 = -1;
  }
}
class GLFrameBuffer extends GLBaseObject {
  constructor(state, ag) {
    super(state);
    this.p8u_1 = ag;
    this.q8u_1 = genRenderbuffer(this.i8q_1);
    this.r8u_1 = genFramebuffer(this.i8q_1);
    this.s8u_1 = Companion_getInstance_44().a8e_1;
  }
  j8q() {
    deleteRenderbuffer(this.i8q_1, this.q8u_1);
    deleteFramebuffer(this.i8q_1, this.r8u_1);
    this.q8u_1 = -1;
    this.r8u_1 = -1;
  }
}
class GLProgramInfo {
  constructor(programId, vertexId, fragmentId, blocks, config) {
    this.n8o_1 = programId;
    this.o8o_1 = vertexId;
    this.p8o_1 = fragmentId;
    this.q8o_1 = blocks;
    this.r8o_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.q8o_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.blocksByFixedLocation.<anonymous>' call
      var tmp$ret$0 = element.n8b_1;
      destination.k3(tmp$ret$0, element);
    }
    tmp.s8o_1 = destination;
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.q8o_1.b1();
      if (!iterator.c1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
      var maxValue = iterator.d1().n8b_1;
      while (iterator.c1()) {
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
        var v = iterator.d1().n8b_1;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.t8o_1 = (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) + 1 | 0;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.t8o_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp0_safe_receiver = this.s8o_1.e3(tmp_5);
      var tmp_6;
      if (tmp0_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.uniforms.<anonymous>' call
        tmp_6 = UniformsRef.e8v(tmp0_safe_receiver);
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.u8o_1 = tmp_4;
    this.v8o_1 = FastStringMap();
    this.w8o_1 = FastStringMap();
  }
  i8p(gl, name) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.w8o_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(name);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.getUniformLocation.<anonymous>' call
      var out = gl.f8v(this.n8o_1, name);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(name, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  d8v(gl) {
    gl.g8v(this.n8o_1);
  }
  c8v(gl) {
    if (!(this.o8o_1 === 0)) {
      gl.h8v(this.o8o_1);
    }
    if (!(this.p8o_1 === 0)) {
      gl.h8v(this.p8o_1);
    }
    if (!(this.n8o_1 === 0)) {
      gl.i8v(this.n8o_1);
    }
    this.o8o_1 = 0;
    this.p8o_1 = 0;
    this.n8o_1 = 0;
  }
  toString() {
    return 'GLProgramInfo(programId=' + this.n8o_1 + ', vertexId=' + this.o8o_1 + ', fragmentId=' + this.p8o_1 + ', blocks=' + toString(this.q8o_1) + ', config=' + this.r8o_1.toString() + ')';
  }
  hashCode() {
    var result = this.n8o_1;
    result = imul(result, 31) + this.o8o_1 | 0;
    result = imul(result, 31) + this.p8o_1 | 0;
    result = imul(result, 31) + hashCode(this.q8o_1) | 0;
    result = imul(result, 31) + this.r8o_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GLProgramInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GLProgramInfo ? other : THROW_CCE();
    if (!(this.n8o_1 === tmp0_other_with_cast.n8o_1))
      return false;
    if (!(this.o8o_1 === tmp0_other_with_cast.o8o_1))
      return false;
    if (!(this.p8o_1 === tmp0_other_with_cast.p8o_1))
      return false;
    if (!equals(this.q8o_1, tmp0_other_with_cast.q8o_1))
      return false;
    if (!this.r8o_1.equals(tmp0_other_with_cast.r8o_1))
      return false;
    return true;
  }
}
class GLShaderCompiler {
  constructor() {
    GLShaderCompiler_instance = this;
    this.h8o_1 = Companion_getInstance_1().g26('GLShaderCompiler');
  }
  i8o(gl, config, program, debugName) {
    var id = gl.n8v();
    var guessedGlSlVersion = get_versionInt(gl);
    var tmp0_elvis_lhs = Companion_getInstance_61().p8v();
    var usedGlSlVersion = tmp0_elvis_lhs == null ? guessedGlSlVersion : tmp0_elvis_lhs;
    if (Companion_getInstance_61().q8v()) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = this.h8o_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.q46(level)) {
        // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
        var tmp$ret$0 = 'GLSL version: usedGlSlVersion=' + usedGlSlVersion + ', guessed=' + guessedGlSlVersion + ', forced=' + Companion_getInstance_61().p8v() + '. used=' + usedGlSlVersion;
        this_0.r46(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf_0([false, true]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
      var tmp$ret$2 = config.r8v(VOID, VOID, usedGlSlVersion, item);
      destination.h(tmp$ret$2);
    }
    var _destruct__k2r9zo = this.s8v(gl, program, debugName, destination);
    var fragmentShaderId = _destruct__k2r9zo.em();
    var vertexShaderId = _destruct__k2r9zo.fm();
    var finalConfig = _destruct__k2r9zo.jt();
    var _iterator__ex2g4s = program.v8a_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var attr = _iterator__ex2g4s.d1();
      var location = attr.e8j_1;
      gl.t8v(id, location, attr.d8p_1);
    }
    gl.u8v(id, fragmentShaderId);
    gl.u8v(id, vertexShaderId);
    gl.v8v(id);
    // Inline function 'korlibs.kgl.KmlGl.LINK_STATUS' call
    var linkStatus = getProgramiv(gl, id, 35714);
    return new GLProgramInfo(id, vertexShaderId, fragmentShaderId, program.s8a_1, finalConfig);
  }
  s8v(gl, program, debugName, configs) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var errors = ArrayList.z();
    var _iterator__ex2g4s = configs.b1();
    $l$loop: while (_iterator__ex2g4s.c1()) {
      var config = _iterator__ex2g4s.d1();
      try {
        var fragmentString = toNewGlslString(program.o8a_1, config);
        var vertexString = toNewGlslString(program.n8a_1, config);
        var fragmentShaderId = createShader(this, gl, 35632, fragmentString, debugName);
        var vertexShaderId = createShader(this, gl, 35633, vertexString, debugName);
        // Inline function 'korlibs.logger.Logger.debug' call
        var this_0 = this.h8o_1;
        var level = Level_DEBUG_getInstance();
        var tmp;
        if (this_0.q46(level)) {
          // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
          var tmp$ret$1 = '!!! PROGRAM SUCCESSFULLY COMPILED: config=' + config.toString() + '\n' + vertexString + '\n' + fragmentString;
          this_0.r46(level, tmp$ret$1);
          tmp = Unit_instance;
        }
        return new Triple(fragmentShaderId, vertexShaderId, config);
      } catch ($p) {
        if ($p instanceof ShaderException) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.debug' call
          var this_1 = this.h8o_1;
          var level_0 = Level_DEBUG_getInstance();
          var tmp_0;
          if (this_1.q46(level_0)) {
            // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
            var tmp$ret$3 = stackTraceToString(e);
            this_1.r46(level_0, tmp$ret$3);
            tmp_0 = Unit_instance;
          }
          // Inline function 'kotlin.collections.plusAssign' call
          errors.h(e);
          continue $l$loop;
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(errors, 10));
    var tmp0_iterator = errors.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
      var tmp$ret$5 = item.message;
      destination.h(tmp$ret$5);
    }
    throw Exception.pe('Tried several shaders: ' + toString(destination), last(errors));
  }
}
class AGDummy extends AG {
  static a8w(size) {
    size = size === VOID ? Size2D.w3j(640, 480) : size;
    var $this = this.g83();
    $this.v83().t87(numberToInt(size.u3j_1), numberToInt(size.v3j_1));
    return $this;
  }
}
class AGBaseLog extends AGDummy {
  static u8w(size) {
    size = size === VOID ? Size2D.w3j(640, 480) : size;
    var $this = this.a8w(size);
    $this.p8w_1 = 0;
    $this.q8w_1 = 0;
    $this.r8w_1 = 0;
    $this.s8w_1 = 0;
    $this.t8w_1 = linkedHashMapOf([]);
    return $this;
  }
  v8w(str, kind) {
  }
  y83(command) {
    this.v8w(toString(command), Kind_COMMAND_getInstance());
  }
  x83() {
    return this.v8w('finish()', Kind_FLIP_getInstance());
  }
}
class AGPrint extends AGBaseLog {
  static k8w(size) {
    size = size === VOID ? Size2D.w3j(640, 480) : size;
    return this.u8w(size);
  }
  v8w(str, kind) {
    println('PrintAG: ' + str);
  }
}
class Kind_0 extends Enum {}
class Companion_43 {
  constructor() {
    Companion_instance_52 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp.p84_1 = new UniformBlocksBuffersRef(tmp_0, tmp$ret$1, new Int32Array(0));
  }
}
class UniformBlocksBuffersRef {
  constructor(blocks, buffers, valueIndices) {
    Companion_getInstance_58();
    this.b8u_1 = blocks;
    this.c8u_1 = buffers;
    this.d8u_1 = valueIndices;
  }
  g1() {
    return this.b8u_1.length;
  }
}
class Gen {
  constructor(block, name, voffset, vindex, type, arrayCount, size, align) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    this.u8h_1 = block;
    this.v8h_1 = name;
    this.w8h_1 = voffset;
    this.x8h_1 = vindex;
    this.y8h_1 = type;
    this.z8h_1 = arrayCount;
    this.a8i_1 = size;
    this.b8i_1 = align;
    var tmp = this;
    tmp.c8i_1 = lazy(UniformBlock$Gen$uniform$delegate$lambda(this));
  }
  x8w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c8i_1;
    uniform$factory();
    return this_0.w1();
  }
  d8i(block, property) {
    var tmp = this;
    var tmp0_elvis_lhs = this.v8h_1;
    tmp.v8h_1 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    return this.x8w();
  }
  toString() {
    return 'Gen(block=' + this.u8h_1.toString() + ', name=' + this.v8h_1 + ', voffset=' + this.w8h_1 + ', vindex=' + this.x8h_1 + ', type=' + this.y8h_1.toString() + ', arrayCount=' + this.z8h_1 + ', size=' + this.a8i_1 + ', align=' + this.b8i_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.u8h_1);
    result = imul(result, 31) + (this.v8h_1 == null ? 0 : getStringHashCode(this.v8h_1)) | 0;
    result = imul(result, 31) + this.w8h_1 | 0;
    result = imul(result, 31) + this.x8h_1 | 0;
    result = imul(result, 31) + this.y8h_1.hashCode() | 0;
    result = imul(result, 31) + this.z8h_1 | 0;
    result = imul(result, 31) + this.a8i_1 | 0;
    result = imul(result, 31) + this.b8i_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Gen))
      return false;
    var tmp0_other_with_cast = other instanceof Gen ? other : THROW_CCE();
    if (!equals(this.u8h_1, tmp0_other_with_cast.u8h_1))
      return false;
    if (!(this.v8h_1 == tmp0_other_with_cast.v8h_1))
      return false;
    if (!(this.w8h_1 === tmp0_other_with_cast.w8h_1))
      return false;
    if (!(this.x8h_1 === tmp0_other_with_cast.x8h_1))
      return false;
    if (!this.y8h_1.equals(tmp0_other_with_cast.y8h_1))
      return false;
    if (!(this.z8h_1 === tmp0_other_with_cast.z8h_1))
      return false;
    if (!(this.a8i_1 === tmp0_other_with_cast.a8i_1))
      return false;
    if (!(this.b8i_1 === tmp0_other_with_cast.b8i_1))
      return false;
    return true;
  }
}
class Operand {
  static z95(type) {
    var $this = createThis(this);
    $this.r8q_1 = type;
    return $this;
  }
  p3m() {
    return this.r8q_1;
  }
}
class OperandWithArray extends Operand {
  static w97(type, arrayCount) {
    var $this = this.z95(type);
    $this.t8q_1 = arrayCount;
    $this.u8q_1 = type.a8r_1;
    $this.v8q_1 = type.b8r_1;
    $this.w8q_1 = imul($this.v8q_1, $this.t8q_1);
    $this.x8q_1 = imul(type.d8r_1, $this.t8q_1);
    return $this;
  }
}
class Variable extends OperandWithArray {
  static w96(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    var $this = this.w97(type, arrayCount);
    $this.d8p_1 = name;
    $this.e8p_1 = precision;
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(arrayCount), null);
    while (tmp_0 < arrayCount) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = $this.d8p_1 + '[' + tmp_2 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.f8p_1 = tmp_1;
    $this.g8p_1 = 0;
    $this.h8p_1 = null;
    return $this;
  }
  static n97(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.w96(name, type, 1, precision);
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this.g8p_1 === other.g8p_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.p3m().equals(other.p3m());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t8q_1 === other.t8q_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d8p_1 === other.d8p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g8p_1 + imul(this.p3m().hashCode(), 7) | 0) + imul(getStringHashCode(this.d8p_1), 11) | 0;
  }
}
class VariableWithOffset extends Variable {
  static o8x(name, type, arrayCount, precision, offset) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.w96(name, type, arrayCount, precision);
    $this.n8x_1 = offset;
    return $this;
  }
}
class TypedUniform extends VariableWithOffset {
  static w8w(name, voffset, vindex, block, type, arrayCount) {
    var $this = this.o8x(name, type, arrayCount, Precision_DEFAULT_getInstance());
    $this.j8b_1 = voffset;
    $this.k8b_1 = vindex;
    $this.l8b_1 = block;
    $this.m8b_1 = Uniform.c8y(name, type, arrayCount, VOID, VOID, $this);
    return $this;
  }
  np(thisRef, property) {
    return this;
  }
  toString() {
    return "TypedUniform(name='" + this.d8p_1 + "', offset=" + this.j8b_1 + ', type=' + this.p3m().toString() + ')';
  }
}
class Companion_44 {}
class UniformBlockBuffer {
  constructor(block) {
    this.t89_1 = block;
    this.u89_1 = new AGBuffer();
    this.v89_1 = this.t89_1.h8i();
    this.w89_1 = this.t89_1.i8i();
    this.x89_1 = this.t89_1.g8i().g1();
    this.y89_1 = Buffer.o2c(imul(this.w89_1, 1));
    this.z89_1 = UniformsRef.d8y(this.t89_1, this.y89_1, -1);
    this.a8a_1 = Buffer.o2c(this.t89_1.i8i());
  }
  toString() {
    return 'UniformBlockBuffer(' + toString(this.t89_1) + ')';
  }
  e8y(value) {
    this.z89_1.h8u_1 = value;
  }
  s8b() {
    return this.z89_1.h8u_1;
  }
  f8y(index) {
    if (index >= (_get_bufferSize__mp12kq(this) - 1 | 0)) {
      // Inline function 'kotlin.math.max' call
      var a = index + 1 | 0;
      var b = imul(index + 2 | 0, 3);
      var newCapacity = Math.max(a, b);
      this.y89_1 = copyOf(this.y89_1, imul(this.w89_1, newCapacity));
      this.z89_1.g8u_1 = this.y89_1;
    }
  }
  u1w() {
    this.e8y(-1);
  }
  c8a() {
    var tmp = this.y89_1;
    // Inline function 'kotlin.math.max' call
    var b = imul(this.s8b() + 1 | 0, this.t89_1.i8i());
    var tmp$ret$0 = Math.max(0, b);
    this.u89_1.i86(tmp, 0, tmp$ret$0);
    return this;
  }
  g8y() {
    var _unary__edvuaz = this.s8b();
    this.e8y(_unary__edvuaz - 1 | 0);
  }
}
class UBLayoutBuilder {
  constructor() {
    this.y8w_1 = 0;
    this.z8w_1 = 4;
    var tmp = this;
    tmp.a8x_1 = lazy(UBLayoutBuilder$size$delegate$lambda(this));
  }
  g1() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a8x_1;
    size$factory();
    return this_0.w1();
  }
  b8x(size, align_0) {
    // Inline function 'kotlin.also' call
    var this_0 = align(this, align_0).y8w_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UBLayoutBuilder.rawAlloc.<anonymous>' call
    this.y8w_1 = this.y8w_1 + size | 0;
    return this_0;
  }
}
class UniformsRef {
  static d8y(block, buffer, index) {
    var $this = createThis(this);
    $this.f8u_1 = block;
    $this.g8u_1 = buffer;
    $this.h8u_1 = index;
    $this.i8u_1 = $this.f8u_1.i8i();
    return $this;
  }
  static e8v(block, size, index) {
    size = size === VOID ? 1 : size;
    index = index === VOID ? 0 : index;
    return this.d8y(block, Buffer.o2c(imul(block.i8i(), size)), index);
  }
  h8y(uniform) {
    return imul(this.h8u_1, this.i8u_1) + uniform.j8b_1 | 0;
  }
  i8y(uniform, value) {
    switch (uniform.p3m().p3_1) {
      case 3:
        this.j8y(uniform, value, Companion_getInstance_6().x3o_1);
        break;
      case 2:
        this.k8y(uniform, value, Companion_getInstance_6().x3o_1, 12);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.je();
    }
  }
  k8y(uniform, value, indices, max) {
    // Inline function 'kotlin.also' call
    var this_0 = this.h8y(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.memory.setF32' call
        var this_1 = this.g8u_1;
        var byteOffset = this_0 + imul(n, 4) | 0;
        // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>.<anonymous>' call
        var it = indices[n];
        var value_0 = value.b3q(it);
        var tmp;
        if (true) {
          this_1.n2c(byteOffset, value_0);
          tmp = Unit_instance;
        } else {
          this_1.m2c(byteOffset, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  }
  j8y(uniform, value, indices, max, $super) {
    max = max === VOID ? indices.length : max;
    var tmp;
    if ($super === VOID) {
      this.k8y(uniform, value, indices, max);
      tmp = Unit_instance;
    } else {
      tmp = $super.k8y.call(this, uniform, value, indices, max);
    }
    return tmp;
  }
}
class Companion_45 {
  l8y(isES, isWebGL, isCore, version, os) {
    return _GLVariant___init__impl__cjzpjb(insert8(insert8(insert(insert(insert(0, isES, 0), isWebGL, 1), isCore, 2), version, 8), os.p3_1, 16));
  }
  m8y(isES, isWebGL, isCore, version, os, $super) {
    isES = isES === VOID ? false : isES;
    isWebGL = isWebGL === VOID ? false : isWebGL;
    isCore = isCore === VOID ? false : isCore;
    version = version === VOID ? 0 : version;
    os = os === VOID ? Os_UNKNOWN_getInstance() : os;
    return $super === VOID ? this.l8y(isES, isWebGL, isCore, version, os) : $super.l8y.call(this, isES, isWebGL, isCore, version, os).n8y_1;
  }
  o8y() {
    return Companion_instance_54.m8y(false, VOID, VOID, 1, Os_UNKNOWN_getInstance());
  }
  p8y(version) {
    return Companion_instance_54.m8y(true, true, VOID, version);
  }
}
class GLVariant {
  constructor(data) {
    this.n8y_1 = data;
  }
  toString() {
    return GLVariant__toString_impl_o5yi3l(this.n8y_1);
  }
  hashCode() {
    return GLVariant__hashCode_impl_2eslaq(this.n8y_1);
  }
  equals(other) {
    return GLVariant__equals_impl_kmlw2(this.n8y_1, other);
  }
}
class Visitor {
  constructor(default_0, $box) {
    boxApply(this, $box);
    this.i90_1 = default_0;
  }
  j90(func) {
    this.k90(func.b92_1);
  }
  x95(stms) {
    var _iterator__ex2g4s = stms.b1();
    while (_iterator__ex2g4s.c1()) {
      var stm = _iterator__ex2g4s.d1();
      this.k90(stm);
    }
  }
  k90(stm) {
    var tmp;
    if (stm == null) {
      tmp = Unit_instance;
    } else {
      if (stm instanceof Stms) {
        this.l90(stm);
        tmp = Unit_instance;
      } else {
        if (stm instanceof Set) {
          this.o90(stm);
          tmp = Unit_instance;
        } else {
          if (stm instanceof If) {
            this.m90(stm);
            tmp = Unit_instance;
          } else {
            if (stm instanceof ForSimple) {
              this.n90(stm);
              tmp = Unit_instance;
            } else {
              if (stm instanceof Discard) {
                this.p90(stm);
                tmp = Unit_instance;
              } else {
                if (stm instanceof Continue) {
                  this.r90(stm);
                  tmp = Unit_instance;
                } else {
                  if (stm instanceof Break) {
                    this.q90(stm);
                    tmp = Unit_instance;
                  } else {
                    if (stm instanceof Raw) {
                      this.s90(stm);
                      tmp = Unit_instance;
                    } else {
                      if (stm instanceof Return) {
                        this.t90(stm);
                        tmp = Unit_instance;
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  l90(stms) {
    var _iterator__ex2g4s = stms.p92_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var stm = _iterator__ex2g4s.d1();
      this.k90(stm);
    }
  }
  m90(stm) {
    this.u90(stm.j93_1);
    this.k90(stm.k93_1);
    this.k90(stm.l93_1);
  }
  n90(stm) {
    this.x90(stm.m93_1);
    this.u90(stm.n93_1);
    this.k90(stm.p93_1);
  }
  o90(stm) {
    this.u90(stm.r92_1);
    this.u90(stm.q92_1);
  }
  p90(stm) {
  }
  q90(stm) {
  }
  r90(stm) {
  }
  s90(stm) {
    this.k90(stm.l92_1);
  }
  t90(stm) {
    var tmp0_safe_receiver = stm.s92_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.shader.Visitor.visit.<anonymous>' call
      this.u90(tmp0_safe_receiver);
    }
  }
  u90(operand) {
    var tmp;
    if (operand instanceof Variable) {
      tmp = this.x90(operand);
    } else {
      if (operand instanceof Unop) {
        tmp = this.b91(operand);
      } else {
        if (operand instanceof Binop) {
          tmp = this.c91(operand);
        } else {
          if (operand instanceof Ternary) {
            tmp = this.d91(operand);
          } else {
            if (operand instanceof BoolLiteral) {
              tmp = this.j91(operand);
            } else {
              if (operand instanceof IntLiteral) {
                tmp = this.h91(operand);
              } else {
                if (operand instanceof FloatLiteral) {
                  tmp = this.i91(operand);
                } else {
                  if (operand instanceof Vector) {
                    tmp = this.g91(operand);
                  } else {
                    if (operand instanceof Swizzle) {
                      tmp = this.e91(operand);
                    } else {
                      if (operand instanceof ArrayAccess) {
                        tmp = this.f91(operand);
                      } else {
                        if (operand instanceof BaseFunc) {
                          tmp = this.v90(operand);
                        } else {
                          invalidOp("Don't know how to visit operand " + toString(operand));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  v90(func) {
    var _iterator__ex2g4s = func.e93().b1();
    while (_iterator__ex2g4s.c1()) {
      var op = _iterator__ex2g4s.d1();
      this.u90(op);
    }
    var tmp;
    if (func instanceof Func) {
      tmp = this.w90(func);
    } else {
      if (func instanceof CustomFunc) {
        tmp = this.h90(func);
      } else {
        invalidOp("Don't know how to visit func " + toString(func));
      }
    }
    return tmp;
  }
  w90(func) {
    return this.i90_1;
  }
  h90(func) {
    return this.i90_1;
  }
  x90(operand) {
    var tmp;
    if (operand instanceof Attribute) {
      tmp = this.t8z(operand);
    } else {
      if (operand instanceof Varying) {
        tmp = this.v8z(operand);
      } else {
        if (operand instanceof Sampler) {
          tmp = this.b90(operand);
        } else {
          if (operand instanceof Uniform) {
            tmp = this.x8z(operand);
          } else {
            if (operand instanceof TypedUniform) {
              tmp = this.z8z(operand);
            } else {
              if (operand instanceof Output) {
                tmp = this.a91(operand);
              } else {
                if (operand instanceof Temp) {
                  tmp = this.y90(operand);
                } else {
                  if (operand instanceof Arg) {
                    tmp = this.z90(operand);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  y90(temp) {
    return this.i90_1;
  }
  z90(arg) {
    return this.i90_1;
  }
  t8z(attribute) {
    return this.i90_1;
  }
  v8z(varying) {
    return this.i90_1;
  }
  x8z(uniform) {
    return this.i90_1;
  }
  b90(sampler) {
    return this.i90_1;
  }
  z8z(typedUniform) {
    return this.x8z(typedUniform.m8b_1);
  }
  a91(output) {
    return this.i90_1;
  }
  b91(operand) {
    this.u90(operand.y92_1);
    return this.i90_1;
  }
  c91(operand) {
    this.u90(operand.a93_1);
    this.u90(operand.c93_1);
    return this.i90_1;
  }
  d91(operand) {
    this.u90(operand.g93_1);
    this.u90(operand.h93_1);
    this.u90(operand.i93_1);
    return this.i90_1;
  }
  e91(operand) {
    this.u90(operand.x93_1);
    return this.i90_1;
  }
  f91(operand) {
    this.u90(operand.a94_1);
    this.u90(operand.b94_1);
    return this.i90_1;
  }
  g91(operand) {
    var indexedObject = operand.v92_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.u90(op);
    }
    return this.i90_1;
  }
  h91(operand) {
    return this.i90_1;
  }
  i91(operand) {
    return this.i90_1;
  }
  j91(operand) {
    return this.i90_1;
  }
}
class GlobalsProgramVisitor extends Visitor {
  constructor() {
    super(Unit_instance);
    this.l8z_1 = LinkedHashSet.r1();
    this.m8z_1 = LinkedHashSet.r1();
    this.n8z_1 = LinkedHashSet.r1();
    this.o8z_1 = LinkedHashSet.r1();
    this.p8z_1 = LinkedHashSet.r1();
    this.q8z_1 = LinkedHashSet.r1();
    this.r8z_1 = LinkedHashSet.r1();
  }
  s8z(attribute) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.l8z_1.h(attribute);
  }
  t8z(attribute) {
    this.s8z(attribute);
    return Unit_instance;
  }
  u8z(varying) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.m8z_1.h(varying);
  }
  v8z(varying) {
    this.u8z(varying);
    return Unit_instance;
  }
  w8z(uniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.n8z_1.h(uniform);
    var tmp0_safe_receiver = uniform.b8y_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.o8z_1.h(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.p8z_1;
    var element = uniform.b8y_1.l8b_1;
    this_0.h(element);
  }
  x8z(uniform) {
    this.w8z(uniform);
    return Unit_instance;
  }
  y8z(typedUniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.n8z_1;
    var element = typedUniform.m8b_1;
    this_0.h(element);
    // Inline function 'kotlin.collections.plusAssign' call
    this.o8z_1.h(typedUniform);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.p8z_1;
    var element_0 = typedUniform.l8b_1;
    this_1.h(element_0);
  }
  z8z(typedUniform) {
    this.y8z(typedUniform);
    return Unit_instance;
  }
  a90(sampler) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.q8z_1.h(sampler);
  }
  b90(sampler) {
    this.a90(sampler);
    return Unit_instance;
  }
  c90(func) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.r8z_1;
    var element = func.g90().q3();
    this_0.h(element);
  }
  h90(func) {
    this.c90(func);
    return Unit_instance;
  }
}
class Companion_46 {
  constructor() {
    Companion_instance_55 = this;
    this.o8v_1 = Companion_getInstance_1().g26('GlslGenerator');
  }
  p8v() {
    return Companion_getInstance_62().p8v();
  }
  q8v() {
    return Companion_getInstance_62().q8v();
  }
}
class Result {
  constructor(generator, result, attributes, uniforms, varyings) {
    this.q8y_1 = generator;
    this.r8y_1 = result;
    this.s8y_1 = attributes;
    this.t8y_1 = uniforms;
    this.u8y_1 = varyings;
  }
  toString() {
    return 'Result(generator=' + toString(this.q8y_1) + ', result=' + this.r8y_1 + ', attributes=' + toString(this.s8y_1) + ', uniforms=' + toString(this.t8y_1) + ', varyings=' + toString(this.u8y_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.q8y_1);
    result = imul(result, 31) + getStringHashCode(this.r8y_1) | 0;
    result = imul(result, 31) + hashCode(this.s8y_1) | 0;
    result = imul(result, 31) + hashCode(this.t8y_1) | 0;
    result = imul(result, 31) + hashCode(this.u8y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.q8y_1, tmp0_other_with_cast.q8y_1))
      return false;
    if (!(this.r8y_1 === tmp0_other_with_cast.r8y_1))
      return false;
    if (!equals(this.s8y_1, tmp0_other_with_cast.s8y_1))
      return false;
    if (!equals(this.t8y_1, tmp0_other_with_cast.t8y_1))
      return false;
    if (!equals(this.u8y_1, tmp0_other_with_cast.u8y_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.p91_1 = function_0;
  }
  vj(a, b) {
    return this.p91_1(a, b);
  }
  compare(a, b) {
    return this.vj(a, b);
  }
  o4() {
    return this.p91_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class BaseGlslGenerator {}
function precToString(prec) {
  var tmp;
  if (!_GLVariant___get_isES__impl__yezzg8(this.i92().m8p_1)) {
    tmp = '';
  } else {
    var tmp_0;
    switch (prec.p3_1) {
      case 0:
        tmp_0 = '';
        break;
      case 1:
        tmp_0 = 'lowp ';
        break;
      case 2:
        tmp_0 = 'mediump ';
        break;
      case 3:
        tmp_0 = 'highp ';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeToString(type) {
  var tmp;
  switch (type.p3_1) {
    case 0:
      tmp = 'void';
      break;
    case 21:
      tmp = 'vec4';
      break;
    case 1:
      tmp = 'mat2';
      break;
    case 2:
      tmp = 'mat3';
      break;
    case 3:
      tmp = 'mat4';
      break;
    case 4:
      tmp = 'sampler1D';
      break;
    case 5:
      tmp = 'sampler2D';
      break;
    case 6:
      tmp = 'sampler3D';
      break;
    case 7:
      tmp = 'samplerCube';
      break;
    default:
      var tmp_0;
      switch (type.a8r_1.p3_1) {
        case 0:
          var tmp_1;
          switch (type.b8r_1) {
            case 1:
              tmp_1 = 'bool';
              break;
            case 2:
              tmp_1 = 'bvec2';
              break;
            case 3:
              tmp_1 = 'bvec3';
              break;
            case 4:
              tmp_1 = 'bvec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_1;
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
          var tmp_2;
          switch (type.b8r_1) {
            case 1:
              tmp_2 = 'float';
              break;
            case 2:
              tmp_2 = 'vec2';
              break;
            case 3:
              tmp_2 = 'vec3';
              break;
            case 4:
              tmp_2 = 'vec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_2;
          break;
        case 5:
          var tmp_3;
          switch (type.b8r_1) {
            case 1:
              tmp_3 = 'int';
              break;
            case 2:
              tmp_3 = 'ivec2';
              break;
            case 3:
              tmp_3 = 'ivec3';
              break;
            case 4:
              tmp_3 = 'ivec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_3;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
}
function get_arrayDecl(_this__u8e3s4) {
  return !(_this__u8e3s4.t8q_1 === 1) ? '[' + _this__u8e3s4.t8q_1 + ']' : '';
}
function get_IN() {
  return this.i92().r91();
}
function get_OUT() {
  return this.i92().w91();
}
function get_UNIFORM() {
  return this.i92().v91();
}
class GlslGenerator {
  constructor(kind, config) {
    Companion_getInstance_61();
    this.h8z_1 = kind;
    this.i8z_1 = config;
  }
  i92() {
    return this.i8z_1;
  }
  j8z(shader) {
    return this.j92(shader.w8y_1, shader.x8y_1);
  }
  j92(root, funcs) {
    var types = new GlobalsProgramVisitor();
    if (this.h8z_1.equals(ShaderType_FRAGMENT_getInstance()) && this.i8z_1.q91()) {
      types.m8z_1.h(Varying.r8j(this.i8z_1.x91(), VarType_Float4_getInstance()));
    }
    var tmp = VarType_TVOID_getInstance();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    var mainFunc = new FuncDecl('main', tmp, tmp$ret$0, root);
    types.j90(mainFunc);
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.z();
    var tmp0_iterator = funcs.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      if (types.r8z_1.z2(element.c92_1.q3())) {
        destination.h(element);
      }
    }
    var this_0 = reversed(destination);
    var set = HashSet.va();
    var list = ArrayList.z();
    var tmp0_iterator_0 = this_0.b1();
    while (tmp0_iterator_0.c1()) {
      var e = tmp0_iterator_0.d1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      var key = e.c92_1.q3();
      if (set.h(key)) {
        list.h(e);
      }
    }
    var customFuncs = list;
    var _iterator__ex2g4s = funcs.b1();
    while (_iterator__ex2g4s.c1()) {
      var func = _iterator__ex2g4s.d1();
      types.j90(mainFunc);
    }
    var allFuncs = plus(customFuncs, listOf(mainFunc));
    // Inline function 'kotlin.also' call
    var tmp_0 = Companion_getInstance_11();
    var this_1 = tmp_0.g4h(GlslGenerator$generateResult$lambda(this, types, allFuncs)).toString();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
    if (Companion_getInstance_62().q8v()) {
      // Inline function 'korlibs.logger.Logger.info' call
      var this_2 = Companion_getInstance_61().o8v_1;
      var level = Level_INFO_getInstance();
      var tmp_1;
      if (this_2.q46(level)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$6 = 'GlSlGenerator.version: ' + this.i8z_1.o8p_1;
        this_2.r46(level, tmp$ret$6);
        tmp_1 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.debug' call
      var this_3 = Companion_getInstance_61().o8v_1;
      var level_0 = Level_DEBUG_getInstance();
      var tmp_2;
      if (this_3.q46(level_0)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$8 = 'GlSlGenerator:\n' + this_1;
        this_3.r46(level_0, tmp$ret$8);
        tmp_2 = Unit_instance;
      }
    }
    var result = this_1;
    var tmp_3;
    if (root instanceof Raw) {
      tmp_3 = root.m92(Companion_getInstance_62().l91_1);
    } else {
      tmp_3 = result;
    }
    return new Result(this, tmp_3, toList(types.l8z_1), toList(types.n8z_1), toList(types.m8z_1));
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_56 = this;
    this.k91_1 = new GlslConfig(Companion_instance_54.o8y(), new Immutable(VOID, VOID, VOID, true));
    this.l91_1 = 'GLSL';
    this.m91_1 = 100;
    this.n91_1 = 'fragColor';
    this.o91_1 = 'gl_FragColor';
  }
  p8v() {
    var tmp0_safe_receiver = Companion_instance_1.cj('FORCE_GLSL_VERSION');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : replace(tmp0_safe_receiver, '.', '');
    return tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  }
  q8v() {
    return Companion_instance_1.cj('DEBUG_GLSL') === 'true';
  }
}
class GlslConfig {
  constructor(variant, features, glslVersion, compatibility) {
    Companion_getInstance_62();
    glslVersion = glslVersion === VOID ? -1 : glslVersion;
    compatibility = compatibility === VOID ? true : compatibility;
    this.m8p_1 = variant;
    this.n8p_1 = features;
    this.o8p_1 = glslVersion;
    this.p8p_1 = compatibility;
  }
  n92(name) {
    if (this.p8p_1)
      return name;
    return name === 'texture2D' ? 'texture' : name;
  }
  q91() {
    if (_GLVariant___get_isES__impl__yezzg8(this.m8p_1))
      return this.o8p_1 >= 300;
    return !this.p8p_1;
  }
  q8p() {
    return get_ENABLE_UNIFORM_BLOCKS() && this.q91() && this.n8p_1.d84();
  }
  r91() {
    return this.q91() ? 'in' : 'attribute';
  }
  w91() {
    return this.q91() ? 'out' : 'varying';
  }
  v91() {
    return 'uniform';
  }
  x91() {
    return this.q91() ? Companion_getInstance_62().n91_1 : Companion_getInstance_62().o91_1;
  }
  o92(variant, features, glslVersion, compatibility) {
    return new GlslConfig(variant, features, glslVersion, compatibility);
  }
  r8v(variant, features, glslVersion, compatibility, $super) {
    variant = variant === VOID ? this.m8p_1 : variant;
    features = features === VOID ? this.n8p_1 : features;
    glslVersion = glslVersion === VOID ? this.o8p_1 : glslVersion;
    compatibility = compatibility === VOID ? this.p8p_1 : compatibility;
    return $super === VOID ? this.o92(variant, features, glslVersion, compatibility) : $super.o92.call(this, new GLVariant(variant), features, glslVersion, compatibility);
  }
  toString() {
    return 'GlslConfig(variant=' + GLVariant__toString_impl_o5yi3l(this.m8p_1) + ', features=' + toString(this.n8p_1) + ', glslVersion=' + this.o8p_1 + ', compatibility=' + this.p8p_1 + ')';
  }
  hashCode() {
    var result = GLVariant__hashCode_impl_2eslaq(this.m8p_1);
    result = imul(result, 31) + hashCode(this.n8p_1) | 0;
    result = imul(result, 31) + this.o8p_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p8p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this.m8p_1 === tmp0_other_with_cast.m8p_1))
      return false;
    if (!equals(this.n8p_1, tmp0_other_with_cast.n8p_1))
      return false;
    if (!(this.o8p_1 === tmp0_other_with_cast.o8p_1))
      return false;
    if (!(this.p8p_1 === tmp0_other_with_cast.p8p_1))
      return false;
    return true;
  }
}
class GlslBodyGenerator extends Visitor {
  constructor(kind, config) {
    super('');
    this.e92_1 = kind;
    this.f92_1 = config;
    this.g92_1 = LinkedHashSet.r1();
    this.h92_1 = new Indenter();
  }
  i92() {
    return this.f92_1;
  }
  l90(stms) {
    var _iterator__ex2g4s = stms.p92_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var stm = _iterator__ex2g4s.d1();
      this.k90(stm);
    }
  }
  o90(stm) {
    this.h92_1.z4h(this.u90(stm.q92_1) + ' = ' + this.u90(stm.r92_1) + ';');
  }
  p90(stm) {
    this.h92_1.z4h('discard;');
  }
  q90(stm) {
    this.h92_1.z4h('break;');
  }
  r90(stm) {
    this.h92_1.z4h('continue;');
  }
  t90(stm) {
    var result = stm.s92_1;
    if (!(result == null)) {
      this.h92_1.z4h('return ' + this.u90(result) + ';');
    } else {
      this.h92_1.z4h('return;');
    }
  }
  g91(operand) {
    var tmp = this.t91(operand.u92_1) + '(';
    return tmp + joinToString_0(operand.v92_1, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda(this)) + ')';
  }
  b91(operand) {
    return '(' + operand.x92_1 + '(' + this.u90(operand.y92_1) + ')' + ')';
  }
  c91(operand) {
    return '(' + this.u90(operand.a93_1) + ' ' + operand.b93_1 + ' ' + this.u90(operand.c93_1) + ')';
  }
  v90(func) {
    var tmp = this.f92_1.n92(func.q3()) + '(';
    var tmp_0 = func.e93();
    return tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda_0(this)) + ')';
  }
  d91(ternary) {
    return '((' + this.u90(ternary.g93_1) + ') ? (' + this.u90(ternary.h93_1) + ') : (' + this.u90(ternary.i93_1) + '))';
  }
  m90(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.h92_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'if (' + this.u90(stm.j93_1) + ')';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.z4h(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.v1k();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.k90(stm.k93_1);
    }finally {
      this_0.a4i();
    }
    this_0.z4h('}');
    if (!(stm.l93_1 == null)) {
      // Inline function 'korlibs.io.util.Indenter.line' call
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        tmp_0 = 'else' + ' {';
      }
      this_0.z4h(tmp_0);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      this_0.v1k();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
        this.k90(ensureNotNull(stm.l93_1));
      }finally {
        this_0.a4i();
      }
      this_0.z4h('}');
    }
  }
  n90(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.h92_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    var varType = this.t91(stm.m93_1.p3m());
    var loopVar = this.x90(stm.m93_1);
    var min = this.u90(stm.n93_1);
    var maxExclusive = this.u90(stm.o93_1);
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'for (' + varType + ' ' + loopVar + ' = (' + min + '); ' + loopVar + ' < (' + maxExclusive + '); ' + loopVar + '++)';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.z4h(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.v1k();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.k90(stm.p93_1);
    }finally {
      this_0.a4i();
    }
    this_0.z4h('}');
  }
  s90(stm) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    this.h92_1.z4h(stm.m92(Companion_getInstance_62().l91_1));
  }
  x90(operand) {
    super.x90(operand);
    var tmp;
    if (operand instanceof Output) {
      var tmp_0;
      switch (this.e92_1.p3_1) {
        case 0:
          tmp_0 = 'gl_Position';
          break;
        case 1:
          tmp_0 = this.f92_1.x91();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = operand.d8p_1;
    }
    return tmp;
  }
  y90(temp) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.g92_1.h(temp);
    return super.y90(temp);
  }
  a91(output) {
    return super.a91(output);
  }
  h91(operand) {
    return '' + operand.r93_1;
  }
  i91(operand) {
    var str = '' + operand.t93_1;
    return contains(str, _Char___init__impl__6a9atx(46)) ? str : str + '.0';
  }
  j91(operand) {
    return '' + operand.v93_1;
  }
  e91(operand) {
    return this.u90(operand.x93_1) + '.' + operand.y93_1;
  }
  f91(operand) {
    return this.u90(operand.a94_1) + '[' + this.u90(operand.b94_1) + ']';
  }
}
class ProgramLayout {
  static c94(items, layoutSize, fixedLocation) {
    fixedLocation = fixedLocation === VOID ? -1 : fixedLocation;
    var $this = createThis(this);
    $this.y8b_1 = items;
    $this.z8b_1 = layoutSize;
    $this.a8c_1 = fixedLocation;
    $this.b8c_1 = 0;
    var tmp = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = $this.y8b_1;
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.l3w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s = this_0.b1();
    while (_iterator__ex2g4s.c1()) {
      var v = _iterator__ex2g4s.d1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout.alignments.<anonymous>' call
      var a = v.p3m().a8r_1.f94_1;
      var tmp$ret$0 = a <= 1 ? 1 : a;
      this_1.r3w(tmp$ret$0);
    }
    tmp.c8c_1 = this_1;
    var tmp_0 = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_2 = $this.y8b_1;
    // Inline function 'kotlin.also' call
    var this_3 = IntArrayList.l3w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s_0 = this_2.b1();
    while (_iterator__ex2g4s_0.c1()) {
      var v_0 = _iterator__ex2g4s_0.d1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout._positions.<anonymous>' call
      $this.b8c_1 = !(v_0.n8x_1 == null) ? v_0.n8x_1 : nextAlignedTo($this.b8c_1, v_0.p3m().a8r_1.f94_1);
      var out = $this.b8c_1;
      $this.b8c_1 = $this.b8c_1 + v_0.p3m().d8r_1 | 0;
      this_3.r3w(out);
    }
    tmp_0.d8c_1 = this_3;
    var tmp_1 = $this;
    var tmp0_elvis_lhs = maxOrNull($this.c8c_1);
    tmp_1.e8c_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = $this;
    var tmp0_elvis_lhs_0 = $this.z8b_1;
    tmp_2.f8c_1 = tmp0_elvis_lhs_0 == null ? nextAlignedTo($this.b8c_1, $this.e8c_1) : tmp0_elvis_lhs_0;
    return $this;
  }
  static g8c(variables, layoutSize) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    return this.c94(toFastList_0(variables), layoutSize);
  }
  g94() {
    return joinToString(this.y8b_1, ', ', VOID, VOID, VOID, VOID, ProgramLayout$names$lambda);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this)) + '[' + this.g94() + ', fixedLocation=' + this.a8c_1 + ']';
  }
  b1() {
    return this.y8b_1.b1();
  }
}
class Attribute extends VariableWithOffset {
  static h94(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    offset = offset === VOID ? null : offset;
    active = active === VOID ? true : active;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    divisor = divisor === VOID ? 0 : divisor;
    var $this = this.o8x(name, type, 1, precision, offset);
    $this.b8j_1 = normalized;
    $this.c8j_1 = active;
    $this.d8j_1 = divisor;
    $this.e8j_1 = fixedLocation;
    return $this;
  }
  static f8j(name, type, normalized, precision, fixedLocation) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.h94(name, type, normalized, null, true, precision, VOID, fixedLocation);
  }
  toString() {
    return 'Attribute(' + this.d8p_1 + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this.g8p_1 === other.g8p_1;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = this.p3m().equals(other.p3m());
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.t8q_1 === other.t8q_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.d8p_1 === other.d8p_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.b8j_1 === (other instanceof Attribute ? other : THROW_CCE()).b8j_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n8x_1 == other.n8x_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.c8j_1 === other.c8j_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    var out = (this.g8p_1 + imul(this.p3m().hashCode(), 7) | 0) + imul(getStringHashCode(this.d8p_1), 11) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.b8j_1) | 0;
    out = imul(out, 7);
    var tmp = out;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.n8x_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.c8j_1) | 0;
    return out;
  }
}
class Stm {}
class Stms extends Stm {
  constructor(stms) {
    super();
    this.p92_1 = stms;
  }
  toString() {
    return 'Stms(stms=' + toString(this.p92_1) + ')';
  }
  hashCode() {
    return hashCode(this.p92_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals(this.p92_1, tmp0_other_with_cast.p92_1))
      return false;
    return true;
  }
}
class Set extends Stm {
  constructor(to, from) {
    super();
    this.q92_1 = to;
    this.r92_1 = from;
  }
  toString() {
    return 'Set(to=' + toString(this.q92_1) + ', from=' + toString(this.r92_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.q92_1);
    result = imul(result, 31) + hashCode(this.r92_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Set))
      return false;
    var tmp0_other_with_cast = other instanceof Set ? other : THROW_CCE();
    if (!equals(this.q92_1, tmp0_other_with_cast.q92_1))
      return false;
    if (!equals(this.r92_1, tmp0_other_with_cast.r92_1))
      return false;
    return true;
  }
}
class Return extends Stm {
  constructor(result) {
    super();
    this.s92_1 = result;
  }
  toString() {
    return 'Return(result=' + toString_1(this.s92_1) + ')';
  }
  hashCode() {
    return this.s92_1 == null ? 0 : hashCode(this.s92_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Return))
      return false;
    var tmp0_other_with_cast = other instanceof Return ? other : THROW_CCE();
    if (!equals(this.s92_1, tmp0_other_with_cast.s92_1))
      return false;
    return true;
  }
}
class Break extends Stm {}
class Continue extends Stm {}
class Discard extends Stm {
  constructor() {
    Discard_instance = null;
    super();
    Discard_instance = this;
  }
  toString() {
    return 'Discard';
  }
}
class If extends Stm {
  constructor(cond, tbody, fbody) {
    fbody = fbody === VOID ? null : fbody;
    super();
    this.j93_1 = cond;
    this.k93_1 = tbody;
    this.l93_1 = fbody;
  }
  toString() {
    return 'If(cond=' + toString(this.j93_1) + ', tbody=' + toString(this.k93_1) + ', fbody=' + toString_1(this.l93_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.j93_1);
    result = imul(result, 31) + hashCode(this.k93_1) | 0;
    result = imul(result, 31) + (this.l93_1 == null ? 0 : hashCode(this.l93_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals(this.j93_1, tmp0_other_with_cast.j93_1))
      return false;
    if (!equals(this.k93_1, tmp0_other_with_cast.k93_1))
      return false;
    if (!equals(this.l93_1, tmp0_other_with_cast.l93_1))
      return false;
    return true;
  }
}
class ForSimple extends Stm {}
class Raw extends Stm {
  i94(name) {
    return this.k92_1.e3(name);
  }
  j94(name, default_0) {
    var tmp0_elvis_lhs = this.i94(name);
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  m92(name, default_0, $super) {
    default_0 = default_0 === VOID ? '' : default_0;
    return $super === VOID ? this.j94(name, default_0) : $super.j94.call(this, name, default_0);
  }
}
class FuncBuilder extends Builder {
  static s94(parent) {
    var $this = this.t94(parent);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.q94_1 = ArrayList.z();
    return $this;
  }
  r94(name, type) {
    // Inline function 'kotlin.also' call
    var this_0 = Arg.f95(name, type);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.FuncBuilder.ARG.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.q94_1.h(this_0);
    return this_0;
  }
}
class FuncDeclGetter {
  constructor(decl) {
    this.u95_1 = decl;
  }
  np(thisRef, property) {
    var tmp = this.u95_1;
    return isInterface(tmp, FuncRef) ? tmp : THROW_CCE();
  }
}
class FuncProvider {
  constructor(rettype, varTypes, builder, block) {
    this.k94_1 = rettype;
    this.l94_1 = varTypes;
    this.m94_1 = builder;
    this.n94_1 = block;
  }
  o8i(thisRef, property) {
    var tmp = property.callableName;
    var tmp_0 = this.m94_1.g8l(tmp, this.k94_1, Program$Builder$FuncProvider$provideDelegate$lambda(this));
    return new FuncDeclGetter(tmp_0 instanceof FuncDecl ? tmp_0 : THROW_CCE());
  }
}
class Program$Builder$_funcs$1 extends Visitor {
  constructor($funcs, $box) {
    if ($box === VOID)
      $box = {};
    $box.w95_1 = $funcs;
    super(Unit_instance, $box);
  }
  c90(func) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.w95_1;
    var key = func.q3();
    var tmp = func.g90();
    var value = tmp instanceof FuncDecl ? tmp : THROW_CCE();
    this_0.k3(key, value);
  }
  h90(func) {
    this.c90(func);
    return Unit_instance;
  }
}
class Ternary extends Operand {
  static y95(cond, otrue, ofalse) {
    var $this = this.z95(otrue.p3m());
    $this.g93_1 = cond;
    $this.h93_1 = otrue;
    $this.i93_1 = ofalse;
    return $this;
  }
  toString() {
    return 'Ternary(cond=' + toString(this.g93_1) + ', otrue=' + toString(this.h93_1) + ', ofalse=' + toString(this.i93_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.g93_1);
    result = imul(result, 31) + hashCode(this.h93_1) | 0;
    result = imul(result, 31) + hashCode(this.i93_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ternary))
      return false;
    var tmp0_other_with_cast = other instanceof Ternary ? other : THROW_CCE();
    if (!equals(this.g93_1, tmp0_other_with_cast.g93_1))
      return false;
    if (!equals(this.h93_1, tmp0_other_with_cast.h93_1))
      return false;
    if (!equals(this.i93_1, tmp0_other_with_cast.i93_1))
      return false;
    return true;
  }
}
class Unop extends Operand {
  static a96(op, right) {
    var $this = this.z95(right.p3m());
    $this.x92_1 = op;
    $this.y92_1 = right;
    return $this;
  }
  toString() {
    return 'Unop(op=' + this.x92_1 + ', right=' + toString(this.y92_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.x92_1);
    result = imul(result, 31) + hashCode(this.y92_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Unop))
      return false;
    var tmp0_other_with_cast = other instanceof Unop ? other : THROW_CCE();
    if (!(this.x92_1 === tmp0_other_with_cast.x92_1))
      return false;
    if (!equals(this.y92_1, tmp0_other_with_cast.y92_1))
      return false;
    return true;
  }
}
class Binop extends Operand {
  static b96(left, op, right) {
    var $this = this.z95(left.p3m());
    $this.a93_1 = left;
    $this.b93_1 = op;
    $this.c93_1 = right;
    return $this;
  }
  toString() {
    return 'Binop(left=' + toString(this.a93_1) + ', op=' + this.b93_1 + ', right=' + toString(this.c93_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.a93_1);
    result = imul(result, 31) + getStringHashCode(this.b93_1) | 0;
    result = imul(result, 31) + hashCode(this.c93_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals(this.a93_1, tmp0_other_with_cast.a93_1))
      return false;
    if (!(this.b93_1 === tmp0_other_with_cast.b93_1))
      return false;
    if (!equals(this.c93_1, tmp0_other_with_cast.c93_1))
      return false;
    return true;
  }
}
class IntLiteral extends Operand {}
class FloatLiteral extends Operand {
  static c96(value) {
    var $this = this.z95(VarType_Float1_getInstance());
    $this.t93_1 = value;
    return $this;
  }
  toString() {
    return 'FloatLiteral(value=' + this.t93_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.t93_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals(this.t93_1, tmp0_other_with_cast.t93_1))
      return false;
    return true;
  }
}
class BoolLiteral extends Operand {}
class Vector extends Operand {
  static d96(type, ops) {
    var $this = this.z95(type);
    $this.u92_1 = type;
    $this.v92_1 = ops;
    return $this;
  }
  p3m() {
    return this.u92_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this.u92_1.equals(other.u92_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.v92_1, other.v92_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return imul(this.u92_1.hashCode(), 7) + contentHashCode(this.v92_1) | 0;
  }
  toString() {
    return 'Vector(type=' + this.u92_1.toString() + ', ops=' + toString(this.v92_1) + ')';
  }
}
class Swizzle extends Operand {
  static e96(left, swizzle) {
    var $this = this.z95(left.p3m().f96(swizzle.length));
    $this.x93_1 = left;
    $this.y93_1 = swizzle;
    return $this;
  }
  toString() {
    return 'Swizzle(left=' + toString(this.x93_1) + ', swizzle=' + this.y93_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x93_1);
    result = imul(result, 31) + getStringHashCode(this.y93_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals(this.x93_1, tmp0_other_with_cast.x93_1))
      return false;
    if (!(this.y93_1 === tmp0_other_with_cast.y93_1))
      return false;
    return true;
  }
}
class ArrayAccess extends Operand {}
class BaseFunc extends Operand {
  static g96(type) {
    return this.z95(type);
  }
}
class Func extends BaseFunc {
  static l96(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    var $this = this.g96(type);
    $this.i96_1 = name;
    $this.j96_1 = ops;
    $this.k96_1 = type;
    return $this;
  }
  q3() {
    return this.i96_1;
  }
  e93() {
    return this.j96_1;
  }
  p3m() {
    return this.k96_1;
  }
  static m96(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    return this.l96(name, toList_0(ops), type);
  }
  toString() {
    return 'Func(name=' + this.i96_1 + ', ops=' + toString(this.j96_1) + ', type=' + this.k96_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.i96_1);
    result = imul(result, 31) + hashCode(this.j96_1) | 0;
    result = imul(result, 31) + this.k96_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this.i96_1 === tmp0_other_with_cast.i96_1))
      return false;
    if (!equals(this.j96_1, tmp0_other_with_cast.j96_1))
      return false;
    if (!this.k96_1.equals(tmp0_other_with_cast.k96_1))
      return false;
    return true;
  }
}
class CustomFunc extends BaseFunc {
  static n96(ref, ops) {
    var $this = this.g96(ref.o96());
    $this.e90_1 = ref;
    $this.f90_1 = ops;
    return $this;
  }
  g90() {
    return this.e90_1;
  }
  e93() {
    return this.f90_1;
  }
  q3() {
    return this.g90().q3();
  }
}
class FuncRef {}
class BuilderContext {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.p96_1 = ArrayList.z();
    this.q96_1 = 3;
  }
}
class Program {
  constructor(vertex, fragment, name) {
    name = name === VOID ? 'program-' + vertex.y8y_1 + '-' + fragment.y8y_1 : name;
    this.n8a_1 = vertex;
    this.o8a_1 = fragment;
    this.p8a_1 = name;
    this.q8a_1 = plus_0(this.n8a_1.d8z_1, this.o8a_1.d8z_1);
    this.r8a_1 = plus_0(this.n8a_1.e8z_1, this.o8a_1.e8z_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.r8a_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.Program.uniformBlocks.<anonymous>' call
      var tmp$ret$0 = item.l8b_1;
      destination.h(tmp$ret$0);
    }
    tmp.s8a_1 = distinct(destination);
    this.t8a_1 = plus_0(this.n8a_1.g8z_1, this.o8a_1.g8z_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = withIndex(this.q8a_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap.xc(capacity);
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element = tmp0_iterator_0.d1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.graphics.shader.Program.uniformsToIndex.<anonymous>' call
      var pair = to(element.dm_1, new UniformInProgram(element.dm_1, element.cm_1));
      destination_0.k3(pair.nm_1, pair.om_1);
    }
    tmp_0.u8a_1 = destination_0;
    this.v8a_1 = plus_0(this.n8a_1.f8z_1, this.o8a_1.f8z_1);
    this.w8a_1 = (imul(this.n8a_1.hashCode(), 11) + imul(this.o8a_1.hashCode(), 7) | 0) + getStringHashCode(this.p8a_1) | 0;
  }
  hashCode() {
    return this.w8a_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof Program) {
        tmp_2 = this.n8a_1.equals(other.n8a_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = this.o8a_1.equals(other.o8a_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.p8a_1 === other.p8a_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  p6() {
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.v8a_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$0 = item.d8p_1;
      destination.h(tmp$ret$0);
    }
    var tmp = toString(destination);
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.q8a_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var item_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$3 = item_0.d8p_1;
      destination_0.h(tmp$ret$3);
    }
    return 'Program(name=' + this.p8a_1 + ', attributes=' + tmp + ', uniforms=' + toString(destination_0) + ')';
  }
  t96(vertex, fragment, name) {
    return new Program(vertex, fragment, name);
  }
  u96(vertex, fragment, name, $super) {
    vertex = vertex === VOID ? this.n8a_1 : vertex;
    fragment = fragment === VOID ? this.o8a_1 : fragment;
    name = name === VOID ? this.p8a_1 : name;
    return $super === VOID ? this.t96(vertex, fragment, name) : $super.t96.call(this, vertex, fragment, name);
  }
}
class Shader {
  constructor(type, stm, functions, name) {
    name = name === VOID ? null : name;
    this.v8y_1 = type;
    this.w8y_1 = stm;
    this.x8y_1 = functions;
    this.y8y_1 = name;
    this.z8y_1 = hashCode(this.w8y_1);
    this.a8z_1 = hashCode(this.x8y_1);
    this.b8z_1 = (imul(this.v8y_1.hashCode(), 17) + this.z8y_1 | 0) + imul(this.a8z_1, 53) | 0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new GlobalsProgramVisitor();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Shader.globals.<anonymous>' call
    this_0.k90(this.w8y_1);
    tmp.c8z_1 = this_0;
    this.d8z_1 = this.c8z_1.n8z_1;
    this.e8z_1 = this.c8z_1.o8z_1;
    this.f8z_1 = this.c8z_1.l8z_1;
    this.g8z_1 = this.c8z_1.q8z_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      if (other instanceof Shader) {
        tmp_3 = this.v8y_1.equals(other.v8y_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = this.b8z_1 === other.b8z_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(this.w8y_1, other.w8y_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(this.x8y_1, other.x8y_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    return this.b8z_1;
  }
  toString() {
    return 'Shader(type=' + this.v8y_1.toString() + ', stm=' + toString(this.w8y_1) + ', functions=' + toString(this.x8y_1) + ', name=' + this.y8y_1 + ')';
  }
}
class Varying extends Variable {
  static v96(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.w96(name, type, arrayCount, precision);
  }
  static r8j(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.v96(name, type, 1, precision);
  }
  toString() {
    return 'Varying(' + this.d8p_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this.g8p_1 === other.g8p_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.p3m().equals(other.p3m());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t8q_1 === other.t8q_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d8p_1 === other.d8p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g8p_1 + imul(this.p3m().hashCode(), 7) | 0) + imul(getStringHashCode(this.d8p_1), 11) | 0;
  }
}
class Output extends Varying {
  static i97() {
    Output_instance = null;
    var $this = this.r8j('out', VarType_Float4_getInstance());
    Output_instance = $this;
    return $this;
  }
  toString() {
    return 'Output';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output) {
      tmp_2 = this.g8p_1 === other.g8p_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.p3m().equals(other.p3m());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t8q_1 === other.t8q_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d8p_1 === other.d8p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g8p_1 + imul(this.p3m().hashCode(), 7) | 0) + imul(getStringHashCode(this.d8p_1), 11) | 0;
  }
}
class Provider {
  constructor(index, stype) {
    this.m8i_1 = index;
    this.n8i_1 = stype;
  }
  o8i(thisRef, property) {
    return Sampler.j97(property.callableName, this.m8i_1, this.n8i_1);
  }
}
class Sampler extends Variable {
  static j97(name, index, stype) {
    var $this = this.n97(name, stype.m97_1);
    $this.c87_1 = index;
    $this.d87_1 = stype;
    return $this;
  }
  toString() {
    return 'Sampler(' + this.d8p_1 + ', ' + this.c87_1 + ', ' + this.d87_1.toString() + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Sampler) {
      tmp_2 = this.g8p_1 === other.g8p_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.p3m().equals(other.p3m());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t8q_1 === other.t8q_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d8p_1 === other.d8p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g8p_1 + imul(this.p3m().hashCode(), 7) | 0) + imul(getStringHashCode(this.d8p_1), 11) | 0;
  }
  np(thisRef, property) {
    return this;
  }
}
class SamplerVarType extends Enum {
  constructor(name, ordinal, vtype) {
    super(name, ordinal);
    this.m97_1 = vtype;
  }
}
class Uniform extends VariableWithOffset {
  static c8y(name, type, arrayCount, precision, offset, typedUniform) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.o8x(name, type, arrayCount, precision, offset);
    $this.b8y_1 = typedUniform;
    if (type.o97()) {
      // Inline function 'kotlin.error' call
      var message = "Can't create uniform '" + name + "' with a sampler type '" + type.toString() + "', please use `Sampler` class instead";
      throw IllegalStateException.h5(toString(message));
    }
    return $this;
  }
  toString() {
    return 'Uniform(' + this.d8p_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this.g8p_1 === other.g8p_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.p3m().equals(other.p3m());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t8q_1 === other.t8q_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d8p_1 === other.d8p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g8p_1 + imul(this.p3m().hashCode(), 7) | 0) + imul(getStringHashCode(this.d8p_1), 11) | 0;
  }
}
class Companion_48 {
  p97(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SByte1_getInstance();
        break;
      case 2:
        tmp = VarType_SByte2_getInstance();
        break;
      case 3:
        tmp = VarType_SByte3_getInstance();
        break;
      case 4:
        tmp = VarType_SByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  q97(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UByte1_getInstance();
        break;
      case 2:
        tmp = VarType_UByte2_getInstance();
        break;
      case 3:
        tmp = VarType_UByte3_getInstance();
        break;
      case 4:
        tmp = VarType_UByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  r97(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SShort1_getInstance();
        break;
      case 2:
        tmp = VarType_SShort2_getInstance();
        break;
      case 3:
        tmp = VarType_SShort3_getInstance();
        break;
      case 4:
        tmp = VarType_SShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  s97(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UShort1_getInstance();
        break;
      case 2:
        tmp = VarType_UShort2_getInstance();
        break;
      case 3:
        tmp = VarType_UShort3_getInstance();
        break;
      case 4:
        tmp = VarType_UShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  t97(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SInt1_getInstance();
        break;
      case 2:
        tmp = VarType_SInt2_getInstance();
        break;
      case 3:
        tmp = VarType_SInt3_getInstance();
        break;
      case 4:
        tmp = VarType_SInt4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  u97(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Float2_getInstance();
        break;
      case 3:
        tmp = VarType_Float3_getInstance();
        break;
      case 4:
        tmp = VarType_Float4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
}
class VarType extends Enum {
  constructor(name, ordinal, kind, elementCount, isMatrix) {
    isMatrix = isMatrix === VOID ? false : isMatrix;
    super(name, ordinal);
    this.a8r_1 = kind;
    this.b8r_1 = elementCount;
    this.c8r_1 = isMatrix;
    this.d8r_1 = imul(this.a8r_1.f94_1, this.b8r_1);
  }
  f96(length) {
    var tmp;
    switch (this.a8r_1.p3_1) {
      case 1:
        tmp = Companion_instance_57.p97(length);
        break;
      case 2:
        tmp = Companion_instance_57.q97(length);
        break;
      case 3:
        tmp = Companion_instance_57.r97(length);
        break;
      case 4:
        tmp = Companion_instance_57.s97(length);
        break;
      case 5:
        tmp = Companion_instance_57.t97(length);
        break;
      case 6:
        tmp = Companion_instance_57.u97(length);
        break;
      default:
        throw NotImplementedError.je();
    }
    return tmp;
  }
  o97() {
    return this.equals(VarType_Sampler1D_getInstance()) || this.equals(VarType_Sampler2D_getInstance()) || this.equals(VarType_Sampler3D_getInstance()) || this.equals(VarType_SamplerCube_getInstance());
  }
}
class Precision extends Enum {}
class Temp extends Variable {
  static v97(id, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.w96('temp' + id, type, arrayCount, precision);
  }
  static d8k(id, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.v97(id, type, 1, precision);
  }
  toString() {
    return 'Temp(' + this.d8p_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp) {
      tmp_2 = this.g8p_1 === other.g8p_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.p3m().equals(other.p3m());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t8q_1 === other.t8q_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d8p_1 === other.d8p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g8p_1 + imul(this.p3m().hashCode(), 7) | 0) + imul(getStringHashCode(this.d8p_1), 11) | 0;
  }
}
class FuncDecl {
  constructor(name, rettype, args, stm) {
    this.y91_1 = name;
    this.z91_1 = rettype;
    this.a92_1 = args;
    this.b92_1 = stm;
    this.c92_1 = this;
  }
  q3() {
    return this.y91_1;
  }
  o96() {
    return this.z91_1;
  }
  toString() {
    return 'FuncDecl(name=' + this.y91_1 + ', rettype=' + this.z91_1.toString() + ', args=' + toString(this.a92_1) + ', stm=' + toString(this.b92_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.y91_1);
    result = imul(result, 31) + this.z91_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.a92_1) | 0;
    result = imul(result, 31) + hashCode(this.b92_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FuncDecl))
      return false;
    var tmp0_other_with_cast = other instanceof FuncDecl ? other : THROW_CCE();
    if (!(this.y91_1 === tmp0_other_with_cast.y91_1))
      return false;
    if (!this.z91_1.equals(tmp0_other_with_cast.z91_1))
      return false;
    if (!equals(this.a92_1, tmp0_other_with_cast.a92_1))
      return false;
    if (!equals(this.b92_1, tmp0_other_with_cast.b92_1))
      return false;
    return true;
  }
}
class VarKind extends Enum {
  constructor(name, ordinal, bytesSize) {
    super(name, ordinal);
    this.f94_1 = bytesSize;
  }
}
class UniformInProgram {
  constructor(uniform, index) {
    this.x97_1 = uniform;
    this.y97_1 = index;
  }
  toString() {
    return 'UniformInProgram(uniform=' + this.x97_1.toString() + ', index=' + this.y97_1 + ')';
  }
  hashCode() {
    var result = this.x97_1.hashCode();
    result = imul(result, 31) + this.y97_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UniformInProgram))
      return false;
    var tmp0_other_with_cast = other instanceof UniformInProgram ? other : THROW_CCE();
    if (!this.x97_1.equals(tmp0_other_with_cast.x97_1))
      return false;
    if (!(this.y97_1 === tmp0_other_with_cast.y97_1))
      return false;
    return true;
  }
}
class Arg extends Variable {
  static f95(name, type, arrayCount, precision) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.w96(name, type, arrayCount, precision);
  }
  toString() {
    return 'Arg(' + this.d8p_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Arg) {
      tmp_2 = this.g8p_1 === other.g8p_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.p3m().equals(other.p3m());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t8q_1 === other.t8q_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d8p_1 === other.d8p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g8p_1 + imul(this.p3m().hashCode(), 7) | 0) + imul(getStringHashCode(this.d8p_1), 11) | 0;
  }
}
class ShaderType extends Enum {}
class sam$kotlinx_coroutines_DisposableHandle$0 {
  constructor(function_0) {
    this.z97_1 = function_0;
  }
  k2i() {
    return this.z97_1();
  }
  o4() {
    return this.z97_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class ContextInfo {
  constructor() {
    var tmp = this;
    tmp.a98_1 = KmlGl$ContextInfo$current$lambda;
  }
  toString() {
    return 'current=' + toString_1(this.a98_1());
  }
}
class Companion_49 {
  constructor() {
    this.b98_1 = 33309;
    this.c98_1 = 33084;
    this.d98_1 = 33085;
    this.e98_1 = 256;
    this.f98_1 = 1024;
    this.g98_1 = 16384;
    this.h98_1 = 0;
    this.i98_1 = 1;
    this.j98_1 = 0;
    this.k98_1 = 1;
    this.l98_1 = 2;
    this.m98_1 = 3;
    this.n98_1 = 4;
    this.o98_1 = 5;
    this.p98_1 = 6;
    this.q98_1 = 0;
    this.r98_1 = 1;
    this.s98_1 = 768;
    this.t98_1 = 769;
    this.u98_1 = 770;
    this.v98_1 = 771;
    this.w98_1 = 772;
    this.x98_1 = 773;
    this.y98_1 = 774;
    this.z98_1 = 775;
    this.a99_1 = 776;
    this.b99_1 = 32774;
    this.c99_1 = 32777;
    this.d99_1 = 32777;
    this.e99_1 = 34877;
    this.f99_1 = 32778;
    this.g99_1 = 32779;
    this.h99_1 = 32968;
    this.i99_1 = 32969;
    this.j99_1 = 32970;
    this.k99_1 = 32971;
    this.l99_1 = 32769;
    this.m99_1 = 32770;
    this.n99_1 = 32771;
    this.o99_1 = 32772;
    this.p99_1 = 32773;
    this.q99_1 = 34962;
    this.r99_1 = 34963;
    this.s99_1 = 34964;
    this.t99_1 = 34965;
    this.u99_1 = 35040;
    this.v99_1 = 35044;
    this.w99_1 = 35048;
    this.x99_1 = 34660;
    this.y99_1 = 34661;
    this.z99_1 = 34342;
    this.a9a_1 = 1028;
    this.b9a_1 = 1029;
    this.c9a_1 = 1032;
    this.d9a_1 = 3553;
    this.e9a_1 = 32879;
    this.f9a_1 = 2884;
    this.g9a_1 = 3042;
    this.h9a_1 = 3024;
    this.i9a_1 = 2960;
    this.j9a_1 = 2929;
    this.k9a_1 = 3089;
    this.l9a_1 = 32823;
    this.m9a_1 = 32926;
    this.n9a_1 = 32928;
    this.o9a_1 = 0;
    this.p9a_1 = 1280;
    this.q9a_1 = 1281;
    this.r9a_1 = 1282;
    this.s9a_1 = 1285;
    this.t9a_1 = 2304;
    this.u9a_1 = 2305;
    this.v9a_1 = 2849;
    this.w9a_1 = 33901;
    this.x9a_1 = 33902;
    this.y9a_1 = 2885;
    this.z9a_1 = 2886;
    this.a9b_1 = 2928;
    this.b9b_1 = 2930;
    this.c9b_1 = 2931;
    this.d9b_1 = 2932;
    this.e9b_1 = 2961;
    this.f9b_1 = 2962;
    this.g9b_1 = 2964;
    this.h9b_1 = 2965;
    this.i9b_1 = 2966;
    this.j9b_1 = 2967;
    this.k9b_1 = 2963;
    this.l9b_1 = 2968;
    this.m9b_1 = 34816;
    this.n9b_1 = 34817;
    this.o9b_1 = 34818;
    this.p9b_1 = 34819;
    this.q9b_1 = 36003;
    this.r9b_1 = 36004;
    this.s9b_1 = 36005;
    this.t9b_1 = 2978;
    this.u9b_1 = 3088;
    this.v9b_1 = 3106;
    this.w9b_1 = 3107;
    this.x9b_1 = 3317;
    this.y9b_1 = 3333;
    this.z9b_1 = 3379;
    this.a9c_1 = 3386;
    this.b9c_1 = 3408;
    this.c9c_1 = 3410;
    this.d9c_1 = 3411;
    this.e9c_1 = 3412;
    this.f9c_1 = 3413;
    this.g9c_1 = 3414;
    this.h9c_1 = 3415;
    this.i9c_1 = 10752;
    this.j9c_1 = 32824;
    this.k9c_1 = 32873;
    this.l9c_1 = 32936;
    this.m9c_1 = 32937;
    this.n9c_1 = 32938;
    this.o9c_1 = 32939;
    this.p9c_1 = 34466;
    this.q9c_1 = 34467;
    this.r9c_1 = 4352;
    this.s9c_1 = 4353;
    this.t9c_1 = 4354;
    this.u9c_1 = 33170;
    this.v9c_1 = 5120;
    this.w9c_1 = 5121;
    this.x9c_1 = 5122;
    this.y9c_1 = 5123;
    this.z9c_1 = 5124;
    this.a9d_1 = 5125;
    this.b9d_1 = 5126;
    this.c9d_1 = 5132;
    this.d9d_1 = 6402;
    this.e9d_1 = 6406;
    this.f9d_1 = 6407;
    this.g9d_1 = 6408;
    this.h9d_1 = 6409;
    this.i9d_1 = 6410;
    this.j9d_1 = 32819;
    this.k9d_1 = 32820;
    this.l9d_1 = 33635;
    this.m9d_1 = 35632;
    this.n9d_1 = 35633;
    this.o9d_1 = 34921;
    this.p9d_1 = 36347;
    this.q9d_1 = 36348;
    this.r9d_1 = 35661;
    this.s9d_1 = 35660;
    this.t9d_1 = 34930;
    this.u9d_1 = 36349;
    this.v9d_1 = 35663;
    this.w9d_1 = 35712;
    this.x9d_1 = 35714;
    this.y9d_1 = 35715;
    this.z9d_1 = 35717;
    this.a9e_1 = 35718;
    this.b9e_1 = 35719;
    this.c9e_1 = 35721;
    this.d9e_1 = 35722;
    this.e9e_1 = 35724;
    this.f9e_1 = 35725;
    this.g9e_1 = 512;
    this.h9e_1 = 513;
    this.i9e_1 = 514;
    this.j9e_1 = 515;
    this.k9e_1 = 516;
    this.l9e_1 = 517;
    this.m9e_1 = 518;
    this.n9e_1 = 519;
    this.o9e_1 = 7680;
    this.p9e_1 = 7681;
    this.q9e_1 = 7682;
    this.r9e_1 = 7683;
    this.s9e_1 = 5386;
    this.t9e_1 = 34055;
    this.u9e_1 = 34056;
    this.v9e_1 = 7936;
    this.w9e_1 = 7937;
    this.x9e_1 = 7938;
    this.y9e_1 = 7939;
    this.z9e_1 = 9728;
    this.a9f_1 = 9729;
    this.b9f_1 = 9984;
    this.c9f_1 = 9985;
    this.d9f_1 = 9986;
    this.e9f_1 = 9987;
    this.f9f_1 = 10240;
    this.g9f_1 = 10241;
    this.h9f_1 = 10242;
    this.i9f_1 = 10243;
    this.j9f_1 = 32882;
    this.k9f_1 = 5890;
    this.l9f_1 = 34067;
    this.m9f_1 = 34068;
    this.n9f_1 = 34069;
    this.o9f_1 = 34070;
    this.p9f_1 = 34071;
    this.q9f_1 = 34072;
    this.r9f_1 = 34073;
    this.s9f_1 = 34074;
    this.t9f_1 = 34076;
    this.u9f_1 = 33984;
    this.v9f_1 = 33985;
    this.w9f_1 = 33986;
    this.x9f_1 = 33987;
    this.y9f_1 = 33988;
    this.z9f_1 = 33989;
    this.a9g_1 = 33990;
    this.b9g_1 = 33991;
    this.c9g_1 = 33992;
    this.d9g_1 = 33993;
    this.e9g_1 = 33994;
    this.f9g_1 = 33995;
    this.g9g_1 = 33996;
    this.h9g_1 = 33997;
    this.i9g_1 = 33998;
    this.j9g_1 = 33999;
    this.k9g_1 = 34000;
    this.l9g_1 = 34001;
    this.m9g_1 = 34002;
    this.n9g_1 = 34003;
    this.o9g_1 = 34004;
    this.p9g_1 = 34005;
    this.q9g_1 = 34006;
    this.r9g_1 = 34007;
    this.s9g_1 = 34008;
    this.t9g_1 = 34009;
    this.u9g_1 = 34010;
    this.v9g_1 = 34011;
    this.w9g_1 = 34012;
    this.x9g_1 = 34013;
    this.y9g_1 = 34014;
    this.z9g_1 = 34015;
    this.a9h_1 = 34016;
    this.b9h_1 = 10497;
    this.c9h_1 = 33071;
    this.d9h_1 = 33648;
    this.e9h_1 = 35664;
    this.f9h_1 = 35665;
    this.g9h_1 = 35666;
    this.h9h_1 = 35667;
    this.i9h_1 = 35668;
    this.j9h_1 = 35669;
    this.k9h_1 = 35670;
    this.l9h_1 = 35671;
    this.m9h_1 = 35672;
    this.n9h_1 = 35673;
    this.o9h_1 = 35674;
    this.p9h_1 = 35675;
    this.q9h_1 = 35676;
    this.r9h_1 = 35678;
    this.s9h_1 = 35680;
    this.t9h_1 = 34338;
    this.u9h_1 = 34339;
    this.v9h_1 = 34340;
    this.w9h_1 = 34341;
    this.x9h_1 = 34922;
    this.y9h_1 = 34373;
    this.z9h_1 = 34975;
    this.a9i_1 = 35738;
    this.b9i_1 = 35739;
    this.c9i_1 = 35713;
    this.d9i_1 = 35716;
    this.e9i_1 = 35720;
    this.f9i_1 = 36346;
    this.g9i_1 = 36344;
    this.h9i_1 = 36345;
    this.i9i_1 = 36336;
    this.j9i_1 = 36337;
    this.k9i_1 = 36338;
    this.l9i_1 = 36339;
    this.m9i_1 = 36340;
    this.n9i_1 = 36341;
    this.o9i_1 = 36160;
    this.p9i_1 = 36161;
    this.q9i_1 = 32854;
    this.r9i_1 = 32855;
    this.s9i_1 = 36194;
    this.t9i_1 = 33189;
    this.u9i_1 = 6401;
    this.v9i_1 = 36168;
    this.w9i_1 = 36162;
    this.x9i_1 = 36163;
    this.y9i_1 = 36164;
    this.z9i_1 = 36176;
    this.a9j_1 = 36177;
    this.b9j_1 = 36178;
    this.c9j_1 = 36179;
    this.d9j_1 = 36180;
    this.e9j_1 = 36181;
    this.f9j_1 = 36048;
    this.g9j_1 = 36049;
    this.h9j_1 = 36050;
    this.i9j_1 = 36051;
    this.j9j_1 = 36064;
    this.k9j_1 = 36096;
    this.l9j_1 = 33306;
    this.m9j_1 = 34041;
    this.n9j_1 = 36128;
    this.o9j_1 = 0;
    this.p9j_1 = 36053;
    this.q9j_1 = 36054;
    this.r9j_1 = 36055;
    this.s9j_1 = 36057;
    this.t9j_1 = 36061;
    this.u9j_1 = 36006;
    this.v9j_1 = 36007;
    this.w9j_1 = 34024;
    this.x9j_1 = 1286;
    this.y9j_1 = 37120;
    this.z9j_1 = 34836;
    this.a9k_1 = 3313;
    this.b9k_1 = 3314;
    this.c9k_1 = 3316;
    this.d9k_1 = 3315;
    this.e9k_1 = 3312;
    this.f9k_1 = 37441;
    this.g9k_1 = 36197;
    this.h9k_1 = 35345;
    this.i9k_1 = 35368;
    this.j9k_1 = 35380;
  }
}
class KmlGl {
  constructor() {
    this.b8o_1 = new Mixin();
    this.c8o_1 = new ContextInfo();
    this.d8o_1 = null;
    var tmp = this;
    tmp.e8o_1 = lazy(KmlGl$isFloatTextureSupported$delegate$lambda(this));
  }
  q8r(texture) {
    throw NotImplementedError.je();
  }
  u8v(program, shader) {
    throw NotImplementedError.je();
  }
  t8v(program, index, name) {
    throw NotImplementedError.je();
  }
  k8q(target, buffer) {
    throw NotImplementedError.je();
  }
  m8u(target, framebuffer) {
    throw NotImplementedError.je();
  }
  t8u(target, renderbuffer) {
    throw NotImplementedError.je();
  }
  k8u(target, texture) {
    throw NotImplementedError.je();
  }
  x8s(modeRGB, modeAlpha) {
    throw NotImplementedError.je();
  }
  y8s(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    throw NotImplementedError.je();
  }
  u8r(target, size, data, usage) {
    throw NotImplementedError.je();
  }
  t8r(target, offset, size, data) {
    throw NotImplementedError.je();
  }
  q1s(mask) {
    throw NotImplementedError.je();
  }
  p8s(red, green, blue, alpha) {
    throw NotImplementedError.je();
  }
  r8s(d) {
    throw NotImplementedError.je();
  }
  t8s(s) {
    throw NotImplementedError.je();
  }
  a8v(red, green, blue, alpha) {
    throw NotImplementedError.je();
  }
  l8v(shader) {
    throw NotImplementedError.je();
  }
  n8v() {
    throw NotImplementedError.je();
  }
  j8v(type) {
    throw NotImplementedError.je();
  }
  q8t(mode) {
    throw NotImplementedError.je();
  }
  k9k(n, items) {
    throw NotImplementedError.je();
  }
  l9k(n, items) {
    throw NotImplementedError.je();
  }
  i8v(program) {
    throw NotImplementedError.je();
  }
  m9k(n, items) {
    throw NotImplementedError.je();
  }
  h8v(shader) {
    throw NotImplementedError.je();
  }
  n9k(n, items) {
    throw NotImplementedError.je();
  }
  z8u(func) {
    throw NotImplementedError.je();
  }
  q8s(flag) {
    throw NotImplementedError.je();
  }
  y8u(n, f) {
    throw NotImplementedError.je();
  }
  c8t(cap) {
    throw NotImplementedError.je();
  }
  s8t(index) {
    throw NotImplementedError.je();
  }
  j8t(mode, first, count) {
    throw NotImplementedError.je();
  }
  l8t(mode, count, type, indices) {
    throw NotImplementedError.je();
  }
  d8t(cap) {
    throw NotImplementedError.je();
  }
  w8t(index) {
    throw NotImplementedError.je();
  }
  gd() {
    throw NotImplementedError.je();
  }
  w8u(target, attachment, renderbuffertarget, renderbuffer) {
    throw NotImplementedError.je();
  }
  v8u(target, attachment, textarget, texture, level) {
    throw NotImplementedError.je();
  }
  x8u(mode) {
    throw NotImplementedError.je();
  }
  o9k(n, buffers) {
    throw NotImplementedError.je();
  }
  y8r(target) {
    throw NotImplementedError.je();
  }
  p9k(n, framebuffers) {
    throw NotImplementedError.je();
  }
  q9k(n, renderbuffers) {
    throw NotImplementedError.je();
  }
  r9k(n, textures) {
    throw NotImplementedError.je();
  }
  f8v(program, name) {
    throw NotImplementedError.je();
  }
  m8v() {
    throw NotImplementedError.je();
  }
  s9k(pname, data) {
    throw NotImplementedError.je();
  }
  t9k(program, pname, params) {
    throw NotImplementedError.je();
  }
  u9k(shader, pname, params) {
    throw NotImplementedError.je();
  }
  v9k(shader, bufSize, length, infoLog) {
    throw NotImplementedError.je();
  }
  f8o(name) {
    throw NotImplementedError.je();
  }
  v8v(program) {
    throw NotImplementedError.je();
  }
  v8r(pname, param) {
    throw NotImplementedError.je();
  }
  u8u(target, internalformat, width, height) {
    throw NotImplementedError.je();
  }
  b8v(x, y, width, height) {
    throw NotImplementedError.je();
  }
  k8v(shader, string) {
    throw NotImplementedError.je();
  }
  f8t(func, ref, mask) {
    throw NotImplementedError.je();
  }
  e8t(face, func, ref, mask) {
    throw NotImplementedError.je();
  }
  s8s(mask) {
    throw NotImplementedError.je();
  }
  i8t(face, mask) {
    throw NotImplementedError.je();
  }
  h8t(fail, zfail, zpass) {
    throw NotImplementedError.je();
  }
  g8t(face, sfail, dpfail, dppass) {
    throw NotImplementedError.je();
  }
  w8r(target, level, internalformat, width, height, border, format, type, pixels) {
    throw NotImplementedError.je();
  }
  x8r(target, level, internalformat, format, type, data) {
    var buffer = Buffer.o2c(imul(imul(data.r56_1, data.s56_1), 4), true);
    setArrayLE(buffer, 0, data.o5e().h56_1);
    this.w8r(target, level, internalformat, data.r56_1, data.s56_1, 0, format, type, buffer);
  }
  p8r(target, pname, param) {
    throw NotImplementedError.je();
  }
  l8r(location, count, value) {
    throw NotImplementedError.je();
  }
  j8p(location, v0) {
    throw NotImplementedError.je();
  }
  e8r(location, count, value) {
    throw NotImplementedError.je();
  }
  m8r(location, count, value) {
    throw NotImplementedError.je();
  }
  f8r(location, count, value) {
    throw NotImplementedError.je();
  }
  n8r(location, count, value) {
    throw NotImplementedError.je();
  }
  g8r(location, count, value) {
    throw NotImplementedError.je();
  }
  o8r(location, count, value) {
    throw NotImplementedError.je();
  }
  h8r(location, count, value) {
    throw NotImplementedError.je();
  }
  i8r(location, count, transpose, value) {
    throw NotImplementedError.je();
  }
  j8r(location, count, transpose, value) {
    throw NotImplementedError.je();
  }
  k8r(location, count, transpose, value) {
    throw NotImplementedError.je();
  }
  g8v(program) {
    throw NotImplementedError.je();
  }
  x8t(index, size, type, normalized, stride, pointer) {
    throw NotImplementedError.je();
  }
  l8u(x, y, width, height) {
    throw NotImplementedError.je();
  }
  z8s(cap, enable) {
    if (enable) {
      this.d8t(cap);
    } else {
      this.c8t(cap);
    }
    return enable;
  }
  k8t(mode, first, count, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  m8t(mode, count, type, indices, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  r8t(index, divisor) {
    unsupported();
  }
  e8u(target, index, buffer, offset, size) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  k8p(program, name) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  l8p(program, uniformBlockIndex, uniformBlockBinding) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  w9k(n, arrays) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  t8t(array) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  r8r() {
    return Companion_instance_54.o8y();
  }
  k8s() {
    return Unit_instance;
  }
  o8t(contextVersion) {
    return Unit_instance;
  }
  x9k(name, index) {
    throw NotImplementedError.je();
  }
  a7b() {
    if (this.d8o_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        var numExtensions = getIntegerv(this, 33309);
        if (numExtensions <= 0) {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.je();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = until(0, numExtensions);
        var destination = ArrayList.z();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = this_0.f2_1;
        var last = this_0.g2_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'korlibs.kgl.KmlGl.<get-extensions>.<anonymous>' call
            var it = element;
            // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
            var tmp0_safe_receiver = this.x9k(7939, it);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              destination.h(tmp0_safe_receiver);
            }
          }
           while (!(element === last));
        tmp_0 = toSet(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          tmp_1 = toSet(split(this.f8o(7939), [' ']));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp.d8o_1 = tmp_0;
    }
    return ensureNotNull(this.d8o_1);
  }
  l8s() {
    return this.a7b();
  }
  c28(value) {
    this.b8o_1.c28(value);
  }
  d28() {
    return this.b8o_1.d28();
  }
}
class KmlGlContext {
  constructor(window_0, gl, parent, $box) {
    parent = parent === VOID ? null : parent;
    boxApply(this, $box);
    this.h8s_1 = window_0;
    this.i8s_1 = gl;
    this.j8s_1 = parent;
  }
  n8t() {
  }
  p8t() {
  }
  p6() {
  }
}
class KorgeReloadInternalImpl {
  y9k(clazz, context) {
    return clazz;
  }
  z9k(old, new_0) {
    return Unit_instance;
  }
}
class ReloadClassContext {
  constructor(injector, refreshedClasses, rootFolders) {
    this.a9l_1 = injector;
    this.b9l_1 = refreshedClasses;
    this.c9l_1 = rootFolders;
  }
}
class KorgeReload {
  constructor() {
    KorgeReload_instance = this;
    this.d9l_1 = null;
    this.e9l_1 = Companion_getInstance_1().g26('KorgeReload');
  }
  f9l(eventDispatcher) {
    if (!Companion_getInstance_3().u23().f24() || !(Companion_instance_1.cj('KORGE_AUTORELOAD') === 'true'))
      return Unit_instance;
    this.d9l_1 = eventDispatcher;
  }
  g9l() {
    if (!Companion_getInstance_3().u23().f24())
      return Unit_instance;
    if (!(this.d9l_1 == null))
      this.d9l_1 = null;
  }
}
class Companion_50 {}
class Companion_51 {
  constructor() {
    Companion_instance_60 = this;
    var tmp = this;
    var tmp0_factors = Companion_getInstance_42().m84_1;
    tmp.h9l_1 = new BlendMode(tmp0_factors, 'NORMAL');
    this.i9l_1 = this.h9l_1.u9o(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp0_factors_0 = Companion_getInstance_42().g8d(Companion_getInstance_52().x8c_1, Companion_getInstance_52().e8d_1);
    tmp_0.j9l_1 = new BlendMode(tmp0_factors_0, 'NONE');
    var tmp_1 = this;
    var tmp0_factors_1 = Companion_getInstance_42().o84_1;
    tmp_1.k9l_1 = new BlendMode(tmp0_factors_1, 'ADD');
    var tmp_2 = this;
    var tmp0_factors_2 = Companion_getInstance_42().g8d(Companion_getInstance_52().w8c_1, Companion_getInstance_52().a8d_1);
    tmp_2.l9l_1 = new BlendMode(tmp0_factors_2, 'MULTIPLY');
    var tmp_3 = this;
    var tmp0_factors_3 = Companion_getInstance_42().g8d(Companion_getInstance_52().x8c_1, Companion_getInstance_52().b8d_1);
    tmp_3.m9l_1 = new BlendMode(tmp0_factors_3, 'SCREEN');
    var tmp_4 = this;
    var tmp0_factors_4 = Companion_getInstance_42().g8d(Companion_getInstance_52().e8d_1, Companion_getInstance_52().a8d_1);
    tmp_4.n9l_1 = new BlendMode(tmp0_factors_4, 'ERASE');
    var tmp_5 = this;
    var tmp0_factors_5 = Companion_getInstance_42().g8d(Companion_getInstance_52().e8d_1, Companion_getInstance_52().c8d_1);
    tmp_5.o9l_1 = new BlendMode(tmp0_factors_5, 'MASK');
    var tmp_6 = this;
    var tmp0_factors_6 = Companion_getInstance_42().g8d(Companion_getInstance_52().y8c_1, Companion_getInstance_52().v8c_1);
    tmp_6.p9l_1 = new BlendMode(tmp0_factors_6, 'BELOW');
    var tmp_7 = this;
    var tmp0_factors_7 = Companion_getInstance_42().f8d(Companion_getInstance_52().c8d_1, Companion_getInstance_52().v8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_53().k8d_1);
    tmp_7.q9l_1 = new BlendMode(tmp0_factors_7, 'SUBTRACT');
    var tmp_8 = this;
    var tmp0_factors_8 = Companion_getInstance_42().f8d(Companion_getInstance_52().z8c_1, Companion_getInstance_52().e8d_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1);
    tmp_8.r9l_1 = new BlendMode(tmp0_factors_8, 'INVERT');
    var tmp_9 = this;
    var tmp0_factors_9 = Companion_getInstance_42().f8d(Companion_getInstance_52().c8d_1, Companion_getInstance_52().v8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1);
    tmp_9.s9l_1 = new BlendMode(tmp0_factors_9, 'LIGHTEN');
    var tmp_10 = this;
    var tmp0_factors_10 = Companion_getInstance_42().f8d(Companion_getInstance_52().c8d_1, Companion_getInstance_52().v8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1);
    tmp_10.t9l_1 = new BlendMode(tmp0_factors_10, 'DARKEN');
    var tmp_11 = this;
    var tmp0_factors_11 = Companion_getInstance_42().f8d(Companion_getInstance_52().c8d_1, Companion_getInstance_52().v8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1);
    tmp_11.u9l_1 = new BlendMode(tmp0_factors_11, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp0_factors_12 = Companion_getInstance_42().f8d(Companion_getInstance_52().c8d_1, Companion_getInstance_52().v8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1);
    tmp_12.v9l_1 = new BlendMode(tmp0_factors_12, 'ALPHA');
    var tmp_13 = this;
    var tmp0_factors_13 = Companion_getInstance_42().f8d(Companion_getInstance_52().c8d_1, Companion_getInstance_52().v8c_1, Companion_getInstance_52().x8c_1, Companion_getInstance_52().x8c_1);
    tmp_13.w9l_1 = new BlendMode(tmp0_factors_13, 'HARDLIGHT');
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.x9l_1 = [this.i9l_1, this.j9l_1, this.h9l_1, this.k9l_1, this.l9l_1, this.m9l_1, this.n9l_1, this.o9l_1, this.p9l_1, this.q9l_1, this.r9l_1, this.s9l_1, this.t9l_1, this.u9l_1, this.v9l_1, this.w9l_1];
    var tmp_15 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.x9l_1;
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.blend.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$3 = ensureNotNull(element.s9o_1);
      destination.k3(tmp$ret$3, element);
    }
    tmp_15.y9l_1 = destination;
    this.z9l_1 = toList_0(this.x9l_1);
    var tmp_16 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_indices(this.x9l_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.xc(capacity_0);
    var inductionVariable_0 = this_1.f2_1;
    var last_0 = this_1.g2_1;
    if (inductionVariable_0 <= last_0)
      do {
        var element_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'korlibs.korge.blend.Companion.TO_ORDINAL.<anonymous>' call
        var it = element_0;
        var tmp$ret$6 = Companion_getInstance_66().x9l_1[it];
        destination_0.k3(tmp$ret$6, element_0);
      }
       while (!(element_0 === last_0));
    tmp_16.a9m_1 = destination_0;
  }
}
class BlendMode {
  constructor(factors, name) {
    Companion_getInstance_66();
    name = name === VOID ? null : name;
    this.r9o_1 = factors;
    this.s9o_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.r9o_1);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.s9o_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.t9o_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  hashCode() {
    return this.t9o_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.r9o_1 === other.r9o_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.s9o_1 == other.s9o_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  toString() {
    var tmp0_elvis_lhs = this.s9o_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  }
  v9o(factors, name) {
    return new BlendMode(factors, name);
  }
  u9o(factors, name, $super) {
    factors = factors === VOID ? this.r9o_1 : factors;
    name = name === VOID ? this.s9o_1 : name;
    return $super === VOID ? this.v9o(factors, name) : $super.v9o.call(this, new AGBlending(factors), name);
  }
}
class InputKeys {
  constructor() {
    this.w9o_1 = booleanArray(Companion_getInstance_34().x81_1);
    this.x9o_1 = booleanArray(Companion_getInstance_34().x81_1);
    this.y9o_1 = false;
    this.z9o_1 = false;
    this.a9p_1 = false;
    this.b9p_1 = false;
  }
  c9p(key) {
    return this.d9p(key);
  }
  d9p(key) {
    return this.w9o_1[key.p3_1];
  }
  e9p(key) {
    return this.w9o_1[key.p3_1] && !this.x9o_1[key.p3_1];
  }
  f9p(key, up, shift, ctrl, alt, meta) {
    switch (up) {
      case true:
        this.w9o_1[key.p3_1] = false;
        break;
      case false:
        this.w9o_1[key.p3_1] = true;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.y9o_1 = shift || this.c9p(Companion_getInstance_34().l82()) || this.c9p(Companion_getInstance_34().m82());
    this.z9o_1 = ctrl || this.c9p(Companion_getInstance_34().j82()) || this.c9p(Companion_getInstance_34().k82());
    this.a9p_1 = alt || this.c9p(Companion_getInstance_34().n82()) || this.c9p(Companion_getInstance_34().o82());
    this.b9p_1 = meta || this.c9p(Key_META_getInstance());
  }
  g9p(e) {
    switch (e.q7w_1.p3_1) {
      case 0:
      case 1:
        this.f9p(e.s7w_1, e.q7w_1.equals(Type_UP_getInstance()), this.y9o_1, this.z9o_1, this.a9p_1, this.b9p_1);
        break;
      default:
        break;
    }
  }
  h9p(delta) {
  }
  i9p(delta) {
    arraycopy_4(this.w9o_1, 0, this.x9o_1, 0, this.w9o_1.length);
  }
}
class Companion_52 {
  constructor() {
    this.j9p_1 = 256;
  }
}
class Input {
  constructor() {
    this.k9p_1 = new Mixin();
    this.l9p_1 = Companion_getInstance_27().s7y_1;
    this.m9p_1 = new TouchEvent();
    var tmp = this;
    tmp.n9p_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.o9p_1 = toDuration(400, DurationUnit_MILLISECONDS_getInstance());
    this.p9p_1 = 20.0;
    this.q9p_1 = Vector2D.y3k(-1000.0, -1000.0);
    this.r9p_1 = Vector2D.y3k(-1000.0, -1000.0);
    this.s9p_1 = 0;
    this.t9p_1 = false;
    this.u9p_1 = true;
    this.v9p_1 = false;
    this.w9p_1 = new InputKeys();
    this.x9p_1 = booleanArray(256);
    this.y9p_1 = booleanArray(256);
    this.z9p_1 = new Float64Array(256);
    this.a9q_1 = new Float64Array(256);
    this.b9q_1 = booleanArray(256);
    this.c9q_1 = booleanArray(256);
    this.d9q_1 = booleanArray(256);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.f2_1;
    var last = this_0.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.input.Input.gamepads.<anonymous>' call
        var it = item;
        var tmp$ret$2 = new GamepadInfo(it);
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    tmp_1.e9q_1 = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_2.f9q_1 = ArrayList.z();
  }
  h9q(touchEvent) {
    this.m9p_1.z7z(touchEvent);
  }
  i9q() {
    return this.q9p_1;
  }
  j9q(p, down) {
    if (down)
      this.r9p_1 = p;
    else
      this.q9p_1 = p;
  }
  k9q(button, down) {
    this.s9p_1 = setBits(this.s9p_1, button.z82_1, down);
  }
  l9q() {
    this.f9q_1.h3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.e9q_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.input.Input.updateConnectedGamepads.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gamepad = this_0[_unary__edvuaz];
      if (gamepad.u80_1) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.f9q_1.h(gamepad);
      }
    }
  }
  m9q(keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.x9p_1.length - 1 | 0) : false) {
      this.x9p_1[pKeyCode] = b;
    }
  }
  n9q(delta) {
    var tmp0_safe_receiver = this.d28();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.h3();
    }
    this.w9p_1.h9p(delta);
  }
  o9q(delta) {
    this.v9p_1 = false;
    this.w9p_1.i9p(delta);
    endFrameOldKeys(this, delta);
  }
  p9q(e) {
    switch (e.q7w_1.p3_1) {
      case 1:
        this.m9q(e.t7w_1, true);
        break;
      case 0:
        this.m9q(e.t7w_1, false);
        break;
      case 2:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  c28(value) {
    this.k9p_1.c28(value);
  }
  d28() {
    return this.k9p_1.d28();
  }
}
class DefaultViewport {
  constructor() {
    DefaultViewport_instance = this;
    this.q9q_1 = 1280;
    this.r9q_1 = 720;
    this.s9q_1 = Size2D.w3j(1280, 720);
  }
}
class Companion_53 {
  t9q(str) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Props();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.logger.Companion.load.<anonymous>' call
    this_0.v9q(str);
    return this_0;
  }
}
class Props {
  constructor(props) {
    props = props === VOID ? LinkedHashMap.wc() : props;
    this.u9q_1 = props;
  }
  w9q(str) {
    var _iterator__ex2g4s = split(str, ['\n']).b1();
    $l$loop_0: while (_iterator__ex2g4s.c1()) {
      var line = _iterator__ex2g4s.d1();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      // Inline function 'kotlin.text.trim' call
      var this_0 = parts.h1(0);
      var key = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.collections.getOrElse' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (0 <= 1 ? 1 < parts.g1() : false) {
        tmp = parts.h1(1);
      } else {
        // Inline function 'korlibs.korge.logger.Props.deserializeAdd.<anonymous>' call
        tmp = ' ';
      }
      var this_1 = tmp;
      var value = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.set' call
      this.u9q_1.k3(key, value);
    }
  }
  v9q(str) {
    this.h3();
    this.w9q(str);
  }
  h3() {
    this.u9q_1.h3();
  }
  x9q(key, value) {
    return this.u9q_1.k3(key, value);
  }
  k3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.x9q(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  y9q(from) {
    this.u9q_1.m3(from);
  }
  m3(from) {
    return this.y9q(from);
  }
  o28(key) {
    return this.u9q_1.l3(key);
  }
  l3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.o28((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  u1() {
    return this.u9q_1.u1();
  }
  f3() {
    return this.u9q_1.f3();
  }
  n3() {
    return this.u9q_1.n3();
  }
  m1j(key) {
    return this.u9q_1.c3(key);
  }
  c3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.m1j((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  cj(key) {
    return this.u9q_1.e3(key);
  }
  e3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.cj((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  j1() {
    return this.u9q_1.j1();
  }
  g1() {
    return this.u9q_1.g1();
  }
}
class Entry {
  constructor(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.z9q_1 = closeable;
  }
  a9r() {
    var tmp0_safe_receiver = this.z9q_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p6();
    }
    this.z9q_1 = null;
  }
  u1w() {
    this.z9q_1 = null;
  }
}
class AgAutoFreeManager {
  constructor() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.b9r_1 = Pool.c42(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.c9r_1 = FastIdentityMap();
    this.d9r_1 = fastArrayListOf([]);
    this.e9r_1 = 0;
    this.f9r_1 = 60;
  }
  g9r(closeable) {
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.c9r_1;
      var res = get_0(this_0, closeable);
      if (!(res == null)) {
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.b9r_1.f42();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>.<anonymous>' call
      this_1.z9q_1 = closeable;
      var out = this_1;
      set(this_0, closeable, out);
    }
  }
  h9r() {
    this.e9r_1 = this.e9r_1 + 1 | 0;
    if (this.e9r_1 >= this.f9r_1) {
      this.e9r_1 = 0;
      this.i9r();
    }
  }
  i9r() {
    var _iterator__ex2g4s = this.d9r_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var entry = _iterator__ex2g4s.d1();
      if (!contains_1(this.c9r_1, entry.z9q_1)) {
        var tmp0_safe_receiver = entry.z9q_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.p6();
        }
        this.b9r_1.g42(entry);
      }
    }
    this.d9r_1.h3();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.c9r_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.gc.<anonymous>' call
      var it_0 = ensureNotNull(get_0(this_0, it));
      this.d9r_1.h(it_0);
    }
    clear(this.c9r_1);
  }
  p6() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.d9r_1.s28_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      array[_unary__edvuaz].a9r();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.c9r_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).a9r();
    }
    this.d9r_1.h3();
    this.b9r_1.h3();
    clear(this.c9r_1);
  }
}
class BitmapTextureInfo {
  constructor() {
    this.j9r_1 = 0;
    this.k9r_1 = TextureBase.p9r(null, 0, 0);
    this.l9r_1 = FastIdentityMap();
  }
  u1w() {
    this.j9r_1 = 0;
    this.k9r_1.m9r_1 = null;
    this.k9r_1.o9r_1 = -1;
    this.k9r_1.q9r(0);
    this.k9r_1.r9r(0);
    clear(this.l9r_1);
  }
  toString() {
    return 'BitmapTextureInfo(textureBase=' + this.k9r_1.toString() + ', usedMemory=' + this.j9r_1 + ', slices=' + get_size(this.l9r_1) + ')';
  }
}
class AgBitmapTextureManager {
  constructor(ag) {
    this.s9r_1 = ag;
    this.t9r_1 = new Long(0, 0);
    this.u9r_1 = FastSmallSet.r3z();
    this.v9r_1 = FastSmallSet.r3z();
    this.w9r_1 = FastArrayList.u28();
    this.x9r_1 = 60;
    this.y9r_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.z9r_1 = Pool.c42(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.a9s_1 = FastIdentityMap();
    this.b9s_1 = null;
    this.c9s_1 = null;
    this.d9s_1 = null;
    this.e9s_1 = null;
    this.f9s_1 = null;
    this.g9s_1 = null;
    this.h9s_1 = null;
    this.i9s_1 = null;
    this.j9s_1 = 0;
  }
  l9s() {
    return this.u9r_1.g1();
  }
  m9s() {
    return this.v9r_1.g1();
  }
  n9s() {
    return this.w9r_1.g1();
  }
  toString() {
    return this.o9s();
  }
  o9s() {
    return 'AgBitmapTextureManager(numCachedBitmaps=' + this.l9s() + ', numReferencedBitmapsSinceGC=' + this.m9s() + ', numReferencedBitmaps=' + this.n9s() + ', maxCachedMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().p2e(this.t9r_1)) + ', managedTextureMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().p2e(this.y9r_1)) + ')';
  }
  p9s(bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).k9r_1);
  }
  q9s(slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  }
  r9s(slice) {
    return _getTexture(this, slice);
  }
  s9s() {
    clearFastCacheAccess(this);
    this.j9s_1 = this.j9s_1 + 1 | 0;
    if (this.j9s_1 >= this.x9r_1) {
      this.j9s_1 = 0;
      this.i9r();
    }
  }
  i9r() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.w9r_1.s28_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var bmp = array[_unary__edvuaz];
      if (!this.v9r_1.am(bmp))
        if (this.t9r_1.b2(this.y9r_1) < 0 || this.y9r_1.b2(new Long(0, 0)) < 0) {
          this.t9s(bmp, 'GC');
        } else
          this.u9r_1.s3z(bmp);
    }
    this.w9r_1.h3();
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.v9r_1.n3z_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.w9r_1.h(element);
    }
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.u9r_1.n3z_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.w9r_1.h(element_0);
    }
    this.v9r_1.h3();
  }
  t9s(bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.a9s_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.Long.minus' call
    var this_0 = this.y9r_1;
    var other = info.j9r_1;
    tmp_0.y9r_1 = this_0.c2(toLong(other));
    this.v9r_1.t3z(bmp);
    if (this.c9s_1 === info || this.e9s_1 === info) {
      clearFastCacheAccess(this);
    }
    info.k9r_1.p6();
    this.z9r_1.g42(info);
    this.u9r_1.t3z(bmp);
  }
  p6() {
    clearFastCacheAccess(this);
    var _iterator__ex2g4s = toList(get_keys(this.a9s_1)).b1();
    while (_iterator__ex2g4s.c1()) {
      var bmp = _iterator__ex2g4s.d1();
      this.t9s(bmp, 'close');
    }
    clear(this.a9s_1);
    this.w9r_1.h3();
    this.v9r_1.h3();
    this.u9r_1.h3();
    this.z9r_1.h3();
  }
}
class AgBufferManager {
  constructor(ag) {
    this.u9s_1 = ag;
    this.v9s_1 = FastIdentityMap();
    this.w9s_1 = FastSmallSet.r3z();
    var tmp = this;
    tmp.x9s_1 = Pool.d42(VOID, AgBufferManager$bufferPool$lambda);
    this.y9s_1 = 0;
    this.z9s_1 = 60;
    this.a9t_1 = Buffer.o2c(0);
  }
  h9r() {
    removeCache(this);
    this.y9s_1 = this.y9s_1 + 1 | 0;
    if (this.y9s_1 >= this.z9s_1) {
      this.y9s_1 = 0;
      this.i9r();
    }
  }
  i9r() {
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.w9s_1.n3z_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBufferManager.gc.<anonymous>' call
      this.b9t(element);
    }
    this.w9s_1.h3();
  }
  b9t(buffer) {
    var buf = getAndRemove(this.v9s_1, buffer);
    if (buf == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      buf.j86(this.a9t_1);
      this.x9s_1.g42(buf);
    }
  }
}
class BatchBuffers {
  constructor() {
    this.m9t_1 = new AGBuffer();
    this.n9t_1 = new AGBuffer();
    this.o9t_1 = new AGBuffer();
    this.p9t_1 = AGVertexArrayObject.x8b([new AGVertexData(Companion_getInstance_69().j9t_1, this.m9t_1), new AGVertexData(Companion_getInstance_69().k9t_1, this.n9t_1)], false);
  }
}
class Companion_54 {
  constructor() {
    Companion_instance_63 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Sampler.j97('u_Tex' + tmp_3, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.c9t_1 = tmp_2;
    this.d9t_1 = 16383;
    this.e9t_1 = 8192;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_4;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$2 = 'BatchBuilder2D.Companion[0]';
      this_0.r46(level, tmp$ret$2);
      tmp_4 = Unit_instance;
    }
    this.f9t_1 = Attribute.f8j('a_Col2', VarType_UByte4_getInstance(), true, VOID, 3);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_5;
    if (this_1.q46(level_0)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$4 = 'BatchBuilder2D.Companion[1]';
      this_1.r46(level_0, tmp$ret$4);
      tmp_5 = Unit_instance;
    }
    this.g9t_1 = Varying.r8j('v_Col2', VarType_Float4_getInstance());
    this.h9t_1 = Attribute.f8j('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.i9t_1 = Varying.r8j('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_6;
    if (this_2.q46(level_1)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$6 = 'BatchBuilder2D.Companion[2]';
      this_2.r46(level_1, tmp$ret$6);
      tmp_6 = Unit_instance;
    }
    this.j9t_1 = ProgramLayout.g8c([DefaultShaders_getInstance().l8f_1, DefaultShaders_getInstance().m8f_1, this.q9t(), this.f9t_1]);
    this.k9t_1 = ProgramLayout.g8c([this.h9t_1]);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.q46(level_2)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$8 = 'BatchBuilder2D.Companion[3]';
      this_3.r46(level_2, tmp$ret$8);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_4 = ProgramBuilderDefault.g8k();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    this_4.l8k(this_4.h8k(), this_4.i8k());
    this_4.l8k(Companion_getInstance_69().i9t_1, Companion_getInstance_69().h9t_1);
    this_4.l8k(Companion_getInstance_69().r9t(), this_4.s8k([this_4.p8k(this_4.u8k(Companion_getInstance_69().q9t(), 'rgb'), this_4.u8k(Companion_getInstance_69().q9t(), 'a')), this_4.u8k(Companion_getInstance_69().q9t(), 'a')]));
    this_4.l8k(Companion_getInstance_69().g9t_1, Companion_getInstance_69().f9t_1);
    this_4.l8k(this_4.o8k(), this_4.p8k(this_4.p8k(this_4.e8i(), this_4.f8i()), this_4.s8k([this_4.q8k(), this_4.r8k(0.0), this_4.r8k(1.0)])));
    var tmp_9 = VertexShader(this_4.t8k());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_5 = ProgramBuilderDefault.g8k();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    Companion_getInstance_69().s9t(this_5);
    this_5.l8k(this_5.o8k(), this_5.p8k(this_5.o8k(), Companion_getInstance_69().r9t()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_5.b8m(this_5.u8k(this_5.o8k(), 'a'), this_5.r8k(0.0));
    var body = this_5.c8l();
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>.<anonymous>' call
    body.s8l();
    var stmIf = new If(cond, body.e8l());
    // Inline function 'kotlin.collections.plusAssign' call
    this_5.k8k_1.h(stmIf);
    var tmp$ret$14 = FragmentShader(this_5.t8k());
    tmp_8.l9t_1 = new Program(tmp_9, tmp$ret$14, 'BatchBuilder2D.Tinted');
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_6.q46(level_3)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D.Companion[4]';
      this_6.r46(level_3, tmp$ret$15);
      tmp_10 = Unit_instance;
    }
  }
  q9t() {
    return DefaultShaders_getInstance().n8f_1;
  }
  r9t() {
    return DefaultShaders_getInstance().p8f_1;
  }
  s9t(builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.createTextureLookup.<anonymous>' call
    var tmp = Companion_getInstance_69().i9t_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.r8l(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
  }
}
class BatchBuilder2D {
  constructor(ctx, reqMaxQuads) {
    Companion_getInstance_69();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_69().e9t_1 : reqMaxQuads;
    this.j9n_1 = ctx;
    this.k9n_1 = reqMaxQuads;
    this.l9n_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    // Inline function 'kotlin.math.min' call
    var a = this.k9n_1;
    var b = Companion_getInstance_69().d9t_1;
    tmp.m9n_1 = Math.min(a, b);
    this.n9n_1 = this.j9n_1.v9m_1;
    this.o9n_1 = this.j9n_1.c9m_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_0;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$1 = 'BatchBuilder2D[0]';
      this_0.r46(level, tmp$ret$1);
      tmp_0 = Unit_instance;
    }
    this.j9n_1.x9m_1.k38(BatchBuilder2D$lambda(this));
    this.p9n_1 = imul(this.m9n_1, 4);
    this.q9n_1 = imul(this.m9n_1, 6);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.q46(level_0)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$3 = 'BatchBuilder2D[1]';
      this_1.r46(level_0, tmp$ret$3);
      tmp_1 = Unit_instance;
    }
    this.r9n_1 = Buffer.o2c(imul(24, this.p9n_1));
    this.s9n_1 = new Int8Array(this.p9n_1);
    this.t9n_1 = Buffer.o2c(imul(2, this.q9n_1));
    this.u9n_1 = get_u16(this.t9n_1);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.q46(level_1)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$5 = 'BatchBuilder2D[2]';
      this_2.r46(level_1, tmp$ret$5);
      tmp_2 = Unit_instance;
    }
    this.v9n_1 = 0;
    this.w9n_1 = 0;
    this.x9n_1 = 0;
    this.y9n_1 = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.l9n_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = null;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.z9n_1 = tmp_6;
    this.a9o_1 = false;
    this.b9o_1 = Companion_getInstance_66().h9l_1;
    this.c9o_1 = Companion_getInstance_69().l9t_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.q46(level_2)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$9 = 'BatchBuilder2D[3]';
      this_3.r46(level_2, tmp$ret$9);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    tmp_8.d9o_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_4 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_9;
    if (this_4.q46(level_3)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$11 = 'BatchBuilder2D[4]';
      this_4.r46(level_3, tmp$ret$11);
      tmp_9 = Unit_instance;
    }
    this.e9o_1 = Companion_getInstance_45().t84_1;
    this.f9o_1 = Companion_getInstance_46().v84_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_5 = get_logger();
    var level_4 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_5.q46(level_4)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$13 = 'BatchBuilder2D[5]';
      this_5.r46(level_4, tmp$ret$13);
      tmp_10 = Unit_instance;
    }
    this.g9o_1 = _AGColorMask___init__impl__j38ai8_1();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_5 = Level_TRACE_getInstance();
    var tmp_11;
    if (this_6.q46(level_5)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D[6]';
      this_6.r46(level_5, tmp$ret$15);
      tmp_11 = Unit_instance;
    }
    this.h9o_1 = Companion_getInstance_43().h85_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_7 = get_logger();
    var level_6 = Level_TRACE_getInstance();
    var tmp_12;
    if (this_7.q46(level_6)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$17 = 'BatchBuilder2D[7]';
      this_7.r46(level_6, tmp$ret$17);
      tmp_12 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_8 = get_logger();
    var level_7 = Level_TRACE_getInstance();
    var tmp_13;
    if (this_8.q46(level_7)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$19 = 'BatchBuilder2D[11]';
      this_8.r46(level_7, tmp$ret$19);
      tmp_13 = Unit_instance;
    }
    this.i9o_1 = new Signal();
    this.j9o_1 = new Signal();
    this.k9o_1 = fastArrayListOf([]);
    this.l9o_1 = 0;
    this.m9o_1 = 0;
    this.n9o_1 = 0;
  }
  v9t(value) {
    this.v9n_1 = value;
  }
  w9t() {
    return this.v9n_1;
  }
  x9t() {
    var inductionVariable = 0;
    var last = this.l9n_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.z9n_1[n] = null;
      }
       while (inductionVariable < last);
    this.y9n_1 = 0;
  }
  h9r() {
    this.d9o_1.u1w();
  }
  y9t() {
    return this.h9o_1;
  }
  z9t(vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.s9n_1[vp / 6 | 0] = toByte(texIndex);
    return 6;
  }
  a9u(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.b9u(6, 4);
    this.c9u();
    var vp = this.w9n_1;
    var vd = this.r9n_1;
    vp = vp + this.z9t(vd, vp, x0, y0, tex.c4t(), tex.d4t(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.z9t(vd, vp, x1, y1, tex.e4t(), tex.f4t(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.z9t(vd, vp, x2, y2, tex.g4t(), tex.h4t(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.z9t(vd, vp, x3, y3, tex.i4t(), tex.j4t(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.w9n_1 = vp;
    this.v9t(this.w9t() + 4 | 0);
  }
  d9u(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.y9n_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.a9u(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.a9u.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  }
  e9u(vc) {
    this.x9n_1 = this.x9n_1 + _addIndices(this, this.u9n_1, this.x9n_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  }
  c9u(vc, $super) {
    vc = vc === VOID ? this.w9t() : vc;
    var tmp;
    if ($super === VOID) {
      this.e9u(vc);
      tmp = Unit_instance;
    } else {
      tmp = $super.e9u.call(this, vc);
    }
    return tmp;
  }
  f9u(array, matrix, vcount, icount, texIndex) {
    this.b9u(icount, vcount);
    var i16 = this.u9n_1;
    var ip = this.x9n_1;
    var vc = this.w9t();
    var arrayIndices = array.g9u_1;
    // Inline function 'kotlin.math.min' call
    var b = array.j9u_1;
    var icount_0 = Math.min(icount, b);
    arraycopy_5(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.w9n_1;
    var src = get_i32(array.k9u_1);
    var dst = get_i32(this.r9n_1);
    arraycopy_6(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.w9n_1 / 6 | 0;
    arrayfill(this.s9n_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (matrix.h3j()) {
      applyMatrix(this, matrix, this.w9n_1, vcount);
    }
    this.v9n_1 = this.v9n_1 + vcount | 0;
    this.w9n_1 = this.w9n_1 + imul(vcount, 6) | 0;
    this.x9n_1 = this.x9n_1 + icount_0 | 0;
  }
  n9u(array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.i9u_1 : vcount;
    icount = icount === VOID ? array.j9u_1 : icount;
    texIndex = texIndex === VOID ? this.y9n_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.f9u(array, matrix, vcount, icount, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.f9u.call(this, array, matrix, vcount, icount, texIndex);
    }
    return tmp;
  }
  b9u(indices, vertices) {
    if (indices === 0 && vertices === 0)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.o9u();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var message = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException.h5(toString(message));
    }
    return doFlush;
  }
  p9u(tex, smoothing, blendMode, program, icount, vcount) {
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.m9r_1;
      this.b9u(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_69().l9t_1 : program;
      if (this.q9u(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this.t9t();
      if (!contains_0(this.z9n_1, tex_0)) {
        this.y9n_1 = 0;
        this.z9n_1[0] = tex_0;
      }
      this.a9o_1 = smoothing;
      this.b9o_1 = blendMode;
      this.c9o_1 = pprogram;
    }
  }
  r9u(tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z9n_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.hasTex.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      if (this_0[_unary__edvuaz] === tex)
        return true;
    }
    return false;
  }
  q9u(tex, smoothing, blendMode, program) {
    var hasTex = this.r9u(tex);
    if (!(this.z9n_1[0] === null) && !hasTex) {
      var inductionVariable = 1;
      var last = this.z9n_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.z9n_1[n] === null) {
            this.z9n_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.z9n_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.z9n_1[n_0]) {
          this.y9n_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return hasTex && this.a9o_1 === smoothing && this.b9o_1 === blendMode && this.c9o_1 === program;
  }
  s9u(tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.t9u(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_instance);
  }
  q9o(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.f3u() : width;
    height = height === VOID ? tex.g3u() : height;
    m = m === VOID ? Companion_getInstance_7().z3l_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().y57_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_66().h9l_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.s9u(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_instance;
    } else {
      tmp = $super.s9u.call(this, tex, x, y, width, height, m, filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  }
  t9u(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.p9u(tex.r4s(), filtering, blendMode, program, 6, 4);
    this.u9u(x, y, width, height, m, tex, colorMul);
  }
  u9u(x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.d9u(m.s3m(x0, y0), m.t3m(x0, y0), m.s3m(x1, y0), m.t3m(x1, y0), m.s3m(x1, y1), m.t3m(x1, y1), m.s3m(x0, y1), m.t3m(x0, y1), tex, colorMul);
  }
  v9u() {
    this.d9o_1.u42_1.o9t_1.i86(this.t9n_1, 0, imul(this.x9n_1, 2));
  }
  w9u() {
    this.j9n_1.w9u();
    var inductionVariable = 0;
    var last = this.l9n_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_39().q89(VOID, this.a9o_1);
        this.j9n_1.l9m_1.q86(Companion_getInstance_69().c9t_1[n], this.z9n_1[n], info);
      }
       while (inductionVariable < last);
  }
  t9t() {
    if (this.l9o_1 === this.x9n_1)
      return Unit_instance;
    this.w9u();
    this.m9o_1 = this.m9o_1 + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.k9o_1;
    var tmp0_frameBuffer = this.j9n_1.f9n_1.h83_1;
    var tmp1_frameBufferInfo = this.j9n_1.f9n_1.n85();
    var tmp2_vertexData = this.d9o_1.u42_1.p9t_1;
    var tmp3_indices = this.d9o_1.u42_1.o9t_1;
    var tmp4_program = this.c9o_1;
    var tmp5_drawType = Companion_getInstance_40().o8c_1;
    var tmp6_blending = this.b9o_1.r9o_1;
    var tmp7_uniformBlocks = this.j9n_1.x9u(this.c9o_1, false);
    var tmp8_textureUnits = this.j9n_1.l9m_1.z27();
    var tmp9_stencilOpFunc = this.f9o_1;
    var tmp10_stencilRef = this.e9o_1;
    var tmp11_colorMask = this.g9o_1;
    var tmp12_scissor = this.h9o_1;
    var tmp13_drawOffset = imul(this.l9o_1, 2);
    var tmp14_vertexCount = this.x9n_1 - this.l9o_1 | 0;
    var element = new AGBatch(tmp0_frameBuffer, tmp1_frameBufferInfo, tmp2_vertexData, tmp3_indices, VOID, tmp4_program, tmp7_uniformBlocks, tmp8_textureUnits, tmp6_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp12_scissor, VOID, tmp5_drawType, tmp13_drawOffset, tmp14_vertexCount);
    this_0.h(element);
    this.l9o_1 = this.x9n_1;
  }
  y9u(uploadVertices, uploadIndices) {
    this.z9u(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.l9n_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.z9n_1[n] = null;
      }
       while (inductionVariable < last);
    this.y9n_1 = 0;
  }
  u9t(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.y9u(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.y9u.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  z9u(uploadVertices, uploadIndices) {
    this.t9t();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.k9o_1.j1()) {
      if (uploadVertices) {
        this.d9o_1.u42_1.m9t_1.i86(this.r9n_1, 0, imul(this.w9n_1, 4));
        this.d9o_1.u42_1.n9t_1.h86(this.s9n_1, 0, this.w9n_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.v9u();
      }
      this.j9n_1.a9v();
      draw_0(this.o9n_1, new AGMultiBatch(toList(this.k9o_1)));
      this.k9o_1.h3();
      this.i9o_1.r38(this);
      this.n9o_1 = this.n9o_1 + 1 | 0;
      this.j9n_1.b9v();
      this.d9o_1.d1();
    }
    this.v9t(0);
    this.w9n_1 = 0;
    this.l9o_1 = 0;
    this.x9n_1 = 0;
  }
  o9u(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.z9u(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.z9u.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
}
class BoundsProvider {}
function get_virtualLeft() {
  return this.p9v().i3j();
}
function get_virtualTop() {
  return this.p9v().d3q();
}
function get_virtualRight() {
  return this.p9v().j3j();
}
function get_virtualBottom() {
  return this.p9v().c3q();
}
function get_windowToGlobalScaleAvg() {
  return get_scale(this.k9v()).g3o();
}
function windowToGlobalCoords(pos) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = this.i9v();
    if (this_0.g3j()) {
      tmp$ret$0 = pos;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.y3k(this_0.r3m(pos.r3i_1, pos.s3i_1), this_0.u3m(pos.r3i_1, pos.s3i_1));
  }
  return tmp$ret$0;
}
class Base {
  constructor() {
    this.c9v_1 = Companion_getInstance_7().c3m();
    this.d9v_1 = MatrixTransform.e3o();
    this.e9v_1 = Companion_getInstance_7().c3m();
    this.f9v_1 = MatrixTransform.e3o();
    this.g9v_1 = Companion_getInstance_5().k3q(0, 0, 1280, 720);
  }
  h9v(_set____db54di) {
    this.c9v_1 = _set____db54di;
  }
  i9v() {
    return this.c9v_1;
  }
  j9v(_set____db54di) {
    this.d9v_1 = _set____db54di;
  }
  k9v() {
    return this.d9v_1;
  }
  l9v(_set____db54di) {
    this.e9v_1 = _set____db54di;
  }
  m9v() {
    return this.e9v_1;
  }
  n9v(_set____db54di) {
    this.f9v_1 = _set____db54di;
  }
  o9v(_set____db54di) {
    this.g9v_1 = _set____db54di;
  }
  p9v() {
    return this.g9v_1;
  }
}
class Companion_55 {
  constructor() {
    Companion_instance_64 = this;
    this.w9v_1 = ProgramLayout.g8c([DefaultShaders_getInstance().l8f_1, DefaultShaders_getInstance().n8f_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_0 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>.<anonymous>' call
    builder.l8k(builder.o8k(), builder.p8k(builder.p8k(this_0.e8i(), this_0.f8i()), builder.s8k([this_0.l8f_1, builder.r8k(0.0), builder.r8k(1.0)])));
    builder.l8k(this_0.p8f_1, this_0.n8f_1);
    tmp.x9v_1 = VertexShader(builder.t8k());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.g8k();
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_1 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>.<anonymous>' call
    builder_0.l8k(builder_0.o8k(), this_1.p8f_1);
    tmp_0.y9v_1 = FragmentShader(builder_0.t8k());
    this.z9v_1 = new Program(this.x9v_1, this.y9v_1);
  }
}
class LineRenderBatcher {
  constructor(ctx) {
    Companion_getInstance_70();
    this.a9w_1 = ctx;
    this.b9w_1 = new Signal();
    this.a9w_1.x9m_1.k38(LineRenderBatcher$lambda(this));
    this.c9w_1 = this.a9w_1.c9m_1;
    this.d9w_1 = Colors_getInstance().o5d_1;
    this.e9w_1 = new AGBuffer();
    this.f9w_1 = AGVertexArrayObject.x8b([new AGVertexData(Companion_getInstance_70().w9v_1, this.e9w_1)], false);
    this.g9w_1 = 1024;
    this.h9w_1 = allocDirect(Companion_instance_4, imul(24, this.g9w_1));
    this.i9w_1 = Matrix4.d3p();
    this.j9w_1 = 0;
    this.k9w_1 = 0;
    this.l9w_1 = Companion_getInstance_66().h9l_1;
    this.m9w_1 = Companion_getInstance_7().c3m();
  }
  n9w(p0, p1, color0, color1, m) {
    return this.o9w(p0.r3i_1, p0.s3i_1, p1.r3i_1, p1.s3i_1, this.d9w_1, color1, m);
  }
  p9w(p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.d9w_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.m9w_1 : m;
    var tmp;
    if ($super === VOID) {
      this.n9w(p0, p1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.n9w.call(this, p0, p1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  q9w(x0, y0, x1, y1, color0, color1, m) {
    if (this.j9w_1 >= (this.g9w_1 - 2 | 0)) {
      this.gd();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  }
  r9w(x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.d9w_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.m9w_1 : m;
    var tmp;
    if ($super === VOID) {
      this.q9w(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.q9w.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  o9w(x0, y0, x1, y1, color0, color1, m) {
    return this.q9w(x0, y0, x1, y1, color0, color1, m);
  }
  s9w(path, m) {
    var lastPos = {_v: Vector2D.i3l()};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.i3l();
    var l = Vector2D.i3l();
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.n4p_1;
    var n_0 = 0;
    while (n_0 < this_0.g1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.x27(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.o4p_1.h1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.y3k(tmp, path.o4p_1.h1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!true) {
            this.p9w(lastPos._v, it, VOID, VOID, m);
          }

          lastPos._v = it;
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.o4p_1.h1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.y3k(tmp_0, path.o4p_1.h1(_unary__edvuaz_3));
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!false) {
            this.p9w(lastPos._v, it_0, VOID, VOID, m);
          }

          lastPos._v = it_0;
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.o4p_1.h1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.y3k(tmp_1, path.o4p_1.h1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.o4p_1.h1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.y3k(tmp_2, path.o4p_1.h1(_unary__edvuaz_7));
          var sum = Companion_getInstance_4().d3t(l, c) + Companion_getInstance_4().d3t(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos_0 = {_v: Vector2D.i3l()};
          var prevPos = {_v: Vector2D.i3l()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_10().p27_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_12().h4n(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_12().h4n(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.p9w(lastPos._v, it_1, VOID, VOID, m);
              }
              lastPos._v = it_1;
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos_0._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.o4p_1.h1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.y3k(tmp_3, path.o4p_1.h1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.o4p_1.h1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.y3k(tmp_4, path.o4p_1.h1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.o4p_1.h1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.y3k(tmp_5, path.o4p_1.h1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_4().d3t(l, c0) + Companion_getInstance_4().d3t(c0, c1) + Companion_getInstance_4().d3t(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_1 = {_v: Vector2D.i3l()};
          var prevPos_0 = {_v: Vector2D.i3l()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_10().p27_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_12().g4n(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_12().g4n(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.p9w(lastPos._v, it_2, VOID, VOID, m);
              }
              lastPos._v = it_2;
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_1._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          var p = i;
          if (!false) {
            this.p9w(lastPos._v, p, VOID, VOID, m);
          }

          lastPos._v = p;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
      }
    }
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  }
  gd() {
    if (this.j9w_1 > 0) {
      this.b9w_1.r38(this);
      this.e9w_1.i86(this.h9w_1, 0, imul(this.k9w_1, 4));
      this.a9w_1.w9u();
      var tmp0_$receiver = this.c9w_1;
      var tmp1_frameBuffer = this.a9w_1.f9n_1;
      var tmp2_vertexData = this.f9w_1;
      var tmp3_program = Companion_getInstance_70().z9v_1;
      var tmp4_drawType = Companion_getInstance_40().n8c_1;
      var tmp5_vertexCount = this.j9w_1;
      var tmp6_uniformBlocks = this.a9w_1.t9w(Companion_getInstance_70().z9v_1);
      var tmp7_blending = this.l9w_1.r9o_1;
      draw(tmp0_$receiver, tmp1_frameBuffer, tmp2_vertexData, tmp3_program, tmp4_drawType, tmp5_vertexCount, VOID, VOID, VOID, tmp7_blending, tmp6_uniformBlocks);
    }
    this.j9w_1 = 0;
    this.k9w_1 = 0;
  }
}
class FlushKind extends Enum {}
class DeviceDimensionsProvider {}
function get_devicePixelRatio() {
  return 1.0;
}
function get_pixelsPerInch() {
  return 96.0 * this.n9x();
}
function get_pixelsPerLogicalInchRatio() {
  return this.o9x() / 96.0;
}
function get_computedPixelRatio() {
  return this.n9x() * this.p9x();
}
class RenderContext {
  constructor(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads, windowConfig) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_instance : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_69().e9t_1 : batchMaxQuads;
    windowConfig = windowConfig === VOID ? new Impl() : windowConfig;
    this.b9m_1 = new Mixin();
    this.c9m_1 = ag;
    this.d9m_1 = bp;
    this.e9m_1 = deviceDimensionsProvider;
    this.f9m_1 = stats;
    this.g9m_1 = coroutineContext;
    this.h9m_1 = batchMaxQuads;
    this.i9m_1 = windowConfig;
    this.j9m_1 = new BufferCache();
    this.k9m_1 = FastIdentityMap();
    this.l9m_1 = AGTextureUnits.n86();
    this.m9m_1 = Companion_getInstance_7().c3m();
    this.n9m_1 = Companion_getInstance_7().c3m();
    this.o9m_1 = Matrix4.d3p();
    this.p9m_1 = Matrix4.d3p();
    this.q9m_1 = Companion_getInstance_7().c3m();
    this.r9m_1 = true;
    var tmp_0 = this;
    tmp_0.s9m_1 = Pool.d42(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.t9m_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.u9m_1 = new AgAutoFreeManager();
    this.v9m_1 = new AgBitmapTextureManager(this.c9m_1);
    this.w9m_1 = new AgBufferManager(this.c9m_1);
    this.x9m_1 = new Signal();
    this.y9m_1 = 1.0;
    this.z9m_1 = Colors_getInstance().y57_1;
    this.a9n_1 = new BatchBuilder2D(this, this.h9m_1);
    var tmp_2 = this;
    tmp_2.b9n_1 = Pool.d42(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.c9n_1 = new RenderContext2D(this.a9n_1, this.v9m_1);
    this.d9n_1 = true;
    this.e9n_1 = null;
    this.f9n_1 = this.c9m_1.v83();
    this.g9n_1 = LinkedHashSet.r1();
    var tmp_3 = this;
    tmp_3.h9n_1 = Pool.d42(VOID, RenderContext$frameBuffers$lambda);
    this.i9n_1 = FastArrayList.u28();
  }
  u9w() {
    return this.i9m_1.u9w();
  }
  b9v() {
  }
  v9w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t9m_1;
    projViewMatUB$factory();
    return this_0.w1();
  }
  w9u() {
    if (this.r9m_1 && this.f9n_1.j87()) {
      this.o9m_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().p3q(0, this.f9n_1.p83_1, this.f9n_1.o83_1, 0), -1.0, 1.0);
    } else {
      this.o9m_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().p3q(0, 0, this.f9n_1.o83_1, this.f9n_1.p83_1), -1.0, 1.0);
      this.o9m_1 = this.o9m_1.a3q(toMatrix4(this.m9m_1));
    }
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = this.v9w();
      var _unary__edvuaz = this_0.s8b();
      this_0.e8y(_unary__edvuaz + 1 | 0);
      this_0.f8y(this_0.s8b() + 1 | 0);
      var blockSize = this_0.w89_1;
      var index0 = imul(this_0.s8b() - 1 | 0, blockSize);
      var index1 = imul(this_0.s8b(), blockSize);
      var texBlockSize = this_0.t89_1.g8i().g1();
      var texIndex0 = imul(this_0.s8b() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.s8b(), texBlockSize);
      if (this_0.s8b() > 0) {
        arraycopy_0(this_0.y89_1, index0, this_0.y89_1, index1, blockSize);
      } else {
        arrayfill_0(this_0.y89_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.updateStandardUniforms.<anonymous>' call
      var $this$push = this_0.t89_1;
      var it = this_0.z89_1;
      it.i8y($this$push.e8i(), this.o9m_1);
      it.i8y($this$push.f8i(), this.p9m_1);
      if (true && this_0.s8b() >= 1) {
        var equals = arrayequal(this_0.y89_1, index0, this_0.y89_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.s8b();
          this_0.e8y(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
  w9w() {
    return coerceAtLeast_0(round(this.x9w() * this.y9m_1), 1.0);
  }
  y9w(kind) {
    this.x9m_1.r38(kind);
  }
  o9o(kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.y9w(kind);
      tmp = Unit_instance;
    } else {
      tmp = $super.y9w.call(this, kind);
    }
    return tmp;
  }
  z9w() {
    var tmp0_elvis_lhs = this.f9n_1;
    return tmp0_elvis_lhs == null ? this.v83() : tmp0_elvis_lhs;
  }
  a9x() {
    return this.z9w() === this.v83();
  }
  v83() {
    return this.c9m_1.v83();
  }
  b9x(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.c9m_1.a84(this.f9n_1.h83_1, this.f9n_1.n85(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  }
  c9x(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().d58_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_43().h85_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.b9x(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_instance;
    } else {
      tmp = $super.b9x.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, scissor);
    }
    return tmp;
  }
  x83() {
    this.c9m_1.x83();
    this.h9n_1.h42(this.g9n_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.g9n_1.j1()) {
      this.g9n_1.h3();
    }
  }
  p9o(bmp) {
    return this.v9m_1.q9s(bmp);
  }
  d9x(bmp) {
    return this.v9m_1.r9s(bmp);
  }
  e9x(bmp) {
    return this.v9m_1.p9s(bmp);
  }
  f9x(closeable) {
    return this.u9m_1.g9r(closeable);
  }
  g9x() {
    this.a9n_1.x9t();
  }
  s9s() {
    this.o9o();
    this.x83();
    this.a9n_1.h9r();
    this.u9m_1.h9r();
    this.v9m_1.s9s();
    this.w9m_1.h9r();
  }
  p6() {
    this.v9m_1.p6();
    this.u9m_1.p6();
  }
  h9x(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    // Inline function 'kotlin.math.max' call
    var realWidth = Math.max(width, 64);
    // Inline function 'kotlin.math.max' call
    var realHeight = Math.max(height, 64);
    var rb = this.h9n_1.f42();
    if (onlyThisFrame) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.g9n_1.h(rb);
    }
    rb.v87(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.m88(hasDepth, hasStencil);
    rb.l88(msamples);
    return rb;
  }
  i9x(width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.h9x(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.h9x.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  }
  j9x(rb) {
    this.g9n_1.g3(rb);
    this.h9n_1.g42(rb);
  }
  k9x(frameBuffer) {
    this.i9n_1.h(this.f9n_1);
    this.f9n_1 = frameBuffer;
  }
  l9x() {
    this.f9n_1 = this.i9n_1.j3(this.i9n_1.g1() - 1 | 0);
  }
  d8a(uniformBlock) {
    return this.j9m_1.d8a(uniformBlock);
  }
  m9x(program) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.k9m_1;
      var res = get_0(this_0, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.RenderContext.get.<anonymous>' call
      var out = new AGProgramWithUniforms(program, this.j9m_1);
      set(this_0, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  x9u(program, autoUpload) {
    if (autoUpload) {
      this.a9v();
    }
    return this.m9x(program).r8b();
  }
  t9w(program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.x9u(program, autoUpload) : $super.x9u.call(this, program, autoUpload);
  }
  a9v() {
    this.j9m_1.b8a();
  }
  c28(value) {
    this.b9m_1.c28(value);
  }
  d28() {
    return this.b9m_1.d28();
  }
  h9v(_set____db54di) {
    this.d9m_1.h9v(_set____db54di);
  }
  i9v() {
    return this.d9m_1.i9v();
  }
  j9v(_set____db54di) {
    this.d9m_1.j9v(_set____db54di);
  }
  k9v() {
    return this.d9m_1.k9v();
  }
  l9v(_set____db54di) {
    this.d9m_1.l9v(_set____db54di);
  }
  m9v() {
    return this.d9m_1.m9v();
  }
  n9v(_set____db54di) {
    this.d9m_1.n9v(_set____db54di);
  }
  o9v(_set____db54di) {
    this.d9m_1.o9v(_set____db54di);
  }
  p9v() {
    return this.d9m_1.p9v();
  }
  q9v() {
    return this.d9m_1.q9v();
  }
  r9v() {
    return this.d9m_1.r9v();
  }
  s9v() {
    return this.d9m_1.s9v();
  }
  t9v() {
    return this.d9m_1.t9v();
  }
  u9v() {
    return this.d9m_1.u9v();
  }
  v9v(pos) {
    return this.d9m_1.v9v(pos);
  }
  c84() {
    return this.c9m_1.c84();
  }
  d84() {
    return this.c9m_1.d84();
  }
  e84() {
    return this.c9m_1.e84();
  }
  n9x() {
    return this.e9m_1.n9x();
  }
  o9x() {
    return this.e9m_1.o9x();
  }
  p9x() {
    return this.e9m_1.p9x();
  }
  x9w() {
    return this.e9m_1.x9w();
  }
}
class RenderContext2D {
  constructor(batch, agBitmapTextureManager) {
    this.q9x_1 = new Mixin();
    this.r9x_1 = batch;
    this.s9x_1 = agBitmapTextureManager;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger_0();
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$0 = 'RenderContext2D[0]';
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.t9x_1 = Size2D.w3j(0, 0);
    var tmp_0 = this;
    tmp_0.u9x_1 = Pool.d42(VOID, RenderContext2D$mpool$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger_0();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.q46(level_0)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$2 = 'RenderContext2D[1]';
      this_1.r46(level_0, tmp$ret$2);
      tmp_1 = Unit_instance;
    }
    this.v9x_1 = Companion_getInstance_7().z3l_1;
    this.w9x_1 = Companion_getInstance_66().h9l_1;
    this.x9x_1 = Colors_getInstance().y57_1;
    this.y9x_1 = true;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger_0();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.q46(level_1)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$4 = 'RenderContext2D[2]';
      this_2.r46(level_1, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
  }
  z9x(matrix) {
    this.v9x_1 = matrix;
  }
  a9y(rect, color, filtering, bmp, program) {
    var tmp0_$this = this.r9x_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.getTexture' call
    var tmp1_tex = this.s9x_1.q9s(bmp);
    var tmp2_x = rect.b3j_1;
    var tmp3_y = rect.c3j_1;
    var tmp4_width = rect.d3j_1;
    var tmp5_height = rect.e3j_1;
    var tmp6_m = this.v9x_1;
    var tmp7_blendMode = this.w9x_1;
    tmp0_$this.s9u(tmp1_tex, tmp2_x, tmp3_y, tmp4_width, tmp5_height, tmp6_m, filtering, color, tmp7_blendMode, program);
  }
  b9y(scissor) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.v9x_1;
      var p = Vector2D.k3l(scissor.i3j(), scissor.d3q());
      if (this_0.g3j()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.y3k(this_0.r3m(p.r3i_1, p.s3i_1), this_0.u3m(p.r3i_1, p.s3i_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_1 = this.v9x_1;
      var p_0 = Vector2D.k3l(scissor.j3j(), scissor.c3q());
      if (this_1.g3j()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.y3k(this_1.r3m(p_0.r3i_1, p_0.s3i_1), this_1.u3m(p_0.r3i_1, p_0.s3i_1));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_43().r8d(tl.r3i_1, tl.s3i_1, br.r3i_1, br.s3i_1);
  }
  c28(value) {
    this.q9x_1.c28(value);
  }
  d28() {
    return this.q9x_1.d28();
  }
}
class SDFShaders extends Builder {
  static u9y() {
    SDFShaders_instance = null;
    var $this = this.b8l();
    SDFShaders_instance = $this;
    var tmp = $this;
    var tmp_0 = $this.u8l();
    var tmp_1 = $this.u8l();
    var tmp_2 = $this.u8l();
    var tmp_3 = $this.u8l();
    tmp.e9y_1 = $this.m8l(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda).o8i($this, opInterpolate$factory());
    var tmp_4 = $this;
    var tmp_5 = $this.u8l();
    var tmp_6 = $this.u8l();
    var tmp_7 = $this.u8l();
    tmp_4.f9y_1 = $this.k8l(tmp_5, tmp_6, VOID, tmp_7, SDFShaders$opUnion$delegate$lambda).o8i($this, opUnion$factory());
    var tmp_8 = $this;
    var tmp_9 = $this.u8l();
    var tmp_10 = $this.u8l();
    var tmp_11 = $this.u8l();
    tmp_8.g9y_1 = $this.k8l(tmp_9, tmp_10, VOID, tmp_11, SDFShaders$opIntersect$delegate$lambda).o8i($this, opIntersect$factory());
    var tmp_12 = $this;
    var tmp_13 = $this.u8l();
    var tmp_14 = $this.u8l();
    var tmp_15 = $this.u8l();
    tmp_12.h9y_1 = $this.k8l(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opSubtract$delegate$lambda).o8i($this, opSubtract$factory());
    var tmp_16 = $this;
    var tmp_17 = $this.u8l();
    var tmp_18 = $this.u8l();
    var tmp_19 = $this.u8l();
    tmp_16.i9y_1 = $this.k8l(tmp_17, tmp_18, VOID, tmp_19, SDFShaders$opRound$delegate$lambda).o8i($this, opRound$factory());
    var tmp_20 = $this;
    var tmp_21 = $this.u8l();
    var tmp_22 = $this.u8l();
    var tmp_23 = $this.u8l();
    tmp_20.j9y_1 = $this.k8l(tmp_21, tmp_22, VOID, tmp_23, SDFShaders$opBorder$delegate$lambda).o8i($this, opBorder$factory());
    var tmp_24 = $this;
    var tmp_25 = $this.u8l();
    var tmp_26 = $this.u8l();
    var tmp_27 = $this.u8l();
    tmp_24.k9y_1 = $this.k8l(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opBorderInner$delegate$lambda).o8i($this, opBorderInner$factory());
    var tmp_28 = $this;
    var tmp_29 = $this.u8l();
    var tmp_30 = $this.u8l();
    tmp_28.l9y_1 = $this.i8l(tmp_29, VOID, tmp_30, SDFShaders$opAA$delegate$lambda).o8i($this, opAA$factory());
    var tmp_31 = $this;
    var tmp_32 = $this.u8l();
    var tmp_33 = $this.u8l();
    tmp_31.m9y_1 = $this.i8l(tmp_32, VOID, tmp_33, SDFShaders$opAARev$delegate$lambda).o8i($this, opAARev$factory());
    var tmp_34 = $this;
    var tmp_35 = $this.u8l();
    var tmp_36 = $this.u8l();
    var tmp_37 = $this.u8l();
    var tmp_38 = $this.u8l();
    tmp_34.n9y_1 = $this.m8l(tmp_35, tmp_36, tmp_37, VOID, tmp_38, SDFShaders$opSmoothUnion$delegate$lambda).o8i($this, opSmoothUnion$factory());
    var tmp_39 = $this;
    var tmp_40 = $this.u8l();
    var tmp_41 = $this.u8l();
    var tmp_42 = $this.u8l();
    var tmp_43 = $this.u8l();
    tmp_39.o9y_1 = $this.m8l(tmp_40, tmp_41, tmp_42, VOID, tmp_43, SDFShaders$opSmoothSubtraction$delegate$lambda).o8i($this, opSmoothSubtraction$factory());
    var tmp_44 = $this;
    var tmp_45 = $this.u8l();
    var tmp_46 = $this.u8l();
    var tmp_47 = $this.u8l();
    var tmp_48 = $this.u8l();
    tmp_44.p9y_1 = $this.m8l(tmp_45, tmp_46, tmp_47, VOID, tmp_48, SDFShaders$opSmoothIntersection$delegate$lambda).o8i($this, opSmoothIntersection$factory());
    var tmp_49 = $this;
    var tmp_50 = $this.r96();
    var tmp_51 = $this.u8l();
    var tmp_52 = $this.u8l();
    tmp_49.q9y_1 = $this.k8l(tmp_50, tmp_51, VOID, tmp_52, SDFShaders$circle$delegate$lambda).o8i($this, circle$factory());
    var tmp_53 = $this;
    var tmp_54 = $this.r96();
    var tmp_55 = $this.r96();
    var tmp_56 = $this.s96();
    var tmp_57 = $this.u8l();
    tmp_53.r9y_1 = $this.m8l(tmp_54, tmp_55, tmp_56, VOID, tmp_57, SDFShaders$roundedBox$delegate$lambda).o8i($this, roundedBox$factory());
    var tmp_58 = $this;
    var tmp_59 = $this.r96();
    var tmp_60 = $this.r96();
    var tmp_61 = $this.u8l();
    tmp_58.s9y_1 = $this.k8l(tmp_59, tmp_60, VOID, tmp_61, SDFShaders$box$delegate$lambda).o8i($this, box$factory());
    var tmp_62 = $this;
    var tmp_63 = $this.s96();
    var tmp_64 = $this.s96();
    var tmp_65 = $this.s96();
    tmp_62.t9y_1 = $this.k8l(tmp_63, tmp_64, VOID, tmp_65, SDFShaders$opCombinePremultipliedColors$delegate$lambda).o8i($this, opCombinePremultipliedColors$factory());
    return $this;
  }
  v9y() {
    return this.e9y_1.np(this, opInterpolate$factory_0());
  }
  w9y() {
    return this.f9y_1.np(this, opUnion$factory_0());
  }
  x9y() {
    return this.g9y_1.np(this, opIntersect$factory_0());
  }
  y9y() {
    return this.h9y_1.np(this, opSubtract$factory_0());
  }
  z9y() {
    return this.i9y_1.np(this, opRound$factory_0());
  }
  a9z() {
    return this.j9y_1.np(this, opBorder$factory_0());
  }
  b9z() {
    return this.k9y_1.np(this, opBorderInner$factory_0());
  }
  c9z() {
    return this.l9y_1.np(this, opAA$factory_0());
  }
  d9z() {
    return this.m9y_1.np(this, opAARev$factory_0());
  }
  e9z() {
    return this.n9y_1.np(this, opSmoothUnion$factory_0());
  }
  f9z() {
    return this.o9y_1.np(this, opSmoothSubtraction$factory_0());
  }
  g9z() {
    return this.p9y_1.np(this, opSmoothIntersection$factory_0());
  }
  h9z() {
    return this.q9y_1.np(this, circle$factory_0());
  }
  i9z() {
    return this.r9y_1.np(this, roundedBox$factory_0());
  }
  j9z() {
    return this.s9y_1.np(this, box$factory_0());
  }
  k9z() {
    return this.t9y_1.np(this, opCombinePremultipliedColors$factory_0());
  }
}
class TextureBase {
  static l9z(base, size) {
    var $this = createThis(this);
    $this.m9r_1 = base;
    $this.n9r_1 = size;
    $this.o9r_1 = -1;
    return $this;
  }
  g1() {
    return this.n9r_1;
  }
  static p9r(base, width, height) {
    return this.l9z(base, SizeInt.x3s(width, height));
  }
  q9r(width) {
    this.n9r_1 = SizeInt.x3s(width, this.g3u());
  }
  f3u() {
    return this.n9r_1.v3s_1;
  }
  r9r(height) {
    this.n9r_1 = SizeInt.x3s(this.f3u(), height);
  }
  g3u() {
    return this.n9r_1.w3s_1;
  }
  p6() {
    var tmp0_safe_receiver = this.m9r_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p6();
    }
    this.m9r_1 = null;
  }
  k9s(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp0_safe_receiver = this.m9r_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.i89(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  toString() {
    return 'TextureBase(' + toString_1(this.m9r_1) + ')';
  }
}
class Companion_56 {
  constructor() {
    Companion_instance_65 = this;
    this.m9z_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
}
class TexturedVertexArray {
  constructor(vcount, indices, icount) {
    Companion_getInstance_71();
    icount = icount === VOID ? indices.length : icount;
    this.g9u_1 = indices;
    this.h9u_1 = vcount;
    this.i9u_1 = vcount;
    this.j9u_1 = icount;
    this.k9u_1 = allocNoDirect(Companion_instance_4, imul(imul(6, this.h9u_1), 4));
    this.l9u_1 = this.k9u_1;
    this.m9u_1 = 0;
  }
  n9z(index, x, y, u, v, colMul) {
    this.o9z(this.l9u_1, imul(index, 6), x, y, u, v, _RGBA___get_value__impl__hhco8v(colMul));
  }
  o9z(fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  }
  p9z(index, x, y, width, height, matrix, bmp, colMul) {
    this.q9z(index, x, y, width, height, matrix, bmp.c4t(), bmp.d4t(), bmp.e4t(), bmp.f4t(), bmp.i4t(), bmp.j4t(), bmp.g4t(), bmp.h4t(), colMul);
  }
  q9z(index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix.e3m_1;
    var cf = matrix.g3m_1;
    var txf = matrix.i3m_1;
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix.h3m_1;
    var bf = matrix.f3m_1;
    var tyf = matrix.j3m_1;
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.l9u_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.o9z(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.o9z(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.o9z(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.o9z(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  }
}
class ShrinkableTexturedVertexArray {
  constructor(vertices, vcount, icount) {
    vcount = vcount === VOID ? 0 : vcount;
    icount = icount === VOID ? 0 : icount;
    this.r9z_1 = vertices;
    this.s9z_1 = vcount;
    this.t9z_1 = icount;
  }
  u9z(x, y, u, v, colMul) {
    var _unary__edvuaz = this.s9z_1;
    this.s9z_1 = _unary__edvuaz + 1 | 0;
    this.r9z_1.n9z(_unary__edvuaz, x, y, u, v, colMul);
  }
  u1w() {
    this.s9z_1 = 0;
    this.t9z_1 = 0;
  }
  toString() {
    return 'GrowableTexturedVertexArray(vcount=' + this.s9z_1 + ', icount=' + this.t9z_1 + ')';
  }
}
class ResourcesRoot {
  x9z(path, file) {
    _get_mountable__707cy(this).n4b(path, file);
  }
  p7s(injector) {
    var tmp = this;
    // Inline function 'korlibs.io.file.std.MountableVfs' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync' call
    // Inline function 'kotlin.also' call
    var this_0 = new MountableVfs(false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync.<anonymous>' call
    // Inline function 'korlibs.io.file.std.MountableVfs.<anonymous>' call
    // Inline function 'korlibs.korge.resources.ResourcesRoot.init.<anonymous>' call
    this.w9z_1 = this_0;
    tmp.v9z_1 = this_0.o3g();
    this.x9z('/', get_resourcesVfs());
  }
  toString() {
    return 'ResourcesRoot[' + _get_root__dd8asp(this).toString() + ']';
  }
}
class Counter {
  constructor(name) {
    this.y9z_1 = name;
    this.z9z_1 = 0.0;
    this.aa0_1 = 0;
    this.ba0_1 = 0.0;
  }
  ca0() {
    return this.ba0_1 / this.z9z_1;
  }
  da0(count) {
    this.aa0_1 = this.aa0_1 + count | 0;
  }
  z83() {
    this.ba0_1 = this.ba0_1 + this.aa0_1;
    this.z9z_1 = this.z9z_1 + 1;
    this.aa0_1 = 0;
  }
  toString() {
    return 'Counter(' + this.y9z_1 + '): [frames=' + this.z9z_1 + ', totalCount=' + this.ba0_1 + ', countThisFrame=' + this.aa0_1 + ', avgCountPerFrame=' + this.ca0() + ']';
  }
}
class RCollection {
  constructor() {
    this.ea0_1 = ArrayList.z();
    this.fa0_1 = LinkedHashMap.wc();
  }
}
class Stats {
  constructor() {
    this.ga0_1 = new RCollection();
    this.ha0_1 = new RCollection();
  }
  z83() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ga0_1.ea0_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.h1(_unary__edvuaz).z83();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.ha0_1.ea0_1;
    var n_0 = 0;
    while (n_0 < this_1.g1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      this_1.h1(_unary__edvuaz_0).z83();
    }
  }
  la0(name) {
    // Inline function 'korlibs.korge.stat.RCollection.getOrPut' call
    var this_0 = this.ga0_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var this_1 = this_0.fa0_1;
    var value = this_1.e3(name);
    var tmp;
    if (value == null) {
      // Inline function 'korlibs.korge.stat.RCollection.getOrPut.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'korlibs.korge.stat.Stats.counter.<anonymous>' call
      var this_2 = new Counter(name);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.stat.RCollection.getOrPut.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      this_0.ea0_1.h(this_2);
      var answer = this_2;
      this_1.k3(name, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
}
class V2 {
  constructor(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) {
    fastStartTime = fastStartTime === VOID ? Companion_instance_3.r35() : fastStartTime;
    fastDuration = fastDuration === VOID ? Companion_instance_3.s35() : fastDuration;
    initialization = initialization === VOID ? null : initialization;
    this.ma0_1 = key;
    this.na0_1 = initial;
    this.oa0_1 = end;
    this.pa0_1 = interpolator;
    this.qa0_1 = includeStart;
    this.ra0_1 = fastStartTime;
    this.sa0_1 = fastDuration;
    this.ta0_1 = initialization;
    this.ua0_1 = FastDuration__plus_impl_q1enab(this.ra0_1, equals(this.sa0_1, Companion_instance_3.s35()) ? get_fastNanoseconds_0(0) : this.sa0_1);
  }
  va0() {
    return toDuration_1(this.ra0_1);
  }
  h6p() {
    return toDuration_1(this.sa0_1);
  }
  b4j() {
    if (!this.qa0_1) {
      this.na0_1 = this.ma0_1.get();
    }
    var tmp0_safe_receiver = this.ta0_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  wa0(ratio) {
    this.ma0_1.set(this.pa0_1(new Ratio(ratio), this.na0_1, this.oa0_1));
  }
  toString() {
    return 'V2(key=' + this.ma0_1.callableName + ', range=[' + toString_1(this.na0_1) + '-' + toString_1(this.oa0_1) + '], startTime=' + Duration__toString_impl_8d916b(this.va0()) + ', duration=' + Duration__toString_impl_8d916b(this.h6p()) + ')';
  }
  hashCode() {
    var result = hashCode(this.ma0_1);
    result = imul(result, 31) + (this.na0_1 == null ? 0 : hashCode(this.na0_1)) | 0;
    result = imul(result, 31) + (this.oa0_1 == null ? 0 : hashCode(this.oa0_1)) | 0;
    result = imul(result, 31) + hashCode(this.pa0_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.qa0_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.ra0_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.sa0_1) | 0;
    result = imul(result, 31) + (this.ta0_1 == null ? 0 : hashCode(this.ta0_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.ma0_1, tmp0_other_with_cast.ma0_1))
      return false;
    if (!equals(this.na0_1, tmp0_other_with_cast.na0_1))
      return false;
    if (!equals(this.oa0_1, tmp0_other_with_cast.oa0_1))
      return false;
    if (!equals(this.pa0_1, tmp0_other_with_cast.pa0_1))
      return false;
    if (!(this.qa0_1 === tmp0_other_with_cast.qa0_1))
      return false;
    if (!equals(this.ra0_1, tmp0_other_with_cast.ra0_1))
      return false;
    if (!equals(this.sa0_1, tmp0_other_with_cast.sa0_1))
      return false;
    if (!equals(this.ta0_1, tmp0_other_with_cast.ta0_1))
      return false;
    return true;
  }
}
class DEFAULT {}
class Impl {
  constructor(quality) {
    quality = quality === VOID ? Quality_AUTOMATIC_getInstance() : quality;
    this.xa0_1 = quality;
  }
  u9w() {
    return this.xa0_1;
  }
}
class Companion_57 {
  constructor() {
    Companion_instance_66 = this;
    this.ya0_1 = mapOf([to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
}
class Cursor extends Enum {}
class MenuItem {
  constructor(text, enabled, children, action) {
    enabled = enabled === VOID ? true : enabled;
    children = children === VOID ? null : children;
    var tmp;
    if (action === VOID) {
      tmp = GameWindow$MenuItem$_init_$lambda_465oqx;
    } else {
      tmp = action;
    }
    action = tmp;
    this.ba1_1 = text;
    this.ca1_1 = enabled;
    this.da1_1 = children;
    this.ea1_1 = action;
  }
  toString() {
    return 'MenuItem(text=' + this.ba1_1 + ', enabled=' + this.ca1_1 + ', children=' + toString_1(this.da1_1) + ', action=' + toString(this.ea1_1) + ')';
  }
  hashCode() {
    var result = this.ba1_1 == null ? 0 : getStringHashCode(this.ba1_1);
    result = imul(result, 31) + getBooleanHashCode(this.ca1_1) | 0;
    result = imul(result, 31) + (this.da1_1 == null ? 0 : hashCode(this.da1_1)) | 0;
    result = imul(result, 31) + hashCode(this.ea1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this.ba1_1 == tmp0_other_with_cast.ba1_1))
      return false;
    if (!(this.ca1_1 === tmp0_other_with_cast.ca1_1))
      return false;
    if (!equals(this.da1_1, tmp0_other_with_cast.da1_1))
      return false;
    if (!equals(this.ea1_1, tmp0_other_with_cast.ea1_1))
      return false;
    return true;
  }
}
class CoroutineKey {
  constructor() {
    CoroutineKey_instance = this;
    this.fa1_1 = 60;
    this.ga1_1 = Companion_getInstance_1().g26('GameWindow');
    this.ha1_1 = new MenuItem(null);
  }
}
class Quality extends Enum {
  constructor(name, ordinal, level) {
    super(name, ordinal);
    this.va3_1 = level;
    this.wa3_1 = 4000000;
  }
  o46() {
    return this.va3_1;
  }
  xa3(width, height, devicePixelRatio, targetPixels) {
    var tmp;
    switch (this.p3_1) {
      case 0:
        tmp = 1.0;
        break;
      case 1:
        tmp = devicePixelRatio;
        break;
      case 2:
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = listOf_0([devicePixelRatio, 2.0, 1.0]).b1();
          while (tmp0_iterator.c1()) {
            var element = tmp0_iterator.d1();
            // Inline function 'korlibs.render.Quality.computeTargetScale.<anonymous>' call
            if (imul(width, height) * element <= targetPixels) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }

        var tmp1_elvis_lhs = tmp$ret$1;
        tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  ya3(width, height, devicePixelRatio, targetPixels, $super) {
    targetPixels = targetPixels === VOID ? this.wa3_1 : targetPixels;
    return $super === VOID ? this.xa3(width, height, devicePixelRatio, targetPixels) : $super.xa3.call(this, width, height, devicePixelRatio, targetPixels);
  }
}
class GameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.za0_1 = $entry;
    this.aa1_1 = this$0;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
  }
}
class _no_name_provided__qut3iv extends ObservableProperty {
  constructor($initialValue, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.fa4_1 = this$0;
    super($initialValue, $box);
  }
  ga4(property, oldValue, newValue) {
    var tmp0_safe_receiver = this.fa4_1.za2_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(newValue);
    return Unit_instance;
  }
  mp(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
    return this.ga4(property, tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  }
}
class GameWindow extends BaseEventListener {
  static ha4() {
    CoroutineKey_getInstance();
    var $this = this.y7u();
    $this.ma1_1 = new Mixin();
    $this.na1_1 = Cursor_DEFAULT_getInstance();
    $this.oa1_1 = false;
    $this.pa1_1 = AGDummy.a8w();
    $this.qa1_1 = SyncEventLoopCoroutineDispatcher.ka4();
    $this.ra1_1 = GameWindowCoroutineDispatcher.va4();
    $this.sa1_1 = new PauseEvent();
    $this.ta1_1 = new ResumeEvent();
    $this.ua1_1 = new StopEvent();
    $this.va1_1 = new DestroyEvent();
    $this.wa1_1 = new UpdateEvent();
    $this.xa1_1 = new RenderEvent();
    $this.ya1_1 = new InitEvent();
    $this.za1_1 = new DisposeEvent();
    $this.aa2_1 = new FullScreenEvent();
    $this.ba2_1 = new ReshapeEvent();
    $this.ca2_1 = new KeyEvent();
    $this.da2_1 = new MouseEvent();
    $this.ea2_1 = new GestureEvent();
    $this.fa2_1 = new DropFileEvent();
    var tmp = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    tmp.ga2_1 = new IntTimedCache(tmp_0, VOID, GameWindow$fpsCached$delegate$lambda($this));
    $this.ha2_1 = 60;
    $this.ia2_1 = 0;
    $this.ja2_1 = 0;
    $this.ka2_1 = true;
    $this.la2_1 = null;
    $this.ma2_1 = false;
    $this.na2_1 = false;
    $this.oa2_1 = Colors_getInstance().z57_1;
    $this.pa2_1 = new Signal();
    $this.qa2_1 = new Signal();
    $this.ra2_1 = null;
    $this.sa2_1 = false;
    $this.ta2_1 = true;
    $this.ua2_1 = 0;
    $this.va2_1 = true;
    $this.wa2_1 = false;
    var tmp_1 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_1.xa2_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.ya2_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    $this.za2_1 = null;
    var tmp_3 = $this;
    // Inline function 'kotlin.properties.Delegates.observable' call
    tmp_3.aa3_1 = new _no_name_provided__qut3iv(true, $this);
    $this.ba3_1 = false;
    $this.ca3_1 = -1;
    $this.da3_1 = -1;
    $this.ea3_1 = -1;
    $this.fa3_1 = -1;
    $this.ga3_1 = false;
    $this.ha3_1 = false;
    $this.ia3_1 = false;
    $this.ja3_1 = 0;
    $this.ka3_1 = Companion_instance_3.r35();
    $this.la3_1 = new Lock();
    $this.ma3_1 = booleanArray(Companion_getInstance_34().x81_1);
    $this.na3_1 = 0;
    $this.oa3_1 = 0.0;
    $this.pa3_1 = 0.0;
    $this.qa3_1 = 0.0;
    $this.ra3_1 = false;
    $this.sa3_1 = new GamepadInfoEmitter($this);
    return $this;
  }
  wa4(_set____db54di) {
    this.na1_1 = _set____db54di;
  }
  xa4() {
    return this.na1_1;
  }
  v1() {
    return CoroutineKey_getInstance();
  }
  ya4() {
    return this.pa1_1;
  }
  za4() {
    return this.ra1_1;
  }
  aa5(coroutineContext) {
    return coroutineContext.eo(this.za4());
  }
  za3($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.hd();
    return this.aa5(tmp$ret$0);
  }
  ba5(block) {
    return this.a7v(Companion_getInstance_18(), block);
  }
  ba4() {
    return get_fastMicroseconds(1000000.0 / this.ca5());
  }
  da5() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = 1000000.0 / this.ca5();
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  ea5() {
    return this.da5();
  }
  da4() {
    return 60;
  }
  fa5(name, time) {
  }
  ca5() {
    return _get_fpsCached__581dty(this);
  }
  ga5(value) {
    return Unit_instance;
  }
  f3u() {
    return this.ia2_1;
  }
  g3u() {
    return this.ja2_1;
  }
  ha5(_set____db54di) {
    this.la2_1 = _set____db54di;
  }
  ia5(_set____db54di) {
    this.ma2_1 = _set____db54di;
  }
  ja5(_set____db54di) {
    this.na2_1 = _set____db54di;
  }
  ka5(_set____db54di) {
    this.oa2_1 = _set____db54di;
  }
  la5() {
    return this.oa2_1;
  }
  ma5(value) {
    return Unit_instance;
  }
  u9w() {
    return Quality_AUTOMATIC_getInstance();
  }
  na5(value) {
    this.sa2_1 = value;
    this.qa2_1.r38(value);
    if (value) {
      invoke(this.pa2_1);
    }
  }
  oa5() {
    return this.sa2_1;
  }
  pa5(width, height) {
    return Unit_instance;
  }
  qa5(exitCode) {
    return this.i2n(exitCode);
  }
  ra5(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.qa5(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.qa5.call(this, exitCode);
    }
    return tmp;
  }
  i2n(exitCode) {
    if (this.wa2_1)
      return Unit_instance;
    this.wa2_1 = true;
    this.va2_1 = false;
    this.ua2_1 = exitCode;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = CoroutineKey_getInstance().ga1_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.render.GameWindow.close.<anonymous>' call
      var tmp$ret$0 = 'GameWindow.close';
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.za4().p6();
    cancelChildren(this.za4());
  }
  sa5(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.i2n(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.i2n.call(this, exitCode);
    }
    return tmp;
  }
  ta5($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_waitClose__fhnm35.bind(VOID, this), $completion);
  }
  ua5(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8.bind(VOID, this, entry), $completion);
  }
  ca4(time, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loopDelay__vgtnit.bind(VOID, this, time), $completion);
  }
  va5(_set____db54di) {
    return this.aa3_1.qp(this, continuousRenderMode$factory(), _set____db54di);
  }
  wa5() {
    return this.aa3_1.op(this, continuousRenderMode$factory_0());
  }
  xa5(doUpdate, doRender, frameStartTime) {
    var startTime = PerformanceCounter_getInstance().z7s();
    if (doRender) {
      var tmp = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark = Monotonic_instance.fk();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      this.ya5(doUpdate, true);
      tmp.xa2_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    }
    if (doUpdate) {
      var tmp_0 = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark_0 = Monotonic_instance.fk();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      if (!doRender) {
        this.ya5(true, false);
      }
      this.za5(frameStartTime);
      tmp_0.ya2_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark_0);
    }
    var endTime = PerformanceCounter_getInstance().a7t();
    return FastDuration__minus_impl_evs237_0(endTime, startTime);
  }
  aa4(doUpdate, doRender, frameStartTime, $super) {
    doUpdate = doUpdate === VOID ? true : doUpdate;
    doRender = doRender === VOID ? true : doRender;
    frameStartTime = frameStartTime === VOID ? PerformanceCounter_getInstance().a7t() : frameStartTime;
    return $super === VOID ? this.xa5(doUpdate, doRender, frameStartTime) : $super.xa5.call(this, doUpdate, doRender, new FastDuration(frameStartTime)).u35_1;
  }
  ya5(doUpdate, doRender) {
    if (doRender) {
      if (this.ia3_1) {
        this.ia3_1 = false;
        this.ya4().w83();
      }
      if (this.ba3_1) {
        this.ba3_1 = false;
        this.ya4().v83().u87(this.ca3_1, this.da3_1, this.ea3_1, this.fa3_1);
        this.aa6(this.ca3_1, this.da3_1, this.ea3_1, this.fa3_1);
      }
    }
    if (this.ga3_1) {
      this.ga3_1 = false;
      println('---------------- Trigger AG.initialized ag.mainFrameBuffer.setSize (' + this.f3u() + ', ' + this.g3u() + ') --------------');
      // Inline function 'korlibs.event.reset' call
      var this_0 = this.ya1_1;
      this_0.t7v_1 = false;
      // Inline function 'korlibs.event.reset.<anonymous>' call
      this.l7v(this_0);
    }
    try {
      this.ba6(doUpdate, doRender);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  z83() {
    this.ja3_1 = 0;
  }
  ca6() {
    this.ja3_1 = this.ja3_1 + 1 | 0;
  }
  za5(startTime) {
    var tmp = this;
    // Inline function 'korlibs.time.fastMeasureTime' call
    var stopwatch = new Stopwatch();
    // Inline function 'korlibs.render.GameWindow.frameUpdate.<anonymous>' call
    this.da6();
    tmp.ka3_1 = stopwatch.g7t();
    try {
      var now = PerformanceCounter_getInstance().z7s();
      var consumed = minus(now, startTime);
      var tmp0_elvis_lhs = this.za4().ta4_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
        tmp_0 = Duration__times_impl_sfuzvp(this.da5(), 10);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var timeForTasks = tmp_0;
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$2 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
      var finalTimeForTasks = max(timeForTasks, tmp$ret$2);
      this.za4().ea6(finalTimeForTasks);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
      } else {
        throw $p;
      }
    }
  }
  da6() {
  }
  ba6(update, render) {
    // Inline function 'korlibs.render.GameWindow.updateRenderLock' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.la3_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.c36();
      try {
        // Inline function 'korlibs.event.reset' call
        var this_1 = this.xa1_1;
        this_1.t7v_1 = false;
        // Inline function 'korlibs.render.GameWindow.dispatchRenderEvent.<anonymous>.<anonymous>' call
        this_1.z7v_1 = update;
        this_1.a7w_1 = render;
        this.l7v(this_1);
        break $l$block;
      }finally {
        this_0.e36();
      }
    }
  }
  fa6(type, files) {
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.fa2_1;
    this_0.t7v_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchDropfileEvent.<anonymous>' call
    this_0.m7y_1 = type;
    this_0.n7y_1 = files;
    return this.l7v(this_0);
  }
  aa6(x, y, width, height) {
    this.ga6(x, y, width, height, width, height);
  }
  ga6(x, y, width, height, fullWidth, fullHeight) {
    this.ya4().v83().v87(x, y, width, height, fullWidth, fullHeight);
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.ba2_1;
    this_0.t7v_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchReshapeEventEx.<anonymous>' call
    this_0.i7w_1 = x;
    this_0.j7w_1 = y;
    this_0.k7w_1 = width;
    this_0.l7w_1 = height;
    this.l7v(this_0);
  }
  o80() {
    this.sa3_1.o80();
  }
  a81(info) {
    this.sa3_1.a81(info);
  }
  c81(out) {
    return this.sa3_1.c81(out);
  }
  ha6(out, $super) {
    out = out === VOID ? IntArrayList.l3w() : out;
    return $super === VOID ? this.c81(out) : $super.c81.call(this, out);
  }
  c28(_set____db54di) {
    this.ma1_1.c28(_set____db54di);
  }
  d28() {
    return this.ma1_1.d28();
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_67 = this;
    this.ia6_1 = new GameWindowCreationConfig();
  }
}
class GameWindowCreationConfig {
  constructor(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    Companion_getInstance_73();
    multithreaded = multithreaded === VOID ? null : multithreaded;
    hdr = hdr === VOID ? null : hdr;
    msaa = msaa === VOID ? null : msaa;
    checkGl = checkGl === VOID ? false : checkGl;
    logGl = logGl === VOID ? false : logGl;
    cacheGl = cacheGl === VOID ? false : cacheGl;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    decorated = decorated === VOID ? true : decorated;
    transparent = transparent === VOID ? false : transparent;
    resizable = resizable === VOID ? true : resizable;
    title = title === VOID ? '' : title;
    this.ja6_1 = multithreaded;
    this.ka6_1 = hdr;
    this.la6_1 = msaa;
    this.ma6_1 = checkGl;
    this.na6_1 = logGl;
    this.oa6_1 = cacheGl;
    this.pa6_1 = fullscreen;
    this.qa6_1 = decorated;
    this.ra6_1 = transparent;
    this.sa6_1 = resizable;
    this.ta6_1 = title;
  }
  ua6(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    return new GameWindowCreationConfig(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  va6(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title, $super) {
    multithreaded = multithreaded === VOID ? this.ja6_1 : multithreaded;
    hdr = hdr === VOID ? this.ka6_1 : hdr;
    msaa = msaa === VOID ? this.la6_1 : msaa;
    checkGl = checkGl === VOID ? this.ma6_1 : checkGl;
    logGl = logGl === VOID ? this.na6_1 : logGl;
    cacheGl = cacheGl === VOID ? this.oa6_1 : cacheGl;
    fullscreen = fullscreen === VOID ? this.pa6_1 : fullscreen;
    decorated = decorated === VOID ? this.qa6_1 : decorated;
    transparent = transparent === VOID ? this.ra6_1 : transparent;
    resizable = resizable === VOID ? this.sa6_1 : resizable;
    title = title === VOID ? this.ta6_1 : title;
    return $super === VOID ? this.ua6(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) : $super.ua6.call(this, multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  toString() {
    return 'GameWindowCreationConfig(multithreaded=' + this.ja6_1 + ', hdr=' + this.ka6_1 + ', msaa=' + this.la6_1 + ', checkGl=' + this.ma6_1 + ', logGl=' + this.na6_1 + ', cacheGl=' + this.oa6_1 + ', fullscreen=' + this.pa6_1 + ', decorated=' + this.qa6_1 + ', transparent=' + this.ra6_1 + ', resizable=' + this.sa6_1 + ', title=' + this.ta6_1 + ')';
  }
  hashCode() {
    var result = this.ja6_1 == null ? 0 : getBooleanHashCode(this.ja6_1);
    result = imul(result, 31) + (this.ka6_1 == null ? 0 : getBooleanHashCode(this.ka6_1)) | 0;
    result = imul(result, 31) + (this.la6_1 == null ? 0 : this.la6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ma6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.na6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.oa6_1) | 0;
    result = imul(result, 31) + (this.pa6_1 == null ? 0 : getBooleanHashCode(this.pa6_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.qa6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ra6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sa6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ta6_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWindowCreationConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameWindowCreationConfig ? other : THROW_CCE();
    if (!(this.ja6_1 == tmp0_other_with_cast.ja6_1))
      return false;
    if (!(this.ka6_1 == tmp0_other_with_cast.ka6_1))
      return false;
    if (!(this.la6_1 == tmp0_other_with_cast.la6_1))
      return false;
    if (!(this.ma6_1 === tmp0_other_with_cast.ma6_1))
      return false;
    if (!(this.na6_1 === tmp0_other_with_cast.na6_1))
      return false;
    if (!(this.oa6_1 === tmp0_other_with_cast.oa6_1))
      return false;
    if (!(this.pa6_1 == tmp0_other_with_cast.pa6_1))
      return false;
    if (!(this.qa6_1 === tmp0_other_with_cast.qa6_1))
      return false;
    if (!(this.ra6_1 === tmp0_other_with_cast.ra6_1))
      return false;
    if (!(this.sa6_1 === tmp0_other_with_cast.sa6_1))
      return false;
    if (!(this.ta6_1 === tmp0_other_with_cast.ta6_1))
      return false;
    return true;
  }
}
class TimedTask_0 {
  constructor(time, continuation, callback) {
    this.wa6_1 = time;
    this.xa6_1 = continuation;
    this.ya6_1 = callback;
    this.za6_1 = null;
  }
}
class Companion_59 {
  constructor() {
    Companion_instance_68 = this;
    this.aa7_1 = Companion_getInstance_1().g26('GameWindow');
  }
}
class sam$kotlinx_coroutines_DisposableHandle$0_0 {
  constructor(function_0) {
    this.ba7_1 = function_0;
  }
  k2i() {
    return this.ba7_1();
  }
  o4() {
    return this.ba7_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class GameWindowCoroutineDispatcher extends CoroutineDispatcher {
  static va4(nowProvider, fast) {
    Companion_getInstance_74();
    var tmp;
    if (nowProvider === VOID) {
      tmp = GameWindowCoroutineDispatcher$_init_$lambda_ooms1e;
    } else {
      tmp = nowProvider;
    }
    nowProvider = tmp;
    fast = fast === VOID ? false : fast;
    var $this = this.n2l();
    $this.ma4_1 = nowProvider;
    $this.na4_1 = fast;
    $this.oa4_1 = new TGenQueue();
    var tmp_0 = $this;
    var tmp_1 = Companion_instance_0;
    tmp_0.pa4_1 = tmp_1.y42(VOID, GameWindowCoroutineDispatcher$timedTasks$lambda);
    $this.qa4_1 = new NonRecursiveLock();
    $this.ra4_1 = get_fastMilliseconds_0(0);
    $this.sa4_1 = get_fastMilliseconds_0(0);
    $this.ta4_1 = null;
    $this.ua4_1 = Companion_getInstance_1().g26('Korgw.GameWindow.TooManyCallbacks');
    return $this;
  }
  q2l(context, block) {
    return this.p2l(context, block);
  }
  ca7(block) {
    if (block == null)
      return Unit_instance;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.qa4_1.x35_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.oa4_1.h43(block);
  }
  p2l(context, block) {
    return this.ca7(block);
  }
  da7() {
    return this.ma4_1().u35_1;
  }
  b2m(timeMillis, continuation) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.n4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    this.ea7(tmp$ret$0, continuation);
  }
  ea7(time, continuation) {
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(this.da7(), time), continuation, null);
    continuation.y2h(GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda(task));
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.qa4_1.x35_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.scheduleResumeAfterDelay.<anonymous>' call
    this.pa4_1.p3y(task);
  }
  c2m(timeMillis, block, context) {
    var tmp = this.da7();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.n4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(tmp, tmp$ret$0), null, block);
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.qa4_1.x35_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.invokeOnTimeout.<anonymous>' call
    this.pa4_1.p3y(task);
    var tmp_0 = GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this, task);
    return new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_0);
  }
  ea6(availableTime) {
    this.fa7(get_fast(availableTime));
  }
  fa7(availableTime) {
    try {
      var startTime = this.da7();
      var processedTimedTasks = 0;
      var processedTasks = 0;
      var tmp = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_0: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.qa4_1.x35_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.pa4_1.j1()) {
          tmp_1 = this.na4_1 || FastDuration__compareTo_impl_4fhnj7(startTime, this.pa4_1.e43().wa6_1) >= 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.pa4_1.f43();
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var item = tmp_2;
        try {
          if (!(item.za6_1 == null)) {
            var tmp1_safe_receiver = item.xa6_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception = ensureNotNull(item.za6_1);
              var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(exception));
              tmp1_safe_receiver.jd(tmp$ret$5);
            }
            if (!(item.ya6_1 == null)) {
              var tmp2_safe_receiver = item.za6_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp2_safe_receiver);
              }
            }
          } else {
            var tmp3_safe_receiver = item.xa6_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
              tmp3_safe_receiver.jd(tmp$ret$7);
            }
            var tmp4_safe_receiver = item.ya6_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.l2k();
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        finally {
          processedTimedTasks = processedTimedTasks + 1 | 0;
        }
        var elapsedTime = FastDuration__minus_impl_evs237(this.da7(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, availableTime) >= 0) {
          this.ga7(elapsedTime, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_0;
        }
      }
      tmp.ra4_1 = stopwatch.g7t();
      var tmp_3 = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch_0 = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_2: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.qa4_1.x35_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_4;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.oa4_1.j1()) {
          tmp_4 = this.oa4_1.i43();
        } else {
          tmp_4 = null;
        }
        var tmp0_elvis_lhs_0 = tmp_4;
        var tmp_5;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop_2;
        } else {
          tmp_5 = tmp0_elvis_lhs_0;
        }
        var task = tmp_5;
        // Inline function 'korlibs.time.fastMeasureTime' call
        var stopwatch_1 = new Stopwatch();
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        try {
          task.l2k();
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            printStackTrace(e_0);
          } else {
            throw $p;
          }
        }
        finally {
          processedTasks = processedTasks + 1 | 0;
        }
        var time = stopwatch_1.g7t();
        var elapsed = FastDuration__minus_impl_evs237(this.da7(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsed, availableTime) >= 0) {
          this.ga7(elapsed, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_2;
        }
      }
      tmp_3.sa4_1 = stopwatch_0.g7t();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace(e_1);
      } else {
        throw $p;
      }
    }
  }
  ga7(elapsedTime, availableTime, processedTimedTasks, processedTasks) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var this_0 = this.ua4_1;
    var level = Level_WARN_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.informTooManyCallbacksToHandleInThisFrame.<anonymous>' call
      var tmp$ret$0 = 'Too many callbacks to handle in this frame elapsedTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(elapsedTime)) + ', availableTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(availableTime)) + ' pending timedTasks=' + this.pa4_1.b43_1 + ', tasks=' + this.oa4_1.g1() + ', processedTimedTasks=' + processedTimedTasks + ', processedTasks=' + processedTasks;
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  p6() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(2, DurationUnit_SECONDS_getInstance());
    this.ea6(tmp$ret$1);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_74().aa7_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.close.<anonymous>' call
      var tmp$ret$2 = 'GameWindowCoroutineDispatcher.close';
      this_0.r46(level, tmp$ret$2);
      tmp = Unit_instance;
    }
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.pa4_1.j1()) {
        break $l$loop;
      }
      var tmp0_safe_receiver = this.pa4_1.f43().xa6_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.jd(tmp$ret$5);
      }
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.oa4_1.j1()) {
        break $l$loop_0;
      }
      this.oa4_1.i43().l2k();
    }
  }
  toString() {
    return 'GameWindowCoroutineDispatcher(setNow=setNow, fast=' + this.na4_1 + ')';
  }
}
class SyncEventLoopCoroutineDispatcher extends CoroutineDispatcher {
  static ha7(eventLoop) {
    var $this = this.n2l();
    $this.ja4_1 = eventLoop;
    return $this;
  }
  static ka4(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    return this.ha7(new SyncEventLoop(immediateRun));
  }
  p6() {
    this.ja4_1.p6();
  }
  p2l(context, block) {
    this.ja4_1.g7u(SyncEventLoopCoroutineDispatcher$dispatch$lambda(block));
  }
  b2m(timeMillis, continuation) {
    var cancelled = {_v: null};
    continuation.y2h(SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda(cancelled));
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    this.ja4_1.h7u(tmp, SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(cancelled, continuation));
  }
  c2m(timeMillis, block, context) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    return toDisposable(this.ja4_1.h7u(tmp, SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda(block)));
  }
}
class Companion_60 {}
class UpdateEvent extends Event {
  constructor(fastDeltaTime) {
    fastDeltaTime = fastDeltaTime === VOID ? Companion_instance_3.r35() : fastDeltaTime;
    super();
    this.ka7_1 = fastDeltaTime;
  }
  la7() {
    return toDuration_1(this.ka7_1);
  }
  p3m() {
    return Companion_instance_69;
  }
  toString() {
    return 'UpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.ka7_1) + ')';
  }
}
class Companion_61 {
  constructor() {
    this.ma7_1 = 536805376;
    this.na7_1 = 805240832;
    this.oa7_1 = 2;
    this.pa7_1 = 32;
    this.qa7_1 = 256;
    this.ra7_1 = 512;
    this.sa7_1 = 768;
    this.ta7_1 = 769;
    this.ua7_1 = 1024;
    this.va7_1 = 1025;
    this.wa7_1 = 1026;
    this.xa7_1 = 1027;
  }
}
class SDL extends FFILib {
  static qa8() {
    var $this = this.h48([get_SDLPath()]);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_13().n48_1;
    tmp.da8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config, true)).a48($this, SDL_Init$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_13().n48_1;
    tmp_0.ea8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().zg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_0, true)).a48($this, SDL_CreateWindow$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_13().n48_1;
    tmp_1.fa8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().zg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).a48($this, SDL_SetWindowTitle$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_13().n48_1;
    tmp_2.ga8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).a48($this, SDL_SetWindowSize$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_13().n48_1;
    tmp_3.ha8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).a48($this, SDL_SetWindowPosition$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_13().n48_1;
    tmp_4.ia8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).a48($this, SDL_ShowWindow$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_13().n48_1;
    tmp_5.ja8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).a48($this, SDL_RaiseWindow$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_13().n48_1;
    tmp_6.ka8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), false))]), false), null, config_6, true)).a48($this, SDL_PollEvent$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_13().n48_1;
    tmp_7.la8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).a48($this, SDL_Quit$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_13().n48_1;
    tmp_8.ma8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_8, true)).a48($this, SDL_GL_CreateContext$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_13().n48_1;
    tmp_9.na8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).a48($this, SDL_GL_DeleteContext$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_13().n48_1;
    tmp_10.oa8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_10, true)).a48($this, SDL_GL_MakeCurrent$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_13().n48_1;
    tmp_11.pa8_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).a48($this, SDL_GL_SwapWindow$factory());
    return $this;
  }
  ra8() {
    return this.da8_1.op(this, SDL_Init$factory_0());
  }
  sa8() {
    return this.ea8_1.op(this, SDL_CreateWindow$factory_0());
  }
  ta8() {
    return this.fa8_1.op(this, SDL_SetWindowTitle$factory_0());
  }
  ua8() {
    return this.ga8_1.op(this, SDL_SetWindowSize$factory_0());
  }
  va8() {
    return this.ha8_1.op(this, SDL_SetWindowPosition$factory_0());
  }
  wa8() {
    return this.ia8_1.op(this, SDL_ShowWindow$factory_0());
  }
  xa8() {
    return this.ja8_1.op(this, SDL_RaiseWindow$factory_0());
  }
  ya8() {
    return this.ka8_1.op(this, SDL_PollEvent$factory_0());
  }
  za8() {
    return this.la8_1.op(this, SDL_Quit$factory_0());
  }
  aa9() {
    return this.ma8_1.op(this, SDL_GL_CreateContext$factory_0());
  }
  ba9() {
    return this.na8_1.op(this, SDL_GL_DeleteContext$factory_0());
  }
  ca9() {
    return this.oa8_1.op(this, SDL_GL_MakeCurrent$factory_0());
  }
  da9() {
    return this.pa8_1.op(this, SDL_GL_SwapWindow$factory_0());
  }
}
class KmlGlOpenGL extends KmlGl {
  constructor(gl) {
    gl = gl === VOID ? OpenGL.haf() : gl;
    super();
    this.maf_1 = gl;
  }
  naf(_this__u8e3s4) {
    return CreateFFIPointer(toLong(_this__u8e3s4));
  }
  oaf(_this__u8e3s4) {
    return CreateFFIPointer(_this__u8e3s4);
  }
  q8r(texture) {
    return this.maf_1.paf()(texture);
  }
  u8v(program, shader) {
    return this.maf_1.qaf()(program, shader);
  }
  t8v(program, index, name) {
    return this.maf_1.raf()(program, index, name);
  }
  k8q(target, buffer) {
    return this.maf_1.saf()(target, buffer);
  }
  m8u(target, framebuffer) {
    return this.maf_1.taf()(target, framebuffer);
  }
  t8u(target, renderbuffer) {
    return this.maf_1.uaf()(target, renderbuffer);
  }
  k8u(target, texture) {
    return this.maf_1.vaf()(target, texture);
  }
  x8s(modeRGB, modeAlpha) {
    return this.maf_1.waf()(modeRGB, modeAlpha);
  }
  y8s(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.maf_1.xaf()(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  u8r(target, size, data, usage) {
    return this.maf_1.yaf()(target, this.naf(size), get_pointer_0(data), usage);
  }
  t8r(target, offset, size, data) {
    return this.maf_1.zaf()(target, this.naf(offset), this.naf(size), get_pointer_0(data));
  }
  q1s(mask) {
    return this.maf_1.aag()(mask);
  }
  p8s(red, green, blue, alpha) {
    return this.maf_1.bag()(red, green, blue, alpha);
  }
  r8s(d) {
    return this.maf_1.cag()(d);
  }
  t8s(s) {
    return this.maf_1.dag()(s);
  }
  a8v(red, green, blue, alpha) {
    var tmp = this.maf_1.eag();
    // Inline function 'korlibs.math.toInt' call
    var tmp_0 = red ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_1 = green ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_2 = blue ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    return tmp(tmp_0, tmp_1, tmp_2, alpha ? 1 : 0);
  }
  l8v(shader) {
    return this.maf_1.fag()(shader);
  }
  n8v() {
    return this.maf_1.gag()();
  }
  j8v(type) {
    return this.maf_1.hag()(type);
  }
  q8t(mode) {
    return this.maf_1.iag()(mode);
  }
  k9k(n, items) {
    return this.maf_1.jag()(n, get_pointer_0(items));
  }
  l9k(n, items) {
    return this.maf_1.kag()(n, get_pointer_0(items));
  }
  i8v(program) {
    return this.maf_1.lag()(program);
  }
  m9k(n, items) {
    return this.maf_1.mag()(n, get_pointer_0(items));
  }
  h8v(shader) {
    return this.maf_1.nag()(shader);
  }
  n9k(n, items) {
    return this.maf_1.oag()(n, get_pointer_0(items));
  }
  z8u(func) {
    return this.maf_1.pag()(func);
  }
  q8s(flag) {
    var tmp = this.maf_1.qag();
    // Inline function 'korlibs.math.toInt' call
    return tmp(flag ? 1 : 0);
  }
  y8u(n, f) {
    return this.maf_1.rag()(n, f);
  }
  c8t(cap) {
    return this.maf_1.sag()(cap);
  }
  s8t(index) {
    return this.maf_1.tag()(index);
  }
  j8t(mode, first, count) {
    return this.maf_1.uag()(mode, first, count);
  }
  l8t(mode, count, type, indices) {
    return this.maf_1.vag()(mode, count, type, this.naf(indices));
  }
  d8t(cap) {
    return this.maf_1.wag()(cap);
  }
  w8t(index) {
    return this.maf_1.xag()(index);
  }
  gd() {
    return this.maf_1.yag()();
  }
  w8u(target, attachment, renderbuffertarget, renderbuffer) {
    return this.maf_1.zag()(target, attachment, renderbuffertarget, renderbuffer);
  }
  v8u(target, attachment, textarget, texture, level) {
    return this.maf_1.aah()(target, attachment, textarget, texture, level);
  }
  x8u(mode) {
    return this.maf_1.bah()(mode);
  }
  o9k(n, buffers) {
    return this.maf_1.cah()(n, get_pointer_0(buffers));
  }
  y8r(target) {
    return this.maf_1.dah()(target);
  }
  p9k(n, framebuffers) {
    return this.maf_1.eah()(n, get_pointer_0(framebuffers));
  }
  q9k(n, renderbuffers) {
    return this.maf_1.fah()(n, get_pointer_0(renderbuffers));
  }
  r9k(n, textures) {
    return this.maf_1.gah()(n, get_pointer_0(textures));
  }
  f8v(program, name) {
    return this.maf_1.hah()(program, name);
  }
  m8v() {
    return this.maf_1.iah()();
  }
  s9k(pname, data) {
    return this.maf_1.jah()(pname, get_pointer_0(data));
  }
  t9k(program, pname, params) {
    return this.maf_1.kah()(program, pname, get_pointer_0(params));
  }
  u9k(shader, pname, params) {
    return this.maf_1.lah()(shader, pname, get_pointer_0(params));
  }
  v9k(shader, bufSize, length, infoLog) {
    this.maf_1.mah()(shader, bufSize, get_pointer_0(length), get_pointer_0(infoLog));
  }
  f8o(name) {
    var tmp0_elvis_lhs = this.maf_1.nah()(name);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }
  v8v(program) {
    return this.maf_1.oah()(program);
  }
  v8r(pname, param) {
    return this.maf_1.pah()(pname, param);
  }
  u8u(target, internalformat, width, height) {
    return this.maf_1.qah()(target, internalformat, width, height);
  }
  b8v(x, y, width, height) {
    return this.maf_1.rah()(x, y, width, height);
  }
  k8v(shader, string) {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = CreateFFIMemory(8);
    var lengthsPtr = get_pointer(Deno.UnsafePointer.of(this_0));
    var bytes = encodeToByteArray(string + '\x00');
    set32(lengthsPtr, bytes.length - 1 | 0);
    // Inline function 'korlibs.ffi.usePointer' call
    var this_1 = CreateFFIMemory_0(bytes);
    var strPtr = get_pointer(Deno.UnsafePointer.of(this_1));
    // Inline function 'korlibs.ffi.usePointer' call
    var this_2 = CreateFFIMemory(8);
    var strPtrPtr = get_pointer(Deno.UnsafePointer.of(this_2));
    setFFIPointer(strPtrPtr, strPtr);
    this.maf_1.sah()(shader, 1, strPtrPtr, lengthsPtr);
  }
  f8t(func, ref, mask) {
    return this.maf_1.tah()(func, ref, mask);
  }
  e8t(face, func, ref, mask) {
    return this.maf_1.uah()(face, func, ref, mask);
  }
  s8s(mask) {
    return this.maf_1.vah()(mask);
  }
  i8t(face, mask) {
    return this.maf_1.wah()(face, mask);
  }
  h8t(fail, zfail, zpass) {
    return this.maf_1.xah()(fail, zfail, zpass);
  }
  g8t(face, sfail, dpfail, dppass) {
    return this.maf_1.yah()(face, sfail, dpfail, dppass);
  }
  w8r(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp = this.maf_1.zah();
    tmp(target, level, internalformat, width, height, border, format, type, pixels == null ? null : get_pointer_0(pixels));
  }
  p8r(target, pname, param) {
    return this.maf_1.aai()(target, pname, param);
  }
  l8r(location, count, value) {
    return this.maf_1.bai()(location, count, get_pointer_0(value));
  }
  j8p(location, v0) {
    return this.maf_1.cai()(location, v0);
  }
  e8r(location, count, value) {
    return this.maf_1.dai()(location, count, get_pointer_0(value));
  }
  m8r(location, count, value) {
    return this.maf_1.eai()(location, count, get_pointer_0(value));
  }
  f8r(location, count, value) {
    return this.maf_1.fai()(location, count, get_pointer_0(value));
  }
  n8r(location, count, value) {
    return this.maf_1.gai()(location, count, get_pointer_0(value));
  }
  g8r(location, count, value) {
    return this.maf_1.hai()(location, count, get_pointer_0(value));
  }
  o8r(location, count, value) {
    return this.maf_1.iai()(location, count, get_pointer_0(value));
  }
  h8r(location, count, value) {
    return this.maf_1.jai()(location, count, get_pointer_0(value));
  }
  i8r(location, count, transpose, value) {
    var tmp = this.maf_1.kai();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  j8r(location, count, transpose, value) {
    var tmp = this.maf_1.lai();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  k8r(location, count, transpose, value) {
    var tmp = this.maf_1.mai();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  g8v(program) {
    return this.maf_1.nai()(program);
  }
  x8t(index, size, type, normalized, stride, pointer) {
    var tmp = this.maf_1.oai();
    // Inline function 'korlibs.math.toInt' call
    return tmp(index, size, type, normalized ? 1 : 0, stride, this.oaf(pointer));
  }
  l8u(x, y, width, height) {
    return this.maf_1.pai()(x, y, width, height);
  }
  k8t(mode, first, count, instancecount) {
    return this.maf_1.qai()(mode, first, count, instancecount);
  }
  m8t(mode, count, type, indices, instancecount) {
    return this.maf_1.rai()(mode, count, type, this.naf(indices), instancecount);
  }
  r8t(index, divisor) {
    return this.maf_1.sai()(index, divisor);
  }
  d84() {
    return true;
  }
  e8u(target, index, buffer, offset, size) {
    return this.maf_1.tai()(target, index, buffer, this.naf(offset), this.naf(size));
  }
  k8p(program, name) {
    return this.maf_1.uai()(program, name);
  }
  l8p(program, uniformBlockIndex, uniformBlockBinding) {
    return this.maf_1.vai()(program, uniformBlockIndex, uniformBlockBinding);
  }
  e84() {
    return true;
  }
  w9k(n, arrays) {
    return this.maf_1.wai()(n, get_pointer_0(arrays));
  }
  t8t(array) {
    return this.maf_1.xai()(array);
  }
}
class Companion_62 {
  constructor() {
    this.yai_1 = 16384;
  }
}
class OpenGL extends FFILib {
  static haf() {
    var $this = this.h48(['/System/Library/Frameworks/OpenGL.framework/OpenGL']);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_13().n48_1;
    tmp.ja9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config, true)).a48($this, glDrawArraysInstanced$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_13().n48_1;
    tmp_0.ka9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_0, true)).a48($this, glDrawElementsInstanced$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_13().n48_1;
    tmp_1.la9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).a48($this, glVertexAttribDivisor$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_13().n48_1;
    tmp_2.ma9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).a48($this, glTexSubImage2D$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_13().n48_1;
    tmp_3.na9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).a48($this, glTexImage2D$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_13().n48_1;
    tmp_4.oa9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).a48($this, glTexParameteri$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_13().n48_1;
    tmp_5.pa9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).a48($this, glTexParameterf$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_13().n48_1;
    tmp_6.qa9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_6, true)).a48($this, glTexParameterfv$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_13().n48_1;
    tmp_7.ra9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).a48($this, glTexParameteriv$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_13().n48_1;
    tmp_8.sa9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_8, true)).a48($this, glStencilOp$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_13().n48_1;
    tmp_9.ta9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).a48($this, glStencilMask$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_13().n48_1;
    tmp_10.ua9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_10, true)).a48($this, glReadPixels$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_13().n48_1;
    tmp_11.va9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).a48($this, glStencilFunc$factory());
    var tmp_12 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_12 = Companion_getInstance_13().n48_1;
    tmp_12.wa9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_12, true)).a48($this, glScissor$factory());
    var tmp_13 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_13 = Companion_getInstance_13().n48_1;
    tmp_13.xa9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_13, true)).a48($this, glPolygonOffset$factory());
    var tmp_14 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_14 = Companion_getInstance_13().n48_1;
    tmp_14.ya9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_14, true)).a48($this, glPixelStorei$factory());
    var tmp_15 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_15 = Companion_getInstance_13().n48_1;
    tmp_15.za9_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_15, true)).a48($this, glLineWidth$factory());
    var tmp_16 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_16 = Companion_getInstance_13().n48_1;
    tmp_16.aaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_16, true)).a48($this, glGetTexParameterfv$factory());
    var tmp_17 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_17 = Companion_getInstance_13().n48_1;
    tmp_17.baa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_17, true)).a48($this, glGetTexParameteriv$factory());
    var tmp_18 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_18 = Companion_getInstance_13().n48_1;
    tmp_18.caa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_18, true)).a48($this, glGetError$factory());
    var tmp_19 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_19 = Companion_getInstance_13().n48_1;
    tmp_19.daa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_19, true)).a48($this, glGetFloatv$factory());
    var tmp_20 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_20 = Companion_getInstance_13().n48_1;
    tmp_20.eaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_20, true)).a48($this, glGetIntegerv$factory());
    var tmp_21 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_21 = Companion_getInstance_13().n48_1;
    tmp_21.faa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_21, true)).a48($this, glGetBooleanv$factory());
    var tmp_22 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_22 = Companion_getInstance_13().n48_1;
    tmp_22.gaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_22, true)).a48($this, glGenTextures$factory());
    var tmp_23 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_23 = Companion_getInstance_13().n48_1;
    tmp_23.haa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_23, true)).a48($this, glDepthRange$factory());
    var tmp_24 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_24 = Companion_getInstance_13().n48_1;
    tmp_24.iaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_24, true)).a48($this, glDepthRangef$factory());
    var tmp_25 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_25 = Companion_getInstance_13().n48_1;
    tmp_25.jaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_25, true)).a48($this, glClearDepth$factory());
    var tmp_26 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_26 = Companion_getInstance_13().n48_1;
    tmp_26.kaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_26, true)).a48($this, glClearDepthf$factory());
    var tmp_27 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_27 = Companion_getInstance_13().n48_1;
    tmp_27.laa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_27, true)).a48($this, glDrawArrays$factory());
    var tmp_28 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_28 = Companion_getInstance_13().n48_1;
    tmp_28.maa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_28, true)).a48($this, glDrawElements$factory());
    var tmp_29 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_29 = Companion_getInstance_13().n48_1;
    tmp_29.naa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_29, true)).a48($this, glFrontFace$factory());
    var tmp_30 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_30 = Companion_getInstance_13().n48_1;
    tmp_30.oaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_30, true)).a48($this, glFinish$factory());
    var tmp_31 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_31 = Companion_getInstance_13().n48_1;
    tmp_31.paa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_31, true)).a48($this, glFlush$factory());
    var tmp_32 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_32 = Companion_getInstance_13().n48_1;
    tmp_32.qaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_32, true)).a48($this, glEnable$factory());
    var tmp_33 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_33 = Companion_getInstance_13().n48_1;
    tmp_33.raa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_33, true)).a48($this, glIsEnabled$factory());
    var tmp_34 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_34 = Companion_getInstance_13().n48_1;
    tmp_34.saa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_34, true)).a48($this, glDisable$factory());
    var tmp_35 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_35 = Companion_getInstance_13().n48_1;
    tmp_35.taa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_35, true)).a48($this, glDepthMask$factory());
    var tmp_36 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_36 = Companion_getInstance_13().n48_1;
    tmp_36.uaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_36, true)).a48($this, glDepthFunc$factory());
    var tmp_37 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_37 = Companion_getInstance_13().n48_1;
    tmp_37.vaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_37, true)).a48($this, glDeleteTextures$factory());
    var tmp_38 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_38 = Companion_getInstance_13().n48_1;
    tmp_38.waa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_38, true)).a48($this, glCullFace$factory());
    var tmp_39 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_39 = Companion_getInstance_13().n48_1;
    tmp_39.xaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_39, true)).a48($this, glCopyTexImage2D$factory());
    var tmp_40 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_40 = Companion_getInstance_13().n48_1;
    tmp_40.yaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_40, true)).a48($this, glCopyTexSubImage2D$factory());
    var tmp_41 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_41 = Companion_getInstance_13().n48_1;
    tmp_41.zaa_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_41, true)).a48($this, glColorMask$factory());
    var tmp_42 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_42 = Companion_getInstance_13().n48_1;
    tmp_42.aab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_42, true)).a48($this, glClearStencil$factory());
    var tmp_43 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_43 = Companion_getInstance_13().n48_1;
    tmp_43.bab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_43, true)).a48($this, glClearColor$factory());
    var tmp_44 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_44 = Companion_getInstance_13().n48_1;
    tmp_44.cab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_44, true)).a48($this, glClear$factory());
    var tmp_45 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_45 = Companion_getInstance_13().n48_1;
    tmp_45.dab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_45, true)).a48($this, glBindTexture$factory());
    var tmp_46 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_46 = Companion_getInstance_13().n48_1;
    tmp_46.eab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_46, true)).a48($this, glHint$factory());
    var tmp_47 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_47 = Companion_getInstance_13().n48_1;
    tmp_47.fab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_47, true)).a48($this, glViewport$factory());
    var tmp_48 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_48 = Companion_getInstance_13().n48_1;
    tmp_48.gab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().zg(), arrayOf([]), true))]), false), null, config_48, true)).a48($this, glGetString$factory());
    var tmp_49 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_49 = Companion_getInstance_13().n48_1;
    tmp_49.hab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().zg(), arrayOf([]), true))]), false), null, config_49, true)).a48($this, glGetStringi$factory());
    var tmp_50 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_50 = Companion_getInstance_13().n48_1;
    tmp_50.iab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_50, true)).a48($this, glVertexAttribPointer$factory());
    var tmp_51 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_51 = Companion_getInstance_13().n48_1;
    tmp_51.jab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_51, true)).a48($this, glVertexAttrib4fv$factory());
    var tmp_52 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_52 = Companion_getInstance_13().n48_1;
    tmp_52.kab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_52, true)).a48($this, glActiveTexture$factory());
    var tmp_53 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_53 = Companion_getInstance_13().n48_1;
    tmp_53.lab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_53, true)).a48($this, glAttachShader$factory());
    var tmp_54 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_54 = Companion_getInstance_13().n48_1;
    tmp_54.mab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().zg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_54, true)).a48($this, glBindAttribLocation$factory());
    var tmp_55 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_55 = Companion_getInstance_13().n48_1;
    tmp_55.nab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_55, true)).a48($this, glBindBuffer$factory());
    var tmp_56 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_56 = Companion_getInstance_13().n48_1;
    tmp_56.oab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_56, true)).a48($this, glBindFramebuffer$factory());
    var tmp_57 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_57 = Companion_getInstance_13().n48_1;
    tmp_57.pab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_57, true)).a48($this, glBindRenderbuffer$factory());
    var tmp_58 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_58 = Companion_getInstance_13().n48_1;
    tmp_58.qab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_58, true)).a48($this, glBlendColor$factory());
    var tmp_59 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_59 = Companion_getInstance_13().n48_1;
    tmp_59.rab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_59, true)).a48($this, glBlendEquation$factory());
    var tmp_60 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_60 = Companion_getInstance_13().n48_1;
    tmp_60.sab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_60, true)).a48($this, glBlendEquationSeparate$factory());
    var tmp_61 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_61 = Companion_getInstance_13().n48_1;
    tmp_61.tab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_61, true)).a48($this, glBlendFunc$factory());
    var tmp_62 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_62 = Companion_getInstance_13().n48_1;
    tmp_62.uab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_62, true)).a48($this, glBlendFuncSeparate$factory());
    var tmp_63 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_63 = Companion_getInstance_13().n48_1;
    tmp_63.vab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_63, true)).a48($this, glBufferData$factory());
    var tmp_64 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_64 = Companion_getInstance_13().n48_1;
    tmp_64.wab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_64, true)).a48($this, glBufferSubData$factory());
    var tmp_65 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_65 = Companion_getInstance_13().n48_1;
    tmp_65.xab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_65, true)).a48($this, glCheckFramebufferStatus$factory());
    var tmp_66 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_66 = Companion_getInstance_13().n48_1;
    tmp_66.yab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_66, true)).a48($this, glCompileShader$factory());
    var tmp_67 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_67 = Companion_getInstance_13().n48_1;
    tmp_67.zab_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_67, true)).a48($this, glCompressedTexImage2D$factory());
    var tmp_68 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_68 = Companion_getInstance_13().n48_1;
    tmp_68.aac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_68, true)).a48($this, glCompressedTexSubImage2D$factory());
    var tmp_69 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_69 = Companion_getInstance_13().n48_1;
    tmp_69.bac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_69, true)).a48($this, glCreateProgram$factory());
    var tmp_70 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_70 = Companion_getInstance_13().n48_1;
    tmp_70.cac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_70, true)).a48($this, glCreateShader$factory());
    var tmp_71 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_71 = Companion_getInstance_13().n48_1;
    tmp_71.dac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_71, true)).a48($this, glDeleteBuffers$factory());
    var tmp_72 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_72 = Companion_getInstance_13().n48_1;
    tmp_72.eac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_72, true)).a48($this, glDeleteFramebuffers$factory());
    var tmp_73 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_73 = Companion_getInstance_13().n48_1;
    tmp_73.fac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_73, true)).a48($this, glDeleteProgram$factory());
    var tmp_74 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_74 = Companion_getInstance_13().n48_1;
    tmp_74.gac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_74, true)).a48($this, glDeleteRenderbuffers$factory());
    var tmp_75 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_75 = Companion_getInstance_13().n48_1;
    tmp_75.hac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_75, true)).a48($this, glDeleteShader$factory());
    var tmp_76 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_76 = Companion_getInstance_13().n48_1;
    tmp_76.iac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_76, true)).a48($this, glDetachShader$factory());
    var tmp_77 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_77 = Companion_getInstance_13().n48_1;
    tmp_77.jac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_77, true)).a48($this, glDisableVertexAttribArray$factory());
    var tmp_78 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_78 = Companion_getInstance_13().n48_1;
    tmp_78.kac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_78, true)).a48($this, glEnableVertexAttribArray$factory());
    var tmp_79 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_79 = Companion_getInstance_13().n48_1;
    tmp_79.lac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_79, true)).a48($this, glFramebufferRenderbuffer$factory());
    var tmp_80 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_80 = Companion_getInstance_13().n48_1;
    tmp_80.mac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_80, true)).a48($this, glFramebufferTexture2D$factory());
    var tmp_81 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_81 = Companion_getInstance_13().n48_1;
    tmp_81.nac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_81, true)).a48($this, glGenBuffers$factory());
    var tmp_82 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_82 = Companion_getInstance_13().n48_1;
    tmp_82.oac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_82, true)).a48($this, glGenerateMipmap$factory());
    var tmp_83 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_83 = Companion_getInstance_13().n48_1;
    tmp_83.pac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_83, true)).a48($this, glGenFramebuffers$factory());
    var tmp_84 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_84 = Companion_getInstance_13().n48_1;
    tmp_84.qac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_84, true)).a48($this, glGenRenderbuffers$factory());
    var tmp_85 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_85 = Companion_getInstance_13().n48_1;
    tmp_85.rac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_85, true)).a48($this, glGetActiveAttrib$factory());
    var tmp_86 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_86 = Companion_getInstance_13().n48_1;
    tmp_86.sac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_86, true)).a48($this, glGetActiveUniform$factory());
    var tmp_87 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_87 = Companion_getInstance_13().n48_1;
    tmp_87.tac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_87, true)).a48($this, glGetAttachedShaders$factory());
    var tmp_88 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_88 = Companion_getInstance_13().n48_1;
    tmp_88.uac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().zg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_88, true)).a48($this, glGetAttribLocation$factory());
    var tmp_89 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_89 = Companion_getInstance_13().n48_1;
    tmp_89.vac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().zg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_89, true)).a48($this, glGetUniformLocation$factory());
    var tmp_90 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_90 = Companion_getInstance_13().n48_1;
    tmp_90.wac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_90, true)).a48($this, glGetBufferParameteriv$factory());
    var tmp_91 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_91 = Companion_getInstance_13().n48_1;
    tmp_91.xac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_91, true)).a48($this, glGetFramebufferAttachmentParameteriv$factory());
    var tmp_92 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_92 = Companion_getInstance_13().n48_1;
    tmp_92.yac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_92, true)).a48($this, glGetProgramInfoLog$factory());
    var tmp_93 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_93 = Companion_getInstance_13().n48_1;
    tmp_93.zac_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_93, true)).a48($this, glGetRenderbufferParameteriv$factory());
    var tmp_94 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_94 = Companion_getInstance_13().n48_1;
    tmp_94.aad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_94, true)).a48($this, glGetProgramiv$factory());
    var tmp_95 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_95 = Companion_getInstance_13().n48_1;
    tmp_95.bad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_95, true)).a48($this, glGetShaderiv$factory());
    var tmp_96 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_96 = Companion_getInstance_13().n48_1;
    tmp_96.cad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_96, true)).a48($this, glGetShaderInfoLog$factory());
    var tmp_97 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_97 = Companion_getInstance_13().n48_1;
    tmp_97.dad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_97, true)).a48($this, glGetShaderPrecisionFormat$factory());
    var tmp_98 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_98 = Companion_getInstance_13().n48_1;
    tmp_98.ead_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_98, true)).a48($this, glGetShaderSource$factory());
    var tmp_99 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_99 = Companion_getInstance_13().n48_1;
    tmp_99.fad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_99, true)).a48($this, glGetUniformfv$factory());
    var tmp_100 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_100 = Companion_getInstance_13().n48_1;
    tmp_100.gad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_100, true)).a48($this, glGetUniformiv$factory());
    var tmp_101 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_101 = Companion_getInstance_13().n48_1;
    tmp_101.had_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_101, true)).a48($this, glGetVertexAttribfv$factory());
    var tmp_102 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_102 = Companion_getInstance_13().n48_1;
    tmp_102.iad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_102, true)).a48($this, glGetVertexAttribiv$factory());
    var tmp_103 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_103 = Companion_getInstance_13().n48_1;
    tmp_103.jad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_103, true)).a48($this, glGetVertexAttribPointerv$factory());
    var tmp_104 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_104 = Companion_getInstance_13().n48_1;
    tmp_104.kad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_104, true)).a48($this, glIsBuffer$factory());
    var tmp_105 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_105 = Companion_getInstance_13().n48_1;
    tmp_105.lad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_105, true)).a48($this, glIsFramebuffer$factory());
    var tmp_106 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_106 = Companion_getInstance_13().n48_1;
    tmp_106.mad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_106, true)).a48($this, glIsProgram$factory());
    var tmp_107 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_107 = Companion_getInstance_13().n48_1;
    tmp_107.nad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_107, true)).a48($this, glIsRenderbuffer$factory());
    var tmp_108 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_108 = Companion_getInstance_13().n48_1;
    tmp_108.oad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_108, true)).a48($this, glIsTexture$factory());
    var tmp_109 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_109 = Companion_getInstance_13().n48_1;
    tmp_109.pad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_109, true)).a48($this, glIsShader$factory());
    var tmp_110 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_110 = Companion_getInstance_13().n48_1;
    tmp_110.qad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_110, true)).a48($this, glLinkProgram$factory());
    var tmp_111 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_111 = Companion_getInstance_13().n48_1;
    tmp_111.rad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_111, true)).a48($this, glReleaseShaderCompiler$factory());
    var tmp_112 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_112 = Companion_getInstance_13().n48_1;
    tmp_112.sad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_112, true)).a48($this, glRenderbufferStorage$factory());
    var tmp_113 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_113 = Companion_getInstance_13().n48_1;
    tmp_113.tad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_113, true)).a48($this, glSampleCoverage$factory());
    var tmp_114 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_114 = Companion_getInstance_13().n48_1;
    tmp_114.uad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_114, true)).a48($this, glShaderBinary$factory());
    var tmp_115 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_115 = Companion_getInstance_13().n48_1;
    tmp_115.vad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_115, true)).a48($this, glShaderSource$factory());
    var tmp_116 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_116 = Companion_getInstance_13().n48_1;
    tmp_116.wad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_116, true)).a48($this, glStencilFuncSeparate$factory());
    var tmp_117 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_117 = Companion_getInstance_13().n48_1;
    tmp_117.xad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_117, true)).a48($this, glStencilMaskSeparate$factory());
    var tmp_118 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_118 = Companion_getInstance_13().n48_1;
    tmp_118.yad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_118, true)).a48($this, glStencilOpSeparate$factory());
    var tmp_119 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_119 = Companion_getInstance_13().n48_1;
    tmp_119.zad_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_119, true)).a48($this, glUniform1f$factory());
    var tmp_120 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_120 = Companion_getInstance_13().n48_1;
    tmp_120.aae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_120, true)).a48($this, glUniform2f$factory());
    var tmp_121 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_121 = Companion_getInstance_13().n48_1;
    tmp_121.bae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_121, true)).a48($this, glUniform3f$factory());
    var tmp_122 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_122 = Companion_getInstance_13().n48_1;
    tmp_122.cae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_122, true)).a48($this, glUniform4f$factory());
    var tmp_123 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_123 = Companion_getInstance_13().n48_1;
    tmp_123.dae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_123, true)).a48($this, glUniform1i$factory());
    var tmp_124 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_124 = Companion_getInstance_13().n48_1;
    tmp_124.eae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_124, true)).a48($this, glUniform2i$factory());
    var tmp_125 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_125 = Companion_getInstance_13().n48_1;
    tmp_125.fae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_125, true)).a48($this, glUniform3i$factory());
    var tmp_126 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_126 = Companion_getInstance_13().n48_1;
    tmp_126.gae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_126, true)).a48($this, glUniform4i$factory());
    var tmp_127 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_127 = Companion_getInstance_13().n48_1;
    tmp_127.hae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_127, true)).a48($this, glUniform1fv$factory());
    var tmp_128 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_128 = Companion_getInstance_13().n48_1;
    tmp_128.iae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_128, true)).a48($this, glUniform2fv$factory());
    var tmp_129 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_129 = Companion_getInstance_13().n48_1;
    tmp_129.jae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_129, true)).a48($this, glUniform3fv$factory());
    var tmp_130 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_130 = Companion_getInstance_13().n48_1;
    tmp_130.kae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_130, true)).a48($this, glUniform4fv$factory());
    var tmp_131 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_131 = Companion_getInstance_13().n48_1;
    tmp_131.lae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_131, true)).a48($this, glUniform1iv$factory());
    var tmp_132 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_132 = Companion_getInstance_13().n48_1;
    tmp_132.mae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_132, true)).a48($this, glUniform2iv$factory());
    var tmp_133 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_133 = Companion_getInstance_13().n48_1;
    tmp_133.nae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_133, true)).a48($this, glUniform3iv$factory());
    var tmp_134 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_134 = Companion_getInstance_13().n48_1;
    tmp_134.oae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_134, true)).a48($this, glUniform4iv$factory());
    var tmp_135 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_135 = Companion_getInstance_13().n48_1;
    tmp_135.pae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_135, true)).a48($this, glUniformMatrix2fv$factory());
    var tmp_136 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_136 = Companion_getInstance_13().n48_1;
    tmp_136.qae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_136, true)).a48($this, glUniformMatrix3fv$factory());
    var tmp_137 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_137 = Companion_getInstance_13().n48_1;
    tmp_137.rae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_137, true)).a48($this, glUniformMatrix4fv$factory());
    var tmp_138 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_138 = Companion_getInstance_13().n48_1;
    tmp_138.sae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_138, true)).a48($this, glUseProgram$factory());
    var tmp_139 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_139 = Companion_getInstance_13().n48_1;
    tmp_139.tae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_139, true)).a48($this, glValidateProgram$factory());
    var tmp_140 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_140 = Companion_getInstance_13().n48_1;
    tmp_140.uae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_140, true)).a48($this, glVertexAttrib1f$factory());
    var tmp_141 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_141 = Companion_getInstance_13().n48_1;
    tmp_141.vae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_141, true)).a48($this, glVertexAttrib2f$factory());
    var tmp_142 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_142 = Companion_getInstance_13().n48_1;
    tmp_142.wae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_142, true)).a48($this, glVertexAttrib3f$factory());
    var tmp_143 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_143 = Companion_getInstance_13().n48_1;
    tmp_143.xae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_143, true)).a48($this, glVertexAttrib4f$factory());
    var tmp_144 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_144 = Companion_getInstance_13().n48_1;
    tmp_144.yae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_144, true)).a48($this, glVertexAttrib1fv$factory());
    var tmp_145 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_145 = Companion_getInstance_13().n48_1;
    tmp_145.zae_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_145, true)).a48($this, glVertexAttrib2fv$factory());
    var tmp_146 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_146 = Companion_getInstance_13().n48_1;
    tmp_146.aaf_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_146, true)).a48($this, glVertexAttrib3fv$factory());
    var tmp_147 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_147 = Companion_getInstance_13().n48_1;
    tmp_147.baf_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_147, true)).a48($this, glBindBufferRange$factory());
    var tmp_148 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_148 = Companion_getInstance_13().n48_1;
    tmp_148.caf_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().zg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false))]), false), null, config_148, true)).a48($this, glGetUniformBlockIndex$factory());
    var tmp_149 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_149 = Companion_getInstance_13().n48_1;
    tmp_149.daf_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_149, true)).a48($this, glUniformBlockBinding$factory());
    var tmp_150 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_150 = Companion_getInstance_13().n48_1;
    tmp_150.eaf_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_150, true)).a48($this, glGenVertexArrays$factory());
    var tmp_151 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_151 = Companion_getInstance_13().n48_1;
    tmp_151.faf_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_151, true)).a48($this, glDeleteVertexArrays$factory());
    var tmp_152 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_152 = Companion_getInstance_13().n48_1;
    tmp_152.gaf_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_152, true)).a48($this, glBindVertexArray$factory());
    return $this;
  }
  qai() {
    return this.ja9_1.op(this, glDrawArraysInstanced$factory_0());
  }
  rai() {
    return this.ka9_1.op(this, glDrawElementsInstanced$factory_0());
  }
  sai() {
    return this.la9_1.op(this, glVertexAttribDivisor$factory_0());
  }
  zai() {
    return this.ma9_1.op(this, glTexSubImage2D$factory_0());
  }
  zah() {
    return this.na9_1.op(this, glTexImage2D$factory_0());
  }
  aai() {
    return this.oa9_1.op(this, glTexParameteri$factory_0());
  }
  aaj() {
    return this.pa9_1.op(this, glTexParameterf$factory_0());
  }
  baj() {
    return this.qa9_1.op(this, glTexParameterfv$factory_0());
  }
  caj() {
    return this.ra9_1.op(this, glTexParameteriv$factory_0());
  }
  xah() {
    return this.sa9_1.op(this, glStencilOp$factory_0());
  }
  vah() {
    return this.ta9_1.op(this, glStencilMask$factory_0());
  }
  daj() {
    return this.ua9_1.op(this, glReadPixels$factory_0());
  }
  tah() {
    return this.va9_1.op(this, glStencilFunc$factory_0());
  }
  rah() {
    return this.wa9_1.op(this, glScissor$factory_0());
  }
  eaj() {
    return this.xa9_1.op(this, glPolygonOffset$factory_0());
  }
  pah() {
    return this.ya9_1.op(this, glPixelStorei$factory_0());
  }
  faj() {
    return this.za9_1.op(this, glLineWidth$factory_0());
  }
  gaj() {
    return this.aaa_1.op(this, glGetTexParameterfv$factory_0());
  }
  haj() {
    return this.baa_1.op(this, glGetTexParameteriv$factory_0());
  }
  iah() {
    return this.caa_1.op(this, glGetError$factory_0());
  }
  iaj() {
    return this.daa_1.op(this, glGetFloatv$factory_0());
  }
  jah() {
    return this.eaa_1.op(this, glGetIntegerv$factory_0());
  }
  jaj() {
    return this.faa_1.op(this, glGetBooleanv$factory_0());
  }
  gah() {
    return this.gaa_1.op(this, glGenTextures$factory_0());
  }
  kaj() {
    return this.haa_1.op(this, glDepthRange$factory_0());
  }
  rag() {
    return this.iaa_1.op(this, glDepthRangef$factory_0());
  }
  laj() {
    return this.jaa_1.op(this, glClearDepth$factory_0());
  }
  cag() {
    return this.kaa_1.op(this, glClearDepthf$factory_0());
  }
  uag() {
    return this.laa_1.op(this, glDrawArrays$factory_0());
  }
  vag() {
    return this.maa_1.op(this, glDrawElements$factory_0());
  }
  bah() {
    return this.naa_1.op(this, glFrontFace$factory_0());
  }
  maj() {
    return this.oaa_1.op(this, glFinish$factory_0());
  }
  yag() {
    return this.paa_1.op(this, glFlush$factory_0());
  }
  wag() {
    return this.qaa_1.op(this, glEnable$factory_0());
  }
  naj() {
    return this.raa_1.op(this, glIsEnabled$factory_0());
  }
  sag() {
    return this.saa_1.op(this, glDisable$factory_0());
  }
  qag() {
    return this.taa_1.op(this, glDepthMask$factory_0());
  }
  pag() {
    return this.uaa_1.op(this, glDepthFunc$factory_0());
  }
  oag() {
    return this.vaa_1.op(this, glDeleteTextures$factory_0());
  }
  iag() {
    return this.waa_1.op(this, glCullFace$factory_0());
  }
  oaj() {
    return this.xaa_1.op(this, glCopyTexImage2D$factory_0());
  }
  paj() {
    return this.yaa_1.op(this, glCopyTexSubImage2D$factory_0());
  }
  eag() {
    return this.zaa_1.op(this, glColorMask$factory_0());
  }
  dag() {
    return this.aab_1.op(this, glClearStencil$factory_0());
  }
  bag() {
    return this.bab_1.op(this, glClearColor$factory_0());
  }
  aag() {
    return this.cab_1.op(this, glClear$factory_0());
  }
  vaf() {
    return this.dab_1.op(this, glBindTexture$factory_0());
  }
  qaj() {
    return this.eab_1.op(this, glHint$factory_0());
  }
  pai() {
    return this.fab_1.op(this, glViewport$factory_0());
  }
  nah() {
    return this.gab_1.op(this, glGetString$factory_0());
  }
  raj() {
    return this.hab_1.op(this, glGetStringi$factory_0());
  }
  oai() {
    return this.iab_1.op(this, glVertexAttribPointer$factory_0());
  }
  saj() {
    return this.jab_1.op(this, glVertexAttrib4fv$factory_0());
  }
  paf() {
    return this.kab_1.op(this, glActiveTexture$factory_0());
  }
  qaf() {
    return this.lab_1.op(this, glAttachShader$factory_0());
  }
  raf() {
    return this.mab_1.op(this, glBindAttribLocation$factory_0());
  }
  saf() {
    return this.nab_1.op(this, glBindBuffer$factory_0());
  }
  taf() {
    return this.oab_1.op(this, glBindFramebuffer$factory_0());
  }
  uaf() {
    return this.pab_1.op(this, glBindRenderbuffer$factory_0());
  }
  taj() {
    return this.qab_1.op(this, glBlendColor$factory_0());
  }
  uaj() {
    return this.rab_1.op(this, glBlendEquation$factory_0());
  }
  waf() {
    return this.sab_1.op(this, glBlendEquationSeparate$factory_0());
  }
  vaj() {
    return this.tab_1.op(this, glBlendFunc$factory_0());
  }
  xaf() {
    return this.uab_1.op(this, glBlendFuncSeparate$factory_0());
  }
  yaf() {
    return this.vab_1.op(this, glBufferData$factory_0());
  }
  zaf() {
    return this.wab_1.op(this, glBufferSubData$factory_0());
  }
  waj() {
    return this.xab_1.op(this, glCheckFramebufferStatus$factory_0());
  }
  fag() {
    return this.yab_1.op(this, glCompileShader$factory_0());
  }
  xaj() {
    return this.zab_1.op(this, glCompressedTexImage2D$factory_0());
  }
  yaj() {
    return this.aac_1.op(this, glCompressedTexSubImage2D$factory_0());
  }
  gag() {
    return this.bac_1.op(this, glCreateProgram$factory_0());
  }
  hag() {
    return this.cac_1.op(this, glCreateShader$factory_0());
  }
  jag() {
    return this.dac_1.op(this, glDeleteBuffers$factory_0());
  }
  kag() {
    return this.eac_1.op(this, glDeleteFramebuffers$factory_0());
  }
  lag() {
    return this.fac_1.op(this, glDeleteProgram$factory_0());
  }
  mag() {
    return this.gac_1.op(this, glDeleteRenderbuffers$factory_0());
  }
  nag() {
    return this.hac_1.op(this, glDeleteShader$factory_0());
  }
  zaj() {
    return this.iac_1.op(this, glDetachShader$factory_0());
  }
  tag() {
    return this.jac_1.op(this, glDisableVertexAttribArray$factory_0());
  }
  xag() {
    return this.kac_1.op(this, glEnableVertexAttribArray$factory_0());
  }
  zag() {
    return this.lac_1.op(this, glFramebufferRenderbuffer$factory_0());
  }
  aah() {
    return this.mac_1.op(this, glFramebufferTexture2D$factory_0());
  }
  cah() {
    return this.nac_1.op(this, glGenBuffers$factory_0());
  }
  dah() {
    return this.oac_1.op(this, glGenerateMipmap$factory_0());
  }
  eah() {
    return this.pac_1.op(this, glGenFramebuffers$factory_0());
  }
  fah() {
    return this.qac_1.op(this, glGenRenderbuffers$factory_0());
  }
  aak() {
    return this.rac_1.op(this, glGetActiveAttrib$factory_0());
  }
  bak() {
    return this.sac_1.op(this, glGetActiveUniform$factory_0());
  }
  cak() {
    return this.tac_1.op(this, glGetAttachedShaders$factory_0());
  }
  dak() {
    return this.uac_1.op(this, glGetAttribLocation$factory_0());
  }
  hah() {
    return this.vac_1.op(this, glGetUniformLocation$factory_0());
  }
  eak() {
    return this.wac_1.op(this, glGetBufferParameteriv$factory_0());
  }
  fak() {
    return this.xac_1.op(this, glGetFramebufferAttachmentParameteriv$factory_0());
  }
  gak() {
    return this.yac_1.op(this, glGetProgramInfoLog$factory_0());
  }
  hak() {
    return this.zac_1.op(this, glGetRenderbufferParameteriv$factory_0());
  }
  kah() {
    return this.aad_1.op(this, glGetProgramiv$factory_0());
  }
  lah() {
    return this.bad_1.op(this, glGetShaderiv$factory_0());
  }
  mah() {
    return this.cad_1.op(this, glGetShaderInfoLog$factory_0());
  }
  iak() {
    return this.dad_1.op(this, glGetShaderPrecisionFormat$factory_0());
  }
  jak() {
    return this.ead_1.op(this, glGetShaderSource$factory_0());
  }
  kak() {
    return this.fad_1.op(this, glGetUniformfv$factory_0());
  }
  lak() {
    return this.gad_1.op(this, glGetUniformiv$factory_0());
  }
  mak() {
    return this.had_1.op(this, glGetVertexAttribfv$factory_0());
  }
  nak() {
    return this.iad_1.op(this, glGetVertexAttribiv$factory_0());
  }
  oak() {
    return this.jad_1.op(this, glGetVertexAttribPointerv$factory_0());
  }
  pak() {
    return this.kad_1.op(this, glIsBuffer$factory_0());
  }
  qak() {
    return this.lad_1.op(this, glIsFramebuffer$factory_0());
  }
  rak() {
    return this.mad_1.op(this, glIsProgram$factory_0());
  }
  sak() {
    return this.nad_1.op(this, glIsRenderbuffer$factory_0());
  }
  tak() {
    return this.oad_1.op(this, glIsTexture$factory_0());
  }
  uak() {
    return this.pad_1.op(this, glIsShader$factory_0());
  }
  oah() {
    return this.qad_1.op(this, glLinkProgram$factory_0());
  }
  vak() {
    return this.rad_1.op(this, glReleaseShaderCompiler$factory_0());
  }
  qah() {
    return this.sad_1.op(this, glRenderbufferStorage$factory_0());
  }
  wak() {
    return this.tad_1.op(this, glSampleCoverage$factory_0());
  }
  xak() {
    return this.uad_1.op(this, glShaderBinary$factory_0());
  }
  sah() {
    return this.vad_1.op(this, glShaderSource$factory_0());
  }
  uah() {
    return this.wad_1.op(this, glStencilFuncSeparate$factory_0());
  }
  wah() {
    return this.xad_1.op(this, glStencilMaskSeparate$factory_0());
  }
  yah() {
    return this.yad_1.op(this, glStencilOpSeparate$factory_0());
  }
  yak() {
    return this.zad_1.op(this, glUniform1f$factory_0());
  }
  zak() {
    return this.aae_1.op(this, glUniform2f$factory_0());
  }
  aal() {
    return this.bae_1.op(this, glUniform3f$factory_0());
  }
  bal() {
    return this.cae_1.op(this, glUniform4f$factory_0());
  }
  cai() {
    return this.dae_1.op(this, glUniform1i$factory_0());
  }
  cal() {
    return this.eae_1.op(this, glUniform2i$factory_0());
  }
  dal() {
    return this.fae_1.op(this, glUniform3i$factory_0());
  }
  eal() {
    return this.gae_1.op(this, glUniform4i$factory_0());
  }
  bai() {
    return this.hae_1.op(this, glUniform1fv$factory_0());
  }
  eai() {
    return this.iae_1.op(this, glUniform2fv$factory_0());
  }
  gai() {
    return this.jae_1.op(this, glUniform3fv$factory_0());
  }
  iai() {
    return this.kae_1.op(this, glUniform4fv$factory_0());
  }
  dai() {
    return this.lae_1.op(this, glUniform1iv$factory_0());
  }
  fai() {
    return this.mae_1.op(this, glUniform2iv$factory_0());
  }
  hai() {
    return this.nae_1.op(this, glUniform3iv$factory_0());
  }
  jai() {
    return this.oae_1.op(this, glUniform4iv$factory_0());
  }
  kai() {
    return this.pae_1.op(this, glUniformMatrix2fv$factory_0());
  }
  lai() {
    return this.qae_1.op(this, glUniformMatrix3fv$factory_0());
  }
  mai() {
    return this.rae_1.op(this, glUniformMatrix4fv$factory_0());
  }
  nai() {
    return this.sae_1.op(this, glUseProgram$factory_0());
  }
  fal() {
    return this.tae_1.op(this, glValidateProgram$factory_0());
  }
  gal() {
    return this.uae_1.op(this, glVertexAttrib1f$factory_0());
  }
  hal() {
    return this.vae_1.op(this, glVertexAttrib2f$factory_0());
  }
  ial() {
    return this.wae_1.op(this, glVertexAttrib3f$factory_0());
  }
  jal() {
    return this.xae_1.op(this, glVertexAttrib4f$factory_0());
  }
  kal() {
    return this.yae_1.op(this, glVertexAttrib1fv$factory_0());
  }
  lal() {
    return this.zae_1.op(this, glVertexAttrib2fv$factory_0());
  }
  mal() {
    return this.aaf_1.op(this, glVertexAttrib3fv$factory_0());
  }
  tai() {
    return this.baf_1.op(this, glBindBufferRange$factory_0());
  }
  uai() {
    return this.caf_1.op(this, glGetUniformBlockIndex$factory_0());
  }
  vai() {
    return this.daf_1.op(this, glUniformBlockBinding$factory_0());
  }
  wai() {
    return this.eaf_1.op(this, glGenVertexArrays$factory_0());
  }
  nal() {
    return this.faf_1.op(this, glDeleteVertexArrays$factory_0());
  }
  xai() {
    return this.gaf_1.op(this, glBindVertexArray$factory_0());
  }
}
class SDLGameWindow$ag$1 extends KmlGlContext {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.ral_1 = this$0;
    super(this$0.gao_1, new KmlGlOpenGL(), VOID, $box);
  }
  n8t() {
    var tmp = this.ral_1.fao_1.ca9();
    var tmp_0 = this.h8s_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), this.ral_1.hao_1);
  }
  p8t() {
    var tmp = this.ral_1.fao_1.ca9();
    var tmp_0 = this.h8s_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), null);
  }
  p6() {
    this.ral_1.fao_1.ba9()(this.ral_1.hao_1);
  }
}
class SDLGameWindow extends GameWindow {
  static mao(size, config) {
    size = size === VOID ? Size2D.w3j(640, 480) : size;
    config = config === VOID ? Companion_getInstance_73().ia6_1 : config;
    var $this = this.ha4();
    $this.dao_1 = size;
    $this.eao_1 = config;
    $this.fao_1 = SDL.qa8();
    $this.gao_1 = $this.fao_1.sa8()($this.eao_1.ta6_1, 805240832, 805240832, numberToInt($this.dao_1.u3j_1), numberToInt($this.dao_1.v3j_1), 34);
    $this.hao_1 = $this.fao_1.aa9()($this.gao_1);
    $this.fao_1.wa8()($this.gao_1);
    var tmp = $this;
    tmp.iao_1 = AGOpengl.g8s(new SDLGameWindow$ag$1($this));
    $this.jao_1 = $this.ya4().v8m_1;
    $this.kao_1 = '';
    $this.lao_1 = CreateFFIMemory(1024);
    return $this;
  }
  ya4() {
    return this.iao_1;
  }
  ga5(value) {
    this.kao_1 = value;
    this.fao_1.ta8()(this.gao_1, this.nao());
  }
  nao() {
    return this.kao_1;
  }
  pa5(width, height) {
    this.fao_1.ua8()(this.gao_1, width, height);
    this.fao_1.va8()(this.gao_1, 805240832, 805240832);
  }
  oao() {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = this.lao_1;
    var it = get_pointer(Deno.UnsafePointer.of(this_0));
    while (this.fao_1.ya8()(it)) {
      var type = getS32(it, 0);
      switch (type) {
        case 512:
          println('WINDOW EVENT');
          break;
        case 1024:
          println('MOUSE MOTION');
          break;
        case 1025:
          println('MOUSE DOWN');
          break;
        case 1026:
          println('MOUSE UP');
          break;
        case 256:
          this.sa5();
          break;
        default:
          println('EVENT: type=' + type);
          break;
      }
    }
    this.fao_1.ca9()(this.gao_1, this.hao_1);
    this.jao_1.p8s(1.0, 0.0, 0.0, 1.0);
    this.jao_1.q1s(16384);
  }
  pao() {
    this.fao_1.da9()(this.gao_1);
  }
  i2n(exitCode) {
    super.i2n(exitCode);
    this.fao_1.ba9()(this.hao_1);
    this.fao_1.za8()();
  }
}
class Size3D {
  constructor(width, height, depthOrArrayLayers) {
    height = height === VOID ? 1 : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? 1 : depthOrArrayLayers;
    this.width = width;
    this.height = height;
    this.depthOrArrayLayers = depthOrArrayLayers;
  }
  q9r(_set____db54di) {
    this.width = _set____db54di;
  }
  f3u() {
    return this.width;
  }
  r9r(_set____db54di) {
    this.height = _set____db54di;
  }
  g3u() {
    return this.height;
  }
  qao(_set____db54di) {
    this.depthOrArrayLayers = _set____db54di;
  }
  rao() {
    return this.depthOrArrayLayers;
  }
  toArray() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.width, this.height, this.depthOrArrayLayers];
  }
  em() {
    return this.width;
  }
  fm() {
    return this.height;
  }
  jt() {
    return this.depthOrArrayLayers;
  }
  sao(width, height, depthOrArrayLayers) {
    return new Size3D(width, height, depthOrArrayLayers);
  }
  copy(width, height, depthOrArrayLayers, $super) {
    width = width === VOID ? this.width : width;
    height = height === VOID ? this.height : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? this.depthOrArrayLayers : depthOrArrayLayers;
    return this.sao(width, height, depthOrArrayLayers);
  }
  toString() {
    return 'Size3D(width=' + this.width + ', height=' + this.height + ', depthOrArrayLayers=' + this.depthOrArrayLayers + ')';
  }
  hashCode() {
    var result = this.width;
    result = imul(result, 31) + this.height | 0;
    result = imul(result, 31) + this.depthOrArrayLayers | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size3D))
      return false;
    var tmp0_other_with_cast = other instanceof Size3D ? other : THROW_CCE();
    if (!(this.width === tmp0_other_with_cast.width))
      return false;
    if (!(this.height === tmp0_other_with_cast.height))
      return false;
    if (!(this.depthOrArrayLayers === tmp0_other_with_cast.depthOrArrayLayers))
      return false;
    return true;
  }
}
class AGOpenglFactory {
  g9q() {
    // Inline function 'kotlin.js.unsafeCast' call
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }
}
class KmlGlJsCanvas extends KmlGl {
  constructor(canvas, glOpts) {
    super();
    this.xao_1 = canvas;
    this.yao_1 = glOpts;
    this.zao_1 = 1;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    if (null == null) {
      var tmp1_safe_receiver = this.xao_1.getContext('webgl2', this.yao_1);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
        this.zao_1 = 2;
        tmp_1 = tmp1_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = null;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? this.xao_1.getContext('webgl', this.yao_1) : tmp2_elvis_lhs;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_safe_receiver = tmp3_elvis_lhs == null ? this.xao_1.getContext('experimental-webgl', this.yao_1) : tmp3_elvis_lhs;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      println('Created WebGL version=' + this.zao_1 + ', opts=' + JSON.stringify(this.yao_1));
      tmp_2 = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp5_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      tmp5_safe_receiver.getExtension('OES_standard_derivatives');
      tmp5_safe_receiver.getExtension('OES_texture_float');
      tmp5_safe_receiver.getExtension('OES_texture_float_linear');
      tmp5_safe_receiver.getExtension('OES_element_index_uint');
      tmp_3 = tmp5_safe_receiver;
    }
    var tmp6_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      try {
        var tmp0_safe_receiver = document.body;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          var tmp_5 = document.createElement('div');
          var this_0 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>.<anonymous>' call
          this_0.style.color = 'red';
          this_0.style.font = '30px Arial';
          this_0.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp0_safe_receiver.prepend(this_0);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var message = "Can't get webgl context";
      throw IllegalStateException.h5(toString(message));
    } else {
      tmp_4 = tmp6_elvis_lhs;
    }
    tmp.aap_1 = tmp_4;
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_6.bap_1 = fillArrayVal(Array(8192), null);
    this.cap_1 = toMutableList(reversed_0(until(1, this.bap_1.length)));
    var tmp_7 = this;
    tmp_7.dap_1 = lazy(KmlGlJsCanvas$extensions$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.eap_1 = lazy(KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this));
    this.fap_1 = new WebGLExtension(this, 'ANGLE_instanced_arrays', 2, listOf_0(['drawArraysInstanced', 'drawElementsInstanced', 'vertexAttribDivisor']), 'ANGLE');
    this.gap_1 = new WebGLExtension(this, 'OES_vertex_array_object', 2, listOf_0(['createVertexArrayOES', 'deleteVertexArrayOES', 'isVertexArrayOES', 'bindVertexArrayOES']), 'OES');
  }
  r8r() {
    return Companion_instance_54.p8y(this.zao_1);
  }
  q8r(texture) {
    return this.aap_1.activeTexture(texture);
  }
  u8v(program, shader) {
    return this.aap_1.attachShader(get_2(program, this), get_2(shader, this));
  }
  t8v(program, index, name) {
    return this.aap_1.bindAttribLocation(get_2(program, this), index, name);
  }
  k8q(target, buffer) {
    return this.aap_1.bindBuffer(target, get_2(buffer, this));
  }
  m8u(target, framebuffer) {
    return this.aap_1.bindFramebuffer(target, get_2(framebuffer, this));
  }
  t8u(target, renderbuffer) {
    return this.aap_1.bindRenderbuffer(target, get_2(renderbuffer, this));
  }
  k8u(target, texture) {
    return this.aap_1.bindTexture(target, get_2(texture, this));
  }
  x8s(modeRGB, modeAlpha) {
    return this.aap_1.blendEquationSeparate(modeRGB, modeAlpha);
  }
  y8s(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.aap_1.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  u8r(target, size, data, usage) {
    return this.aap_1.bufferData(target, get_arrayUByte(sliceBuffer(data, 0, size)), usage);
  }
  t8r(target, offset, size, data) {
    return this.aap_1.bufferSubData(target, offset, get_arrayUByte(sliceBuffer(data, 0, size)));
  }
  q1s(mask) {
    return this.aap_1.clear(mask);
  }
  p8s(red, green, blue, alpha) {
    return this.aap_1.clearColor(red, green, blue, alpha);
  }
  r8s(d) {
    return this.aap_1.clearDepth(d);
  }
  t8s(s) {
    return this.aap_1.clearStencil(s);
  }
  a8v(red, green, blue, alpha) {
    return this.aap_1.colorMask(red, green, blue, alpha);
  }
  l8v(shader) {
    return this.aap_1.compileShader(get_2(shader, this));
  }
  n8v() {
    return alloc(this.aap_1.createProgram(), this);
  }
  j8v(type) {
    return alloc(this.aap_1.createShader(type), this);
  }
  q8t(mode) {
    return this.aap_1.cullFace(mode);
  }
  k9k(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.aap_1.deleteBuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  l9k(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.aap_1.deleteFramebuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  i8v(program) {
    return this.aap_1.deleteProgram(get_2(program, this));
  }
  m9k(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.aap_1.deleteRenderbuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  h8v(shader) {
    return this.aap_1.deleteShader(get_2(shader, this));
  }
  n9k(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.aap_1.deleteTexture(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  z8u(func) {
    return this.aap_1.depthFunc(func);
  }
  q8s(flag) {
    return this.aap_1.depthMask(flag);
  }
  y8u(n, f) {
    return this.aap_1.depthRange(n, f);
  }
  c8t(cap) {
    return this.aap_1.disable(cap);
  }
  s8t(index) {
    return this.aap_1.disableVertexAttribArray(index);
  }
  j8t(mode, first, count) {
    return this.aap_1.drawArrays(mode, first, count);
  }
  l8t(mode, count, type, indices) {
    return this.aap_1.drawElements(mode, count, type, indices);
  }
  d8t(cap) {
    return this.aap_1.enable(cap);
  }
  w8t(index) {
    return this.aap_1.enableVertexAttribArray(index);
  }
  gd() {
    return this.aap_1.flush();
  }
  w8u(target, attachment, renderbuffertarget, renderbuffer) {
    return this.aap_1.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_2(renderbuffer, this));
  }
  v8u(target, attachment, textarget, texture, level) {
    return this.aap_1.framebufferTexture2D(target, attachment, textarget, get_2(texture, this), level);
  }
  x8u(mode) {
    return this.aap_1.frontFace(mode);
  }
  o9k(n, buffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(buffers)[p] = alloc(this.aap_1.createBuffer(), this);
      }
       while (inductionVariable < n);
  }
  y8r(target) {
    return this.aap_1.generateMipmap(target);
  }
  p9k(n, framebuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(framebuffers)[p] = alloc(this.aap_1.createFramebuffer(), this);
      }
       while (inductionVariable < n);
  }
  q9k(n, renderbuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(renderbuffers)[p] = alloc(this.aap_1.createRenderbuffer(), this);
      }
       while (inductionVariable < n);
  }
  r9k(n, textures) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(textures)[p] = alloc(this.aap_1.createTexture(), this);
      }
       while (inductionVariable < n);
  }
  f8v(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    var prg = get_2(program, this);
    if (prg.uniforms === undefined)
      prg.uniforms = {};
    if (prg.uniforms[name] === undefined) {
      prg.uniforms[name] = alloc(this.aap_1.getUniformLocation(prg, name), this);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return prg.uniforms[name];
  }
  m8v() {
    return this.aap_1.getError();
  }
  s9k(pname, data) {
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(data)[0] = this.aap_1.getParameter(pname);
  }
  t9k(program, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.aap_1.getProgramInfoLog(get_2(program, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.aap_1.getProgramParameter(get_2(program, this), pname);
    }
  }
  u9k(shader, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.aap_1.getShaderInfoLog(get_2(shader, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.aap_1.getShaderParameter(get_2(shader, this), pname);
    }
  }
  v9k(shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs = this.aap_1.getShaderInfoLog(get_2(shader, this));
    var str = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(length)[0] = str.length;
    putAsciiString(infoLog, str);
  }
  f8o(name) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.aap_1.getParameter(name);
  }
  v8v(program) {
    return this.aap_1.linkProgram(get_2(program, this));
  }
  v8r(pname, param) {
    return this.aap_1.pixelStorei(pname, param);
  }
  u8u(target, internalformat, width, height) {
    return this.aap_1.renderbufferStorage(target, internalformat, width, height);
  }
  b8v(x, y, width, height) {
    return this.aap_1.scissor(x, y, width, height);
  }
  k8v(shader, string) {
    return this.aap_1.shaderSource(get_2(shader, this), string);
  }
  f8t(func, ref, mask) {
    return this.aap_1.stencilFunc(func, ref, mask);
  }
  e8t(face, func, ref, mask) {
    return this.aap_1.stencilFuncSeparate(face, func, ref, mask);
  }
  s8s(mask) {
    return this.aap_1.stencilMask(mask);
  }
  i8t(face, mask) {
    return this.aap_1.stencilMaskSeparate(face, mask);
  }
  h8t(fail, zfail, zpass) {
    return this.aap_1.stencilOp(fail, zfail, zpass);
  }
  g8t(face, sfail, dpfail, dppass) {
    return this.aap_1.stencilOpSeparate(face, sfail, dpfail, dppass);
  }
  w8r(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp;
    // Inline function 'korlibs.kgl.KmlGl.FLOAT' call
    if (type === 5126) {
      tmp = pixels == null ? null : get_arrayFloat(pixels);
    } else {
      tmp = pixels == null ? null : get_arrayUByte(pixels);
    }
    var vpixels = tmp;
    this.aap_1.texImage2D(target, level, internalformat, width, height, border, format, type, vpixels);
  }
  x8r(target, level, internalformat, format, type, data) {
    if (data instanceof HtmlNativeImage) {
      // Inline function 'korlibs.math.toInt' call
      var tmp$ret$0 = !data.y56_1 && data.x56_1 ? 1 : 0;
      this.aap_1.pixelStorei(37441, tmp$ret$0);
      this.aap_1.texImage2D(target, level, internalformat, format, type, data.i76_1);
      this.aap_1.pixelStorei(37441, 0);
    } else {
      return super.x8r(target, level, internalformat, format, type, data);
    }
  }
  p8r(target, pname, param) {
    return this.aap_1.texParameteri(target, pname, param);
  }
  l8r(location, count, value) {
    return this.aap_1.uniform1fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 1)));
  }
  j8p(location, v0) {
    return this.aap_1.uniform1i(get_2(location, this), v0);
  }
  e8r(location, count, value) {
    return this.aap_1.uniform1iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 1)));
  }
  m8r(location, count, value) {
    return this.aap_1.uniform2fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 2)));
  }
  f8r(location, count, value) {
    return this.aap_1.uniform2iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 2)));
  }
  n8r(location, count, value) {
    return this.aap_1.uniform3fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 3)));
  }
  g8r(location, count, value) {
    return this.aap_1.uniform3iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 3)));
  }
  o8r(location, count, value) {
    return this.aap_1.uniform4fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  h8r(location, count, value) {
    return this.aap_1.uniform4iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 4)));
  }
  i8r(location, count, transpose, value) {
    return this.aap_1.uniformMatrix2fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  j8r(location, count, transpose, value) {
    return this.aap_1.uniformMatrix3fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 9)));
  }
  k8r(location, count, transpose, value) {
    return this.aap_1.uniformMatrix4fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 16)));
  }
  g8v(program) {
    return this.aap_1.useProgram(get_2(program, this));
  }
  x8t(index, size, type, normalized, stride, pointer) {
    return this.aap_1.vertexAttribPointer(index, size, type, normalized, stride, pointer.l2());
  }
  l8u(x, y, width, height) {
    return this.aap_1.viewport(x, y, width, height);
  }
  a7b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.dap_1;
    extensions$factory();
    return this_0.w1();
  }
  k8t(mode, first, count, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.aap_1.drawArraysInstanced(mode, first, count, instancecount);
  }
  m8t(mode, count, type, indices, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.aap_1.drawElementsInstanced(mode, count, type, indices, instancecount);
  }
  r8t(index, divisor) {
    // Inline function 'kotlin.js.asDynamic' call
    this.aap_1.vertexAttribDivisor(index, divisor);
  }
  d84() {
    return get_versionInt(this) >= 2;
  }
  e8u(target, index, buffer, offset, size) {
    // Inline function 'kotlin.js.asDynamic' call
    this.aap_1.bindBufferRange(target, index, get_2(buffer, this), offset, size);
  }
  k8p(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return this.aap_1.getUniformBlockIndex(get_2(program, this), name);
  }
  l8p(program, uniformBlockIndex, uniformBlockBinding) {
    // Inline function 'kotlin.js.asDynamic' call
    this.aap_1.uniformBlockBinding(get_2(program, this), uniformBlockIndex, uniformBlockBinding);
  }
  e84() {
    return this.gap_1.oap();
  }
  w9k(n, arrays) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.aap_1.createVertexArray();
        setInt32(arrays, i, alloc(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  t8t(array) {
    // Inline function 'kotlin.js.asDynamic' call
    this.aap_1.bindVertexArray(get_2(array, this));
  }
}
class WebGLExtension {
  constructor(canvas, name, coreSince, functions, suffix) {
    coreSince = coreSince === VOID ? 1000 : coreSince;
    functions = functions === VOID ? emptyList() : functions;
    suffix = suffix === VOID ? '' : suffix;
    this.hap_1 = canvas;
    this.iap_1 = name;
    this.jap_1 = coreSince;
    this.kap_1 = functions;
    this.lap_1 = suffix;
    this.map_1 = false;
    this.nap_1 = null;
  }
  w1() {
    if (!this.map_1) {
      this.map_1 = true;
      this.nap_1 = this.hap_1.aap_1.getExtension(this.iap_1);
      var _iterator__ex2g4s = this.kap_1.b1();
      while (_iterator__ex2g4s.c1()) {
        var func = _iterator__ex2g4s.d1();
        var base = removeSuffix(func, this.lap_1);
        var vfunc = this.nap_1[func];
        if (typeof vfunc === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          this.hap_1.aap_1[base] = vfunc.bind(this.nap_1);
        }
      }
    }
    return this.nap_1;
  }
  oap() {
    return this.hap_1.zao_1 >= this.jap_1 || this.w1() != null;
  }
}
class KorgeReloadInternal$1 extends KorgeReloadInternalImpl {}
class JsGameWindow extends GameWindow {
  static ib0() {
    return this.ha4();
  }
}
class NodeJsGameWindow extends JsGameWindow {
  static bav() {
    return this.ib0();
  }
}
class BrowserCanvasJsGameWindow$close$slambda {
  constructor(this$0) {
    this.jb0_1 = this$0;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.kb0_1 = $entry;
    this.lb0_1 = this$0;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow extends JsGameWindow {
  static pas(canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    var $this = this.ib0();
    $this.aas_1 = canvas;
    $this.bas_1 = AGWebgl(new AGConfig(), $this.aas_1);
    $this.cas_1 = new DialogInterfaceJs();
    $this.das_1 = null;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.eas_1 = [GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_SYSTEM_getInstance()];
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.fas_1 = [GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
    $this.gas_1 = new GamepadInfo();
    $this.has_1 = Quality_AUTOMATIC_getInstance();
    $this.ias_1 = 1.0;
    $this.jas_1 = new TouchBuilder();
    $this.kas_1 = Cursor_DEFAULT_getInstance();
    $this.las_1 = null;
    $this.mas_1 = null;
    // Inline function 'kotlin.js.asDynamic' call
    window.canvas = $this.aas_1;
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = $this.ya4();
    // Inline function 'kotlin.js.asDynamic' call
    window.gl = $this.ya4().v8m_1;
    if (get_isCanvasCreatedAndHandled()) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild($this.aas_1);
      var tmp1_safe_receiver = document.body;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.margin = '0px';
      }
      var tmp3_safe_receiver = document.body;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.padding = '0px';
      }
      var tmp5_safe_receiver = document.body;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
      if (tmp6_safe_receiver == null)
        null;
      else {
        tmp6_safe_receiver.overflowX = 'hidden';
      }
      var tmp7_safe_receiver = document.body;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
      if (tmp8_safe_receiver == null)
        null;
      else {
        tmp8_safe_receiver.overflowY = 'hidden';
      }
    }
    $this.aas_1.addEventListener('wheel', BrowserCanvasJsGameWindow$lambda($this));
    $this.aas_1.addEventListener('mouseenter', BrowserCanvasJsGameWindow$lambda_0($this));
    $this.aas_1.addEventListener('mouseleave', BrowserCanvasJsGameWindow$lambda_1($this));
    $this.aas_1.addEventListener('mouseover', BrowserCanvasJsGameWindow$lambda_2($this));
    $this.aas_1.addEventListener('mousemove', BrowserCanvasJsGameWindow$lambda_3($this));
    $this.aas_1.addEventListener('mouseout', BrowserCanvasJsGameWindow$lambda_4($this));
    $this.aas_1.addEventListener('mouseup', BrowserCanvasJsGameWindow$lambda_5($this));
    $this.aas_1.addEventListener('mousedown', BrowserCanvasJsGameWindow$lambda_6($this));
    $this.aas_1.addEventListener('click', BrowserCanvasJsGameWindow$lambda_7($this));
    $this.aas_1.addEventListener('touchstart', BrowserCanvasJsGameWindow$lambda_8($this));
    $this.aas_1.addEventListener('touchmove', BrowserCanvasJsGameWindow$lambda_9($this));
    $this.aas_1.addEventListener('touchend', BrowserCanvasJsGameWindow$lambda_10($this));
    var tmp_1 = window;
    tmp_1.addEventListener('keypress', BrowserCanvasJsGameWindow$lambda_11($this));
    var tmp_2 = window;
    tmp_2.addEventListener('keydown', BrowserCanvasJsGameWindow$lambda_12($this));
    var tmp_3 = window;
    tmp_3.addEventListener('keyup', BrowserCanvasJsGameWindow$lambda_13($this));
    var tmp_4 = window;
    tmp_4.addEventListener('resize', BrowserCanvasJsGameWindow$lambda_14($this));
    $this.aas_1.ondragenter = BrowserCanvasJsGameWindow$lambda_15($this);
    $this.aas_1.ondragexit = BrowserCanvasJsGameWindow$lambda_16($this);
    $this.aas_1.ondragleave = BrowserCanvasJsGameWindow$lambda_17($this);
    $this.aas_1.ondragover = BrowserCanvasJsGameWindow$lambda_18;
    $this.aas_1.ondragstart = BrowserCanvasJsGameWindow$lambda_19($this);
    $this.aas_1.ondragend = BrowserCanvasJsGameWindow$lambda_20($this);
    $this.aas_1.ondrop = BrowserCanvasJsGameWindow$lambda_21($this);
    onResized($this);
    var tmp_5 = $this;
    tmp_5.nas_1 = BrowserCanvasJsGameWindow$lambda_22($this);
    $this.oas_1 = null;
    return $this;
  }
  nb0() {
    return window.devicePixelRatio;
  }
  n9x() {
    return this.nb0() <= 0.0 ? 1.0 : isNaN_0(this.nb0()) ? 1.0 : isInfinite(this.nb0()) ? 1.0 : this.nb0();
  }
  ya4() {
    return this.bas_1;
  }
  mb0() {
    if (this.das_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        var e = $p;
        tmp_1 = false;
        tmp_0 = tmp_1;
      }
      tmp.das_1 = tmp_0;
    }
    return ensureNotNull(this.das_1);
  }
  da6() {
    try {
      if (navigator.getGamepads != null) {
        // Inline function 'kotlin.js.unsafeCast' call
        var gamepads = navigator.getGamepads();
        this.o80();
        var inductionVariable = 0;
        var last = gamepads.length;
        if (inductionVariable < last)
          $l$loop_0: do {
            var gamepadId = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.render.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var controller = tmp;
            if (!(controller.mapping === 'standard'))
              continue $l$loop_0;
            var gamepad = this.gas_1;
            gamepad.v80_1 = controller.id;
            var inductionVariable_0 = 0;
            // Inline function 'kotlin.math.min' call
            var a = controller.buttons.length;
            var b = this.eas_1.length;
            var last_0 = Math.min(a, b);
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp_0 = gamepad.w80_1;
                var tmp_1 = this.eas_1[n].s81();
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0[tmp_1] = controller.buttons[n].value;
              }
               while (inductionVariable_0 < last_0);
            var inductionVariable_1 = 0;
            // Inline function 'kotlin.math.min' call
            var a_0 = controller.axes.length;
            var b_0 = this.fas_1.length;
            var last_1 = Math.min(a_0, b_0);
            if (inductionVariable_1 < last_1)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var isX = (n_0 % 2 | 0) === 0;
                var isY = !isX;
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var value = controller.axes[n_0];
                var valueWithoutDeadRange = Companion_instance_24.n81(value, VOID, n_0 <= 3);
                gamepad.w80_1[this.fas_1[n_0].s81()] = isY ? -valueWithoutDeadRange : valueWithoutDeadRange;
              }
               while (inductionVariable_1 < last_1);
            this.a81(gamepad);
          }
           while (inductionVariable < last);
        this.ha6();
      }
    } catch ($p) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = CoroutineKey_getInstance().ga1_1;
      var level = Level_ERROR_getInstance();
      var tmp_2;
      if (this_0.q46(level)) {
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.updateGamepads.<anonymous>' call
        this_0.r46(level, e);
        tmp_2 = Unit_instance;
      }
    }
  }
  ma5(value) {
    if (!this.has_1.equals(value)) {
      this.has_1 = value;
      onResized(this);
    }
  }
  u9w() {
    return this.has_1;
  }
  ga5(value) {
    document.title = value;
  }
  f3u() {
    return this.aas_1.clientWidth;
  }
  g3u() {
    return this.aas_1.clientHeight;
  }
  wa4(value) {
    this.kas_1 = value;
    var tmp = this.aas_1.style;
    var tmp_0;
    if (value instanceof Cursor) {
      switch (value.p3_1) {
        case 0:
          tmp_0 = 'default';
          break;
        case 1:
          tmp_0 = 'crosshair';
          break;
        case 2:
          tmp_0 = 'text';
          break;
        case 3:
          tmp_0 = 'pointer';
          break;
        case 4:
          tmp_0 = 'move';
          break;
        case 5:
          tmp_0 = 'wait';
          break;
        case 6:
          tmp_0 = 'e-resize';
          break;
        case 7:
          tmp_0 = 'w-resize';
          break;
        case 8:
          tmp_0 = 's-resize';
          break;
        case 9:
          tmp_0 = 'n-resize';
          break;
        case 10:
          tmp_0 = 'ne-resize';
          break;
        case 11:
          tmp_0 = 'nw-resize';
          break;
        case 12:
          tmp_0 = 'se-resize';
          break;
        case 13:
          tmp_0 = 'sw-resize';
          break;
        default:
          tmp_0 = 'default';
          break;
      }
    } else {
      tmp_0 = 'default';
    }
    tmp.cursor = tmp_0;
  }
  xa4() {
    return this.kas_1;
  }
  ha5(value) {
    this.las_1 = value;
    if (!(value == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var link = document.querySelector("link[rel*='icon']");
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = toHtmlNative(value).y76();
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = document.getElementsByTagName('head')[0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
      }
    }
  }
  ia5(value) {
    if (!(this.ob0() === value)) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        // Inline function 'kotlin.Companion.success' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<set-fullscreen>.<anonymous>' call
        var tmp_0;
        if (value) {
          tmp_0 = this.aas_1.requestFullscreen();
        } else {
          tmp_0 = document.exitFullscreen();
        }
        var value_0 = tmp_0;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
    }
  }
  ob0() {
    return !(document.fullscreenElement == null);
  }
  ja5(value) {
    this.aas_1.style.visibility = value ? 'visible' : 'hidden';
  }
  pa5(width, height) {
  }
  i2n(exitCode) {
    var tmp = MainScope();
    launchImmediately_0(tmp, BrowserCanvasJsGameWindow$close$slambda_0(this));
    this.mas_1 = null;
  }
  ua5(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_0.bind(VOID, this, entry), $completion);
  }
}
class DenoJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.pb0_1 = $entry;
    this.qb0_1 = this$0;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
  }
}
class DenoJsGameWindow extends SDLGameWindow {
  static wax(size, config) {
    size = size === VOID ? Size2D.w3j(640, 480) : size;
    config = config === VOID ? Companion_getInstance_73().ia6_1 : config;
    return this.mao(size, config);
  }
  ua5(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_1.bind(VOID, this, entry), $completion);
  }
  i2n(exitCode) {
    super.i2n(exitCode);
    Deno.exit(exitCode);
  }
}
class DialogInterfaceJs {}
//endregion
function _get_now__e6dlkr($this) {
  return $this.b7u_1().lk_1;
}
function _queueAfter($this, time, interval, task) {
  // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
  var this_0 = $this.y7t_1;
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
    this_0.c36();
    try {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop._queueAfter.<anonymous>' call
      var task_0 = new TimedTask($this, _get_now__e6dlkr($this), time, interval, task);
      if ($this.z7t_1) {
        $this.d7u_1.p3y(task_0);
      } else {
        Console_getInstance().w45(['WARNING: QUEUED TASK time=' + Duration__toString_impl_8d916b(time) + ' interval=' + interval + ' without running']);
      }
      $this.y7t_1.g36();
      break $l$block;
    }finally {
      this_0.e36();
    }
  }
  return task_0;
}
function SyncEventLoop$nowProvider$lambda(this$0) {
  return function () {
    return new Duration(ValueTimeMark__elapsedNow_impl_eonqvs(this$0.a7u_1));
  };
}
function SyncEventLoop$timedTasks$lambda(a, b) {
  return a.t7t(b);
}
function SyncEventLoop$uncatchedExceptionHandler$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
function paused$factory($b0) {
  return getPropertyCallableRef('paused', 0, KMutableProperty0, function () {
    return $b0.k44_1;
  }, function (value) {
    return $b0.l44(value);
  });
}
function __updateChildListenerCount($this, type, delta) {
  if (delta === 0)
    return Unit_instance;
  if ($this.x7u_1 == null)
    $this.x7u_1 = FastIdentityMap();
  var tmp0_safe_receiver = $this.x7u_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_elvis_lhs = get_0(ensureNotNull($this.x7u_1), type);
    set(tmp0_safe_receiver, type, (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + delta | 0);
  }
  var tmp2_safe_receiver = $this.v7u_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    __updateChildListenerCount(tmp2_safe_receiver, type, delta);
  }
}
function __updateChildListenerCount_0($this, child, add) {
  var tmp0_safe_receiver = child.x7u_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.fastForEach' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = tmp0_safe_receiver.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.event.BaseEventListener.__updateChildListenerCount.<anonymous>' call
      var i = ensureNotNull(get_0(tmp0_safe_receiver, it));
      __updateChildListenerCount($this, it, add ? +i : -i | 0);
    }
  }
}
var Companion_instance_8;
function Companion_getInstance_14() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_15() {
  return Companion_instance_9;
}
var Companion_instance_10;
function Companion_getInstance_16() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_17() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_18() {
  if (Companion_instance_12 === VOID)
    new Companion_3();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_19() {
  if (Companion_instance_13 === VOID)
    new Companion_4();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_20() {
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_21() {
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_22() {
  return Companion_instance_16;
}
var Type_UP_instance;
var Type_DOWN_instance;
var Type_TYPE_instance;
var Companion_instance_17;
function Companion_getInstance_23() {
  Type_initEntries();
  if (Companion_instance_17 === VOID)
    new Companion_8();
  return Companion_instance_17;
}
function values() {
  return [Type_UP_getInstance(), Type_DOWN_getInstance(), Type_TYPE_getInstance()];
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_UP_instance = new Type('UP', 0);
  Type_DOWN_instance = new Type('DOWN', 1);
  Type_TYPE_instance = new Type('TYPE', 2);
  Companion_getInstance_23();
}
function Type_UP_getInstance() {
  Type_initEntries();
  return Type_UP_instance;
}
function Type_DOWN_getInstance() {
  Type_initEntries();
  return Type_DOWN_instance;
}
function Type_TYPE_getInstance() {
  Type_initEntries();
  return Type_TYPE_instance;
}
var Type_MOVE_instance;
var Type_DRAG_instance;
var Type_UP_instance_0;
var Type_DOWN_instance_0;
var Type_CLICK_instance;
var Type_ENTER_instance;
var Type_EXIT_instance;
var Type_SCROLL_instance;
var Companion_instance_18;
function Companion_getInstance_24() {
  Type_initEntries_0();
  if (Companion_instance_18 === VOID)
    new Companion_9();
  return Companion_instance_18;
}
function values_0() {
  return [Type_MOVE_getInstance(), Type_DRAG_getInstance(), Type_UP_getInstance_0(), Type_DOWN_getInstance_0(), Type_CLICK_getInstance(), Type_ENTER_getInstance(), Type_EXIT_getInstance(), Type_SCROLL_getInstance()];
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_MOVE_instance = new Type_0('MOVE', 0);
  Type_DRAG_instance = new Type_0('DRAG', 1);
  Type_UP_instance_0 = new Type_0('UP', 2);
  Type_DOWN_instance_0 = new Type_0('DOWN', 3);
  Type_CLICK_instance = new Type_0('CLICK', 4);
  Type_ENTER_instance = new Type_0('ENTER', 5);
  Type_EXIT_instance = new Type_0('EXIT', 6);
  Type_SCROLL_instance = new Type_0('SCROLL', 7);
  Companion_getInstance_24();
}
var ScrollDeltaMode_PIXEL_instance;
var ScrollDeltaMode_LINE_instance;
var ScrollDeltaMode_PAGE_instance;
var ScrollDeltaMode_entriesInitialized;
function ScrollDeltaMode_initEntries() {
  if (ScrollDeltaMode_entriesInitialized)
    return Unit_instance;
  ScrollDeltaMode_entriesInitialized = true;
  ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
  ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
  ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
}
function MouseEvent$requestLock$lambda() {
  return Unit_instance;
}
function Type_MOVE_getInstance() {
  Type_initEntries_0();
  return Type_MOVE_instance;
}
function Type_DRAG_getInstance() {
  Type_initEntries_0();
  return Type_DRAG_instance;
}
function Type_UP_getInstance_0() {
  Type_initEntries_0();
  return Type_UP_instance_0;
}
function Type_DOWN_getInstance_0() {
  Type_initEntries_0();
  return Type_DOWN_instance_0;
}
function Type_CLICK_getInstance() {
  Type_initEntries_0();
  return Type_CLICK_instance;
}
function Type_ENTER_getInstance() {
  Type_initEntries_0();
  return Type_ENTER_instance;
}
function Type_EXIT_getInstance() {
  Type_initEntries_0();
  return Type_EXIT_instance;
}
function Type_SCROLL_getInstance() {
  Type_initEntries_0();
  return Type_SCROLL_instance;
}
function ScrollDeltaMode_PIXEL_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PIXEL_instance;
}
function ScrollDeltaMode_LINE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_LINE_instance;
}
function ScrollDeltaMode_PAGE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PAGE_instance;
}
var Type_MAGNIFY_instance;
var Type_ROTATE_instance;
var Type_SWIPE_instance;
var Type_SMART_MAGNIFY_instance;
var Companion_instance_19;
function Companion_getInstance_25() {
  Type_initEntries_1();
  if (Companion_instance_19 === VOID)
    new Companion_10();
  return Companion_instance_19;
}
function values_1() {
  return [Type_MAGNIFY_getInstance(), Type_ROTATE_getInstance(), Type_SWIPE_getInstance(), Type_SMART_MAGNIFY_getInstance()];
}
var Type_entriesInitialized_1;
function Type_initEntries_1() {
  if (Type_entriesInitialized_1)
    return Unit_instance;
  Type_entriesInitialized_1 = true;
  Type_MAGNIFY_instance = new Type_1('MAGNIFY', 0);
  Type_ROTATE_instance = new Type_1('ROTATE', 1);
  Type_SWIPE_instance = new Type_1('SWIPE', 2);
  Type_SMART_MAGNIFY_instance = new Type_1('SMART_MAGNIFY', 3);
  Companion_getInstance_25();
}
function Type_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_MAGNIFY_instance;
}
function Type_ROTATE_getInstance() {
  Type_initEntries_1();
  return Type_ROTATE_instance;
}
function Type_SWIPE_getInstance() {
  Type_initEntries_1();
  return Type_SWIPE_instance;
}
function Type_SMART_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_SMART_MAGNIFY_instance;
}
var Type_START_instance;
var Type_END_instance;
var Type_DROP_instance;
var Companion_instance_20;
function Companion_getInstance_26() {
  Type_initEntries_2();
  if (Companion_instance_20 === VOID)
    new Companion_11();
  return Companion_instance_20;
}
function values_2() {
  return [Type_START_getInstance(), Type_END_getInstance(), Type_DROP_getInstance()];
}
var Type_entriesInitialized_2;
function Type_initEntries_2() {
  if (Type_entriesInitialized_2)
    return Unit_instance;
  Type_entriesInitialized_2 = true;
  Type_START_instance = new Type_2('START', 0);
  Type_END_instance = new Type_2('END', 1);
  Type_DROP_instance = new Type_2('DROP', 2);
  Companion_getInstance_26();
}
function Type_START_getInstance() {
  Type_initEntries_2();
  return Type_START_instance;
}
function Type_END_getInstance() {
  Type_initEntries_2();
  return Type_END_instance;
}
function Type_DROP_getInstance() {
  Type_initEntries_2();
  return Type_DROP_instance;
}
var Status_ADD_instance;
var Status_KEEP_instance;
var Status_REMOVE_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_ADD_instance = new Status('ADD', 0);
  Status_KEEP_instance = new Status('KEEP', 1);
  Status_REMOVE_instance = new Status('REMOVE', 2);
}
var Kind_FINGER_instance;
var Kind_MOUSE_instance;
var Kind_STYLUS_instance;
var Kind_ERASER_instance;
var Kind_UNKNOWN_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_FINGER_instance = new Kind('FINGER', 0);
  Kind_MOUSE_instance = new Kind('MOUSE', 1);
  Kind_STYLUS_instance = new Kind('STYLUS', 2);
  Kind_ERASER_instance = new Kind('ERASER', 3);
  Kind_UNKNOWN_instance = new Kind('UNKNOWN', 4);
}
var Companion_instance_21;
function Companion_getInstance_27() {
  if (Companion_instance_21 === VOID)
    new Companion_12();
  return Companion_instance_21;
}
function Status_ADD_getInstance() {
  Status_initEntries();
  return Status_ADD_instance;
}
function Status_KEEP_getInstance() {
  Status_initEntries();
  return Status_KEEP_instance;
}
function Status_REMOVE_getInstance() {
  Status_initEntries();
  return Status_REMOVE_instance;
}
function Kind_FINGER_getInstance() {
  Kind_initEntries();
  return Kind_FINGER_instance;
}
function Kind_MOUSE_getInstance() {
  Kind_initEntries();
  return Kind_MOUSE_instance;
}
var Type_START_instance_0;
var Type_END_instance_0;
var Type_MOVE_instance_0;
var Type_HOVER_instance;
var Type_UNKNOWN_instance;
var Companion_instance_22;
function Companion_getInstance_28() {
  Type_initEntries_3();
  if (Companion_instance_22 === VOID)
    new Companion_13();
  return Companion_instance_22;
}
function values_3() {
  return [Type_START_getInstance_0(), Type_END_getInstance_0(), Type_MOVE_getInstance_0(), Type_HOVER_getInstance(), Type_UNKNOWN_getInstance()];
}
var Type_entriesInitialized_3;
function Type_initEntries_3() {
  if (Type_entriesInitialized_3)
    return Unit_instance;
  Type_entriesInitialized_3 = true;
  Type_START_instance_0 = new Type_3('START', 0);
  Type_END_instance_0 = new Type_3('END', 1);
  Type_MOVE_instance_0 = new Type_3('MOVE', 2);
  Type_HOVER_instance = new Type_3('HOVER', 3);
  Type_UNKNOWN_instance = new Type_3('UNKNOWN', 4);
  Companion_getInstance_28();
}
var Companion_instance_23;
function Companion_getInstance_29() {
  return Companion_instance_23;
}
function TouchEvent$toString$lambda(it) {
  return it.toString();
}
function Type_START_getInstance_0() {
  Type_initEntries_3();
  return Type_START_instance_0;
}
function Type_END_getInstance_0() {
  Type_initEntries_3();
  return Type_END_instance_0;
}
function Type_MOVE_getInstance_0() {
  Type_initEntries_3();
  return Type_MOVE_instance_0;
}
function Type_HOVER_getInstance() {
  Type_initEntries_3();
  return Type_HOVER_instance;
}
function Type_UNKNOWN_getInstance() {
  Type_initEntries_3();
  return Type_UNKNOWN_instance;
}
function invoke_0(_this__u8e3s4, block) {
  block(_this__u8e3s4);
  return _this__u8e3s4;
}
var Mode_JS_instance;
var Mode_Android_instance;
var Mode_IOS_instance;
var Mode_entriesInitialized;
function Mode_initEntries() {
  if (Mode_entriesInitialized)
    return Unit_instance;
  Mode_entriesInitialized = true;
  Mode_JS_instance = new Mode('JS', 0);
  Mode_Android_instance = new Mode('Android', 1);
  Mode_IOS_instance = new Mode('IOS', 2);
}
function Mode_JS_getInstance() {
  Mode_initEntries();
  return Mode_JS_instance;
}
var BatteryStatus_CHARGING_instance;
var BatteryStatus_DISCHARGING_instance;
var BatteryStatus_FULL_instance;
var BatteryStatus_UNKNOWN_instance;
var BatteryStatus_entriesInitialized;
function BatteryStatus_initEntries() {
  if (BatteryStatus_entriesInitialized)
    return Unit_instance;
  BatteryStatus_entriesInitialized = true;
  BatteryStatus_CHARGING_instance = new BatteryStatus('CHARGING', 0);
  BatteryStatus_DISCHARGING_instance = new BatteryStatus('DISCHARGING', 1);
  BatteryStatus_FULL_instance = new BatteryStatus('FULL', 2);
  BatteryStatus_UNKNOWN_instance = new BatteryStatus('UNKNOWN', 3);
}
var Companion_instance_24;
function Companion_getInstance_30() {
  return Companion_instance_24;
}
function BatteryStatus_UNKNOWN_getInstance() {
  BatteryStatus_initEntries();
  return BatteryStatus_UNKNOWN_instance;
}
var Companion_instance_25;
function Companion_getInstance_31() {
  return Companion_instance_25;
}
var Type_CONNECTED_instance;
var Type_DISCONNECTED_instance;
var Companion_instance_26;
function Companion_getInstance_32() {
  Type_initEntries_4();
  if (Companion_instance_26 === VOID)
    new Companion_17();
  return Companion_instance_26;
}
function values_4() {
  return [Type_CONNECTED_getInstance(), Type_DISCONNECTED_getInstance()];
}
var Type_entriesInitialized_4;
function Type_initEntries_4() {
  if (Type_entriesInitialized_4)
    return Unit_instance;
  Type_entriesInitialized_4 = true;
  Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
  Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
  Companion_getInstance_32();
}
function Type_CONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_CONNECTED_instance;
}
function Type_DISCONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_DISCONNECTED_instance;
}
var GameButton_LEFT_instance;
var GameButton_RIGHT_instance;
var GameButton_UP_instance;
var GameButton_DOWN_instance;
var GameButton_BUTTON_SOUTH_instance;
var GameButton_BUTTON_EAST_instance;
var GameButton_BUTTON_WEST_instance;
var GameButton_BUTTON_NORTH_instance;
var GameButton_SELECT_instance;
var GameButton_START_instance;
var GameButton_SYSTEM_instance;
var GameButton_L1_instance;
var GameButton_R1_instance;
var GameButton_L2_instance;
var GameButton_R2_instance;
var GameButton_L3_instance;
var GameButton_R3_instance;
var GameButton_LX_instance;
var GameButton_LY_instance;
var GameButton_RX_instance;
var GameButton_RY_instance;
var GameButton_BUTTON4_instance;
var GameButton_BUTTON5_instance;
var GameButton_BUTTON6_instance;
var GameButton_BUTTON7_instance;
var GameButton_BUTTON8_instance;
var GameButton_RECORD_instance;
var GameButton_DPADX_instance;
var GameButton_DPADY_instance;
var Companion_instance_27;
function Companion_getInstance_33() {
  GameButton_initEntries();
  if (Companion_instance_27 === VOID)
    new Companion_18();
  return Companion_instance_27;
}
function values_5() {
  return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance(), GameButton_RECORD_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
}
var GameButton_entriesInitialized;
function GameButton_initEntries() {
  if (GameButton_entriesInitialized)
    return Unit_instance;
  GameButton_entriesInitialized = true;
  GameButton_LEFT_instance = new GameButton('LEFT', 0);
  GameButton_RIGHT_instance = new GameButton('RIGHT', 1);
  GameButton_UP_instance = new GameButton('UP', 2);
  GameButton_DOWN_instance = new GameButton('DOWN', 3);
  GameButton_BUTTON_SOUTH_instance = new GameButton('BUTTON_SOUTH', 4);
  GameButton_BUTTON_EAST_instance = new GameButton('BUTTON_EAST', 5);
  GameButton_BUTTON_WEST_instance = new GameButton('BUTTON_WEST', 6);
  GameButton_BUTTON_NORTH_instance = new GameButton('BUTTON_NORTH', 7);
  GameButton_SELECT_instance = new GameButton('SELECT', 8);
  GameButton_START_instance = new GameButton('START', 9);
  GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10);
  GameButton_L1_instance = new GameButton('L1', 11);
  GameButton_R1_instance = new GameButton('R1', 12);
  GameButton_L2_instance = new GameButton('L2', 13);
  GameButton_R2_instance = new GameButton('R2', 14);
  GameButton_L3_instance = new GameButton('L3', 15);
  GameButton_R3_instance = new GameButton('R3', 16);
  GameButton_LX_instance = new GameButton('LX', 17);
  GameButton_LY_instance = new GameButton('LY', 18);
  GameButton_RX_instance = new GameButton('RX', 19);
  GameButton_RY_instance = new GameButton('RY', 20);
  GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21);
  GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22);
  GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23);
  GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24);
  GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25);
  GameButton_RECORD_instance = new GameButton('RECORD', 26);
  GameButton_DPADX_instance = new GameButton('DPADX', 27);
  GameButton_DPADY_instance = new GameButton('DPADY', 28);
  Companion_getInstance_33();
}
function GameButton_LEFT_getInstance() {
  GameButton_initEntries();
  return GameButton_LEFT_instance;
}
function GameButton_RIGHT_getInstance() {
  GameButton_initEntries();
  return GameButton_RIGHT_instance;
}
function GameButton_UP_getInstance() {
  GameButton_initEntries();
  return GameButton_UP_instance;
}
function GameButton_DOWN_getInstance() {
  GameButton_initEntries();
  return GameButton_DOWN_instance;
}
function GameButton_BUTTON_SOUTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_SOUTH_instance;
}
function GameButton_BUTTON_EAST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_EAST_instance;
}
function GameButton_BUTTON_WEST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_WEST_instance;
}
function GameButton_BUTTON_NORTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_NORTH_instance;
}
function GameButton_SELECT_getInstance() {
  GameButton_initEntries();
  return GameButton_SELECT_instance;
}
function GameButton_START_getInstance() {
  GameButton_initEntries();
  return GameButton_START_instance;
}
function GameButton_SYSTEM_getInstance() {
  GameButton_initEntries();
  return GameButton_SYSTEM_instance;
}
function GameButton_L1_getInstance() {
  GameButton_initEntries();
  return GameButton_L1_instance;
}
function GameButton_R1_getInstance() {
  GameButton_initEntries();
  return GameButton_R1_instance;
}
function GameButton_L2_getInstance() {
  GameButton_initEntries();
  return GameButton_L2_instance;
}
function GameButton_R2_getInstance() {
  GameButton_initEntries();
  return GameButton_R2_instance;
}
function GameButton_L3_getInstance() {
  GameButton_initEntries();
  return GameButton_L3_instance;
}
function GameButton_R3_getInstance() {
  GameButton_initEntries();
  return GameButton_R3_instance;
}
function GameButton_LX_getInstance() {
  GameButton_initEntries();
  return GameButton_LX_instance;
}
function GameButton_LY_getInstance() {
  GameButton_initEntries();
  return GameButton_LY_instance;
}
function GameButton_RX_getInstance() {
  GameButton_initEntries();
  return GameButton_RX_instance;
}
function GameButton_RY_getInstance() {
  GameButton_initEntries();
  return GameButton_RY_instance;
}
function GameButton_BUTTON4_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON4_instance;
}
function GameButton_BUTTON5_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON5_instance;
}
function GameButton_BUTTON6_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON6_instance;
}
function GameButton_BUTTON7_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON7_instance;
}
function GameButton_BUTTON8_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON8_instance;
}
function GameButton_RECORD_getInstance() {
  GameButton_initEntries();
  return GameButton_RECORD_instance;
}
function GameButton_DPADX_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADX_instance;
}
function GameButton_DPADY_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADY_instance;
}
var Key_SPACE_instance;
var Key_APOSTROPHE_instance;
var Key_COMMA_instance;
var Key_MINUS_instance;
var Key_PLUS_instance;
var Key_PERIOD_instance;
var Key_SLASH_instance;
var Key_N0_instance;
var Key_N1_instance;
var Key_N2_instance;
var Key_N3_instance;
var Key_N4_instance;
var Key_N5_instance;
var Key_N6_instance;
var Key_N7_instance;
var Key_N8_instance;
var Key_N9_instance;
var Key_N11_instance;
var Key_N12_instance;
var Key_N3D_MODE_instance;
var Key_SEMICOLON_instance;
var Key_EQUAL_instance;
var Key_AT_instance;
var Key_A_instance;
var Key_B_instance;
var Key_C_instance;
var Key_D_instance;
var Key_E_instance;
var Key_F_instance;
var Key_G_instance;
var Key_H_instance;
var Key_I_instance;
var Key_J_instance;
var Key_K_instance;
var Key_L_instance;
var Key_M_instance;
var Key_N_instance;
var Key_O_instance;
var Key_P_instance;
var Key_Q_instance;
var Key_R_instance;
var Key_S_instance;
var Key_T_instance;
var Key_U_instance;
var Key_V_instance;
var Key_W_instance;
var Key_X_instance;
var Key_Y_instance;
var Key_Z_instance;
var Key_LEFT_BRACKET_instance;
var Key_BACKSLASH_instance;
var Key_RIGHT_BRACKET_instance;
var Key_GRAVE_ACCENT_instance;
var Key_WORLD_1_instance;
var Key_WORLD_2_instance;
var Key_ESCAPE_instance;
var Key_META_instance;
var Key_ENTER_instance;
var Key_TAB_instance;
var Key_BACKSPACE_instance;
var Key_INSERT_instance;
var Key_DELETE_instance;
var Key_RIGHT_instance;
var Key_LEFT_instance;
var Key_DOWN_instance;
var Key_UP_instance;
var Key_PAGE_UP_instance;
var Key_PAGE_DOWN_instance;
var Key_FUNCTION_instance;
var Key_HELP_instance;
var Key_MUTE_instance;
var Key_VOLUME_DOWN_instance;
var Key_VOLUME_UP_instance;
var Key_VOLUME_MUTE_instance;
var Key_HOME_instance;
var Key_END_instance;
var Key_CAPS_LOCK_instance;
var Key_SCROLL_LOCK_instance;
var Key_NUM_LOCK_instance;
var Key_PRINT_SCREEN_instance;
var Key_PAUSE_instance;
var Key_F1_instance;
var Key_F2_instance;
var Key_F3_instance;
var Key_F4_instance;
var Key_F5_instance;
var Key_F6_instance;
var Key_F7_instance;
var Key_F8_instance;
var Key_F9_instance;
var Key_F10_instance;
var Key_F11_instance;
var Key_F12_instance;
var Key_F13_instance;
var Key_F14_instance;
var Key_F15_instance;
var Key_F16_instance;
var Key_F17_instance;
var Key_F18_instance;
var Key_F19_instance;
var Key_F20_instance;
var Key_F21_instance;
var Key_F22_instance;
var Key_F23_instance;
var Key_F24_instance;
var Key_F25_instance;
var Key_KP_0_instance;
var Key_KP_1_instance;
var Key_KP_2_instance;
var Key_KP_3_instance;
var Key_KP_4_instance;
var Key_KP_5_instance;
var Key_KP_6_instance;
var Key_KP_7_instance;
var Key_KP_8_instance;
var Key_KP_9_instance;
var Key_KP_DECIMAL_instance;
var Key_KP_DIVIDE_instance;
var Key_KP_MULTIPLY_instance;
var Key_KP_SUBTRACT_instance;
var Key_KP_ADD_instance;
var Key_KP_COMMA_instance;
var Key_KP_DOT_instance;
var Key_KP_ENTER_instance;
var Key_KP_EQUAL_instance;
var Key_KP_SEPARATOR_instance;
var Key_KP_LEFT_PAREN_instance;
var Key_KP_RIGHT_PAREN_instance;
var Key_SHIFT_instance;
var Key_CONTROL_instance;
var Key_ALT_instance;
var Key_SUPER_instance;
var Key_MENU_instance;
var Key_BACK_instance;
var Key_BACKQUOTE_instance;
var Key_QUOTE_instance;
var Key_KP_UP_instance;
var Key_KP_DOWN_instance;
var Key_KP_LEFT_instance;
var Key_KP_RIGHT_instance;
var Key_UNDERLINE_instance;
var Key_SELECT_KEY_instance;
var Key_CANCEL_instance;
var Key_CLEAR_instance;
var Key_OPEN_BRACKET_instance;
var Key_CLOSE_BRACKET_instance;
var Key_PLAY_instance;
var Key_NONAME_instance;
var Key_FINAL_instance;
var Key_OEM102_instance;
var Key_OEM1_instance;
var Key_OEM2_instance;
var Key_OEM3_instance;
var Key_OEM4_instance;
var Key_OEM5_instance;
var Key_OEM6_instance;
var Key_OEM7_instance;
var Key_OEM8_instance;
var Key_LEFT_MENU_instance;
var Key_RIGHT_MENU_instance;
var Key_SLEEP_instance;
var Key_SNAPSHOT_instance;
var Key_INFO_instance;
var Key_XBUTTON1_instance;
var Key_XBUTTON2_instance;
var Key_XBUTTON3_instance;
var Key_XBUTTON4_instance;
var Key_XBUTTON5_instance;
var Key_XBUTTON6_instance;
var Key_XBUTTON7_instance;
var Key_XBUTTON8_instance;
var Key_XBUTTON9_instance;
var Key_XBUTTON10_instance;
var Key_XBUTTON11_instance;
var Key_XBUTTON12_instance;
var Key_XBUTTON13_instance;
var Key_XBUTTON14_instance;
var Key_XBUTTON15_instance;
var Key_XBUTTON16_instance;
var Key_XBUTTON_A_instance;
var Key_XBUTTON_B_instance;
var Key_XBUTTON_C_instance;
var Key_XBUTTON_L1_instance;
var Key_XBUTTON_L2_instance;
var Key_XBUTTON_MODE_instance;
var Key_XBUTTON_R1_instance;
var Key_XBUTTON_R2_instance;
var Key_XBUTTON_SELECT_instance;
var Key_XBUTTON_START_instance;
var Key_XBUTTON_THUMBL_instance;
var Key_XBUTTON_THUMBR_instance;
var Key_XBUTTON_X_instance;
var Key_XBUTTON_Y_instance;
var Key_XBUTTON_Z_instance;
var Key_DPAD_CENTER_instance;
var Key_DPAD_DOWN_instance;
var Key_DPAD_DOWN_LEFT_instance;
var Key_DPAD_DOWN_RIGHT_instance;
var Key_DPAD_LEFT_instance;
var Key_DPAD_RIGHT_instance;
var Key_DPAD_UP_instance;
var Key_DPAD_UP_LEFT_instance;
var Key_DPAD_UP_RIGHT_instance;
var Key_DVR_instance;
var Key_EISU_instance;
var Key_ENDCALL_instance;
var Key_ENVELOPE_instance;
var Key_EXPLORER_instance;
var Key_FOCUS_instance;
var Key_FORWARD_instance;
var Key_GRAVE_instance;
var Key_GUIDE_instance;
var Key_HEADSETHOOK_instance;
var Key_ABNT_C1_instance;
var Key_ABNT_C2_instance;
var Key_ATTN_instance;
var Key_CRSEL_instance;
var Key_EREOF_instance;
var Key_EXECUTE_instance;
var Key_EXSEL_instance;
var Key_ICO_CLEAR_instance;
var Key_ICO_HELP_instance;
var Key_HENKAN_instance;
var Key_PAIRING_instance;
var Key_APP_SWITCH_instance;
var Key_ASSIST_instance;
var Key_AVR_INPUT_instance;
var Key_AVR_POWER_instance;
var Key_BOOKMARK_instance;
var Key_BREAK_instance;
var Key_CAPTIONS_instance;
var Key_CAMERA_instance;
var Key_CALL_instance;
var Key_CALENDAR_instance;
var Key_BRIGHTNESS_DOWN_instance;
var Key_BRIGHTNESS_UP_instance;
var Key_CHANNEL_DOWN_instance;
var Key_CHANNEL_UP_instance;
var Key_CALCULATOR_instance;
var Key_CONTACTS_instance;
var Key_NOTIFICATION_instance;
var Key_COPY_instance;
var Key_CUT_instance;
var Key_PASTE_instance;
var Key_SEARCH_instance;
var Key_SETTINGS_instance;
var Key_SOFT_LEFT_instance;
var Key_SOFT_RIGHT_instance;
var Key_SOFT_SLEEP_instance;
var Key_STAR_instance;
var Key_STB_INPUT_instance;
var Key_STB_POWER_instance;
var Key_STEM_1_instance;
var Key_STEM_2_instance;
var Key_STEM_3_instance;
var Key_STEM_PRIMARY_instance;
var Key_SWITCH_CHARSET_instance;
var Key_SYM_instance;
var Key_SYSRQ_instance;
var Key_NUM_instance;
var Key_TV_instance;
var Key_TV_ANTENNA_CABLE_instance;
var Key_TV_AUDIO_DESCRIPTION_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
var Key_TV_CONTENTS_MENU_instance;
var Key_TV_DATA_SERVICE_instance;
var Key_TV_INPUT_instance;
var Key_TV_INPUT_COMPONENT_1_instance;
var Key_TV_INPUT_COMPONENT_2_instance;
var Key_TV_INPUT_COMPOSITE_1_instance;
var Key_TV_INPUT_COMPOSITE_2_instance;
var Key_TV_INPUT_HDMI_1_instance;
var Key_TV_INPUT_HDMI_2_instance;
var Key_TV_INPUT_HDMI_3_instance;
var Key_TV_INPUT_HDMI_4_instance;
var Key_TV_INPUT_VGA_1_instance;
var Key_TV_MEDIA_CONTEXT_MENU_instance;
var Key_TV_NETWORK_instance;
var Key_TV_NUMBER_ENTRY_instance;
var Key_TV_POWER_instance;
var Key_TV_RADIO_SERVICE_instance;
var Key_TV_SATELLITE_instance;
var Key_TV_SATELLITE_BS_instance;
var Key_TV_SATELLITE_CS_instance;
var Key_TV_SATELLITE_SERVICE_instance;
var Key_TV_TELETEXT_instance;
var Key_TV_TERRESTRIAL_ANALOG_instance;
var Key_TV_TERRESTRIAL_DIGITAL_instance;
var Key_TV_TIMER_PROGRAMMING_instance;
var Key_TV_ZOOM_MODE_instance;
var Key_VOICE_ASSIST_instance;
var Key_WAKEUP_instance;
var Key_WINDOW_instance;
var Key_YEN_instance;
var Key_ZENKAKU_HANKAKU_instance;
var Key_ZOOM_IN_instance;
var Key_ZOOM_OUT_instance;
var Key_SYSTEM_NAVIGATION_DOWN_instance;
var Key_SYSTEM_NAVIGATION_LEFT_instance;
var Key_SYSTEM_NAVIGATION_RIGHT_instance;
var Key_SYSTEM_NAVIGATION_UP_instance;
var Key_PICTSYMBOLS_instance;
var Key_POUND_instance;
var Key_POWER_instance;
var Key_PROG_BLUE_instance;
var Key_PROG_GREEN_instance;
var Key_PROG_RED_instance;
var Key_PROG_YELLOW_instance;
var Key_RO_instance;
var Key_OEM_ATTN_instance;
var Key_OEM_AUTO_instance;
var Key_OEM_AX_instance;
var Key_OEM_BACKTAB_instance;
var Key_OEM_CLEAR_instance;
var Key_OEM_COMMA_instance;
var Key_OEM_COPY_instance;
var Key_OEM_CUSEL_instance;
var Key_OEM_ENLW_instance;
var Key_OEM_FINISH_instance;
var Key_OEM_FJ_LOYA_instance;
var Key_OEM_FJ_MASSHOU_instance;
var Key_OEM_FJ_ROYA_instance;
var Key_OEM_FJ_TOUROKU_instance;
var Key_OEM_JUMP_instance;
var Key_OEM_MINUS_instance;
var Key_OEM_PA1_instance;
var Key_OEM_PA2_instance;
var Key_OEM_PA3_instance;
var Key_OEM_PERIOD_instance;
var Key_OEM_PLUS_instance;
var Key_OEM_RESET_instance;
var Key_OEM_WSCTRL_instance;
var Key_PA1_instance;
var Key_PACKET_instance;
var Key_PROCESSKEY_instance;
var Key_ZOOM_instance;
var Key_NONE_instance;
var Key_ACCEPT_instance;
var Key_APPS_instance;
var Key_BROWSER_BACK_instance;
var Key_BROWSER_FAVORITES_instance;
var Key_BROWSER_FORWARD_instance;
var Key_BROWSER_HOME_instance;
var Key_BROWSER_REFRESH_instance;
var Key_BROWSER_SEARCH_instance;
var Key_BROWSER_STOP_instance;
var Key_CAPITAL_instance;
var Key_CONVERT_instance;
var Key_ICO_00_instance;
var Key_JUNJA_instance;
var Key_KANA_instance;
var Key_KANJI_instance;
var Key_KATAKANA_HIRAGANA_instance;
var Key_LANGUAGE_SWITCH_instance;
var Key_MUHENKAN_instance;
var Key_LAUNCH_APP1_instance;
var Key_LAUNCH_APP2_instance;
var Key_LAUNCH_MAIL_instance;
var Key_LAUNCH_MEDIA_SELECT_instance;
var Key_LEFT_BUTTON_instance;
var Key_MIDDLE_BUTTON_instance;
var Key_MUSIC_instance;
var Key_MEDIA_NEXT_TRACK_instance;
var Key_MEDIA_PLAY_PAUSE_instance;
var Key_MEDIA_PREV_TRACK_instance;
var Key_MEDIA_STOP_instance;
var Key_MEDIA_PLAY_instance;
var Key_MEDIA_PAUSE_instance;
var Key_MEDIA_AUDIO_TRACK_instance;
var Key_MEDIA_CLOSE_instance;
var Key_MEDIA_EJECT_instance;
var Key_MEDIA_FAST_FORWARD_instance;
var Key_MEDIA_RECORD_instance;
var Key_MEDIA_REWIND_instance;
var Key_MEDIA_SKIP_BACKWARD_instance;
var Key_MEDIA_SKIP_FORWARD_instance;
var Key_MEDIA_STEP_BACKWARD_instance;
var Key_MEDIA_STEP_FORWARD_instance;
var Key_MEDIA_TOP_MENU_instance;
var Key_MODECHANGE_instance;
var Key_NEXT_instance;
var Key_NONCONVERT_instance;
var Key_OEM_FJ_JISHO_instance;
var Key_PRIOR_instance;
var Key_RIGHT_BUTTON_instance;
var Key_LAST_CHANNEL_instance;
var Key_MANNER_MODE_instance;
var Key_NAVIGATE_IN_instance;
var Key_NAVIGATE_NEXT_instance;
var Key_NAVIGATE_OUT_instance;
var Key_NAVIGATE_PREVIOUS_instance;
var Key_HYPHEN_instance;
var Key_UNDEFINED_instance;
var Key_UNKNOWN_instance;
var Companion_instance_28;
function Companion_getInstance_34() {
  Key_initEntries();
  if (Companion_instance_28 === VOID)
    new Companion_19();
  return Companion_instance_28;
}
var Key_entriesInitialized;
function Key_initEntries() {
  if (Key_entriesInitialized)
    return Unit_instance;
  Key_entriesInitialized = true;
  Key_SPACE_instance = new Key('SPACE', 0);
  Key_APOSTROPHE_instance = new Key('APOSTROPHE', 1);
  Key_COMMA_instance = new Key('COMMA', 2);
  Key_MINUS_instance = new Key('MINUS', 3);
  Key_PLUS_instance = new Key('PLUS', 4);
  Key_PERIOD_instance = new Key('PERIOD', 5);
  Key_SLASH_instance = new Key('SLASH', 6);
  Key_N0_instance = new Key('N0', 7);
  Key_N1_instance = new Key('N1', 8);
  Key_N2_instance = new Key('N2', 9);
  Key_N3_instance = new Key('N3', 10);
  Key_N4_instance = new Key('N4', 11);
  Key_N5_instance = new Key('N5', 12);
  Key_N6_instance = new Key('N6', 13);
  Key_N7_instance = new Key('N7', 14);
  Key_N8_instance = new Key('N8', 15);
  Key_N9_instance = new Key('N9', 16);
  Key_N11_instance = new Key('N11', 17);
  Key_N12_instance = new Key('N12', 18);
  Key_N3D_MODE_instance = new Key('N3D_MODE', 19);
  Key_SEMICOLON_instance = new Key('SEMICOLON', 20);
  Key_EQUAL_instance = new Key('EQUAL', 21);
  Key_AT_instance = new Key('AT', 22);
  Key_A_instance = new Key('A', 23);
  Key_B_instance = new Key('B', 24);
  Key_C_instance = new Key('C', 25);
  Key_D_instance = new Key('D', 26);
  Key_E_instance = new Key('E', 27);
  Key_F_instance = new Key('F', 28);
  Key_G_instance = new Key('G', 29);
  Key_H_instance = new Key('H', 30);
  Key_I_instance = new Key('I', 31);
  Key_J_instance = new Key('J', 32);
  Key_K_instance = new Key('K', 33);
  Key_L_instance = new Key('L', 34);
  Key_M_instance = new Key('M', 35);
  Key_N_instance = new Key('N', 36);
  Key_O_instance = new Key('O', 37);
  Key_P_instance = new Key('P', 38);
  Key_Q_instance = new Key('Q', 39);
  Key_R_instance = new Key('R', 40);
  Key_S_instance = new Key('S', 41);
  Key_T_instance = new Key('T', 42);
  Key_U_instance = new Key('U', 43);
  Key_V_instance = new Key('V', 44);
  Key_W_instance = new Key('W', 45);
  Key_X_instance = new Key('X', 46);
  Key_Y_instance = new Key('Y', 47);
  Key_Z_instance = new Key('Z', 48);
  Key_LEFT_BRACKET_instance = new Key('LEFT_BRACKET', 49);
  Key_BACKSLASH_instance = new Key('BACKSLASH', 50);
  Key_RIGHT_BRACKET_instance = new Key('RIGHT_BRACKET', 51);
  Key_GRAVE_ACCENT_instance = new Key('GRAVE_ACCENT', 52);
  Key_WORLD_1_instance = new Key('WORLD_1', 53);
  Key_WORLD_2_instance = new Key('WORLD_2', 54);
  Key_ESCAPE_instance = new Key('ESCAPE', 55);
  Key_META_instance = new Key('META', 56);
  Key_ENTER_instance = new Key('ENTER', 57);
  Key_TAB_instance = new Key('TAB', 58);
  Key_BACKSPACE_instance = new Key('BACKSPACE', 59);
  Key_INSERT_instance = new Key('INSERT', 60);
  Key_DELETE_instance = new Key('DELETE', 61);
  Key_RIGHT_instance = new Key('RIGHT', 62);
  Key_LEFT_instance = new Key('LEFT', 63);
  Key_DOWN_instance = new Key('DOWN', 64);
  Key_UP_instance = new Key('UP', 65);
  Key_PAGE_UP_instance = new Key('PAGE_UP', 66);
  Key_PAGE_DOWN_instance = new Key('PAGE_DOWN', 67);
  Key_FUNCTION_instance = new Key('FUNCTION', 68);
  Key_HELP_instance = new Key('HELP', 69);
  Key_MUTE_instance = new Key('MUTE', 70);
  Key_VOLUME_DOWN_instance = new Key('VOLUME_DOWN', 71);
  Key_VOLUME_UP_instance = new Key('VOLUME_UP', 72);
  Key_VOLUME_MUTE_instance = new Key('VOLUME_MUTE', 73);
  Key_HOME_instance = new Key('HOME', 74);
  Key_END_instance = new Key('END', 75);
  Key_CAPS_LOCK_instance = new Key('CAPS_LOCK', 76);
  Key_SCROLL_LOCK_instance = new Key('SCROLL_LOCK', 77);
  Key_NUM_LOCK_instance = new Key('NUM_LOCK', 78);
  Key_PRINT_SCREEN_instance = new Key('PRINT_SCREEN', 79);
  Key_PAUSE_instance = new Key('PAUSE', 80);
  Key_F1_instance = new Key('F1', 81);
  Key_F2_instance = new Key('F2', 82);
  Key_F3_instance = new Key('F3', 83);
  Key_F4_instance = new Key('F4', 84);
  Key_F5_instance = new Key('F5', 85);
  Key_F6_instance = new Key('F6', 86);
  Key_F7_instance = new Key('F7', 87);
  Key_F8_instance = new Key('F8', 88);
  Key_F9_instance = new Key('F9', 89);
  Key_F10_instance = new Key('F10', 90);
  Key_F11_instance = new Key('F11', 91);
  Key_F12_instance = new Key('F12', 92);
  Key_F13_instance = new Key('F13', 93);
  Key_F14_instance = new Key('F14', 94);
  Key_F15_instance = new Key('F15', 95);
  Key_F16_instance = new Key('F16', 96);
  Key_F17_instance = new Key('F17', 97);
  Key_F18_instance = new Key('F18', 98);
  Key_F19_instance = new Key('F19', 99);
  Key_F20_instance = new Key('F20', 100);
  Key_F21_instance = new Key('F21', 101);
  Key_F22_instance = new Key('F22', 102);
  Key_F23_instance = new Key('F23', 103);
  Key_F24_instance = new Key('F24', 104);
  Key_F25_instance = new Key('F25', 105);
  Key_KP_0_instance = new Key('KP_0', 106);
  Key_KP_1_instance = new Key('KP_1', 107);
  Key_KP_2_instance = new Key('KP_2', 108);
  Key_KP_3_instance = new Key('KP_3', 109);
  Key_KP_4_instance = new Key('KP_4', 110);
  Key_KP_5_instance = new Key('KP_5', 111);
  Key_KP_6_instance = new Key('KP_6', 112);
  Key_KP_7_instance = new Key('KP_7', 113);
  Key_KP_8_instance = new Key('KP_8', 114);
  Key_KP_9_instance = new Key('KP_9', 115);
  Key_KP_DECIMAL_instance = new Key('KP_DECIMAL', 116);
  Key_KP_DIVIDE_instance = new Key('KP_DIVIDE', 117);
  Key_KP_MULTIPLY_instance = new Key('KP_MULTIPLY', 118);
  Key_KP_SUBTRACT_instance = new Key('KP_SUBTRACT', 119);
  Key_KP_ADD_instance = new Key('KP_ADD', 120);
  Key_KP_COMMA_instance = new Key('KP_COMMA', 121);
  Key_KP_DOT_instance = new Key('KP_DOT', 122);
  Key_KP_ENTER_instance = new Key('KP_ENTER', 123);
  Key_KP_EQUAL_instance = new Key('KP_EQUAL', 124);
  Key_KP_SEPARATOR_instance = new Key('KP_SEPARATOR', 125);
  Key_KP_LEFT_PAREN_instance = new Key('KP_LEFT_PAREN', 126);
  Key_KP_RIGHT_PAREN_instance = new Key('KP_RIGHT_PAREN', 127);
  Key_SHIFT_instance = new Key('SHIFT', 128);
  Key_CONTROL_instance = new Key('CONTROL', 129);
  Key_ALT_instance = new Key('ALT', 130);
  Key_SUPER_instance = new Key('SUPER', 131);
  Key_MENU_instance = new Key('MENU', 132);
  Key_BACK_instance = new Key('BACK', 133);
  Key_BACKQUOTE_instance = new Key('BACKQUOTE', 134);
  Key_QUOTE_instance = new Key('QUOTE', 135);
  Key_KP_UP_instance = new Key('KP_UP', 136);
  Key_KP_DOWN_instance = new Key('KP_DOWN', 137);
  Key_KP_LEFT_instance = new Key('KP_LEFT', 138);
  Key_KP_RIGHT_instance = new Key('KP_RIGHT', 139);
  Key_UNDERLINE_instance = new Key('UNDERLINE', 140);
  Key_SELECT_KEY_instance = new Key('SELECT_KEY', 141);
  Key_CANCEL_instance = new Key('CANCEL', 142);
  Key_CLEAR_instance = new Key('CLEAR', 143);
  Key_OPEN_BRACKET_instance = new Key('OPEN_BRACKET', 144);
  Key_CLOSE_BRACKET_instance = new Key('CLOSE_BRACKET', 145);
  Key_PLAY_instance = new Key('PLAY', 146);
  Key_NONAME_instance = new Key('NONAME', 147);
  Key_FINAL_instance = new Key('FINAL', 148);
  Key_OEM102_instance = new Key('OEM102', 149);
  Key_OEM1_instance = new Key('OEM1', 150);
  Key_OEM2_instance = new Key('OEM2', 151);
  Key_OEM3_instance = new Key('OEM3', 152);
  Key_OEM4_instance = new Key('OEM4', 153);
  Key_OEM5_instance = new Key('OEM5', 154);
  Key_OEM6_instance = new Key('OEM6', 155);
  Key_OEM7_instance = new Key('OEM7', 156);
  Key_OEM8_instance = new Key('OEM8', 157);
  Key_LEFT_MENU_instance = new Key('LEFT_MENU', 158);
  Key_RIGHT_MENU_instance = new Key('RIGHT_MENU', 159);
  Key_SLEEP_instance = new Key('SLEEP', 160);
  Key_SNAPSHOT_instance = new Key('SNAPSHOT', 161);
  Key_INFO_instance = new Key('INFO', 162);
  Key_XBUTTON1_instance = new Key('XBUTTON1', 163);
  Key_XBUTTON2_instance = new Key('XBUTTON2', 164);
  Key_XBUTTON3_instance = new Key('XBUTTON3', 165);
  Key_XBUTTON4_instance = new Key('XBUTTON4', 166);
  Key_XBUTTON5_instance = new Key('XBUTTON5', 167);
  Key_XBUTTON6_instance = new Key('XBUTTON6', 168);
  Key_XBUTTON7_instance = new Key('XBUTTON7', 169);
  Key_XBUTTON8_instance = new Key('XBUTTON8', 170);
  Key_XBUTTON9_instance = new Key('XBUTTON9', 171);
  Key_XBUTTON10_instance = new Key('XBUTTON10', 172);
  Key_XBUTTON11_instance = new Key('XBUTTON11', 173);
  Key_XBUTTON12_instance = new Key('XBUTTON12', 174);
  Key_XBUTTON13_instance = new Key('XBUTTON13', 175);
  Key_XBUTTON14_instance = new Key('XBUTTON14', 176);
  Key_XBUTTON15_instance = new Key('XBUTTON15', 177);
  Key_XBUTTON16_instance = new Key('XBUTTON16', 178);
  Key_XBUTTON_A_instance = new Key('XBUTTON_A', 179);
  Key_XBUTTON_B_instance = new Key('XBUTTON_B', 180);
  Key_XBUTTON_C_instance = new Key('XBUTTON_C', 181);
  Key_XBUTTON_L1_instance = new Key('XBUTTON_L1', 182);
  Key_XBUTTON_L2_instance = new Key('XBUTTON_L2', 183);
  Key_XBUTTON_MODE_instance = new Key('XBUTTON_MODE', 184);
  Key_XBUTTON_R1_instance = new Key('XBUTTON_R1', 185);
  Key_XBUTTON_R2_instance = new Key('XBUTTON_R2', 186);
  Key_XBUTTON_SELECT_instance = new Key('XBUTTON_SELECT', 187);
  Key_XBUTTON_START_instance = new Key('XBUTTON_START', 188);
  Key_XBUTTON_THUMBL_instance = new Key('XBUTTON_THUMBL', 189);
  Key_XBUTTON_THUMBR_instance = new Key('XBUTTON_THUMBR', 190);
  Key_XBUTTON_X_instance = new Key('XBUTTON_X', 191);
  Key_XBUTTON_Y_instance = new Key('XBUTTON_Y', 192);
  Key_XBUTTON_Z_instance = new Key('XBUTTON_Z', 193);
  Key_DPAD_CENTER_instance = new Key('DPAD_CENTER', 194);
  Key_DPAD_DOWN_instance = new Key('DPAD_DOWN', 195);
  Key_DPAD_DOWN_LEFT_instance = new Key('DPAD_DOWN_LEFT', 196);
  Key_DPAD_DOWN_RIGHT_instance = new Key('DPAD_DOWN_RIGHT', 197);
  Key_DPAD_LEFT_instance = new Key('DPAD_LEFT', 198);
  Key_DPAD_RIGHT_instance = new Key('DPAD_RIGHT', 199);
  Key_DPAD_UP_instance = new Key('DPAD_UP', 200);
  Key_DPAD_UP_LEFT_instance = new Key('DPAD_UP_LEFT', 201);
  Key_DPAD_UP_RIGHT_instance = new Key('DPAD_UP_RIGHT', 202);
  Key_DVR_instance = new Key('DVR', 203);
  Key_EISU_instance = new Key('EISU', 204);
  Key_ENDCALL_instance = new Key('ENDCALL', 205);
  Key_ENVELOPE_instance = new Key('ENVELOPE', 206);
  Key_EXPLORER_instance = new Key('EXPLORER', 207);
  Key_FOCUS_instance = new Key('FOCUS', 208);
  Key_FORWARD_instance = new Key('FORWARD', 209);
  Key_GRAVE_instance = new Key('GRAVE', 210);
  Key_GUIDE_instance = new Key('GUIDE', 211);
  Key_HEADSETHOOK_instance = new Key('HEADSETHOOK', 212);
  Key_ABNT_C1_instance = new Key('ABNT_C1', 213);
  Key_ABNT_C2_instance = new Key('ABNT_C2', 214);
  Key_ATTN_instance = new Key('ATTN', 215);
  Key_CRSEL_instance = new Key('CRSEL', 216);
  Key_EREOF_instance = new Key('EREOF', 217);
  Key_EXECUTE_instance = new Key('EXECUTE', 218);
  Key_EXSEL_instance = new Key('EXSEL', 219);
  Key_ICO_CLEAR_instance = new Key('ICO_CLEAR', 220);
  Key_ICO_HELP_instance = new Key('ICO_HELP', 221);
  Key_HENKAN_instance = new Key('HENKAN', 222);
  Key_PAIRING_instance = new Key('PAIRING', 223);
  Key_APP_SWITCH_instance = new Key('APP_SWITCH', 224);
  Key_ASSIST_instance = new Key('ASSIST', 225);
  Key_AVR_INPUT_instance = new Key('AVR_INPUT', 226);
  Key_AVR_POWER_instance = new Key('AVR_POWER', 227);
  Key_BOOKMARK_instance = new Key('BOOKMARK', 228);
  Key_BREAK_instance = new Key('BREAK', 229);
  Key_CAPTIONS_instance = new Key('CAPTIONS', 230);
  Key_CAMERA_instance = new Key('CAMERA', 231);
  Key_CALL_instance = new Key('CALL', 232);
  Key_CALENDAR_instance = new Key('CALENDAR', 233);
  Key_BRIGHTNESS_DOWN_instance = new Key('BRIGHTNESS_DOWN', 234);
  Key_BRIGHTNESS_UP_instance = new Key('BRIGHTNESS_UP', 235);
  Key_CHANNEL_DOWN_instance = new Key('CHANNEL_DOWN', 236);
  Key_CHANNEL_UP_instance = new Key('CHANNEL_UP', 237);
  Key_CALCULATOR_instance = new Key('CALCULATOR', 238);
  Key_CONTACTS_instance = new Key('CONTACTS', 239);
  Key_NOTIFICATION_instance = new Key('NOTIFICATION', 240);
  Key_COPY_instance = new Key('COPY', 241);
  Key_CUT_instance = new Key('CUT', 242);
  Key_PASTE_instance = new Key('PASTE', 243);
  Key_SEARCH_instance = new Key('SEARCH', 244);
  Key_SETTINGS_instance = new Key('SETTINGS', 245);
  Key_SOFT_LEFT_instance = new Key('SOFT_LEFT', 246);
  Key_SOFT_RIGHT_instance = new Key('SOFT_RIGHT', 247);
  Key_SOFT_SLEEP_instance = new Key('SOFT_SLEEP', 248);
  Key_STAR_instance = new Key('STAR', 249);
  Key_STB_INPUT_instance = new Key('STB_INPUT', 250);
  Key_STB_POWER_instance = new Key('STB_POWER', 251);
  Key_STEM_1_instance = new Key('STEM_1', 252);
  Key_STEM_2_instance = new Key('STEM_2', 253);
  Key_STEM_3_instance = new Key('STEM_3', 254);
  Key_STEM_PRIMARY_instance = new Key('STEM_PRIMARY', 255);
  Key_SWITCH_CHARSET_instance = new Key('SWITCH_CHARSET', 256);
  Key_SYM_instance = new Key('SYM', 257);
  Key_SYSRQ_instance = new Key('SYSRQ', 258);
  Key_NUM_instance = new Key('NUM', 259);
  Key_TV_instance = new Key('TV', 260);
  Key_TV_ANTENNA_CABLE_instance = new Key('TV_ANTENNA_CABLE', 261);
  Key_TV_AUDIO_DESCRIPTION_instance = new Key('TV_AUDIO_DESCRIPTION', 262);
  Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_DOWN', 263);
  Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_UP', 264);
  Key_TV_CONTENTS_MENU_instance = new Key('TV_CONTENTS_MENU', 265);
  Key_TV_DATA_SERVICE_instance = new Key('TV_DATA_SERVICE', 266);
  Key_TV_INPUT_instance = new Key('TV_INPUT', 267);
  Key_TV_INPUT_COMPONENT_1_instance = new Key('TV_INPUT_COMPONENT_1', 268);
  Key_TV_INPUT_COMPONENT_2_instance = new Key('TV_INPUT_COMPONENT_2', 269);
  Key_TV_INPUT_COMPOSITE_1_instance = new Key('TV_INPUT_COMPOSITE_1', 270);
  Key_TV_INPUT_COMPOSITE_2_instance = new Key('TV_INPUT_COMPOSITE_2', 271);
  Key_TV_INPUT_HDMI_1_instance = new Key('TV_INPUT_HDMI_1', 272);
  Key_TV_INPUT_HDMI_2_instance = new Key('TV_INPUT_HDMI_2', 273);
  Key_TV_INPUT_HDMI_3_instance = new Key('TV_INPUT_HDMI_3', 274);
  Key_TV_INPUT_HDMI_4_instance = new Key('TV_INPUT_HDMI_4', 275);
  Key_TV_INPUT_VGA_1_instance = new Key('TV_INPUT_VGA_1', 276);
  Key_TV_MEDIA_CONTEXT_MENU_instance = new Key('TV_MEDIA_CONTEXT_MENU', 277);
  Key_TV_NETWORK_instance = new Key('TV_NETWORK', 278);
  Key_TV_NUMBER_ENTRY_instance = new Key('TV_NUMBER_ENTRY', 279);
  Key_TV_POWER_instance = new Key('TV_POWER', 280);
  Key_TV_RADIO_SERVICE_instance = new Key('TV_RADIO_SERVICE', 281);
  Key_TV_SATELLITE_instance = new Key('TV_SATELLITE', 282);
  Key_TV_SATELLITE_BS_instance = new Key('TV_SATELLITE_BS', 283);
  Key_TV_SATELLITE_CS_instance = new Key('TV_SATELLITE_CS', 284);
  Key_TV_SATELLITE_SERVICE_instance = new Key('TV_SATELLITE_SERVICE', 285);
  Key_TV_TELETEXT_instance = new Key('TV_TELETEXT', 286);
  Key_TV_TERRESTRIAL_ANALOG_instance = new Key('TV_TERRESTRIAL_ANALOG', 287);
  Key_TV_TERRESTRIAL_DIGITAL_instance = new Key('TV_TERRESTRIAL_DIGITAL', 288);
  Key_TV_TIMER_PROGRAMMING_instance = new Key('TV_TIMER_PROGRAMMING', 289);
  Key_TV_ZOOM_MODE_instance = new Key('TV_ZOOM_MODE', 290);
  Key_VOICE_ASSIST_instance = new Key('VOICE_ASSIST', 291);
  Key_WAKEUP_instance = new Key('WAKEUP', 292);
  Key_WINDOW_instance = new Key('WINDOW', 293);
  Key_YEN_instance = new Key('YEN', 294);
  Key_ZENKAKU_HANKAKU_instance = new Key('ZENKAKU_HANKAKU', 295);
  Key_ZOOM_IN_instance = new Key('ZOOM_IN', 296);
  Key_ZOOM_OUT_instance = new Key('ZOOM_OUT', 297);
  Key_SYSTEM_NAVIGATION_DOWN_instance = new Key('SYSTEM_NAVIGATION_DOWN', 298);
  Key_SYSTEM_NAVIGATION_LEFT_instance = new Key('SYSTEM_NAVIGATION_LEFT', 299);
  Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key('SYSTEM_NAVIGATION_RIGHT', 300);
  Key_SYSTEM_NAVIGATION_UP_instance = new Key('SYSTEM_NAVIGATION_UP', 301);
  Key_PICTSYMBOLS_instance = new Key('PICTSYMBOLS', 302);
  Key_POUND_instance = new Key('POUND', 303);
  Key_POWER_instance = new Key('POWER', 304);
  Key_PROG_BLUE_instance = new Key('PROG_BLUE', 305);
  Key_PROG_GREEN_instance = new Key('PROG_GREEN', 306);
  Key_PROG_RED_instance = new Key('PROG_RED', 307);
  Key_PROG_YELLOW_instance = new Key('PROG_YELLOW', 308);
  Key_RO_instance = new Key('RO', 309);
  Key_OEM_ATTN_instance = new Key('OEM_ATTN', 310);
  Key_OEM_AUTO_instance = new Key('OEM_AUTO', 311);
  Key_OEM_AX_instance = new Key('OEM_AX', 312);
  Key_OEM_BACKTAB_instance = new Key('OEM_BACKTAB', 313);
  Key_OEM_CLEAR_instance = new Key('OEM_CLEAR', 314);
  Key_OEM_COMMA_instance = new Key('OEM_COMMA', 315);
  Key_OEM_COPY_instance = new Key('OEM_COPY', 316);
  Key_OEM_CUSEL_instance = new Key('OEM_CUSEL', 317);
  Key_OEM_ENLW_instance = new Key('OEM_ENLW', 318);
  Key_OEM_FINISH_instance = new Key('OEM_FINISH', 319);
  Key_OEM_FJ_LOYA_instance = new Key('OEM_FJ_LOYA', 320);
  Key_OEM_FJ_MASSHOU_instance = new Key('OEM_FJ_MASSHOU', 321);
  Key_OEM_FJ_ROYA_instance = new Key('OEM_FJ_ROYA', 322);
  Key_OEM_FJ_TOUROKU_instance = new Key('OEM_FJ_TOUROKU', 323);
  Key_OEM_JUMP_instance = new Key('OEM_JUMP', 324);
  Key_OEM_MINUS_instance = new Key('OEM_MINUS', 325);
  Key_OEM_PA1_instance = new Key('OEM_PA1', 326);
  Key_OEM_PA2_instance = new Key('OEM_PA2', 327);
  Key_OEM_PA3_instance = new Key('OEM_PA3', 328);
  Key_OEM_PERIOD_instance = new Key('OEM_PERIOD', 329);
  Key_OEM_PLUS_instance = new Key('OEM_PLUS', 330);
  Key_OEM_RESET_instance = new Key('OEM_RESET', 331);
  Key_OEM_WSCTRL_instance = new Key('OEM_WSCTRL', 332);
  Key_PA1_instance = new Key('PA1', 333);
  Key_PACKET_instance = new Key('PACKET', 334);
  Key_PROCESSKEY_instance = new Key('PROCESSKEY', 335);
  Key_ZOOM_instance = new Key('ZOOM', 336);
  Key_NONE_instance = new Key('NONE', 337);
  Key_ACCEPT_instance = new Key('ACCEPT', 338);
  Key_APPS_instance = new Key('APPS', 339);
  Key_BROWSER_BACK_instance = new Key('BROWSER_BACK', 340);
  Key_BROWSER_FAVORITES_instance = new Key('BROWSER_FAVORITES', 341);
  Key_BROWSER_FORWARD_instance = new Key('BROWSER_FORWARD', 342);
  Key_BROWSER_HOME_instance = new Key('BROWSER_HOME', 343);
  Key_BROWSER_REFRESH_instance = new Key('BROWSER_REFRESH', 344);
  Key_BROWSER_SEARCH_instance = new Key('BROWSER_SEARCH', 345);
  Key_BROWSER_STOP_instance = new Key('BROWSER_STOP', 346);
  Key_CAPITAL_instance = new Key('CAPITAL', 347);
  Key_CONVERT_instance = new Key('CONVERT', 348);
  Key_ICO_00_instance = new Key('ICO_00', 349);
  Key_JUNJA_instance = new Key('JUNJA', 350);
  Key_KANA_instance = new Key('KANA', 351);
  Key_KANJI_instance = new Key('KANJI', 352);
  Key_KATAKANA_HIRAGANA_instance = new Key('KATAKANA_HIRAGANA', 353);
  Key_LANGUAGE_SWITCH_instance = new Key('LANGUAGE_SWITCH', 354);
  Key_MUHENKAN_instance = new Key('MUHENKAN', 355);
  Key_LAUNCH_APP1_instance = new Key('LAUNCH_APP1', 356);
  Key_LAUNCH_APP2_instance = new Key('LAUNCH_APP2', 357);
  Key_LAUNCH_MAIL_instance = new Key('LAUNCH_MAIL', 358);
  Key_LAUNCH_MEDIA_SELECT_instance = new Key('LAUNCH_MEDIA_SELECT', 359);
  Key_LEFT_BUTTON_instance = new Key('LEFT_BUTTON', 360);
  Key_MIDDLE_BUTTON_instance = new Key('MIDDLE_BUTTON', 361);
  Key_MUSIC_instance = new Key('MUSIC', 362);
  Key_MEDIA_NEXT_TRACK_instance = new Key('MEDIA_NEXT_TRACK', 363);
  Key_MEDIA_PLAY_PAUSE_instance = new Key('MEDIA_PLAY_PAUSE', 364);
  Key_MEDIA_PREV_TRACK_instance = new Key('MEDIA_PREV_TRACK', 365);
  Key_MEDIA_STOP_instance = new Key('MEDIA_STOP', 366);
  Key_MEDIA_PLAY_instance = new Key('MEDIA_PLAY', 367);
  Key_MEDIA_PAUSE_instance = new Key('MEDIA_PAUSE', 368);
  Key_MEDIA_AUDIO_TRACK_instance = new Key('MEDIA_AUDIO_TRACK', 369);
  Key_MEDIA_CLOSE_instance = new Key('MEDIA_CLOSE', 370);
  Key_MEDIA_EJECT_instance = new Key('MEDIA_EJECT', 371);
  Key_MEDIA_FAST_FORWARD_instance = new Key('MEDIA_FAST_FORWARD', 372);
  Key_MEDIA_RECORD_instance = new Key('MEDIA_RECORD', 373);
  Key_MEDIA_REWIND_instance = new Key('MEDIA_REWIND', 374);
  Key_MEDIA_SKIP_BACKWARD_instance = new Key('MEDIA_SKIP_BACKWARD', 375);
  Key_MEDIA_SKIP_FORWARD_instance = new Key('MEDIA_SKIP_FORWARD', 376);
  Key_MEDIA_STEP_BACKWARD_instance = new Key('MEDIA_STEP_BACKWARD', 377);
  Key_MEDIA_STEP_FORWARD_instance = new Key('MEDIA_STEP_FORWARD', 378);
  Key_MEDIA_TOP_MENU_instance = new Key('MEDIA_TOP_MENU', 379);
  Key_MODECHANGE_instance = new Key('MODECHANGE', 380);
  Key_NEXT_instance = new Key('NEXT', 381);
  Key_NONCONVERT_instance = new Key('NONCONVERT', 382);
  Key_OEM_FJ_JISHO_instance = new Key('OEM_FJ_JISHO', 383);
  Key_PRIOR_instance = new Key('PRIOR', 384);
  Key_RIGHT_BUTTON_instance = new Key('RIGHT_BUTTON', 385);
  Key_LAST_CHANNEL_instance = new Key('LAST_CHANNEL', 386);
  Key_MANNER_MODE_instance = new Key('MANNER_MODE', 387);
  Key_NAVIGATE_IN_instance = new Key('NAVIGATE_IN', 388);
  Key_NAVIGATE_NEXT_instance = new Key('NAVIGATE_NEXT', 389);
  Key_NAVIGATE_OUT_instance = new Key('NAVIGATE_OUT', 390);
  Key_NAVIGATE_PREVIOUS_instance = new Key('NAVIGATE_PREVIOUS', 391);
  Key_HYPHEN_instance = new Key('HYPHEN', 392);
  Key_UNDEFINED_instance = new Key('UNDEFINED', 393);
  Key_UNKNOWN_instance = new Key('UNKNOWN', 394);
  Companion_getInstance_34();
}
function Key_SPACE_getInstance() {
  Key_initEntries();
  return Key_SPACE_instance;
}
function Key_APOSTROPHE_getInstance() {
  Key_initEntries();
  return Key_APOSTROPHE_instance;
}
function Key_COMMA_getInstance() {
  Key_initEntries();
  return Key_COMMA_instance;
}
function Key_MINUS_getInstance() {
  Key_initEntries();
  return Key_MINUS_instance;
}
function Key_PLUS_getInstance() {
  Key_initEntries();
  return Key_PLUS_instance;
}
function Key_PERIOD_getInstance() {
  Key_initEntries();
  return Key_PERIOD_instance;
}
function Key_SLASH_getInstance() {
  Key_initEntries();
  return Key_SLASH_instance;
}
function Key_N0_getInstance() {
  Key_initEntries();
  return Key_N0_instance;
}
function Key_N1_getInstance() {
  Key_initEntries();
  return Key_N1_instance;
}
function Key_N2_getInstance() {
  Key_initEntries();
  return Key_N2_instance;
}
function Key_N3_getInstance() {
  Key_initEntries();
  return Key_N3_instance;
}
function Key_N4_getInstance() {
  Key_initEntries();
  return Key_N4_instance;
}
function Key_N5_getInstance() {
  Key_initEntries();
  return Key_N5_instance;
}
function Key_N6_getInstance() {
  Key_initEntries();
  return Key_N6_instance;
}
function Key_N7_getInstance() {
  Key_initEntries();
  return Key_N7_instance;
}
function Key_N8_getInstance() {
  Key_initEntries();
  return Key_N8_instance;
}
function Key_N9_getInstance() {
  Key_initEntries();
  return Key_N9_instance;
}
function Key_SEMICOLON_getInstance() {
  Key_initEntries();
  return Key_SEMICOLON_instance;
}
function Key_A_getInstance() {
  Key_initEntries();
  return Key_A_instance;
}
function Key_B_getInstance() {
  Key_initEntries();
  return Key_B_instance;
}
function Key_C_getInstance() {
  Key_initEntries();
  return Key_C_instance;
}
function Key_D_getInstance() {
  Key_initEntries();
  return Key_D_instance;
}
function Key_E_getInstance() {
  Key_initEntries();
  return Key_E_instance;
}
function Key_F_getInstance() {
  Key_initEntries();
  return Key_F_instance;
}
function Key_G_getInstance() {
  Key_initEntries();
  return Key_G_instance;
}
function Key_H_getInstance() {
  Key_initEntries();
  return Key_H_instance;
}
function Key_I_getInstance() {
  Key_initEntries();
  return Key_I_instance;
}
function Key_J_getInstance() {
  Key_initEntries();
  return Key_J_instance;
}
function Key_K_getInstance() {
  Key_initEntries();
  return Key_K_instance;
}
function Key_L_getInstance() {
  Key_initEntries();
  return Key_L_instance;
}
function Key_M_getInstance() {
  Key_initEntries();
  return Key_M_instance;
}
function Key_N_getInstance() {
  Key_initEntries();
  return Key_N_instance;
}
function Key_O_getInstance() {
  Key_initEntries();
  return Key_O_instance;
}
function Key_P_getInstance() {
  Key_initEntries();
  return Key_P_instance;
}
function Key_Q_getInstance() {
  Key_initEntries();
  return Key_Q_instance;
}
function Key_R_getInstance() {
  Key_initEntries();
  return Key_R_instance;
}
function Key_S_getInstance() {
  Key_initEntries();
  return Key_S_instance;
}
function Key_T_getInstance() {
  Key_initEntries();
  return Key_T_instance;
}
function Key_U_getInstance() {
  Key_initEntries();
  return Key_U_instance;
}
function Key_V_getInstance() {
  Key_initEntries();
  return Key_V_instance;
}
function Key_W_getInstance() {
  Key_initEntries();
  return Key_W_instance;
}
function Key_X_getInstance() {
  Key_initEntries();
  return Key_X_instance;
}
function Key_Y_getInstance() {
  Key_initEntries();
  return Key_Y_instance;
}
function Key_Z_getInstance() {
  Key_initEntries();
  return Key_Z_instance;
}
function Key_ESCAPE_getInstance() {
  Key_initEntries();
  return Key_ESCAPE_instance;
}
function Key_META_getInstance() {
  Key_initEntries();
  return Key_META_instance;
}
function Key_ENTER_getInstance() {
  Key_initEntries();
  return Key_ENTER_instance;
}
function Key_TAB_getInstance() {
  Key_initEntries();
  return Key_TAB_instance;
}
function Key_BACKSPACE_getInstance() {
  Key_initEntries();
  return Key_BACKSPACE_instance;
}
function Key_INSERT_getInstance() {
  Key_initEntries();
  return Key_INSERT_instance;
}
function Key_DELETE_getInstance() {
  Key_initEntries();
  return Key_DELETE_instance;
}
function Key_RIGHT_getInstance() {
  Key_initEntries();
  return Key_RIGHT_instance;
}
function Key_LEFT_getInstance() {
  Key_initEntries();
  return Key_LEFT_instance;
}
function Key_DOWN_getInstance() {
  Key_initEntries();
  return Key_DOWN_instance;
}
function Key_UP_getInstance() {
  Key_initEntries();
  return Key_UP_instance;
}
function Key_PAGE_UP_getInstance() {
  Key_initEntries();
  return Key_PAGE_UP_instance;
}
function Key_PAGE_DOWN_getInstance() {
  Key_initEntries();
  return Key_PAGE_DOWN_instance;
}
function Key_HOME_getInstance() {
  Key_initEntries();
  return Key_HOME_instance;
}
function Key_END_getInstance() {
  Key_initEntries();
  return Key_END_instance;
}
function Key_F1_getInstance() {
  Key_initEntries();
  return Key_F1_instance;
}
function Key_F2_getInstance() {
  Key_initEntries();
  return Key_F2_instance;
}
function Key_F3_getInstance() {
  Key_initEntries();
  return Key_F3_instance;
}
function Key_F4_getInstance() {
  Key_initEntries();
  return Key_F4_instance;
}
function Key_F5_getInstance() {
  Key_initEntries();
  return Key_F5_instance;
}
function Key_F6_getInstance() {
  Key_initEntries();
  return Key_F6_instance;
}
function Key_F7_getInstance() {
  Key_initEntries();
  return Key_F7_instance;
}
function Key_F8_getInstance() {
  Key_initEntries();
  return Key_F8_instance;
}
function Key_F9_getInstance() {
  Key_initEntries();
  return Key_F9_instance;
}
function Key_F10_getInstance() {
  Key_initEntries();
  return Key_F10_instance;
}
function Key_F11_getInstance() {
  Key_initEntries();
  return Key_F11_instance;
}
function Key_F12_getInstance() {
  Key_initEntries();
  return Key_F12_instance;
}
function Key_F13_getInstance() {
  Key_initEntries();
  return Key_F13_instance;
}
function Key_F14_getInstance() {
  Key_initEntries();
  return Key_F14_instance;
}
function Key_F15_getInstance() {
  Key_initEntries();
  return Key_F15_instance;
}
function Key_F16_getInstance() {
  Key_initEntries();
  return Key_F16_instance;
}
function Key_F17_getInstance() {
  Key_initEntries();
  return Key_F17_instance;
}
function Key_F18_getInstance() {
  Key_initEntries();
  return Key_F18_instance;
}
function Key_F19_getInstance() {
  Key_initEntries();
  return Key_F19_instance;
}
function Key_F20_getInstance() {
  Key_initEntries();
  return Key_F20_instance;
}
function Key_F21_getInstance() {
  Key_initEntries();
  return Key_F21_instance;
}
function Key_F22_getInstance() {
  Key_initEntries();
  return Key_F22_instance;
}
function Key_F23_getInstance() {
  Key_initEntries();
  return Key_F23_instance;
}
function Key_F24_getInstance() {
  Key_initEntries();
  return Key_F24_instance;
}
function Key_F25_getInstance() {
  Key_initEntries();
  return Key_F25_instance;
}
function Key_SHIFT_getInstance() {
  Key_initEntries();
  return Key_SHIFT_instance;
}
function Key_CONTROL_getInstance() {
  Key_initEntries();
  return Key_CONTROL_instance;
}
function Key_ALT_getInstance() {
  Key_initEntries();
  return Key_ALT_instance;
}
function Key_SUPER_getInstance() {
  Key_initEntries();
  return Key_SUPER_instance;
}
function Key_QUOTE_getInstance() {
  Key_initEntries();
  return Key_QUOTE_instance;
}
function Key_UNKNOWN_getInstance() {
  Key_initEntries();
  return Key_UNKNOWN_instance;
}
var MouseButton_LEFT_instance;
var MouseButton_MIDDLE_instance;
var MouseButton_RIGHT_instance;
var MouseButton_BUTTON3_instance;
var MouseButton_BUTTON4_instance;
var MouseButton_BUTTON5_instance;
var MouseButton_BUTTON6_instance;
var MouseButton_BUTTON7_instance;
var MouseButton_BUTTON_WHEEL_instance;
var MouseButton_BUTTON_UNKNOWN_instance;
var MouseButton_NONE_instance;
var Companion_instance_29;
function Companion_getInstance_35() {
  MouseButton_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_20();
  return Companion_instance_29;
}
function values_6() {
  return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
}
var MouseButton_entriesInitialized;
function MouseButton_initEntries() {
  if (MouseButton_entriesInitialized)
    return Unit_instance;
  MouseButton_entriesInitialized = true;
  MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
  MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
  MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
  MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
  MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
  MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
  MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
  MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
  MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
  MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 10);
  MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
  Companion_getInstance_35();
}
function MouseButton_LEFT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_LEFT_instance;
}
function MouseButton_MIDDLE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_MIDDLE_instance;
}
function MouseButton_RIGHT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_RIGHT_instance;
}
function MouseButton_BUTTON3_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON3_instance;
}
function MouseButton_BUTTON4_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON4_instance;
}
function MouseButton_BUTTON5_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON5_instance;
}
function MouseButton_BUTTON6_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON6_instance;
}
function MouseButton_BUTTON7_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON7_instance;
}
function MouseButton_BUTTON_WHEEL_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_WHEEL_instance;
}
function MouseButton_BUTTON_UNKNOWN_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_UNKNOWN_instance;
}
function MouseButton_NONE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_NONE_instance;
}
var Companion_instance_30;
function Companion_getInstance_36() {
  if (Companion_instance_30 === VOID)
    new Companion_21();
  return Companion_instance_30;
}
function draw(_this__u8e3s4, frameBuffer, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
  indices = indices === VOID ? null : indices;
  indexType = indexType === VOID ? Companion_getInstance_41().h84_1 : indexType;
  drawOffset = drawOffset === VOID ? 0 : drawOffset;
  blending = blending === VOID ? Companion_getInstance_42().l84_1 : blending;
  uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_58().p84_1 : uniformBlocks;
  textureUnits = textureUnits === VOID ? Companion_instance_31.r84() : textureUnits;
  stencilRef = stencilRef === VOID ? Companion_getInstance_45().t84_1 : stencilRef;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_46().v84_1 : stencilOpFunc;
  colorMask = colorMask === VOID ? Companion_getInstance_47().z84_1 : colorMask;
  depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_48().d85_1 : depthAndFrontFace;
  scissor = scissor === VOID ? Companion_getInstance_43().h85_1 : scissor;
  cullFace = cullFace === VOID ? Companion_getInstance_49().j85_1 : cullFace;
  instances = instances === VOID ? 1 : instances;
  return _this__u8e3s4.b84(frameBuffer.h83_1, frameBuffer.n85(), vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances);
}
function draw_0(_this__u8e3s4, batch) {
  return batch.w85(_this__u8e3s4);
}
function upload($this, data, needClone) {
  var tmp0_safe_receiver = $this.b86_1;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p2c()) === data.p2c()) {
    if (data.p2c() < 1024 && Companion_instance_4.h2c(data, 0, ensureNotNull($this.b86_1), 0, data.p2c())) {
      return $this;
    }
    Companion_instance_4.g2c(data, 0, ensureNotNull($this.b86_1), 0, data.p2c());
  } else {
    $this.b86_1 = needClone ? clone(data) : data;
  }
  $this.g86();
  return $this;
}
var Companion_instance_31;
function Companion_getInstance_37() {
  return Companion_instance_31;
}
var Companion_instance_32;
function Companion_getInstance_38() {
  return Companion_instance_32;
}
function markAsDirty($this) {
}
function checkBitmaps($this, bmp) {
  if (!bmp.x56_1) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.b88_1;
    var level = Level_ERROR_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.graphics.AGTexture.checkBitmaps.<anonymous>' call
      var tmp$ret$0 = 'Trying to upload a non-premultiplied bitmap: ' + toString(bmp) + '. This will cause rendering artifacts';
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
}
function _AGTextureUnitInfoArray___init__impl__c77rdb(data) {
  return data;
}
function _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this) {
  return $this;
}
function _AGTextureUnitInfoArray___init__impl__c77rdb_0(size) {
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    tmp_0[tmp] = _AGTextureUnitInfo___get_data__impl__oupy3n(Companion_getInstance_39().f87_1);
    tmp = tmp + 1 | 0;
  }
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp_0);
}
function AGTextureUnitInfoArray__set_impl_s95rfh($this, index, value) {
  _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index] = _AGTextureUnitInfo___get_data__impl__oupy3n(value);
}
function AGTextureUnitInfoArray__get_impl_xhvpef($this, index) {
  return Companion_getInstance_39().l89(_AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index]);
}
function AGTextureUnitInfoArray__copyOf_impl_z2w8z3($this) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this).slice();
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp$ret$1);
}
function AGTextureUnitInfoArray__toString_impl_kr9cgh($this) {
  return 'AGTextureUnitInfoArray(data=' + toString($this) + ')';
}
function AGTextureUnitInfoArray__hashCode_impl_siosps($this) {
  return hashCode($this);
}
function _AGTextureUnitInfo___init__impl__s1tthu(data) {
  return data;
}
function _AGTextureUnitInfo___get_data__impl__oupy3n($this) {
  return $this;
}
var Companion_instance_33;
function Companion_getInstance_39() {
  if (Companion_instance_33 === VOID)
    new Companion_24();
  return Companion_instance_33;
}
function _AGTextureUnitInfo___get_wrap__impl__dwp6l($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 0 | 0) & 3;
  return _AGWrapMode___init__impl__x5wmya(tmp$ret$0);
}
function _AGTextureUnitInfo___get_linear__impl__jak6ny($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 2 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 3 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_kind__impl__6xtjoz($this) {
  return _AGTextureTargetKind___init__impl__4zdmch(extract(_AGTextureUnitInfo___get_data__impl__oupy3n($this), 8, 5));
}
function AGTextureUnitInfo__withKind_impl_aa0b04($this, kind) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert5(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGTextureTargetKind___get_ordinal__impl__gjzc5p(kind), 8));
}
function AGTextureUnitInfo__withWrap_impl_akwb6y($this, wrap) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert2(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGWrapMode___get_ordinal__impl__rc38w2(wrap), 0));
}
function AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), linear, 2));
}
function AGTextureUnitInfo__withTrilinear_impl_vhkcy2($this, trilinear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), trilinear, 3));
}
function AGTextureUnitInfo__withLinearTrilinear_impl_aactvz($this, linear, trilinear) {
  return AGTextureUnitInfo__withTrilinear_impl_vhkcy2(AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear), trilinear);
}
function _AGDrawType___init__impl__emm6mb(ordinal) {
  return ordinal;
}
var Companion_instance_34;
function Companion_getInstance_40() {
  if (Companion_instance_34 === VOID)
    new Companion_25();
  return Companion_instance_34;
}
function AGDrawType__toString_impl_eonaeb($this) {
  return $this === Companion_getInstance_40().k8c_1 ? 'POINTS' : $this === Companion_getInstance_40().l8c_1 ? 'LINE_STRIP' : $this === Companion_getInstance_40().m8c_1 ? 'LINE_LOOP' : $this === Companion_getInstance_40().n8c_1 ? 'LINES' : $this === Companion_getInstance_40().o8c_1 ? 'TRIANGLES' : $this === Companion_getInstance_40().p8c_1 ? 'TRIANGLE_STRIP' : $this === Companion_getInstance_40().q8c_1 ? 'TRIANGLE_FAN' : '-';
}
function AGDrawType__hashCode_impl_ylaury($this) {
  return $this;
}
function _AGIndexType___init__impl__yqnmb7(ordinal) {
  return ordinal;
}
var Companion_instance_35;
function Companion_getInstance_41() {
  if (Companion_instance_35 === VOID)
    new Companion_26();
  return Companion_instance_35;
}
function AGIndexType__toString_impl_hjqwm3($this) {
  return $this === Companion_getInstance_41().f84_1 ? 'null' : $this === Companion_getInstance_41().g84_1 ? 'UBYTE' : $this === Companion_getInstance_41().h84_1 ? 'USHORT' : $this === Companion_getInstance_41().i84_1 ? 'UINT' : '-';
}
function AGIndexType__hashCode_impl_47f06s($this) {
  return $this;
}
function _AGBlending___init__impl__upt3bq(data) {
  return data;
}
function _AGBlending___get_data__impl__7m3zd1($this) {
  return $this;
}
function _AGBlending___get_srcRGB__impl__jvh03e($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 0 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_srcA__impl__ftmwxe($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 4 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstRGB__impl__nz9ogp($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 8 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstA__impl__l7q6tv($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 12 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_eqRGB__impl__7pv8oi($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 16 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function _AGBlending___get_eqA__impl__2j4ray($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 18 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function AGBlending__withSRC_impl_hh0mjq($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 0), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 4));
}
function AGBlending__withSRC$default_impl_uuu5hz($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withSRC_impl_hh0mjq($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).s8c.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).r8c_1;
  }
  return tmp;
}
function AGBlending__withDST_impl_y1hpet($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 8), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 12));
}
function AGBlending__withDST$default_impl_leu6qg($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withDST_impl_y1hpet($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).t8c.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).r8c_1;
  }
  return tmp;
}
function AGBlending__withEQ_impl_e9gm04($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert2(insert2(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendEquation___get_ordinal__impl__895p3q(rgb), 16), _AGBlendEquation___get_ordinal__impl__895p3q(a), 18));
}
function AGBlending__withEQ$default_impl_iltiw7($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withEQ_impl_e9gm04($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).u8c.call(new AGBlending($this), new AGBlendEquation(rgb), new AGBlendEquation(a)).r8c_1;
  }
  return tmp;
}
function _AGBlending___get_enabled__impl__s7igz6($this) {
  return !($this === Companion_getInstance_42().k84_1);
}
function AGBlending__toString_impl_d5hic6($this) {
  return 'Blending(outRGB = (srcRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcRGB__impl__jvh03e($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqRGB__impl__7pv8oi($this)) + ' (dstRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstRGB__impl__nz9ogp($this)) + '), outA = (srcA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcA__impl__ftmwxe($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqA__impl__2j4ray($this)) + ' (dstA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstA__impl__l7q6tv($this)) + '))';
}
var Companion_instance_36;
function Companion_getInstance_42() {
  if (Companion_instance_36 === VOID)
    new Companion_27();
  return Companion_instance_36;
}
function AGBlending__hashCode_impl_ywnf51($this) {
  return $this;
}
function AGBlending__equals_impl_rp3dmf($this, other) {
  if (!(other instanceof AGBlending))
    return false;
  if (!($this === (other instanceof AGBlending ? other.r8c_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_37;
function Companion_getInstance_43() {
  if (Companion_instance_37 === VOID)
    new Companion_28();
  return Companion_instance_37;
}
function _AGFrameBufferInfo___init__impl__dbxiro(dataLong) {
  return dataLong;
}
function _AGFrameBufferInfo___get_dataLong__impl__7vov5d($this) {
  return $this;
}
function _AGFrameBufferInfo___get_data__impl__7q146j($this) {
  return get_low(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___get_data2__impl__rgyo5b($this) {
  return get_high(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___init__impl__dbxiro_0(data, data2) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(data).h4(new Long(-1, 0)).i4(toLong(data2).e4(32));
  return _AGFrameBufferInfo___init__impl__dbxiro(tmp$ret$0);
}
function _AGFrameBufferInfo___get_width__impl__yhp94z($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_height__impl__yfespa($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_x__impl__6dzfjj($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_y__impl__mfn1io($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_size__impl__uw80y4($this) {
  return Companion_instance_48.y8d(_AGFrameBufferInfo___get_width__impl__yhp94z($this), _AGFrameBufferInfo___get_height__impl__yfespa($this));
}
function _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 28 | 0) & 1) === 0);
}
function _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 29 | 0) & 1) === 0);
}
function _get_samplesBits__rfaq0u($this) {
  // Inline function 'korlibs.memory.extract2' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 30 | 0) & 3;
}
function _AGFrameBufferInfo___get_samples__impl__7k555s($this) {
  return 1 << _get_samplesBits__rfaq0u($this);
}
function _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj($this) {
  return _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) && _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this);
}
function AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(_AGFrameBufferInfo___get_data__impl__7q146j($this), insert14(insert14(_AGFrameBufferInfo___get_data2__impl__rgyo5b($this), x, 0), y, 14));
}
function AGFrameBufferInfo__withSize_impl_sc5iep($this, width, height) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert14(insert14(_AGFrameBufferInfo___get_data__impl__7q146j($this), width, 0), height, 14), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withBounds_impl_sg0n3x($this, x, y, width, height) {
  return AGFrameBufferInfo__withSize_impl_sc5iep(AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y), width, height);
}
function AGFrameBufferInfo__withHasDepth_impl_fjgbiv($this, hasDepth) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasDepth, 28), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withHasStencil_impl_nbaemo($this, hasStencil) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasStencil, 29), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withSamples_impl_83818f($this, samples) {
  return withSamplesBits($this, ilog2(samples));
}
function withSamplesBits($this, bits) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert2(_AGFrameBufferInfo___get_data__impl__7q146j($this), bits, 30), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__toString_impl_xecyr8($this) {
  return 'AGFrameBufferInfo(width=' + _AGFrameBufferInfo___get_width__impl__yhp94z($this) + ', height=' + _AGFrameBufferInfo___get_height__impl__yfespa($this) + ', hasDepth=' + _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) + ', hasStencil=' + _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) + ', samples=' + _AGFrameBufferInfo___get_samples__impl__7k555s($this) + ')';
}
var Companion_instance_38;
function Companion_getInstance_44() {
  if (Companion_instance_38 === VOID)
    new Companion_29();
  return Companion_instance_38;
}
function AGFrameBufferInfo__hashCode_impl_fvl6f1($this) {
  return $this.hashCode();
}
var AGFinish_instance;
function AGFinish_getInstance() {
  return AGFinish_instance;
}
function _AGStencilReference___init__impl__rta8vg(data) {
  return data;
}
function _AGStencilReference___get_data__impl__j5p6bn($this) {
  return $this;
}
function _AGStencilReference___init__impl__rta8vg_0(front, back) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(front).h4(new Long(-1, 0)).i4(toLong(back).e4(32));
  return _AGStencilReference___init__impl__rta8vg(tmp$ret$0);
}
var Companion_instance_39;
function Companion_getInstance_45() {
  if (Companion_instance_39 === VOID)
    new Companion_30();
  return Companion_instance_39;
}
function _AGStencilReference___get_front__impl__6ggyy0($this) {
  return get_low(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_back__impl__mm7fqe($this) {
  return get_high(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskFront__impl__oc0s46($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 16 | 0) & 255;
}
function _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskBack__impl__mths73($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 16 | 0) & 255;
}
function AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), referenceValue, 0), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), referenceValueBack, 0));
}
function AGStencilReference__withReferenceValue$default_impl_2trj0v($this, referenceValue, referenceValueBack, $super) {
  referenceValueBack = referenceValueBack === VOID ? referenceValue : referenceValueBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).k8e.call(new AGStencilReference($this), referenceValue, referenceValueBack).j8e_1;
  }
  return tmp;
}
function AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), readMask, 8), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), readMaskBack, 8));
}
function AGStencilReference__withReadMask$default_impl_7mdffx($this, readMask, readMaskBack, $super) {
  readMaskBack = readMaskBack === VOID ? readMask : readMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).l8e.call(new AGStencilReference($this), readMask, readMaskBack).j8e_1;
  }
  return tmp;
}
function AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), writeMask, 16), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), writeMaskBack, 16));
}
function AGStencilReference__withWriteMask$default_impl_b7j7b4($this, writeMask, writeMaskBack, $super) {
  writeMaskBack = writeMaskBack === VOID ? writeMask : writeMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).m8e.call(new AGStencilReference($this), writeMask, writeMaskBack).j8e_1;
  }
  return tmp;
}
function AGStencilReference__toString_impl_qu5r8s($this) {
  return 'AGStencilReference(front=[referenceValue=' + _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) + ', readMask=' + _AGStencilReference___get_readMaskFront__impl__oc0s46($this) + ', writeMask=' + _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) + '], back=[referenceValue=' + _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) + ', readMask=' + _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) + ', writeMask=' + _AGStencilReference___get_writeMaskBack__impl__mths73($this) + '])';
}
function AGStencilReference__hashCode_impl_52zufx($this) {
  return $this.hashCode();
}
function AGStencilReference__equals_impl_kj05j($this, other) {
  if (!(other instanceof AGStencilReference))
    return false;
  var tmp0_other_with_cast = other instanceof AGStencilReference ? other.j8e_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function _AGStencilOpFunc___init__impl__t3f62q(data) {
  return data;
}
function _AGStencilOpFunc___get_data__impl__jitrg1($this) {
  return $this;
}
var Companion_instance_40;
function Companion_getInstance_46() {
  if (Companion_instance_40 === VOID)
    new Companion_31();
  return Companion_instance_40;
}
function _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 31 | 0) & 1) === 0);
}
function _AGStencilOpFunc___get_compareModeFront__impl__uctsey($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 0 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 3 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 6 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 9 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 12 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 15 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 18 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 21 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function AGStencilOpFunc__withEnabled_impl_mpcwmr($this, enabled) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert(_AGStencilOpFunc___get_data__impl__jitrg1($this), enabled, 31));
}
function AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGCompareMode___get_ordinal__impl__ikvlmz(compareMode), 0), _AGCompareMode___get_ordinal__impl__ikvlmz(compareModeBack), 12));
}
function AGStencilOpFunc__withCompareMode$default_impl_rzbauv($this, compareMode, compareModeBack, $super) {
  compareModeBack = compareModeBack === VOID ? compareMode : compareModeBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).e8f.call(new AGStencilOpFunc($this), new AGCompareMode(compareMode), new AGCompareMode(compareModeBack)).d8f_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPass), 3), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPassBack), 15));
}
function AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFail), 6), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFailBack), 18));
}
function AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFail), 9), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFailBack), 21));
}
function AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack) {
  return AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35(AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te(AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack), actionOnDepthFail, actionOnDepthFailBack), actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
}
function AGStencilOpFunc__withAction$default_impl_jx9cm1($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack, $super) {
  actionOnDepthFail = actionOnDepthFail === VOID ? actionOnBothPass : actionOnDepthFail;
  actionOnDepthPassStencilFail = actionOnDepthPassStencilFail === VOID ? actionOnDepthFail : actionOnDepthPassStencilFail;
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
  actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).f8f.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnBothPassBack), new AGStencilOp(actionOnDepthFailBack), new AGStencilOp(actionOnDepthPassStencilFailBack)).d8f_1;
  }
  return tmp;
}
function AGStencilOpFunc__toString_impl_pl8quy($this) {
  if (!_AGStencilOpFunc___get_enabled__impl__hxq8wy($this))
    return 'AGStencilOpFunc(enabled=false)';
  return 'AGStencilOpFunc(enabled=' + _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) + ', front=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeFront__impl__uctsey($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this)) + ']], back=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this)) + ']])';
}
function AGStencilOpFunc__hashCode_impl_nopebb($this) {
  return $this;
}
function AGStencilOpFunc__equals_impl_y44i4z($this, other) {
  if (!(other instanceof AGStencilOpFunc))
    return false;
  if (!($this === (other instanceof AGStencilOpFunc ? other.d8f_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGColorMask___init__impl__j38ai8(data) {
  return data;
}
function _AGColorMask___get_data__impl__swj1bz($this) {
  return $this;
}
function _AGColorMask___get_red__impl__opo1fo($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 0 | 0) & 1) === 0);
}
function _AGColorMask___get_green__impl__d3m1w2($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 1 | 0) & 1) === 0);
}
function _AGColorMask___get_blue__impl__42l0s1($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 2 | 0) & 1) === 0);
}
function _AGColorMask___get_alpha__impl__xmrqzb($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 3 | 0) & 1) === 0);
}
function _AGColorMask___init__impl__j38ai8_0(red, green, blue, alpha) {
  return _AGColorMask___init__impl__j38ai8(insert(insert(insert(insert(0, red, 0), green, 1), blue, 2), alpha, 3));
}
function _AGColorMask___init__impl__j38ai8_1(value) {
  value = value === VOID ? true : value;
  return _AGColorMask___init__impl__j38ai8_0(value, value, value, value);
}
function AGColorMask__toString_impl_5i5oqg($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.AGColorMask.toString.<anonymous>' call
  this_0.gc('AGColorMask(');
  this_0.gc(_AGColorMask___get_red__impl__opo1fo($this) ? 'R' : 'r');
  this_0.gc(_AGColorMask___get_green__impl__d3m1w2($this) ? 'G' : 'g');
  this_0.gc(_AGColorMask___get_blue__impl__42l0s1($this) ? 'B' : 'b');
  this_0.gc(_AGColorMask___get_alpha__impl__xmrqzb($this) ? 'A' : 'a');
  this_0.gc(')');
  return this_0.toString();
}
var Companion_instance_41;
function Companion_getInstance_47() {
  if (Companion_instance_41 === VOID)
    new Companion_32();
  return Companion_instance_41;
}
function AGColorMask__hashCode_impl_g9082f($this) {
  return $this;
}
function _AGDepthAndFrontFace___init__impl__ra8x65(data) {
  return data;
}
function _AGDepthAndFrontFace___get_data__impl__v8zkce($this) {
  return $this;
}
var Companion_instance_42;
function Companion_getInstance_48() {
  if (Companion_instance_42 === VOID)
    new Companion_33();
  return Companion_instance_42;
}
function _AGDepthAndFrontFace___get_depthNear__impl__cir3a1($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 0, 12);
}
function _AGDepthAndFrontFace___get_depthFar__impl__g0cno8($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 12, 12);
}
function _AGDepthAndFrontFace___get_depthMask__impl__ouijn($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 24 | 0) & 1) === 0);
}
function _AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 26 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGDepthAndFrontFace___get_frontFace__impl__w07k4s($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 30 | 0) & 3;
  return _AGFrontFace___init__impl__vsm7rb(tmp$ret$0);
}
function AGDepthAndFrontFace__withDepth_impl_wsx82k($this, near, far) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insertScaledf01(insertScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), near, 0, 12), far, 12, 12));
}
function AGDepthAndFrontFace__withDepthMask_impl_610nhs($this, depthMask) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), depthMask, 24));
}
function AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs($this, depthFunc) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert3(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGCompareMode___get_ordinal__impl__ikvlmz(depthFunc), 26));
}
function AGDepthAndFrontFace__withFrontFace_impl_mwk87t($this, frontFace) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert2(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGFrontFace___get_ordinal__impl__d4iagj(frontFace), 30));
}
function AGDepthAndFrontFace__toString_impl_c305m3($this) {
  return 'AGDepthAndFrontFace(data=' + $this + ')';
}
function AGDepthAndFrontFace__hashCode_impl_xu62ey($this) {
  return $this;
}
function _AGCullFace___init__impl__ckmjdg(ordinal) {
  return ordinal;
}
function _AGCullFace___get_ordinal__impl__jd1wps($this) {
  return $this;
}
var Companion_instance_43;
function Companion_getInstance_49() {
  if (Companion_instance_43 === VOID)
    new Companion_34();
  return Companion_instance_43;
}
function AGCullFace__toString_impl_7d891w($this) {
  return $this === Companion_getInstance_49().j85_1 ? 'NONE' : $this === Companion_getInstance_49().m85_1 ? 'BOTH' : $this === Companion_getInstance_49().k85_1 ? 'FRONT' : $this === Companion_getInstance_49().l85_1 ? 'BACK' : '-';
}
function AGCullFace__hashCode_impl_t4e5ur($this) {
  return $this;
}
function _AGTextureTargetKind___init__impl__4zdmch(ordinal) {
  return ordinal;
}
function _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) {
  return $this;
}
function AGTextureTargetKind__toString_impl_68648p($this) {
  return $this === Companion_getInstance_50().n88_1 ? 'TEXTURE_2D' : $this === Companion_getInstance_50().o88_1 ? 'TEXTURE_3D' : $this === Companion_getInstance_50().p88_1 ? 'TEXTURE_CUBE_MAP' : $this === Companion_getInstance_50().q88_1 ? 'EXTERNAL_TEXTURE' : 'AGTextureTargetKind(' + _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) + ')';
}
function _AGTextureTargetKind___get_dims__impl__k3cmhd($this) {
  return $this === Companion_getInstance_50().n88_1 ? 2 : $this === Companion_getInstance_50().o88_1 ? 3 : $this === Companion_getInstance_50().p88_1 ? 3 : $this === Companion_getInstance_50().q88_1 ? 3 : 0;
}
var Companion_instance_44;
function Companion_getInstance_50() {
  if (Companion_instance_44 === VOID)
    new Companion_35();
  return Companion_instance_44;
}
function AGTextureTargetKind__hashCode_impl_rzc11k($this) {
  return $this;
}
function AGTextureTargetKind__equals_impl_q2tams($this, other) {
  if (!(other instanceof AGTextureTargetKind))
    return false;
  if (!($this === (other instanceof AGTextureTargetKind ? other.s88_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGWrapMode___init__impl__x5wmya(ordinal) {
  return ordinal;
}
function _AGWrapMode___get_ordinal__impl__rc38w2($this) {
  return $this;
}
var Companion_instance_45;
function Companion_getInstance_51() {
  if (Companion_instance_45 === VOID)
    new Companion_36();
  return Companion_instance_45;
}
function AGWrapMode__toString_impl_8bjnw2($this) {
  return $this === Companion_getInstance_51().m89_1 ? 'CLAMP_TO_EDGE' : $this === Companion_getInstance_51().n89_1 ? 'REPEAT' : $this === Companion_getInstance_51().o89_1 ? 'MIRRORED_REPEAT' : '<' + _AGWrapMode___get_ordinal__impl__rc38w2($this) + '>';
}
function AGWrapMode__hashCode_impl_u2pkox($this) {
  return $this;
}
function AGWrapMode__equals_impl_4aw0kl($this, other) {
  if (!(other instanceof AGWrapMode))
    return false;
  if (!($this === (other instanceof AGWrapMode ? other.x8g_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendFactor___init__impl__iqtmxr(ordinal) {
  return ordinal;
}
function _AGBlendFactor___get_ordinal__impl__r9efzn($this) {
  return $this;
}
var Companion_instance_46;
function Companion_getInstance_52() {
  if (Companion_instance_46 === VOID)
    new Companion_37();
  return Companion_instance_46;
}
function AGBlendFactor__toString_impl_1hr6m1($this) {
  return $this === Companion_getInstance_52().v8c_1 ? 'DESTINATION_ALPHA' : $this === Companion_getInstance_52().w8c_1 ? 'DESTINATION_COLOR' : $this === Companion_getInstance_52().x8c_1 ? 'ONE' : $this === Companion_getInstance_52().y8c_1 ? 'ONE_MINUS_DESTINATION_ALPHA' : $this === Companion_getInstance_52().z8c_1 ? 'ONE_MINUS_DESTINATION_COLOR' : $this === Companion_getInstance_52().a8d_1 ? 'ONE_MINUS_SOURCE_ALPHA' : $this === Companion_getInstance_52().b8d_1 ? 'ONE_MINUS_SOURCE_COLOR' : $this === Companion_getInstance_52().c8d_1 ? 'SOURCE_ALPHA' : $this === Companion_getInstance_52().d8d_1 ? 'SOURCE_COLOR' : $this === Companion_getInstance_52().e8d_1 ? 'ZERO' : '-';
}
function _AGBlendFactor___get_op__impl__b5pfnd($this) {
  var tmp;
  if ($this === Companion_getInstance_52().v8c_1) {
    tmp = 'dstA';
  } else if ($this === Companion_getInstance_52().w8c_1) {
    tmp = 'dstRGB';
  } else if ($this === Companion_getInstance_52().x8c_1) {
    tmp = '1';
  } else if ($this === Companion_getInstance_52().y8c_1) {
    tmp = '(1 - dstA)';
  } else if ($this === Companion_getInstance_52().z8c_1) {
    tmp = '(1 - dstRGB)';
  } else if ($this === Companion_getInstance_52().a8d_1) {
    tmp = '(1 - srcA)';
  } else if ($this === Companion_getInstance_52().b8d_1) {
    tmp = '(1 - srcRGB)';
  } else if ($this === Companion_getInstance_52().c8d_1) {
    tmp = 'srcA';
  } else if ($this === Companion_getInstance_52().d8d_1) {
    tmp = 'srcRGB';
  } else if ($this === Companion_getInstance_52().e8d_1) {
    tmp = '0';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendFactor__hashCode_impl_n8x3ew($this) {
  return $this;
}
function AGBlendFactor__equals_impl_dlauac($this, other) {
  if (!(other instanceof AGBlendFactor))
    return false;
  if (!($this === (other instanceof AGBlendFactor ? other.y8g_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendEquation___init__impl__fpv7c2(ordinal) {
  return ordinal;
}
function _AGBlendEquation___get_ordinal__impl__895p3q($this) {
  return $this;
}
var Companion_instance_47;
function Companion_getInstance_53() {
  if (Companion_instance_47 === VOID)
    new Companion_38();
  return Companion_instance_47;
}
function AGBlendEquation__toString_impl_5t2sx6($this) {
  return $this === Companion_getInstance_53().i8d_1 ? 'ADD' : $this === Companion_getInstance_53().j8d_1 ? 'SUBTRACT' : $this === Companion_getInstance_53().k8d_1 ? 'REVERSE_SUBTRACT' : '-';
}
function _AGBlendEquation___get_op__impl__7f9os6($this) {
  var tmp;
  if ($this === Companion_getInstance_53().i8d_1) {
    tmp = '+';
  } else if ($this === Companion_getInstance_53().j8d_1) {
    tmp = '-';
  } else if ($this === Companion_getInstance_53().k8d_1) {
    tmp = 'r-';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendEquation__hashCode_impl_fy33vp($this) {
  return $this;
}
function AGBlendEquation__equals_impl_yykk3b($this, other) {
  if (!(other instanceof AGBlendEquation))
    return false;
  if (!($this === (other instanceof AGBlendEquation ? other.z8g_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGSize___init__impl__h9blcq(data) {
  return data;
}
function AGSize__with_impl_qn6qww($this, width, height) {
  return _AGSize___init__impl__h9blcq(insert_0(insert_0(0, width, 0, 16), height, 16, 16));
}
var Companion_instance_48;
function Companion_getInstance_54() {
  return Companion_instance_48;
}
function _AGStencilOp___init__impl__llpkv6(ordinal) {
  return ordinal;
}
function _AGStencilOp___get_ordinal__impl__xkavfu($this) {
  return $this;
}
var Companion_instance_49;
function Companion_getInstance_55() {
  if (Companion_instance_49 === VOID)
    new Companion_40();
  return Companion_instance_49;
}
function AGStencilOp__toString_impl_1dm6fq($this) {
  return $this === Companion_getInstance_55().v8e_1 ? 'DECREMENT_SATURATE' : $this === Companion_getInstance_55().w8e_1 ? 'DECREMENT_WRAP' : $this === Companion_getInstance_55().x8e_1 ? 'INCREMENT_SATURATE' : $this === Companion_getInstance_55().y8e_1 ? 'INCREMENT_WRAP' : $this === Companion_getInstance_55().z8e_1 ? 'INVERT' : $this === Companion_getInstance_55().a8f_1 ? 'KEEP' : $this === Companion_getInstance_55().b8f_1 ? 'SET' : $this === Companion_getInstance_55().c8f_1 ? 'ZERO' : '-';
}
function AGStencilOp__hashCode_impl_n4s38l($this) {
  return $this;
}
function AGStencilOp__equals_impl_rq4p55($this, other) {
  if (!(other instanceof AGStencilOp))
    return false;
  if (!($this === (other instanceof AGStencilOp ? other.b8h_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGCompareMode___init__impl__j8kqbb(ordinal) {
  return ordinal;
}
function _AGCompareMode___get_ordinal__impl__ikvlmz($this) {
  return $this;
}
var Companion_instance_50;
function Companion_getInstance_56() {
  if (Companion_instance_50 === VOID)
    new Companion_41();
  return Companion_instance_50;
}
function AGCompareMode__toString_impl_gs33a9($this) {
  return $this === Companion_getInstance_56().n8e_1 ? 'ALWAYS' : $this === Companion_getInstance_56().o8e_1 ? 'EQUAL' : $this === Companion_getInstance_56().p8e_1 ? 'GREATER' : $this === Companion_getInstance_56().q8e_1 ? 'GREATER_EQUAL' : $this === Companion_getInstance_56().r8e_1 ? 'LESS' : $this === Companion_getInstance_56().s8e_1 ? 'LESS_EQUAL' : $this === Companion_getInstance_56().t8e_1 ? 'NEVER' : $this === Companion_getInstance_56().u8e_1 ? 'NOT_EQUAL' : '-';
}
function AGCompareMode__hashCode_impl_whv1w0($this) {
  return $this;
}
function AGCompareMode__equals_impl_rbniy4($this, other) {
  if (!(other instanceof AGCompareMode))
    return false;
  if (!($this === (other instanceof AGCompareMode ? other.c8h_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGFrontFace___init__impl__vsm7rb(ordinal) {
  return ordinal;
}
function _AGFrontFace___get_ordinal__impl__d4iagj($this) {
  return $this;
}
var Companion_instance_51;
function Companion_getInstance_57() {
  if (Companion_instance_51 === VOID)
    new Companion_42();
  return Companion_instance_51;
}
var AGBufferKind_INDEX_instance;
var AGBufferKind_VERTEX_instance;
var AGBufferKind_UNIFORM_instance;
var AGBufferKind_entriesInitialized;
function AGBufferKind_initEntries() {
  if (AGBufferKind_entriesInitialized)
    return Unit_instance;
  AGBufferKind_entriesInitialized = true;
  AGBufferKind_INDEX_instance = new AGBufferKind('INDEX', 0);
  AGBufferKind_VERTEX_instance = new AGBufferKind('VERTEX', 1);
  AGBufferKind_UNIFORM_instance = new AGBufferKind('UNIFORM', 2);
}
function AGBufferKind_INDEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_INDEX_instance;
}
function AGBufferKind_VERTEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_VERTEX_instance;
}
function AGBufferKind_UNIFORM_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_UNIFORM_instance;
}
var ProjViewUB_instance;
function ProjViewUB_getInstance() {
  if (ProjViewUB_instance === VOID)
    new ProjViewUB();
  return ProjViewUB_instance;
}
var DefaultShaders_instance;
function DefaultShaders_getInstance() {
  if (DefaultShaders_instance === VOID)
    new DefaultShaders();
  return DefaultShaders_instance;
}
function u_Tex$factory() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.v8k();
  }, null);
}
function u_TexEx$factory() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.x8k();
  }, null);
}
function u_Tex$factory_0() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.v8k();
  }, null);
}
function u_TexEx$factory_0() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.x8k();
  }, null);
}
function u_ProjMat$factory() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.e8i();
  }, null);
}
function u_ViewMat$factory() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.f8i();
  }, null);
}
function u_ProjMat$factory_0() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.e8i();
  }, null);
}
function u_ViewMat$factory_0() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.f8i();
  }, null);
}
function get_ENABLE_UNIFORM_BLOCKS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_UNIFORM_BLOCKS;
}
var ENABLE_UNIFORM_BLOCKS;
function get_ENABLE_VERTEX_ARRAY_OBJECTS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_VERTEX_ARRAY_OBJECTS;
}
var ENABLE_VERTEX_ARRAY_OBJECTS;
function set_gl(_this__u8e3s4, _set____db54di) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var this_0 = gl$delegate;
  var property = gl$factory();
  var value = this_0.i28_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.g28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_gl(_this__u8e3s4) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = gl$delegate;
    var property = gl$factory_0();
    var tmp0_elvis_lhs = this_0.g28_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.h28_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.g28_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var gl$delegate;
function useProgram($this, program) {
  var gl = $this.v8m_1;
  var map = $this.z8m_1;
  if ($this.a8n_1 == null) {
    $this.a8n_1 = gl.f8o(35724);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_36().a83_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$0 = 'GL_VERSION=' + gl.f8o(7938);
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_36().a83_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.q46(level_0)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$2 = 'GL_SHADING_LANGUAGE_VERSION=' + $this.a8n_1;
      this_1.r46(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_36().a83_1;
    var level_1 = Level_INFO_getInstance();
    var tmp_1;
    if (this_2.q46(level_1)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$4 = 'GL_UNIFORM_BUFFER_OFFSET_ALIGNMENT=' + getInteger(gl, 35380);
      this_2.r46(level_1, tmp$ret$4);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_3 = Companion_getInstance_36().a83_1;
    var level_2 = Level_INFO_getInstance();
    var tmp_2;
    if (this_3.q46(level_2)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$6 = 'gl.versionString=' + get_versionString(gl);
      this_3.r46(level_2, tmp$ret$6);
      tmp_2 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_4 = Companion_getInstance_36().a83_1;
    var level_3 = Level_INFO_getInstance();
    var tmp_3;
    if (this_4.q46(level_3)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$8 = 'gl.versionInt=' + get_versionInt(gl);
      this_4.r46(level_3, tmp$ret$8);
      tmp_3 = Unit_instance;
    }
  }
  // Inline function 'kotlin.collections.getOrPut' call
  var value = map.e3(program);
  var tmp_4;
  if (value == null) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_5 = new GLBaseProgram($this.y8m_1, GLShaderCompiler_getInstance().i8o(gl, $this.g8o(), program, program.p8a_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>' call
    this_5.m8o();
    var programInfo = this_5.l8o_1;
    var programId = programInfo.n8o_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = program.t8a_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
      var location = programInfo.i8p(gl, element.d8p_1);
      gl.j8p(location, element.c87_1);
    }
    if (programInfo.r8o_1.q8p()) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_6 = program.s8a_1;
      var n = 0;
      while (n < this_6.g1()) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = this_6.h1(_unary__edvuaz);
        var index = gl.k8p(programId, it.q3());
        gl.l8p(programId, index, it.n8b_1);
      }
    }
    var answer = this_5;
    map.k3(program, answer);
    tmp_4 = answer;
  } else {
    tmp_4 = value;
  }
  var nprogram = tmp_4;
  if (!equals($this.j8n_1, nprogram)) {
    $this.j8n_1 = nprogram;
    nprogram.m8o();
  }
}
function resetObjects($this) {
  $this.c8n_1 = null;
  $this.n8n_1 = Companion_getInstance_43().g85_1;
  $this.d8n_1 = Companion_getInstance_42().j84_1;
  $this.e8n_1 = Companion_getInstance_49().i85_1;
  $this.f8n_1 = Companion_getInstance_46().u84_1;
  $this.g8n_1 = Companion_getInstance_45().s84_1;
  $this.h8n_1 = Companion_getInstance_47().w84_1;
  $this.i8n_1 = Companion_getInstance_48().c85_1;
  $this.k8n_1.h3();
  $this.j8n_1 = null;
  $this.y8n_1 = -1;
  $this.w8n_1 = 0;
  $this.x8n_1 = Companion_instance_48.a8h();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.t8n_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.resetObjects.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    this_0[_unary__edvuaz].u1w();
  }
}
function deletePendingObjects($this) {
  while (true) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = $this.y8m_1.f8q_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.c36();
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this.y8m_1.g8q_1.j1()) {
          // Inline function 'kotlin.also' call
          var this_1 = toList($this.y8m_1.g8q_1);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>.<anonymous>' call
          $this.y8m_1.g8q_1.h3();
          tmp = this_1;
        } else {
          return Unit_instance;
        }
        tmp$ret$3 = tmp;
        break $l$block;
      }finally {
        this_0.e36();
      }
    }
    var n = 0;
    while (n < tmp$ret$3.g1()) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      tmp$ret$3.h1(_unary__edvuaz).j8q();
    }
  }
}
function bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated) {
  var gl = $this.v8m_1;
  if (reallocated == null)
    null;
  else {
    reallocated.j43(false);
  }
  if (updated == null)
    null;
  else {
    updated.j43(false);
  }
  if (buffer == null) {
    gl.k8q(toGl_6(target), 0);
    return null;
  }
  var bufferInfo = _get_gl__ndc1ty(buffer, $this);
  if (!onlyUpdate) {
    gl.k8q(toGl_6(target), bufferInfo.n8q_1);
  }
  $this.q8q(buffer, AGOpengl$bindBuffer$lambda(buffer, bufferInfo, onlyUpdate, gl, target, reallocated, updated));
  return bufferInfo;
}
function bindBuffer$default($this, buffer, target, onlyUpdate, reallocated, updated, $super) {
  onlyUpdate = onlyUpdate === VOID ? false : onlyUpdate;
  reallocated = reallocated === VOID ? null : reallocated;
  updated = updated === VOID ? null : updated;
  return bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated);
}
function writeUniform($this, uniform, programInfo, data, source) {
  var gl = $this.v8m_1;
  var location = programInfo.i8p(gl, uniform.d8p_1);
  var uniformType = uniform.p3m();
  var arrayCount = uniform.t8q_1;
  if (uniformType.a8r_1.p3_1 === 6) {
    switch (uniformType.p3_1) {
      case 1:
        gl.i8r(location, arrayCount, false, data);
        break;
      case 2:
        var inductionVariable = 0;
        if (inductionVariable < 3)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            arraycopy_0(data, imul(n, 16), $this.s8n_1, imul(n, 12), 12);
          }
           while (inductionVariable < 3);
        gl.j8r(location, arrayCount, false, $this.s8n_1);
        break;
      case 3:
        gl.k8r(location, arrayCount, false, data);
        break;
      default:
        switch (uniformType.b8r_1) {
          case 1:
            gl.l8r(location, arrayCount, data);
            break;
          case 2:
            gl.m8r(location, arrayCount, data);
            break;
          case 3:
            gl.n8r(location, arrayCount, data);
            break;
          case 4:
            gl.o8r(location, arrayCount, data);
            break;
        }

        break;
    }
  } else {
    switch (uniformType.b8r_1) {
      case 1:
        gl.e8r(location, arrayCount, data);
        break;
      case 2:
        gl.f8r(location, arrayCount, data);
        break;
      case 3:
        gl.g8r(location, arrayCount, data);
        break;
      case 4:
        gl.h8r(location, arrayCount, data);
        break;
    }
  }
}
function textureUnitParameters($this, implForcedTexTarget, wrap, minFilter, magFilter, dims) {
  var gl = $this.v8m_1;
  var params = $this.t8n_1[$this.w8n_1];
  var glTarget = toGl_8(implForcedTexTarget);
  params.s8p_1 = wrap;
  var glWrap = toGl_9(wrap);
  gl.p8r(glTarget, 10242, glWrap);
  gl.p8r(glTarget, 10243, glWrap);
  if (dims >= 3) {
    gl.p8r(glTarget, 32882, glWrap);
  }
  params.t8p_1 = minFilter;
  params.u8p_1 = magFilter;
  gl.p8r(glTarget, 10241, minFilter);
  gl.p8r(glTarget, 10240, magFilter);
}
function createBufferForBitmap($this, bmp) {
  var tmp;
  if (bmp == null) {
    tmp = null;
  } else {
    if (bmp instanceof NativeImage) {
      unsupported('Should not call createBufferForBitmap with a NativeImage');
    } else {
      if (bmp instanceof Bitmap8) {
        // Inline function 'kotlin.also' call
        var this_0 = Buffer.o2c(bmp.x3r());
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
        arraycopy_3(bmp.d5g(), 0, get_i8(this_0), 0, bmp.x3r());
        tmp = this_0;
      } else {
        if (bmp instanceof FloatBitmap32) {
          // Inline function 'kotlin.also' call
          var this_1 = Buffer.o2c(imul(imul(bmp.x3r(), 4), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          arraycopy_2(bmp.n5j_1, 0, get_f32(this_1), 0, imul(bmp.x3r(), 4));
          tmp = this_1;
        } else {
          // Inline function 'kotlin.also' call
          var this_2 = Buffer.o2c(imul(bmp.x3r(), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          var abmp = bmp.x56_1 ? bmp.o5e().v5h() : bmp.o5e().w5h();
          arraycopy_1(abmp.h56_1, 0, get_i32(this_2), 0, abmp.x3r());
          tmp = this_2;
        }
      }
    }
  }
  return tmp;
}
function selectTextureUnit($this, index) {
  var old = $this.w8n_1;
  if (!($this.w8n_1 === index)) {
    $this.w8n_1 = index;
    if (index >= 0) {
      $this.v8m_1.q8r(33984 + index | 0);
    }
  }
  return old;
}
function _get_gl__ndc1ty(_this__u8e3s4, $this) {
  return gl(_this__u8e3s4, $this.y8m_1);
}
function _get_gl__ndc1ty_0(_this__u8e3s4, $this) {
  return gl_0(_this__u8e3s4, $this.y8m_1);
}
function _get_gl__ndc1ty_1(_this__u8e3s4, $this) {
  return gl_1(_this__u8e3s4, $this.y8m_1);
}
function AGOpengl$glslConfig$delegate$lambda(this$0) {
  return function () {
    return new GlslConfig(this$0.v8m_1.r8r(), this$0.v8m_1);
  };
}
function AGOpengl$bindBuffer$lambda($buffer, $bufferInfo, $onlyUpdate, $gl, $target, $reallocated, $updated) {
  return function (it) {
    var tmp0_elvis_lhs = $buffer.b86_1;
    var mem = tmp0_elvis_lhs == null ? Buffer.o2c(0) : tmp0_elvis_lhs;
    $bufferInfo.s8r(mem.p2c());
    var tmp;
    if ($onlyUpdate) {
      $gl.k8q(toGl_6($target), $bufferInfo.n8q_1);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($bufferInfo.o8q_1 < mem.p2c()) {
      $bufferInfo.o8q_1 = mem.p2c();
      $gl.u8r(toGl_6($target), mem.p2c(), mem, 35048);
      var tmp1_safe_receiver = $reallocated;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.j43(true);
      }
      tmp_0 = Unit_instance;
    } else {
      $gl.t8r(toGl_6($target), 0, mem.p2c(), mem);
      tmp_0 = Unit_instance;
    }
    var tmp2_safe_receiver = $updated;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.j43(true);
    }
    return Unit_instance;
  };
}
function AGOpengl$textureBind$lambda($tex, $target, $gl, this$0, $glTex) {
  return function (it) {
    var rbmp = $tex.g88_1;
    var tmp0_safe_receiver = (rbmp == null ? true : rbmp instanceof MultiBitmap) ? rbmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h89_1;
    var bmps = tmp1_elvis_lhs == null ? listOf(rbmp) : tmp1_elvis_lhs;
    var requestMipmaps = $tex.d88_1;
    $tex.h88_1 = $tex.j89(rbmp, requestMipmaps);
    var totalSize = 0.0;
    var iterator = bmps.b1();
    var index = 0;
    while (iterator.c1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var bmp = iterator.d1();
      var isFloat = bmp instanceof FloatBitmap32;
      var tmp;
      if (bmp instanceof Bitmap8) {
        tmp = 6409;
      } else {
        tmp = 6408;
      }
      var type = tmp;
      var texTarget = $target === Companion_getInstance_50().p88_1 ? 34069 + index_0 | 0 : toGl_8($target);
      var internalFormat = isFloat && (_GLVariant___get_isWebGL__impl__bbd1dd($gl.r8r()) && _GLVariant___get_version__impl__9nyfwa($gl.r8r()) >= 2) ? 34836 : type;
      var format = type;
      var texType = isFloat ? 5126 : 5121;
      if (_GLVariant___get_os__impl__aswhdw($gl.r8r()).p23()) {
        $gl.v8r(3313, 0);
        $gl.v8r(3312, 1);
      }
      if (bmp == null) {
        $gl.w8r(toGl_8($target), 0, type, $tex.f3u(), $tex.g3u(), 0, type, 5121, null);
      } else {
        if (bmp instanceof NativeImage) {
          if (!(bmp.x3r() === 0)) {
            $gl.x8r(texTarget, 0, type, type, 5121, bmp);
          }
        } else {
          if (bmp instanceof NullBitmap) {
            $gl.w8r(texTarget, 0, internalFormat, bmp.r56_1, bmp.s56_1, 0, format, texType, null);
          } else {
            var buffer = createBufferForBitmap(this$0, bmp);
            if (!(buffer == null) && !(bmp.r56_1 === 0) && !(bmp.s56_1 === 0) && !(get_size_0(buffer) === 0)) {
              $gl.w8r(texTarget, 0, internalFormat, bmp.r56_1, bmp.s56_1, 0, format, texType, buffer);
            }
          }
        }
      }
      totalSize = totalSize + imul(imul($tex.f3u(), $tex.g3u()), 4);
      if (_GLVariant___get_supportTextureLevel__impl__3yeu62($gl.r8r())) {
        var tmp_0;
        if ($tex.h88_1) {
          var tmp4_elvis_lhs = $tex.e88_1;
          tmp_0 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        } else {
          tmp_0 = 0;
        }
        $gl.p8r(3553, 33084, tmp_0);
        var tmp_1;
        if ($tex.h88_1) {
          var tmp5_elvis_lhs = $tex.f88_1;
          tmp_1 = tmp5_elvis_lhs == null ? 1000 : tmp5_elvis_lhs;
        } else {
          tmp_1 = 0;
        }
        $gl.p8r(3553, 33085, tmp_1);
      }
      if ($tex.h88_1) {
        $gl.y8r(texTarget);
      }
    }
    $glTex.s8r(totalSize);
    return Unit_instance;
  };
}
function gl$delegate$lambda($this$PropertyThis) {
  _init_properties_AGOpengl_kt__dtzqx7();
  return new GLVAO($this$PropertyThis);
}
function gl$factory() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function gl$factory_0() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function glslConfig$factory() {
  return getPropertyCallableRef('glslConfig', 1, KProperty1, function (receiver) {
    return receiver.g8o();
  }, null);
}
var properties_initialized_AGOpengl_kt_5em8g9;
function _init_properties_AGOpengl_kt__dtzqx7() {
  if (!properties_initialized_AGOpengl_kt_5em8g9) {
    properties_initialized_AGOpengl_kt_5em8g9 = true;
    ENABLE_UNIFORM_BLOCKS = !(Companion_instance_1.cj('DISABLE_UNIFORM_BLOCKS') === 'true');
    ENABLE_VERTEX_ARRAY_OBJECTS = !(Companion_instance_1.cj('DISABLE_VERTEX_ARRAY_OBJECTS') === 'true');
    gl$delegate = new PropertyThis(VOID, gl$delegate$lambda);
  }
}
function fromGl(_this__u8e3s4, value) {
  var tmp;
  switch (value) {
    case 3553:
      tmp = Companion_getInstance_50().n88_1;
      break;
    case 32879:
      tmp = Companion_getInstance_50().o88_1;
      break;
    case 34067:
      tmp = Companion_getInstance_50().p88_1;
      break;
    case 36197:
      tmp = Companion_getInstance_50().q88_1;
      break;
    case 34069:
      tmp = Companion_getInstance_50().p88_1;
      break;
    case 34070:
      tmp = Companion_getInstance_50().p88_1;
      break;
    case 34071:
      tmp = Companion_getInstance_50().p88_1;
      break;
    case 34072:
      tmp = Companion_getInstance_50().p88_1;
      break;
    case 34073:
      tmp = Companion_getInstance_50().p88_1;
      break;
    case 34074:
      tmp = Companion_getInstance_50().p88_1;
      break;
    default:
      var reason = 'Unknown TextureTargetKind: ' + value;
      throw NotImplementedError.je('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_53().i8d_1) {
    tmp = 32774;
  } else if (_this__u8e3s4 === Companion_getInstance_53().j8d_1) {
    tmp = 32778;
  } else if (_this__u8e3s4 === Companion_getInstance_53().k8d_1) {
    tmp = 32779;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_52().v8c_1) {
    tmp = 772;
  } else if (_this__u8e3s4 === Companion_getInstance_52().w8c_1) {
    tmp = 774;
  } else if (_this__u8e3s4 === Companion_getInstance_52().x8c_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_52().y8c_1) {
    tmp = 773;
  } else if (_this__u8e3s4 === Companion_getInstance_52().z8c_1) {
    tmp = 775;
  } else if (_this__u8e3s4 === Companion_getInstance_52().a8d_1) {
    tmp = 771;
  } else if (_this__u8e3s4 === Companion_getInstance_52().b8d_1) {
    tmp = 769;
  } else if (_this__u8e3s4 === Companion_getInstance_52().c8d_1) {
    tmp = 770;
  } else if (_this__u8e3s4 === Companion_getInstance_52().d8d_1) {
    tmp = 768;
  } else if (_this__u8e3s4 === Companion_getInstance_52().e8d_1) {
    tmp = 0;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_1(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_56().n8e_1) {
    tmp = 519;
  } else if (_this__u8e3s4 === Companion_getInstance_56().o8e_1) {
    tmp = 514;
  } else if (_this__u8e3s4 === Companion_getInstance_56().p8e_1) {
    tmp = 516;
  } else if (_this__u8e3s4 === Companion_getInstance_56().q8e_1) {
    tmp = 518;
  } else if (_this__u8e3s4 === Companion_getInstance_56().r8e_1) {
    tmp = 513;
  } else if (_this__u8e3s4 === Companion_getInstance_56().s8e_1) {
    tmp = 515;
  } else if (_this__u8e3s4 === Companion_getInstance_56().t8e_1) {
    tmp = 512;
  } else if (_this__u8e3s4 === Companion_getInstance_56().u8e_1) {
    tmp = 517;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_2(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_55().v8e_1 ? 7683 : _this__u8e3s4 === Companion_getInstance_55().w8e_1 ? 34056 : _this__u8e3s4 === Companion_getInstance_55().x8e_1 ? 7682 : _this__u8e3s4 === Companion_getInstance_55().y8e_1 ? 34055 : _this__u8e3s4 === Companion_getInstance_55().z8e_1 ? 5386 : _this__u8e3s4 === Companion_getInstance_55().a8f_1 ? 7680 : _this__u8e3s4 === Companion_getInstance_55().b8f_1 ? 7681 : _this__u8e3s4 === Companion_getInstance_55().c8f_1 ? 0 : 0;
}
function toGl_3(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_40().k8c_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_40().l8c_1) {
    tmp = 3;
  } else if (_this__u8e3s4 === Companion_getInstance_40().m8c_1) {
    tmp = 2;
  } else if (_this__u8e3s4 === Companion_getInstance_40().n8c_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_40().p8c_1) {
    tmp = 5;
  } else if (_this__u8e3s4 === Companion_getInstance_40().q8c_1) {
    tmp = 6;
  } else if (_this__u8e3s4 === Companion_getInstance_40().o8c_1) {
    tmp = 4;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_4(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_41().f84_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_41().g84_1) {
    tmp = 5121;
  } else if (_this__u8e3s4 === Companion_getInstance_41().h84_1) {
    tmp = 5123;
  } else if (_this__u8e3s4 === Companion_getInstance_41().i84_1) {
    tmp = 5125;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_5(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_49().m85_1) {
    tmp = 1032;
  } else if (_this__u8e3s4 === Companion_getInstance_49().k85_1) {
    tmp = 1028;
  } else if (_this__u8e3s4 === Companion_getInstance_49().l85_1) {
    tmp = 1029;
  } else {
    var reason = 'Invalid AGCullFace(' + AGCullFace__toString_impl_7d891w(_this__u8e3s4) + ')';
    throw NotImplementedError.je('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl_6(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.p3_1) {
    case 0:
      tmp = 34963;
      break;
    case 1:
      tmp = 34962;
      break;
    case 2:
      tmp = 35345;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_7(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.a8r_1.p3_1) {
    case 0:
      tmp = 35670;
      break;
    case 1:
      tmp = 5120;
      break;
    case 2:
      tmp = 5121;
      break;
    case 3:
      tmp = 5122;
      break;
    case 4:
      tmp = 5123;
      break;
    case 5:
      tmp = 5125;
      break;
    case 6:
      tmp = 5126;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_8(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_50().n88_1 ? 3553 : _this__u8e3s4 === Companion_getInstance_50().o88_1 ? 32879 : _this__u8e3s4 === Companion_getInstance_50().p88_1 ? 34067 : _this__u8e3s4 === Companion_getInstance_50().q88_1 ? 36197 : _AGTextureTargetKind___get_ordinal__impl__gjzc5p(_this__u8e3s4);
}
function toGl_9(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_51().m89_1 ? 33071 : _this__u8e3s4 === Companion_getInstance_51().n89_1 ? 10497 : _this__u8e3s4 === Companion_getInstance_51().o89_1 ? 33648 : 33071;
}
function toGl_10(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_57().g8f_1) {
    tmp = 2305;
  } else if (_this__u8e3s4 === Companion_getInstance_57().i8f_1) {
    tmp = 2304;
  } else if (_this__u8e3s4 === Companion_getInstance_57().h8f_1) {
    tmp = 2305;
  } else {
    get_unreachable();
  }
  return tmp;
}
function gl(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda(state));
}
function gl_0(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_0(state, _this__u8e3s4));
}
function gl_1(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_1(state));
}
function createOnce(_this__u8e3s4, state, block) {
  if (_this__u8e3s4.c86_1 == null || !(_this__u8e3s4.d86_1 === state.y8p_1.e83_1)) {
    _this__u8e3s4.d86_1 = state.y8p_1.e83_1;
    _this__u8e3s4.k86();
    _this__u8e3s4.c86_1 = block(_this__u8e3s4);
  }
  var tmp = _this__u8e3s4.c86_1;
  return (!(tmp == null) ? isInterface(tmp, AGNativeObject) : false) ? tmp : THROW_CCE();
}
function gl$lambda($state) {
  return function (it) {
    return new GLBuffer($state);
  };
}
function gl$lambda_0($state, $this_gl) {
  return function (it) {
    return new GLFrameBuffer($state, $this_gl);
  };
}
function gl$lambda_1($state) {
  return function (it) {
    return new GLTexture($state);
  };
}
function get_versionString(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionString$delegate;
    var property = versionString$factory();
    var tmp0_elvis_lhs = this_0.g28_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.h28_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.g28_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionString$delegate;
function get_versionInt(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionInt$delegate;
    var property = versionInt$factory();
    var tmp0_elvis_lhs = this_0.g28_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.h28_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.g28_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionInt$delegate;
function createShader($this, gl, type, str, debugName) {
  var shaderId = gl.j8v(type);
  gl.k8v(shaderId, str);
  gl.l8v(shaderId);
  // Inline function 'korlibs.kgl.KmlGl.COMPILE_STATUS' call
  var out = getShaderiv(gl, shaderId, 35713);
  var errorInt = gl.m8v();
  // Inline function 'korlibs.kgl.KmlGl.GTRUE' call
  if (!(out === 1)) {
    var error = getShaderInfoLog(gl, shaderId);
    throw ShaderException.q8m(str, error, errorInt, gl, debugName, type, out);
  }
  return shaderId;
}
var GLShaderCompiler_instance;
function GLShaderCompiler_getInstance() {
  if (GLShaderCompiler_instance === VOID)
    new GLShaderCompiler();
  return GLShaderCompiler_instance;
}
function versionString$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp;
  if (_GLVariant___get_isWebGL__impl__bbd1dd($this$PropertyThis.r8r())) {
    tmp = _GLVariant___get_version__impl__9nyfwa($this$PropertyThis.r8r()) === 1 ? '1.00' : '3.00';
  } else {
    // Inline function 'korlibs.kgl.KmlGl.SHADING_LANGUAGE_VERSION' call
    tmp = $this$PropertyThis.f8o(35724);
  }
  return tmp;
}
function versionInt$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp0_safe_receiver = Regex.pi('(\\d+\\.\\d+)').si(get_versionString($this$PropertyThis));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1();
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : replace(tmp1_safe_receiver, '.', '');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp = toString(trim(isCharSequence(tmp2_safe_receiver) ? tmp2_safe_receiver : THROW_CCE()));
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toIntOrNull(tmp3_safe_receiver);
  return tmp4_elvis_lhs == null ? 100 : tmp4_elvis_lhs;
}
function versionString$factory() {
  return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
    return get_versionString(receiver);
  }, null);
}
function versionInt$factory() {
  return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
    return get_versionInt(receiver);
  }, null);
}
var properties_initialized_GLShaderCompiler_kt_k11ei3;
function _init_properties_GLShaderCompiler_kt__3td561() {
  if (!properties_initialized_GLShaderCompiler_kt_k11ei3) {
    properties_initialized_GLShaderCompiler_kt_k11ei3 = true;
    versionString$delegate = new PropertyThis(VOID, versionString$delegate$lambda);
    versionInt$delegate = new PropertyThis(VOID, versionInt$delegate$lambda);
  }
}
var Kind_COMMAND_instance;
var Kind_DRAW_instance;
var Kind_DRAW_DETAILS_instance;
var Kind_CLEAR_instance;
var Kind_METRICS_instance;
var Kind_FLIP_instance;
var Kind_READ_instance;
var Kind_REPAINT_instance;
var Kind_DISPOSE_instance;
var Kind_TEXTURE_UPLOAD_instance;
var Kind_CLOSE_instance;
var Kind_FRAME_BUFFER_instance;
var Kind_BUFFER_instance;
var Kind_TEXTURE_instance;
var Kind_SHADER_instance;
var Kind_OTHER_instance;
var Kind_UNIFORM_instance;
var Kind_UNIFORM_VALUES_instance;
var Kind_SCISSORS_instance;
var Kind_VIEWPORT_instance;
var Kind_VERTEX_instance;
var Kind_ENABLE_DISABLE_instance;
var Kind_CONTEXT_LOST_instance;
var Kind_FLUSH_instance;
var Kind_entriesInitialized_0;
function Kind_initEntries_0() {
  if (Kind_entriesInitialized_0)
    return Unit_instance;
  Kind_entriesInitialized_0 = true;
  Kind_COMMAND_instance = new Kind_0('COMMAND', 0);
  Kind_DRAW_instance = new Kind_0('DRAW', 1);
  Kind_DRAW_DETAILS_instance = new Kind_0('DRAW_DETAILS', 2);
  Kind_CLEAR_instance = new Kind_0('CLEAR', 3);
  Kind_METRICS_instance = new Kind_0('METRICS', 4);
  Kind_FLIP_instance = new Kind_0('FLIP', 5);
  Kind_READ_instance = new Kind_0('READ', 6);
  Kind_REPAINT_instance = new Kind_0('REPAINT', 7);
  Kind_DISPOSE_instance = new Kind_0('DISPOSE', 8);
  Kind_TEXTURE_UPLOAD_instance = new Kind_0('TEXTURE_UPLOAD', 9);
  Kind_CLOSE_instance = new Kind_0('CLOSE', 10);
  Kind_FRAME_BUFFER_instance = new Kind_0('FRAME_BUFFER', 11);
  Kind_BUFFER_instance = new Kind_0('BUFFER', 12);
  Kind_TEXTURE_instance = new Kind_0('TEXTURE', 13);
  Kind_SHADER_instance = new Kind_0('SHADER', 14);
  Kind_OTHER_instance = new Kind_0('OTHER', 15);
  Kind_UNIFORM_instance = new Kind_0('UNIFORM', 16);
  Kind_UNIFORM_VALUES_instance = new Kind_0('UNIFORM_VALUES', 17);
  Kind_SCISSORS_instance = new Kind_0('SCISSORS', 18);
  Kind_VIEWPORT_instance = new Kind_0('VIEWPORT', 19);
  Kind_VERTEX_instance = new Kind_0('VERTEX', 20);
  Kind_ENABLE_DISABLE_instance = new Kind_0('ENABLE_DISABLE', 21);
  Kind_CONTEXT_LOST_instance = new Kind_0('CONTEXT_LOST', 22);
  Kind_FLUSH_instance = new Kind_0('FLUSH', 23);
}
function Kind_COMMAND_getInstance() {
  Kind_initEntries_0();
  return Kind_COMMAND_instance;
}
function Kind_FLIP_getInstance() {
  Kind_initEntries_0();
  return Kind_FLIP_instance;
}
var Companion_instance_52;
function Companion_getInstance_58() {
  if (Companion_instance_52 === VOID)
    new Companion_43();
  return Companion_instance_52;
}
function UniformBlock$Gen$uniform$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp0_elvis_lhs = this$0.v8h_1;
    var this_0 = TypedUniform.w8w(tmp0_elvis_lhs == null ? 'unknown' + this$0.u8h_1.j8i() : tmp0_elvis_lhs, this$0.w8h_1, this$0.x8h_1, this$0.u8h_1, this$0.y8h_1, this$0.z8h_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Gen.uniform$delegate.<anonymous>.<anonymous>' call
    this$0.u8h_1.p8b_1.h(this_0);
    return this_0;
  };
}
var Companion_instance_53;
function Companion_getInstance_59() {
  return Companion_instance_53;
}
function _get_bufferSize__mp12kq($this) {
  return $this.y89_1.p2c() / $this.w89_1 | 0;
}
function align($this, size) {
  var tmp = $this;
  // Inline function 'kotlin.math.max' call
  var a = $this.z8w_1;
  tmp.z8w_1 = Math.max(a, size);
  while (!(($this.y8w_1 % size | 0) === 0)) {
    $this.y8w_1 = $this.y8w_1 + 1 | 0;
  }
  return $this;
}
function UBLayoutBuilder$size$delegate$lambda(this$0) {
  return function () {
    align(this$0, this$0.z8w_1);
    return this$0.y8w_1;
  };
}
function uniform$factory() {
  return getPropertyCallableRef('uniform', 1, KProperty1, function (receiver) {
    return receiver.x8w();
  }, null);
}
function size$factory() {
  return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
    return receiver.g1();
  }, null);
}
function _GLVariant___init__impl__cjzpjb(data) {
  return data;
}
function _GLVariant___get_data__impl__nn46ye($this) {
  return $this;
}
function _GLVariant___get_isES__impl__yezzg8($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 0 | 0) & 1) === 0);
}
function _GLVariant___get_isWebGL__impl__bbd1dd($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 1 | 0) & 1) === 0);
}
function _GLVariant___get_version__impl__9nyfwa($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_GLVariant___get_data__impl__nn46ye($this) >>> 8 | 0) & 255;
}
function _GLVariant___get_os__impl__aswhdw($this) {
  var tmp = Companion_getInstance_2().l23_1;
  // Inline function 'korlibs.memory.extract8' call
  var tmp$ret$0 = (_GLVariant___get_data__impl__nn46ye($this) >>> 16 | 0) & 255;
  var tmp0_elvis_lhs = getOrNull(tmp, tmp$ret$0);
  return tmp0_elvis_lhs == null ? Os_UNKNOWN_getInstance() : tmp0_elvis_lhs;
}
function _GLVariant___get_supportTextureLevel__impl__3yeu62($this) {
  return !_GLVariant___get_isWebGL__impl__bbd1dd($this) && !_GLVariant___get_isES__impl__yezzg8($this);
}
var Companion_instance_54;
function Companion_getInstance_60() {
  return Companion_instance_54;
}
function GLVariant__toString_impl_o5yi3l($this) {
  return 'GLVariant(data=' + $this + ')';
}
function GLVariant__hashCode_impl_2eslaq($this) {
  return $this;
}
function GLVariant__equals_impl_kmlw2($this, other) {
  if (!(other instanceof GLVariant))
    return false;
  if (!($this === (other instanceof GLVariant ? other.n8y_1 : THROW_CCE())))
    return false;
  return true;
}
function toNewGlslString(_this__u8e3s4, config) {
  return toNewGlslStringResult(_this__u8e3s4, config).r8y_1;
}
function toNewGlslStringResult(_this__u8e3s4, config) {
  return (new GlslGenerator(_this__u8e3s4.v8y_1, config)).j8z(_this__u8e3s4);
}
var Companion_instance_55;
function Companion_getInstance_61() {
  if (Companion_instance_55 === VOID)
    new Companion_46();
  return Companion_instance_55;
}
function GlslGenerator$generateResult$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp = a.d8p_1;
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp$ret$1 = b.d8p_1;
  return compareValues(tmp, tmp$ret$1);
}
function GlslGenerator$generateResult$lambda(this$0, $types, $allFuncs) {
  return function ($this$Indenter) {
    var tmp;
    if (!this$0.i8z_1.p8p_1) {
      var suffix = _GLVariant___get_isES__impl__yezzg8(this$0.i8z_1.m8p_1) ? ' es' : '';
      $this$Indenter.z4h('#version ' + this$0.i8z_1.o8p_1 + suffix);
      tmp = Unit_instance;
    }
    var tmp_0;
    if (this$0.h8z_1.equals(ShaderType_FRAGMENT_getInstance())) {
      $this$Indenter.z4h('#extension GL_OES_standard_derivatives : enable');
      tmp_0 = Unit_instance;
    }
    $this$Indenter.z4h('#ifdef GL_ES');
    $this$Indenter.z4h('precision mediump float;');
    $this$Indenter.z4h('#endif');
    var _iterator__ex2g4s = $types.l8z_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var it = _iterator__ex2g4s.d1();
      var layout = this$0.i8z_1.q91() && this$0.i8z_1.o8p_1 >= 410 ? 'layout(location = ' + it.e8j_1 + ') ' : '';
      $this$Indenter.z4h(layout + this$0.r91() + ' ' + this$0.s91(it.e8p_1) + this$0.t91(it.p3m()) + ' ' + it.d8p_1 + this$0.u91(it) + ';');
    }
    var _iterator__ex2g4s_0 = $types.q8z_1.b1();
    while (_iterator__ex2g4s_0.c1()) {
      var it_0 = _iterator__ex2g4s_0.d1();
      var layout_0 = this$0.i8z_1.q91() ? '' : '';
      $this$Indenter.z4h(layout_0 + this$0.v91() + ' ' + this$0.s91(it_0.e8p_1) + this$0.t91(it_0.p3m()) + ' ' + it_0.d8p_1 + this$0.u91(it_0) + ';');
    }
    var tmp_1;
    if (this$0.i8z_1.q8p()) {
      var _iterator__ex2g4s_1 = $types.p8z_1.b1();
      while (_iterator__ex2g4s_1.c1()) {
        var block = _iterator__ex2g4s_1.d1();
        $this$Indenter.z4h('layout(std140) uniform ' + block.q3() + ' {');
        var _iterator__ex2g4s_2 = block.g8i().b1();
        while (_iterator__ex2g4s_2.c1()) {
          var uniform = _iterator__ex2g4s_2.d1();
          $this$Indenter.z4h('  ' + this$0.s91(uniform.e8p_1) + this$0.t91(uniform.p3m()) + ' ' + uniform.d8p_1 + this$0.u91(uniform) + ';');
        }
        $this$Indenter.z4h('};');
      }
      tmp_1 = Unit_instance;
    } else {
      var _iterator__ex2g4s_3 = $types.n8z_1.b1();
      while (_iterator__ex2g4s_3.c1()) {
        var it_1 = _iterator__ex2g4s_3.d1();
        $this$Indenter.z4h(this$0.v91() + ' ' + this$0.s91(it_1.e8p_1) + this$0.t91(it_1.p3m()) + ' ' + it_1.d8p_1 + this$0.u91(it_1) + ';');
      }
      tmp_1 = Unit_instance;
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = $types.m8z_1;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = GlslGenerator$generateResult$lambda$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_2);
    var iterator = sortedWith(this_0, tmp$ret$0).b1();
    var index = 0;
    $l$loop: while (iterator.c1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var it_2 = iterator.d1();
      if (it_2 instanceof Output)
        continue $l$loop;
      var INOUT = !this$0.i8z_1.q91() ? this$0.w91() : it_2.d8p_1 === this$0.i8z_1.x91() && this$0.h8z_1.equals(ShaderType_FRAGMENT_getInstance()) ? this$0.w91() : this$0.h8z_1.equals(ShaderType_VERTEX_getInstance()) ? this$0.w91() : this$0.r91();
      $this$Indenter.z4h(INOUT + ' ' + this$0.s91(it_2.e8p_1) + this$0.t91(it_2.p3m()) + ' ' + it_2.d8p_1 + ';');
    }
    var _iterator__ex2g4s_4 = $allFuncs.b1();
    while (_iterator__ex2g4s_4.c1()) {
      var func = _iterator__ex2g4s_4.d1();
      var gen = new GlslBodyGenerator(this$0.h8z_1, this$0.i8z_1);
      gen.j90(func);
      // Inline function 'kotlin.collections.map' call
      var this_1 = func.a92_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.b1();
      while (tmp0_iterator.c1()) {
        var item = tmp0_iterator.d1();
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$2 = this$0.t91(item.om_1) + ' ' + item.nm_1;
        destination.h(tmp$ret$2);
      }
      var argsStrings = destination;
      // Inline function 'korlibs.io.util.Indenter.line' call
      var str = this$0.t91(func.z91_1) + ' ' + func.y91_1 + '(' + joinToString(argsStrings, ', ') + ')';
      var tmp_3;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(str) === 0) {
        tmp_3 = '{';
      } else {
        tmp_3 = str + ' {';
      }
      $this$Indenter.z4h(tmp_3);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      $this$Indenter.v1k();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var _iterator__ex2g4s_5 = gen.g92_1.b1();
        while (_iterator__ex2g4s_5.c1()) {
          var temp = _iterator__ex2g4s_5.d1();
          $this$Indenter.z4h(this$0.s91(temp.e8p_1) + this$0.t91(temp.p3m()) + ' ' + temp.d8p_1 + ';');
        }
        $this$Indenter.y4h(gen.h92_1);
      }finally {
        $this$Indenter.a4i();
      }
      $this$Indenter.z4h('}');
    }
    return Unit_instance;
  };
}
var Companion_instance_56;
function Companion_getInstance_62() {
  if (Companion_instance_56 === VOID)
    new Companion_47();
  return Companion_instance_56;
}
function errorType($this, type) {
  invalidOp("Don't know how to serialize type " + type.toString());
}
function GlslBodyGenerator$visit$lambda(this$0) {
  return function (it) {
    return this$0.u90(it);
  };
}
function GlslBodyGenerator$visit$lambda_0(this$0) {
  return function (it) {
    return this$0.u90(it);
  };
}
function ProgramLayout$names$lambda(it) {
  return it.d8p_1;
}
var Discard_instance;
function Discard_getInstance() {
  if (Discard_instance === VOID)
    new Discard();
  return Discard_instance;
}
function Program$Builder$FuncProvider$provideDelegate$lambda(this$0) {
  return function ($this$FUNC) {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.l94_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.FuncProvider.provideDelegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var tmp$ret$0 = $this$FUNC.r94('p' + index_0, item);
      destination.h(tmp$ret$0);
    }
    var args = destination;
    this$0.n94_1($this$FUNC, args);
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.h1(0));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_0($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.h1(0), it.h1(1));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_1($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.h1(0), it.h1(1), it.h1(2));
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda($block, $max) {
  return function ($this$ELSE) {
    $block($this$ELSE, $max);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0($ref, $middle, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.r8l($ref, $middle + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
var Output_instance;
function Output_getInstance() {
  if (Output_instance === VOID)
    Output.i97();
  return Output_instance;
}
function Sampler_0(index, stype) {
  return new Provider(index, stype);
}
var SamplerVarType_Sampler1D_instance;
var SamplerVarType_Sampler2D_instance;
var SamplerVarType_Sampler3D_instance;
var SamplerVarType_SamplerCube_instance;
var SamplerVarType_entriesInitialized;
function SamplerVarType_initEntries() {
  if (SamplerVarType_entriesInitialized)
    return Unit_instance;
  SamplerVarType_entriesInitialized = true;
  SamplerVarType_Sampler1D_instance = new SamplerVarType('Sampler1D', 0, VarType_Sampler1D_getInstance());
  SamplerVarType_Sampler2D_instance = new SamplerVarType('Sampler2D', 1, VarType_Sampler2D_getInstance());
  SamplerVarType_Sampler3D_instance = new SamplerVarType('Sampler3D', 2, VarType_Sampler3D_getInstance());
  SamplerVarType_SamplerCube_instance = new SamplerVarType('SamplerCube', 3, VarType_SamplerCube_getInstance());
}
var VarType_TVOID_instance;
var VarType_Mat2_instance;
var VarType_Mat3_instance;
var VarType_Mat4_instance;
var VarType_Sampler1D_instance;
var VarType_Sampler2D_instance;
var VarType_Sampler3D_instance;
var VarType_SamplerCube_instance;
var VarType_Int1_instance;
var VarType_Float1_instance;
var VarType_Float2_instance;
var VarType_Float3_instance;
var VarType_Float4_instance;
var VarType_Short1_instance;
var VarType_Short2_instance;
var VarType_Short3_instance;
var VarType_Short4_instance;
var VarType_Bool1_instance;
var VarType_Bool2_instance;
var VarType_Bool3_instance;
var VarType_Bool4_instance;
var VarType_Byte4_instance;
var VarType_SByte1_instance;
var VarType_SByte2_instance;
var VarType_SByte3_instance;
var VarType_SByte4_instance;
var VarType_UByte1_instance;
var VarType_UByte2_instance;
var VarType_UByte3_instance;
var VarType_UByte4_instance;
var VarType_SShort1_instance;
var VarType_SShort2_instance;
var VarType_SShort3_instance;
var VarType_SShort4_instance;
var VarType_UShort1_instance;
var VarType_UShort2_instance;
var VarType_UShort3_instance;
var VarType_UShort4_instance;
var VarType_SInt1_instance;
var VarType_SInt2_instance;
var VarType_SInt3_instance;
var VarType_SInt4_instance;
var Companion_instance_57;
function Companion_getInstance_63() {
  return Companion_instance_57;
}
var VarType_entriesInitialized;
function VarType_initEntries() {
  if (VarType_entriesInitialized)
    return Unit_instance;
  VarType_entriesInitialized = true;
  VarType_TVOID_instance = new VarType('TVOID', 0, VarKind_TBYTE_getInstance(), 0);
  VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
  VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
  VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
  VarType_Sampler1D_instance = new VarType('Sampler1D', 4, VarKind_TINT_getInstance(), 1);
  VarType_Sampler2D_instance = new VarType('Sampler2D', 5, VarKind_TINT_getInstance(), 1);
  VarType_Sampler3D_instance = new VarType('Sampler3D', 6, VarKind_TINT_getInstance(), 1);
  VarType_SamplerCube_instance = new VarType('SamplerCube', 7, VarKind_TINT_getInstance(), 1);
  VarType_Int1_instance = new VarType('Int1', 8, VarKind_TINT_getInstance(), 1);
  VarType_Float1_instance = new VarType('Float1', 9, VarKind_TFLOAT_getInstance(), 1);
  VarType_Float2_instance = new VarType('Float2', 10, VarKind_TFLOAT_getInstance(), 2);
  VarType_Float3_instance = new VarType('Float3', 11, VarKind_TFLOAT_getInstance(), 3);
  VarType_Float4_instance = new VarType('Float4', 12, VarKind_TFLOAT_getInstance(), 4);
  VarType_Short1_instance = new VarType('Short1', 13, VarKind_TSHORT_getInstance(), 1);
  VarType_Short2_instance = new VarType('Short2', 14, VarKind_TSHORT_getInstance(), 2);
  VarType_Short3_instance = new VarType('Short3', 15, VarKind_TSHORT_getInstance(), 3);
  VarType_Short4_instance = new VarType('Short4', 16, VarKind_TSHORT_getInstance(), 4);
  VarType_Bool1_instance = new VarType('Bool1', 17, VarKind_TBOOL_getInstance(), 1);
  VarType_Bool2_instance = new VarType('Bool2', 18, VarKind_TBOOL_getInstance(), 2);
  VarType_Bool3_instance = new VarType('Bool3', 19, VarKind_TBOOL_getInstance(), 3);
  VarType_Bool4_instance = new VarType('Bool4', 20, VarKind_TBOOL_getInstance(), 4);
  VarType_Byte4_instance = new VarType('Byte4', 21, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SByte1_instance = new VarType('SByte1', 22, VarKind_TBYTE_getInstance(), 1);
  VarType_SByte2_instance = new VarType('SByte2', 23, VarKind_TBYTE_getInstance(), 2);
  VarType_SByte3_instance = new VarType('SByte3', 24, VarKind_TBYTE_getInstance(), 3);
  VarType_SByte4_instance = new VarType('SByte4', 25, VarKind_TBYTE_getInstance(), 4);
  VarType_UByte1_instance = new VarType('UByte1', 26, VarKind_TUNSIGNED_BYTE_getInstance(), 1);
  VarType_UByte2_instance = new VarType('UByte2', 27, VarKind_TUNSIGNED_BYTE_getInstance(), 2);
  VarType_UByte3_instance = new VarType('UByte3', 28, VarKind_TUNSIGNED_BYTE_getInstance(), 3);
  VarType_UByte4_instance = new VarType('UByte4', 29, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SShort1_instance = new VarType('SShort1', 30, VarKind_TSHORT_getInstance(), 1);
  VarType_SShort2_instance = new VarType('SShort2', 31, VarKind_TSHORT_getInstance(), 2);
  VarType_SShort3_instance = new VarType('SShort3', 32, VarKind_TSHORT_getInstance(), 3);
  VarType_SShort4_instance = new VarType('SShort4', 33, VarKind_TSHORT_getInstance(), 4);
  VarType_UShort1_instance = new VarType('UShort1', 34, VarKind_TUNSIGNED_SHORT_getInstance(), 1);
  VarType_UShort2_instance = new VarType('UShort2', 35, VarKind_TUNSIGNED_SHORT_getInstance(), 2);
  VarType_UShort3_instance = new VarType('UShort3', 36, VarKind_TUNSIGNED_SHORT_getInstance(), 3);
  VarType_UShort4_instance = new VarType('UShort4', 37, VarKind_TUNSIGNED_SHORT_getInstance(), 4);
  VarType_SInt1_instance = new VarType('SInt1', 38, VarKind_TINT_getInstance(), 1);
  VarType_SInt2_instance = new VarType('SInt2', 39, VarKind_TINT_getInstance(), 2);
  VarType_SInt3_instance = new VarType('SInt3', 40, VarKind_TINT_getInstance(), 3);
  VarType_SInt4_instance = new VarType('SInt4', 41, VarKind_TINT_getInstance(), 4);
}
var Precision_DEFAULT_instance;
var Precision_LOW_instance;
var Precision_MEDIUM_instance;
var Precision_HIGH_instance;
var Precision_entriesInitialized;
function Precision_initEntries() {
  if (Precision_entriesInitialized)
    return Unit_instance;
  Precision_entriesInitialized = true;
  Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
  Precision_LOW_instance = new Precision('LOW', 1);
  Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
  Precision_HIGH_instance = new Precision('HIGH', 3);
}
function FragmentShader(info) {
  return FragmentShader_0(info.nm_1, info.om_1);
}
var VarKind_TBOOL_instance;
var VarKind_TBYTE_instance;
var VarKind_TUNSIGNED_BYTE_instance;
var VarKind_TSHORT_instance;
var VarKind_TUNSIGNED_SHORT_instance;
var VarKind_TINT_instance;
var VarKind_TFLOAT_instance;
var VarKind_entriesInitialized;
function VarKind_initEntries() {
  if (VarKind_entriesInitialized)
    return Unit_instance;
  VarKind_entriesInitialized = true;
  VarKind_TBOOL_instance = new VarKind('TBOOL', 0, 1);
  VarKind_TBYTE_instance = new VarKind('TBYTE', 1, 1);
  VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 2, 1);
  VarKind_TSHORT_instance = new VarKind('TSHORT', 3, 2);
  VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 4, 2);
  VarKind_TINT_instance = new VarKind('TINT', 5, 4);
  VarKind_TFLOAT_instance = new VarKind('TFLOAT', 6, 4);
}
var ShaderType_VERTEX_instance;
var ShaderType_FRAGMENT_instance;
var ShaderType_entriesInitialized;
function ShaderType_initEntries() {
  if (ShaderType_entriesInitialized)
    return Unit_instance;
  ShaderType_entriesInitialized = true;
  ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
  ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
}
function VertexShader(info) {
  return VertexShader_0(info.nm_1, info.om_1);
}
function FragmentShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_FRAGMENT_getInstance(), stm, funcs);
}
function VertexShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_VERTEX_getInstance(), stm, funcs);
}
function SamplerVarType_Sampler2D_getInstance() {
  SamplerVarType_initEntries();
  return SamplerVarType_Sampler2D_instance;
}
function VarType_TVOID_getInstance() {
  VarType_initEntries();
  return VarType_TVOID_instance;
}
function VarType_Mat2_getInstance() {
  VarType_initEntries();
  return VarType_Mat2_instance;
}
function VarType_Mat4_getInstance() {
  VarType_initEntries();
  return VarType_Mat4_instance;
}
function VarType_Sampler1D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler1D_instance;
}
function VarType_Sampler2D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler2D_instance;
}
function VarType_Sampler3D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler3D_instance;
}
function VarType_SamplerCube_getInstance() {
  VarType_initEntries();
  return VarType_SamplerCube_instance;
}
function VarType_Float1_getInstance() {
  VarType_initEntries();
  return VarType_Float1_instance;
}
function VarType_Float2_getInstance() {
  VarType_initEntries();
  return VarType_Float2_instance;
}
function VarType_Float3_getInstance() {
  VarType_initEntries();
  return VarType_Float3_instance;
}
function VarType_Float4_getInstance() {
  VarType_initEntries();
  return VarType_Float4_instance;
}
function VarType_SByte1_getInstance() {
  VarType_initEntries();
  return VarType_SByte1_instance;
}
function VarType_SByte2_getInstance() {
  VarType_initEntries();
  return VarType_SByte2_instance;
}
function VarType_SByte3_getInstance() {
  VarType_initEntries();
  return VarType_SByte3_instance;
}
function VarType_SByte4_getInstance() {
  VarType_initEntries();
  return VarType_SByte4_instance;
}
function VarType_UByte1_getInstance() {
  VarType_initEntries();
  return VarType_UByte1_instance;
}
function VarType_UByte2_getInstance() {
  VarType_initEntries();
  return VarType_UByte2_instance;
}
function VarType_UByte3_getInstance() {
  VarType_initEntries();
  return VarType_UByte3_instance;
}
function VarType_UByte4_getInstance() {
  VarType_initEntries();
  return VarType_UByte4_instance;
}
function VarType_SShort1_getInstance() {
  VarType_initEntries();
  return VarType_SShort1_instance;
}
function VarType_SShort2_getInstance() {
  VarType_initEntries();
  return VarType_SShort2_instance;
}
function VarType_SShort3_getInstance() {
  VarType_initEntries();
  return VarType_SShort3_instance;
}
function VarType_SShort4_getInstance() {
  VarType_initEntries();
  return VarType_SShort4_instance;
}
function VarType_UShort1_getInstance() {
  VarType_initEntries();
  return VarType_UShort1_instance;
}
function VarType_UShort2_getInstance() {
  VarType_initEntries();
  return VarType_UShort2_instance;
}
function VarType_UShort3_getInstance() {
  VarType_initEntries();
  return VarType_UShort3_instance;
}
function VarType_UShort4_getInstance() {
  VarType_initEntries();
  return VarType_UShort4_instance;
}
function VarType_SInt1_getInstance() {
  VarType_initEntries();
  return VarType_SInt1_instance;
}
function VarType_SInt2_getInstance() {
  VarType_initEntries();
  return VarType_SInt2_instance;
}
function VarType_SInt3_getInstance() {
  VarType_initEntries();
  return VarType_SInt3_instance;
}
function VarType_SInt4_getInstance() {
  VarType_initEntries();
  return VarType_SInt4_instance;
}
function Precision_DEFAULT_getInstance() {
  Precision_initEntries();
  return Precision_DEFAULT_instance;
}
function Precision_LOW_getInstance() {
  Precision_initEntries();
  return Precision_LOW_instance;
}
function Precision_MEDIUM_getInstance() {
  Precision_initEntries();
  return Precision_MEDIUM_instance;
}
function Precision_HIGH_getInstance() {
  Precision_initEntries();
  return Precision_HIGH_instance;
}
function VarKind_TBOOL_getInstance() {
  VarKind_initEntries();
  return VarKind_TBOOL_instance;
}
function VarKind_TBYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TBYTE_instance;
}
function VarKind_TUNSIGNED_BYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_BYTE_instance;
}
function VarKind_TSHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TSHORT_instance;
}
function VarKind_TUNSIGNED_SHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_SHORT_instance;
}
function VarKind_TINT_getInstance() {
  VarKind_initEntries();
  return VarKind_TINT_instance;
}
function VarKind_TFLOAT_getInstance() {
  VarKind_initEntries();
  return VarKind_TFLOAT_instance;
}
function ShaderType_VERTEX_getInstance() {
  ShaderType_initEntries();
  return ShaderType_VERTEX_instance;
}
function ShaderType_FRAGMENT_getInstance() {
  ShaderType_initEntries();
  return ShaderType_FRAGMENT_instance;
}
function toDisposable(_this__u8e3s4) {
  var tmp = toDisposable$lambda(_this__u8e3s4);
  return new sam$kotlinx_coroutines_DisposableHandle$0(tmp);
}
function toDisposable$lambda($this_toDisposable) {
  return function () {
    $this_toDisposable.p6();
    return Unit_instance;
  };
}
function putAsciiString(_this__u8e3s4, str) {
  var n = 0;
  var inductionVariable = 0;
  var last = str.length;
  while (inductionVariable < last) {
    var c = charSequenceGet(str, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_size_0(_this__u8e3s4) >= n) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      _this__u8e3s4.a2d(_unary__edvuaz, toByte(tmp$ret$0));
    }
  }
  if (get_size_0(_this__u8e3s4) >= n) {
    var _unary__edvuaz_0 = n;
    n = _unary__edvuaz_0 + 1 | 0;
    _this__u8e3s4.a2d(_unary__edvuaz_0, 0);
  }
  return _this__u8e3s4;
}
function toAsciiString(_this__u8e3s4) {
  var out = '';
  var inductionVariable = 0;
  var last = get_size_0(_this__u8e3s4);
  if (inductionVariable < last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = _this__u8e3s4.y2c(n);
      if (b === 0)
        break $l$loop;
      out = out + toString_0(numberToChar(b));
    }
     while (inductionVariable < last);
  return out;
}
function KmlGl$ContextInfo$current$lambda() {
  return null;
}
var Companion_instance_58;
function Companion_getInstance_64() {
  return Companion_instance_58;
}
function KmlGl$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.a7b().z2('GL_OES_texture_float') || this$0.a7b().z2('GL_ARB_texture_float');
  };
}
var logger;
var tempNBufferByte;
function get_tempNBuffer1() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return tempNBuffer1;
}
var tempNBuffer1;
var tempNBuffer4;
function getIntegerv(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getIntegerv.<anonymous>' call
  _this__u8e3s4.s9k(pname, it);
  return getInt32(it, 0);
}
function getInteger(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return getIntegerv(_this__u8e3s4, pname);
}
function genVertexArray(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genVertexArray.<anonymous>' call
  _this__u8e3s4.w9k(1, it);
  return getInt32(it, 0);
}
function getProgramiv(_this__u8e3s4, program, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getProgramiv.<anonymous>' call
  _this__u8e3s4.t9k(program, type, it);
  return getInt32(it, 0);
}
function getShaderiv(_this__u8e3s4, shader, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getShaderiv.<anonymous>' call
  _this__u8e3s4.u9k(shader, type, it);
  return getInt32(it, 0);
}
function getShaderInfoLog(_this__u8e3s4, shader) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.getInfoLog' call
  // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
  var size = getShaderiv(_this__u8e3s4, shader, 35716);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>' call
  var sizev = allocDirect(Companion_instance_4, 4);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>.<anonymous>' call
  var mbuffer = allocDirect(Companion_instance_4, size);
  _this__u8e3s4.v9k(shader, size, sizev, mbuffer);
  return toAsciiString(mbuffer);
}
function genBuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genBuffer.<anonymous>' call
  _this__u8e3s4.o9k(1, it);
  return getInt32(it, 0);
}
function deleteBuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteBuffer.<anonymous>' call
  _this__u8e3s4.k9k(1, it);
  getInt32(it, 0);
}
function genTexture(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genTexture.<anonymous>' call
  _this__u8e3s4.r9k(1, it);
  return getInt32(it, 0);
}
function deleteTexture(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteTexture.<anonymous>' call
  _this__u8e3s4.n9k(1, it);
  getInt32(it, 0);
}
function genRenderbuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genRenderbuffer.<anonymous>' call
  _this__u8e3s4.q9k(1, it);
  return getInt32(it, 0);
}
function genFramebuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genFramebuffer.<anonymous>' call
  _this__u8e3s4.p9k(1, it);
  return getInt32(it, 0);
}
function deleteRenderbuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteRenderbuffer.<anonymous>' call
  _this__u8e3s4.m9k(1, it);
  getInt32(it, 0);
}
function deleteFramebuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteFramebuffer.<anonymous>' call
  _this__u8e3s4.l9k(1, it);
  getInt32(it, 0);
}
function _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return get_tempNBuffer1();
}
var properties_initialized_KmlGlExt_kt_yrhd4c;
function _init_properties_KmlGlExt_kt__r5nfv2() {
  if (!properties_initialized_KmlGlExt_kt_yrhd4c) {
    properties_initialized_KmlGlExt_kt_yrhd4c = true;
    logger = Companion_getInstance_1().g26('KmlGlException');
    tempNBufferByte = Buffer.o2c(1, true);
    tempNBuffer1 = Buffer.o2c(4, true);
    tempNBuffer4 = Buffer.o2c(16, true);
  }
}
var KorgeReload_instance;
function KorgeReload_getInstance() {
  if (KorgeReload_instance === VOID)
    new KorgeReload();
  return KorgeReload_instance;
}
var Companion_instance_59;
function Companion_getInstance_65() {
  return Companion_instance_59;
}
function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().z3l_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().y57_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_66().i9l_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
}
function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().z3l_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().y57_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_66().i9l_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  var scale = textSize / _this__u8e3s4.b5r();
  var m2 = m.f3n(x, y).z3m(scale, scale);
  var dx = 0.0;
  var dy = 0.0;
  // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
  // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
  var this_0 = ctx.a9n_1;
  var this_1 = this_0.j9n_1;
  if (!(this_1.e9n_1 === this_0)) {
    this_1.e9n_1 = this_0;
    this_1.o9o();
  }
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  var tmp;
  if (inductionVariable <= last) {
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c1 = Char__toInt_impl_vasixd(charSequenceGet(str, n));
      if (c1 === 10) {
        dx = 0.0;
        dy = dy + _this__u8e3s4.b5r();
        continue $l$loop;
      }
      // Inline function 'kotlin.text.getOrElse' call
      var index = n + 1 | 0;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (0 <= index ? index <= (charSequenceLength(str) - 1 | 0) : false) {
        tmp_0 = charSequenceGet(str, index);
      } else {
        // Inline function 'korlibs.korge.bitmapfont.drawText.<anonymous>.<anonymous>' call
        tmp_0 = _Char___init__impl__6a9atx(32);
      }
      var tmp$ret$1 = tmp_0;
      var c2 = Char__toInt_impl_vasixd(tmp$ret$1);
      var glyph = _this__u8e3s4.h1(c1);
      var tex = glyph.p5q_1;
      var tmp0_tex = ctx.p9o(tex);
      var tmp1_x = dx + glyph.q5q_1;
      var tmp2_y = dy + glyph.r5q_1;
      var tmp3_width = tex.r4r_1;
      var tmp4_height = tex.s4r_1;
      var tmp5_m = get_immutable(m2);
      this_0.q9o(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp5_m, filtering, colMul, blendMode);
      var tmp6_safe_receiver = _this__u8e3s4.e5r().h1(Companion_instance_5.m5q(c1, c2));
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.x5q_1;
      var kerningOffset = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      dx = dx + (glyph.s5q_1 + kerningOffset | 0);
    }
     while (inductionVariable <= last);
    tmp = Unit_instance;
  }
}
var debugBmpFontOrNull;
function *_generator_debugBmpFont__zhh4ef($completion) {
  if (debugBmpFontOrNull == null) {
    var tmp = readBitmap(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    debugBmpFontOrNull = debugBmpFont_0(slice(tmp.o5e()));
  }
  return ensureNotNull(debugBmpFontOrNull);
}
function debugBmpFont($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_debugBmpFont__zhh4ef.bind(VOID), $completion);
}
function debugBmpFont_0(tex) {
  var fntAdvance = 7.0;
  var fntWidth = 8.0;
  var fntHeight = 8.0;
  var fntBlockX = 2.0;
  var fntBlockY = 2.0;
  var fntBlockWidth = 12.0;
  var fntBlockHeight = 12.0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var base = fntHeight - 1.0;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = until(0, 256);
  var result = LinkedHashMap.xc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var inductionVariable = this_0.f2_1;
  var last = this_0.g2_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.bitmapfont.debugBmpFont.<anonymous>' call
      var it = element;
      var x = it % 16 | 0;
      var y = it / 16 | 0;
      var tmp$ret$0 = new Glyph(fntHeight, it, tex.z4s(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
      result.k3(element, tmp$ret$0);
    }
     while (!(element === last));
  var glyphs = toIntMap(result);
  var kernings = IntMap.a41();
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(base), glyphs, kernings, name, null);
}
function get_DEBUG_FONT_BYTES() {
  return fromBase64('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');
}
var Companion_instance_60;
function Companion_getInstance_66() {
  if (Companion_instance_60 === VOID)
    new Companion_51();
  return Companion_instance_60;
}
var Companion_instance_61;
function Companion_getInstance_67() {
  return Companion_instance_61;
}
function endFrameOldKeys($this, delta) {
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var prev = $this.y9p_1[n];
      var curr = $this.x9p_1[n];
      $this.d9q_1[n] = (prev && !curr);
      $this.c9q_1[n] = (!prev && curr);
      if (curr) {
        var _array__4zh2yp = $this.z9p_1;
        _array__4zh2yp[n] = _array__4zh2yp[n] + _FastDuration___get_fastNanoseconds__impl__9kjwbr(delta);
      } else {
        $this.z9p_1[n] = 0.0;
        $this.a9q_1[n] = 0.0;
      }
      var triggerPress = false;
      var pressingTime = get_fastNanoseconds($this.z9p_1[n]);
      if ($this.z9p_1[n] > 0) {
        var tmp0_subject = _FastDuration___get_fastMilliseconds__impl__pe68va(pressingTime);
        var timeBarrier = (0.0 <= tmp0_subject ? tmp0_subject <= 1.0 : false) ? get_fastMilliseconds(0.0) : (1.0 <= tmp0_subject ? tmp0_subject <= 300.0 : false) ? get_fastMilliseconds(100.0) : (300.0 <= tmp0_subject ? tmp0_subject <= 1000.0 : false) ? get_fastMilliseconds(50.0) : get_fastMilliseconds(20.0);
        var elapsedTime = FastDuration__minus_impl_evs237(pressingTime, get_fastNanoseconds($this.a9q_1[n]));
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, timeBarrier) >= 0) {
          triggerPress = true;
        }
      }
      if (triggerPress) {
        $this.a9q_1[n] = $this.z9p_1[n];
      }
      $this.b9q_1[n] = triggerPress;
    }
     while (inductionVariable < 256);
  arraycopy_4($this.x9p_1, 0, $this.y9p_1, 0, 256);
}
function Input$_isTouchDeviceGen$lambda() {
  return AGOpenglFactory_instance.g9q();
}
var DefaultViewport_instance;
function DefaultViewport_getInstance() {
  if (DefaultViewport_instance === VOID)
    new DefaultViewport();
  return DefaultViewport_instance;
}
function *_generator_configureLoggerFromProperties__heiqlb(file, $completion) {
  try {
    var tmp = file.e3h(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    configureLoggerFromProperties_0(tmp);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function configureLoggerFromProperties(file, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_configureLoggerFromProperties__heiqlb.bind(VOID, file), $completion);
}
function configureLoggerFromProperties_0(str) {
  var props = Companion_instance_62.t9q(str);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = props.u1().b1();
  while (_iterator__ex2g4s.c1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.d1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.v1();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.w1();
    try {
      var tmp = Companion_getInstance_1().g26(key);
      // Inline function 'kotlin.text.toUpperCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = value.toUpperCase();
      tmp.j46(valueOf(tmp$ret$4));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
}
var Companion_instance_62;
function Companion_getInstance_68() {
  return Companion_instance_62;
}
function AgAutoFreeManager$entryPool$lambda(it) {
  it.u1w();
  return Unit_instance;
}
function AgAutoFreeManager$entryPool$lambda_0(it) {
  return new Entry();
}
function getTextureInfo($this, bitmap) {
  if ($this.b9s_1 === bitmap && ensureNotNull($this.c9s_1).k9r_1.o9r_1 === bitmap.a57_1)
    return ensureNotNull($this.c9s_1);
  if ($this.d9s_1 === bitmap && ensureNotNull($this.e9s_1).k9r_1.o9r_1 === bitmap.a57_1)
    return ensureNotNull($this.e9s_1);
  $this.v9r_1.s3z(bitmap);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = $this.a9s_1;
    var res = get_0(this_0, bitmap);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = $this.z9r_1.f42();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>.<anonymous>' call
    var base = this_1.k9r_1;
    base.o9r_1 = -1;
    var tmp = base;
    var tmp_0;
    if (bitmap instanceof MultiBitmap) {
      tmp_0 = Companion_getInstance_50().p88_1;
    } else {
      tmp_0 = Companion_getInstance_50().n88_1;
    }
    tmp.m9r_1 = new AGTexture(tmp_0);
    base.q9r(bitmap.r56_1);
    base.r9r(bitmap.s56_1);
    var out = this_1;
    set(this_0, bitmap, out);
    tmp$ret$0 = out;
  }
  var textureInfo = tmp$ret$0;
  $this.d9s_1 = $this.b9s_1;
  $this.e9s_1 = $this.c9s_1;
  var base_0 = textureInfo.k9r_1;
  $this.b9s_1 = bitmap;
  $this.c9s_1 = textureInfo;
  if (!(bitmap.a57_1 === base_0.o9r_1)) {
    base_0.o9r_1 = bitmap.a57_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.Long.minus' call
    var this_2 = $this.y9r_1;
    var other = textureInfo.j9r_1;
    tmp_1.y9r_1 = this_2.c2(toLong(other));
    try {
      base_0.k9s(bitmap, bitmap.c57_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
    }finally {
      textureInfo.j9r_1 = _get_estimateSizeInBytes__tshb4c(bitmap, $this);
      var tmp_2 = $this;
      // Inline function 'kotlin.Long.plus' call
      var this_3 = $this.y9r_1;
      var other_0 = textureInfo.j9r_1;
      tmp_2.y9r_1 = this_3.w3(toLong(other_0));
    }
    bitmap.n57();
  }
  return textureInfo;
}
function _get_estimateSizeInBytes__tshb4c(_this__u8e3s4, $this) {
  return imul(_this__u8e3s4.s56_1, imul(_this__u8e3s4.r56_1, _this__u8e3s4.t56_1) / 8 | 0);
}
function _getTexture($this, slice) {
  if ($this.f9s_1 === slice)
    return ensureNotNull($this.g9s_1);
  if ($this.h9s_1 === slice)
    return ensureNotNull($this.i9s_1);
  var info = getTextureInfo($this, slice.r4s());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = info.l9r_1;
    var res = get_0(this_0, slice);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager._getTexture.<anonymous>' call
    var tmp;
    if (slice instanceof RectSlice) {
      tmp = Texture_1(info.k9r_1).b4t(RectangleInt.j3r(slice.i3j(), slice.d3q(), slice.r4r_1, slice.s4r_1));
    } else {
      tmp = Companion_instance_7.p4t(info.k9r_1, slice);
    }
    var out = tmp;
    set(this_0, slice, out);
    tmp$ret$0 = out;
  }
  var texture = tmp$ret$0;
  $this.h9s_1 = $this.f9s_1;
  $this.i9s_1 = $this.g9s_1;
  $this.f9s_1 = slice;
  $this.g9s_1 = texture;
  return texture;
}
function clearFastCacheAccess($this) {
  $this.b9s_1 = null;
  $this.c9s_1 = null;
  $this.d9s_1 = null;
  $this.e9s_1 = null;
  $this.f9s_1 = null;
  $this.g9s_1 = null;
  $this.h9s_1 = null;
  $this.i9s_1 = null;
}
function AgBitmapTextureManager$textureInfoPool$lambda(it) {
  it.u1w();
  return Unit_instance;
}
function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
  return new BitmapTextureInfo();
}
function removeCache($this) {
}
function AgBufferManager$bufferPool$lambda(it) {
  return new AGBuffer();
}
function get_logger() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return logger_0;
}
var logger_0;
function get_BB_MAX_TEXTURES() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return BB_MAX_TEXTURES;
}
var BB_MAX_TEXTURES;
function BatchBuilder2D$Companion$createTextureLookup$lambda($$this$apply) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.l8k($this$IF_ELSE_BINARY_LOOKUP.o8k(), $this$IF_ELSE_BINARY_LOOKUP.w8k(Companion_getInstance_69().c9t_1[n], $this$IF_ELSE_BINARY_LOOKUP.u8k($$this$apply.h8k(), 'xy')));
    return Unit_instance;
  };
}
function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
  return 6;
}
function applyMatrix($this, matrix, idx, vcount) {
  var f32 = get_f32($this.r9n_1);
  var idx_0 = idx;
  var ma = matrix.e3m_1;
  var mb = matrix.f3m_1;
  var mc = matrix.g3m_1;
  var md = matrix.h3m_1;
  var mtx = matrix.i3m_1;
  var mty = matrix.j3m_1;
  var inductionVariable = 0;
  if (inductionVariable < vcount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = Vector2D.m3q(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
      var pt = Companion_getInstance_7().m3m(ma, mb, mc, md, mtx, mty, p);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, pt.r3i_1);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, pt.s3i_1);
      idx_0 = idx_0 + 6 | 0;
    }
     while (inductionVariable < vcount);
}
function checkAvailable($this, indices, vertices) {
  return ($this.x9n_1 + indices | 0) < $this.q9n_1 && ($this.w9n_1 + vertices | 0) < $this.p9n_1;
}
var Companion_instance_63;
function Companion_getInstance_69() {
  if (Companion_instance_63 === VOID)
    new Companion_54();
  return Companion_instance_63;
}
function BatchBuilder2D$lambda(this$0) {
  return function (it) {
    var tmp;
    switch (it.p3_1) {
      case 0:
        this$0.t9t();
        tmp = Unit_instance;
        break;
      case 1:
        this$0.u9t();
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  };
}
function BatchBuilder2D$buffers$lambda(it) {
  return new BatchBuffers();
}
var properties_initialized_BatchBuilder2D_kt_532b2j;
function _init_properties_BatchBuilder2D_kt__vdn94j() {
  if (!properties_initialized_BatchBuilder2D_kt_532b2j) {
    properties_initialized_BatchBuilder2D_kt_532b2j = true;
    logger_0 = Companion_getInstance_1().g26('BatchBuilder2D');
    BB_MAX_TEXTURES = Companion_getInstance_3().p23() && Companion_getInstance_3().s23().a23_1 && Companion_getInstance_3().s23().f23() ? 1 : 4;
  }
}
function get_debugLineRenderContext(_this__u8e3s4) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = debugLineRenderContext$delegate;
    var property = debugLineRenderContext$factory();
    var tmp0_elvis_lhs = this_0.g28_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.h28_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.g28_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var debugLineRenderContext$delegate;
var Companion_instance_64;
function Companion_getInstance_70() {
  if (Companion_instance_64 === VOID)
    new Companion_55();
  return Companion_instance_64;
}
function addVertex($this, x, y, color, m) {
  setFloat32($this.h9w_1, $this.k9w_1 + 0 | 0, m.s3m(x, y));
  setFloat32($this.h9w_1, $this.k9w_1 + 1 | 0, m.t3m(x, y));
  setInt32($this.h9w_1, $this.k9w_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
  $this.k9w_1 = $this.k9w_1 + (Companion_getInstance_70().w9v_1.f8c_1 / 4 | 0) | 0;
  $this.j9w_1 = $this.j9w_1 + 1 | 0;
}
function LineRenderBatcher$lambda(this$0) {
  return function (it) {
    this$0.gd();
    return Unit_instance;
  };
}
function debugLineRenderContext$delegate$lambda($this$PropertyThis) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  return new LineRenderBatcher($this$PropertyThis);
}
function debugLineRenderContext$factory() {
  return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
    return get_debugLineRenderContext(receiver);
  }, null);
}
var properties_initialized_LineRenderBatcher_kt_urwcod;
function _init_properties_LineRenderBatcher_kt__ezqewb() {
  if (!properties_initialized_LineRenderBatcher_kt_urwcod) {
    properties_initialized_LineRenderBatcher_kt_urwcod = true;
    debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
  }
}
var FlushKind_STATE_instance;
var FlushKind_FULL_instance;
var FlushKind_entriesInitialized;
function FlushKind_initEntries() {
  if (FlushKind_entriesInitialized)
    return Unit_instance;
  FlushKind_entriesInitialized = true;
  FlushKind_STATE_instance = new FlushKind('STATE', 0);
  FlushKind_FULL_instance = new FlushKind('FULL', 1);
}
function RenderContext$tempTexturePool$lambda(it) {
  return new AGTexture();
}
function RenderContext$projViewMatUB$delegate$lambda(this$0) {
  return function () {
    return this$0.d8a(ProjViewUB_getInstance());
  };
}
function RenderContext$dynamicVertexBufferPool$lambda(it) {
  return new AGBuffer();
}
function RenderContext$frameBuffers$lambda(it) {
  return AGFrameBuffer.u83(VOID, it);
}
function FlushKind_FULL_getInstance() {
  FlushKind_initEntries();
  return FlushKind_FULL_instance;
}
function projViewMatUB$factory() {
  return getPropertyCallableRef('projViewMatUB', 1, KProperty1, function (receiver) {
    return receiver.v9w();
  }, null);
}
function get_logger_0() {
  _init_properties_RenderContext2D_kt__7o43tz();
  return logger_1;
}
var logger_1;
function RenderContext2D$mpool$lambda(it) {
  return new MMatrix();
}
var properties_initialized_RenderContext2D_kt_ica10b;
function _init_properties_RenderContext2D_kt__7o43tz() {
  if (!properties_initialized_RenderContext2D_kt_ica10b) {
    properties_initialized_RenderContext2D_kt_ica10b = true;
    logger_1 = Companion_getInstance_1().g26('RenderContext2D');
  }
}
function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
  $this$FUNC.t8l($this$FUNC.m95(a, b, c));
  return Unit_instance;
}
function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.t8l($this$FUNC.j95(a, b));
  return Unit_instance;
}
function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.t8l($this$FUNC.k95(a, b));
  return Unit_instance;
}
function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.t8l($this$FUNC.k95(a, $this$FUNC.o95(b)));
  return Unit_instance;
}
function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.t8l($this$FUNC.y8l(d, r));
  return Unit_instance;
}
function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.t8l($this$FUNC.y8l($this$FUNC.v8l(d), r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
  // Inline function 'korlibs.graphics.shader.Builder.IF' call
  var cond = $this$FUNC.t95(d, 0.0);
  var body = $this$FUNC.c8l();
  // Inline function 'korlibs.korge.render.SDFShaders.opBorderInner$delegate.<anonymous>.<anonymous>' call
  body.t8l(d);
  var stmIf = new If(cond, body.e8l());
  // Inline function 'kotlin.collections.plusAssign' call
  $this$FUNC.k8k_1.h(stmIf);
  var tmp = stmIf;
  $this$FUNC.q8l(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
  return function ($this$ELSE) {
    $this$ELSE.t8l($this$ELSE.y8l($this$ELSE.v8l($d), $r));
    return Unit_instance;
  };
}
function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
  $this$FUNC.t8l($this$FUNC.p95(1.0, $this$FUNC.i95($this$FUNC.r95($this$FUNC.a8l(d, $this$FUNC.l95(d)), 0.5), $this$FUNC.r8k(0.0), $this$FUNC.r8k(1.0))));
  return Unit_instance;
}
function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
  $this$FUNC.t8l($this$FUNC.i95($this$FUNC.r95($this$FUNC.a8l(d, $this$FUNC.l95(d)), 0.5), $this$FUNC.r8k(0.0), $this$FUNC.r8k(1.0)));
  return Unit_instance;
}
function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.g95($this$FUNC.i95($this$FUNC.q95(0.5, $this$FUNC.a8l($this$FUNC.s95(0.5, $this$FUNC.y8l(d2, d1)), k)), $this$FUNC.r8k(0.0), $this$FUNC.r8k(1.0)));
  $this$FUNC.t8l($this$FUNC.y8l($this$FUNC.m95(d2, d1, h), $this$FUNC.p8k($this$FUNC.p8k(k, h), $this$FUNC.p95(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.g95($this$FUNC.i95($this$FUNC.p95(0.5, $this$FUNC.a8l($this$FUNC.s95(0.5, $this$FUNC.z8l(d2, d1)), k)), $this$FUNC.r8k(0.0), $this$FUNC.r8k(1.0)));
  $this$FUNC.t8l($this$FUNC.z8l($this$FUNC.m95(d2, $this$FUNC.o95(d1), h), $this$FUNC.p8k($this$FUNC.p8k(k, h), $this$FUNC.p95(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.g95($this$FUNC.i95($this$FUNC.p95(0.5, $this$FUNC.a8l($this$FUNC.s95(0.5, $this$FUNC.y8l(d2, d1)), k)), $this$FUNC.r8k(0.0), $this$FUNC.r8k(1.0)));
  $this$FUNC.t8l($this$FUNC.z8l($this$FUNC.m95(d2, d1, h), $this$FUNC.p8k($this$FUNC.p8k(k, h), $this$FUNC.p95(1.0, h))));
  return Unit_instance;
}
function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
  $this$FUNC.t8l($this$FUNC.y8l($this$FUNC.n95(p), r));
  return Unit_instance;
}
function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
  $this$FUNC.l8k($this$FUNC.u8k(r, 'xy'), $this$FUNC.h95($this$FUNC.t95($this$FUNC.w8l(p), 0.0), $this$FUNC.u8k(r, 'xy'), $this$FUNC.u8k(r, 'zw')));
  $this$FUNC.l8k($this$FUNC.w8l(r), $this$FUNC.h95($this$FUNC.t95($this$FUNC.x8l(p), 0.0), $this$FUNC.w8l(r), $this$FUNC.x8l(r)));
  var q = $this$FUNC.g95($this$FUNC.z8l($this$FUNC.y8l($this$FUNC.v8l(p), b), $this$FUNC.w8l(r)));
  $this$FUNC.t8l($this$FUNC.y8l($this$FUNC.z8l($this$FUNC.j95($this$FUNC.k95($this$FUNC.w8l(q), $this$FUNC.x8l(q)), $this$FUNC.r8k(0.0)), $this$FUNC.n95($this$FUNC.k95(q, $this$FUNC.r8k(0.0)))), $this$FUNC.w8l(r)));
  return Unit_instance;
}
function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
  var d = $this$FUNC.g95($this$FUNC.y8l($this$FUNC.v8l(p), b));
  $this$FUNC.t8l($this$FUNC.z8l($this$FUNC.n95($this$FUNC.k95(d, $this$FUNC.r8k(0.0))), $this$FUNC.j95($this$FUNC.k95($this$FUNC.w8l(d), $this$FUNC.x8l(d)), $this$FUNC.r8k(0.0))));
  return Unit_instance;
}
function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
  $this$FUNC.t8l($this$FUNC.z8l(src, $this$FUNC.p8k(dst, $this$FUNC.p95(1.0, $this$FUNC.y8k(src)))));
  return Unit_instance;
}
var SDFShaders_instance;
function SDFShaders_getInstance() {
  if (SDFShaders_instance === VOID)
    SDFShaders.u9y();
  return SDFShaders_instance;
}
function opInterpolate$factory() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.v9y();
  }, null);
}
function opUnion$factory() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.w9y();
  }, null);
}
function opIntersect$factory() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.x9y();
  }, null);
}
function opSubtract$factory() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.y9y();
  }, null);
}
function opRound$factory() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.z9y();
  }, null);
}
function opBorder$factory() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.a9z();
  }, null);
}
function opBorderInner$factory() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.b9z();
  }, null);
}
function opAA$factory() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.c9z();
  }, null);
}
function opAARev$factory() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.d9z();
  }, null);
}
function opSmoothUnion$factory() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.e9z();
  }, null);
}
function opSmoothSubtraction$factory() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.f9z();
  }, null);
}
function opSmoothIntersection$factory() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.g9z();
  }, null);
}
function circle$factory() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.h9z();
  }, null);
}
function roundedBox$factory() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.i9z();
  }, null);
}
function box$factory() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.j9z();
  }, null);
}
function opCombinePremultipliedColors$factory() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.k9z();
  }, null);
}
function opInterpolate$factory_0() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.v9y();
  }, null);
}
function opUnion$factory_0() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.w9y();
  }, null);
}
function opIntersect$factory_0() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.x9y();
  }, null);
}
function opSubtract$factory_0() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.y9y();
  }, null);
}
function opRound$factory_0() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.z9y();
  }, null);
}
function opBorder$factory_0() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.a9z();
  }, null);
}
function opBorderInner$factory_0() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.b9z();
  }, null);
}
function opAA$factory_0() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.c9z();
  }, null);
}
function opAARev$factory_0() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.d9z();
  }, null);
}
function opSmoothUnion$factory_0() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.e9z();
  }, null);
}
function opSmoothSubtraction$factory_0() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.f9z();
  }, null);
}
function opSmoothIntersection$factory_0() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.g9z();
  }, null);
}
function circle$factory_0() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.h9z();
  }, null);
}
function roundedBox$factory_0() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.i9z();
  }, null);
}
function box$factory_0() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.j9z();
  }, null);
}
function opCombinePremultipliedColors$factory_0() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.k9z();
  }, null);
}
function Texture(frameBuffer) {
  return Texture_0(frameBuffer.s87(), frameBuffer.o83_1, frameBuffer.p83_1);
}
function Texture_0(agBase, width, height) {
  return new RectSlice(TextureBase.l9z(agBase, SizeInt.x3s(width, height)), RectangleInt.j3r(0, 0, width, height));
}
function Texture_1(base, left, top, right, bottom) {
  left = left === VOID ? 0 : left;
  top = top === VOID ? 0 : top;
  right = right === VOID ? base.f3u() : right;
  bottom = bottom === VOID ? base.g3u() : bottom;
  return new RectSlice(base, Companion_instance_2.p3q(left, top, right, bottom));
}
function get_TEXTURED_ARRAY_QUAD_INDICES() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_QUAD_INDICES;
}
var TEXTURED_ARRAY_QUAD_INDICES;
var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
function get_TEXTURED_ARRAY_EMPTY_SHORT_ARRAY() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
}
var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
var Companion_instance_65;
function Companion_getInstance_71() {
  if (Companion_instance_65 === VOID)
    new Companion_56();
  return Companion_instance_65;
}
function TEXTURED_ARRAY_quadIndices(quadCount) {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  if (quadCount === 0)
    return get_TEXTURED_ARRAY_EMPTY_SHORT_ARRAY();
  var out = new Int16Array(imul(quadCount, 6));
  var m = 0;
  var base = 0;
  var inductionVariable = 0;
  if (inductionVariable < quadCount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = m;
      m = _unary__edvuaz + 1 | 0;
      out[_unary__edvuaz] = toShort(base + 0 | 0);
      var _unary__edvuaz_0 = m;
      m = _unary__edvuaz_0 + 1 | 0;
      out[_unary__edvuaz_0] = toShort(base + 1 | 0);
      var _unary__edvuaz_1 = m;
      m = _unary__edvuaz_1 + 1 | 0;
      out[_unary__edvuaz_1] = toShort(base + 2 | 0);
      var _unary__edvuaz_2 = m;
      m = _unary__edvuaz_2 + 1 | 0;
      out[_unary__edvuaz_2] = toShort(base + 3 | 0);
      var _unary__edvuaz_3 = m;
      m = _unary__edvuaz_3 + 1 | 0;
      out[_unary__edvuaz_3] = toShort(base + 0 | 0);
      var _unary__edvuaz_4 = m;
      m = _unary__edvuaz_4 + 1 | 0;
      out[_unary__edvuaz_4] = toShort(base + 2 | 0);
      base = base + 4 | 0;
    }
     while (inductionVariable < quadCount);
  return out;
}
var properties_initialized_TexturedVertexArray_kt_ouua70;
function _init_properties_TexturedVertexArray_kt__kev7cq() {
  if (!properties_initialized_TexturedVertexArray_kt_ouua70) {
    properties_initialized_TexturedVertexArray_kt_ouua70 = true;
    // Inline function 'kotlin.shortArrayOf' call
    TEXTURED_ARRAY_QUAD_INDICES = new Int16Array([0, 1, 2, 3, 0, 2]);
    TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
    TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
  }
}
function _get_root__dd8asp($this) {
  var tmp = $this.v9z_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('root');
  }
}
function _get_mountable__707cy($this) {
  var tmp = $this.w9z_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mountable');
  }
}
function _interpolateRatio(ratio, l, r) {
  return interpolate(ratio, l, r);
}
var DEFAULT_instance;
function DEFAULT_getInstance() {
  return DEFAULT_instance;
}
var GLOBAL_CHECK_GL;
var Cursor_DEFAULT_instance;
var Cursor_CROSSHAIR_instance;
var Cursor_TEXT_instance;
var Cursor_HAND_instance;
var Cursor_MOVE_instance;
var Cursor_WAIT_instance;
var Cursor_RESIZE_EAST_instance;
var Cursor_RESIZE_WEST_instance;
var Cursor_RESIZE_SOUTH_instance;
var Cursor_RESIZE_NORTH_instance;
var Cursor_RESIZE_NORTH_EAST_instance;
var Cursor_RESIZE_NORTH_WEST_instance;
var Cursor_RESIZE_SOUTH_EAST_instance;
var Cursor_RESIZE_SOUTH_WEST_instance;
var Companion_instance_66;
function Companion_getInstance_72() {
  Cursor_initEntries();
  if (Companion_instance_66 === VOID)
    new Companion_57();
  return Companion_instance_66;
}
var Cursor_entriesInitialized;
function Cursor_initEntries() {
  if (Cursor_entriesInitialized)
    return Unit_instance;
  Cursor_entriesInitialized = true;
  Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
  Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
  Cursor_TEXT_instance = new Cursor('TEXT', 2);
  Cursor_HAND_instance = new Cursor('HAND', 3);
  Cursor_MOVE_instance = new Cursor('MOVE', 4);
  Cursor_WAIT_instance = new Cursor('WAIT', 5);
  Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
  Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
  Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
  Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
  Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
  Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
  Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
  Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
  Companion_getInstance_72();
}
function GameWindow$MenuItem$_init_$lambda_465oqx() {
  return Unit_instance;
}
var Quality_PERFORMANCE_instance;
var Quality_QUALITY_instance;
var Quality_AUTOMATIC_instance;
var Quality_entriesInitialized;
function Quality_initEntries() {
  if (Quality_entriesInitialized)
    return Unit_instance;
  Quality_entriesInitialized = true;
  Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0, 0.0);
  Quality_QUALITY_instance = new Quality('QUALITY', 1, 1.0);
  Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2, 0.5);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.za0_1($this.aa1_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var CoroutineKey_instance;
function CoroutineKey_getInstance() {
  if (CoroutineKey_instance === VOID)
    new CoroutineKey();
  return CoroutineKey_instance;
}
function _get_fpsCached__581dty($this) {
  return $this.ga2_1.np($this, fpsCached$factory());
}
function *_generator_waitClose__fhnm35($this, $completion) {
  while ($this.va2_1) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    var tmp = delay_0(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_loop__qll5p8($this, entry, $completion) {
  var tmp = $this.za3($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.eo(CoroutineName.v2l('GameWindow.loop'));
  launchImmediately(tmp_0, GameWindow$loop$slambda_0(entry, $this));
  while ($this.va2_1) {
    var elapsed;
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.fk();
    // Inline function 'korlibs.render.GameWindow.loop.<anonymous>' call
    elapsed = $this.aa4();
    var realElapsed = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    var available = FastDuration__minus_impl_evs237($this.ba4(), elapsed);
    if (FastDuration__compareTo_impl_4fhnj7(available, Companion_instance_3.r35()) > 0) {
      var tmp_1 = $this.ca4(available, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  return Unit_instance;
}
function *_generator_loopDelay__vgtnit($this, time, $completion) {
  var tmp = delay(time, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function GameWindow$fpsCached$delegate$lambda(this$0) {
  return function () {
    return this$0.da4();
  };
}
function GameWindow$loop$slambda_0($entry, this$0) {
  var i = new GameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function Cursor_DEFAULT_getInstance() {
  Cursor_initEntries();
  return Cursor_DEFAULT_instance;
}
function Cursor_RESIZE_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_EAST_instance;
}
function Cursor_RESIZE_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_WEST_instance;
}
function Cursor_RESIZE_SOUTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_instance;
}
function Cursor_RESIZE_NORTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_instance;
}
function Cursor_RESIZE_NORTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_EAST_instance;
}
function Cursor_RESIZE_NORTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_WEST_instance;
}
function Cursor_RESIZE_SOUTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_EAST_instance;
}
function Cursor_RESIZE_SOUTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_WEST_instance;
}
function Quality_PERFORMANCE_getInstance() {
  Quality_initEntries();
  return Quality_PERFORMANCE_instance;
}
function Quality_AUTOMATIC_getInstance() {
  Quality_initEntries();
  return Quality_AUTOMATIC_instance;
}
var Companion_instance_67;
function Companion_getInstance_73() {
  if (Companion_instance_67 === VOID)
    new Companion_58();
  return Companion_instance_67;
}
function configure(_this__u8e3s4, size, title, icon, fullscreen, bgcolor) {
  title = title === VOID ? 'GameWindow' : title;
  icon = icon === VOID ? null : icon;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  bgcolor = bgcolor === VOID ? Colors_getInstance().z57_1 : bgcolor;
  _this__u8e3s4.pa5(numberToInt(size.u3j_1), numberToInt(size.v3j_1));
  if (!(title == null)) {
    _this__u8e3s4.ga5(title);
  }
  _this__u8e3s4.ha5(icon);
  if (!(fullscreen == null)) {
    _this__u8e3s4.ia5(fullscreen);
  }
  _this__u8e3s4.ka5(bgcolor);
  _this__u8e3s4.ja5(true);
}
function fpsCached$factory() {
  return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
    return _get_fpsCached__581dty(receiver);
  }, null);
}
function continuousRenderMode$factory() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.wa5();
  }, function (receiver, value) {
    return receiver.va5(value);
  });
}
function continuousRenderMode$factory_0() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.wa5();
  }, function (receiver, value) {
    return receiver.va5(value);
  });
}
var Companion_instance_68;
function Companion_getInstance_74() {
  if (Companion_instance_68 === VOID)
    new Companion_59();
  return Companion_instance_68;
}
function GameWindowCoroutineDispatcher$_init_$lambda_ooms1e() {
  return new FastDuration(PerformanceCounter_getInstance().a7t());
}
function GameWindowCoroutineDispatcher$timedTasks$lambda(a, b) {
  return FastDuration__compareTo_impl_4fhnj7(a.wa6_1, b.wa6_1);
}
function GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda($task) {
  return function (it) {
    $task.za6_1 = it;
    return Unit_instance;
  };
}
function GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this$0, $task) {
  return function () {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this$0.qa4_1.x35_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this$0.pa4_1.q3y($task);
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$dispatch$lambda($block) {
  return function () {
    $block.l2k();
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda($cancelled) {
  return function (it) {
    $cancelled._v = it;
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($cancelled, $continuation) {
  return function () {
    var tmp;
    if (!($cancelled._v == null)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull($cancelled._v);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.jd(tmp$ret$0);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      var this_1 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      this_1.jd(tmp$ret$2);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.l2k();
    return Unit_instance;
  };
}
var Companion_instance_69;
function Companion_getInstance_75() {
  return Companion_instance_69;
}
var korgwJvmEngine;
function get_SDLPath() {
  _init_properties_SDL_kt__pqu7sn();
  // Inline function 'kotlin.getValue' call
  var this_0 = SDLPath$delegate;
  SDLPath$factory();
  return this_0.w1();
}
var SDLPath$delegate;
var Companion_instance_70;
function Companion_getInstance_76() {
  return Companion_instance_70;
}
var Companion_instance_71;
function Companion_getInstance_77() {
  return Companion_instance_71;
}
function SDLPath$delegate$lambda() {
  _init_properties_SDL_kt__pqu7sn();
  return Companion_getInstance_3().q23() ? '/Library/Frameworks/SDL2.framework/SDL2' : 'SDL2.dll';
}
function SDLPath$factory() {
  return getPropertyCallableRef('SDLPath', 0, KProperty0, function () {
    return get_SDLPath();
  }, null);
}
function SDL_Init$factory() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.ra8();
  }, null);
}
function SDL_CreateWindow$factory() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.sa8();
  }, null);
}
function SDL_SetWindowTitle$factory() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.ta8();
  }, null);
}
function SDL_SetWindowSize$factory() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.ua8();
  }, null);
}
function SDL_SetWindowPosition$factory() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.va8();
  }, null);
}
function SDL_ShowWindow$factory() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.wa8();
  }, null);
}
function SDL_RaiseWindow$factory() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.xa8();
  }, null);
}
function SDL_PollEvent$factory() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.ya8();
  }, null);
}
function SDL_Quit$factory() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.za8();
  }, null);
}
function SDL_GL_CreateContext$factory() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.aa9();
  }, null);
}
function SDL_GL_DeleteContext$factory() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.ba9();
  }, null);
}
function SDL_GL_MakeCurrent$factory() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.ca9();
  }, null);
}
function SDL_GL_SwapWindow$factory() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.da9();
  }, null);
}
function SDL_Init$factory_0() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.ra8();
  }, null);
}
function SDL_CreateWindow$factory_0() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.sa8();
  }, null);
}
function SDL_SetWindowTitle$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.ta8();
  }, null);
}
function SDL_SetWindowSize$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.ua8();
  }, null);
}
function SDL_SetWindowPosition$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.va8();
  }, null);
}
function SDL_ShowWindow$factory_0() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.wa8();
  }, null);
}
function SDL_RaiseWindow$factory_0() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.xa8();
  }, null);
}
function SDL_PollEvent$factory_0() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.ya8();
  }, null);
}
function SDL_Quit$factory_0() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.za8();
  }, null);
}
function SDL_GL_CreateContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.aa9();
  }, null);
}
function SDL_GL_DeleteContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.ba9();
  }, null);
}
function SDL_GL_MakeCurrent$factory_0() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.ca9();
  }, null);
}
function SDL_GL_SwapWindow$factory_0() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.da9();
  }, null);
}
function glDrawArraysInstanced$factory() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.qai();
  }, null);
}
function glDrawElementsInstanced$factory() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.rai();
  }, null);
}
function glVertexAttribDivisor$factory() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.sai();
  }, null);
}
function glTexSubImage2D$factory() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.zai();
  }, null);
}
function glTexImage2D$factory() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.zah();
  }, null);
}
function glTexParameteri$factory() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.aai();
  }, null);
}
function glTexParameterf$factory() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.aaj();
  }, null);
}
function glTexParameterfv$factory() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.baj();
  }, null);
}
function glTexParameteriv$factory() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.caj();
  }, null);
}
function glStencilOp$factory() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.xah();
  }, null);
}
function glStencilMask$factory() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.vah();
  }, null);
}
function glReadPixels$factory() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.daj();
  }, null);
}
function glStencilFunc$factory() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.tah();
  }, null);
}
function glScissor$factory() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.rah();
  }, null);
}
function glPolygonOffset$factory() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.eaj();
  }, null);
}
function glPixelStorei$factory() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.pah();
  }, null);
}
function glLineWidth$factory() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.faj();
  }, null);
}
function glGetTexParameterfv$factory() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.gaj();
  }, null);
}
function glGetTexParameteriv$factory() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.haj();
  }, null);
}
function glGetError$factory() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.iah();
  }, null);
}
function glGetFloatv$factory() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.iaj();
  }, null);
}
function glGetIntegerv$factory() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.jah();
  }, null);
}
function glGetBooleanv$factory() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.jaj();
  }, null);
}
function glGenTextures$factory() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.gah();
  }, null);
}
function glDepthRange$factory() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.kaj();
  }, null);
}
function glDepthRangef$factory() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.rag();
  }, null);
}
function glClearDepth$factory() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.laj();
  }, null);
}
function glClearDepthf$factory() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.cag();
  }, null);
}
function glDrawArrays$factory() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.uag();
  }, null);
}
function glDrawElements$factory() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.vag();
  }, null);
}
function glFrontFace$factory() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.bah();
  }, null);
}
function glFinish$factory() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.maj();
  }, null);
}
function glFlush$factory() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.yag();
  }, null);
}
function glEnable$factory() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.wag();
  }, null);
}
function glIsEnabled$factory() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.naj();
  }, null);
}
function glDisable$factory() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.sag();
  }, null);
}
function glDepthMask$factory() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.qag();
  }, null);
}
function glDepthFunc$factory() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.pag();
  }, null);
}
function glDeleteTextures$factory() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.oag();
  }, null);
}
function glCullFace$factory() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.iag();
  }, null);
}
function glCopyTexImage2D$factory() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.oaj();
  }, null);
}
function glCopyTexSubImage2D$factory() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.paj();
  }, null);
}
function glColorMask$factory() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.eag();
  }, null);
}
function glClearStencil$factory() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.dag();
  }, null);
}
function glClearColor$factory() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.bag();
  }, null);
}
function glClear$factory() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.aag();
  }, null);
}
function glBindTexture$factory() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.vaf();
  }, null);
}
function glHint$factory() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.qaj();
  }, null);
}
function glViewport$factory() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.pai();
  }, null);
}
function glGetString$factory() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.nah();
  }, null);
}
function glGetStringi$factory() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.raj();
  }, null);
}
function glVertexAttribPointer$factory() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.oai();
  }, null);
}
function glVertexAttrib4fv$factory() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.saj();
  }, null);
}
function glActiveTexture$factory() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.paf();
  }, null);
}
function glAttachShader$factory() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.qaf();
  }, null);
}
function glBindAttribLocation$factory() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.raf();
  }, null);
}
function glBindBuffer$factory() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.saf();
  }, null);
}
function glBindFramebuffer$factory() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.taf();
  }, null);
}
function glBindRenderbuffer$factory() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.uaf();
  }, null);
}
function glBlendColor$factory() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.taj();
  }, null);
}
function glBlendEquation$factory() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.uaj();
  }, null);
}
function glBlendEquationSeparate$factory() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.waf();
  }, null);
}
function glBlendFunc$factory() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.vaj();
  }, null);
}
function glBlendFuncSeparate$factory() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.xaf();
  }, null);
}
function glBufferData$factory() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.yaf();
  }, null);
}
function glBufferSubData$factory() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.zaf();
  }, null);
}
function glCheckFramebufferStatus$factory() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.waj();
  }, null);
}
function glCompileShader$factory() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.fag();
  }, null);
}
function glCompressedTexImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.xaj();
  }, null);
}
function glCompressedTexSubImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.yaj();
  }, null);
}
function glCreateProgram$factory() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.gag();
  }, null);
}
function glCreateShader$factory() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.hag();
  }, null);
}
function glDeleteBuffers$factory() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.jag();
  }, null);
}
function glDeleteFramebuffers$factory() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.kag();
  }, null);
}
function glDeleteProgram$factory() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.lag();
  }, null);
}
function glDeleteRenderbuffers$factory() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.mag();
  }, null);
}
function glDeleteShader$factory() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.nag();
  }, null);
}
function glDetachShader$factory() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.zaj();
  }, null);
}
function glDisableVertexAttribArray$factory() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.tag();
  }, null);
}
function glEnableVertexAttribArray$factory() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.xag();
  }, null);
}
function glFramebufferRenderbuffer$factory() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.zag();
  }, null);
}
function glFramebufferTexture2D$factory() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.aah();
  }, null);
}
function glGenBuffers$factory() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.cah();
  }, null);
}
function glGenerateMipmap$factory() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.dah();
  }, null);
}
function glGenFramebuffers$factory() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.eah();
  }, null);
}
function glGenRenderbuffers$factory() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.fah();
  }, null);
}
function glGetActiveAttrib$factory() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.aak();
  }, null);
}
function glGetActiveUniform$factory() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.bak();
  }, null);
}
function glGetAttachedShaders$factory() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.cak();
  }, null);
}
function glGetAttribLocation$factory() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.dak();
  }, null);
}
function glGetUniformLocation$factory() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.hah();
  }, null);
}
function glGetBufferParameteriv$factory() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.eak();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.fak();
  }, null);
}
function glGetProgramInfoLog$factory() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.gak();
  }, null);
}
function glGetRenderbufferParameteriv$factory() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.hak();
  }, null);
}
function glGetProgramiv$factory() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.kah();
  }, null);
}
function glGetShaderiv$factory() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.lah();
  }, null);
}
function glGetShaderInfoLog$factory() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.mah();
  }, null);
}
function glGetShaderPrecisionFormat$factory() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.iak();
  }, null);
}
function glGetShaderSource$factory() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.jak();
  }, null);
}
function glGetUniformfv$factory() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.kak();
  }, null);
}
function glGetUniformiv$factory() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.lak();
  }, null);
}
function glGetVertexAttribfv$factory() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.mak();
  }, null);
}
function glGetVertexAttribiv$factory() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.nak();
  }, null);
}
function glGetVertexAttribPointerv$factory() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.oak();
  }, null);
}
function glIsBuffer$factory() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.pak();
  }, null);
}
function glIsFramebuffer$factory() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.qak();
  }, null);
}
function glIsProgram$factory() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.rak();
  }, null);
}
function glIsRenderbuffer$factory() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.sak();
  }, null);
}
function glIsTexture$factory() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.tak();
  }, null);
}
function glIsShader$factory() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.uak();
  }, null);
}
function glLinkProgram$factory() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.oah();
  }, null);
}
function glReleaseShaderCompiler$factory() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.vak();
  }, null);
}
function glRenderbufferStorage$factory() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.qah();
  }, null);
}
function glSampleCoverage$factory() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.wak();
  }, null);
}
function glShaderBinary$factory() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.xak();
  }, null);
}
function glShaderSource$factory() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.sah();
  }, null);
}
function glStencilFuncSeparate$factory() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.uah();
  }, null);
}
function glStencilMaskSeparate$factory() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.wah();
  }, null);
}
function glStencilOpSeparate$factory() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.yah();
  }, null);
}
function glUniform1f$factory() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.yak();
  }, null);
}
function glUniform2f$factory() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.zak();
  }, null);
}
function glUniform3f$factory() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.aal();
  }, null);
}
function glUniform4f$factory() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.bal();
  }, null);
}
function glUniform1i$factory() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.cai();
  }, null);
}
function glUniform2i$factory() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.cal();
  }, null);
}
function glUniform3i$factory() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.dal();
  }, null);
}
function glUniform4i$factory() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.eal();
  }, null);
}
function glUniform1fv$factory() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.bai();
  }, null);
}
function glUniform2fv$factory() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.eai();
  }, null);
}
function glUniform3fv$factory() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.gai();
  }, null);
}
function glUniform4fv$factory() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.iai();
  }, null);
}
function glUniform1iv$factory() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.dai();
  }, null);
}
function glUniform2iv$factory() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.fai();
  }, null);
}
function glUniform3iv$factory() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.hai();
  }, null);
}
function glUniform4iv$factory() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.jai();
  }, null);
}
function glUniformMatrix2fv$factory() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.kai();
  }, null);
}
function glUniformMatrix3fv$factory() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.lai();
  }, null);
}
function glUniformMatrix4fv$factory() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.mai();
  }, null);
}
function glUseProgram$factory() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.nai();
  }, null);
}
function glValidateProgram$factory() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.fal();
  }, null);
}
function glVertexAttrib1f$factory() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.gal();
  }, null);
}
function glVertexAttrib2f$factory() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.hal();
  }, null);
}
function glVertexAttrib3f$factory() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.ial();
  }, null);
}
function glVertexAttrib4f$factory() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.jal();
  }, null);
}
function glVertexAttrib1fv$factory() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.kal();
  }, null);
}
function glVertexAttrib2fv$factory() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.lal();
  }, null);
}
function glVertexAttrib3fv$factory() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.mal();
  }, null);
}
function glBindBufferRange$factory() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.tai();
  }, null);
}
function glGetUniformBlockIndex$factory() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.uai();
  }, null);
}
function glUniformBlockBinding$factory() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.vai();
  }, null);
}
function glGenVertexArrays$factory() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.wai();
  }, null);
}
function glDeleteVertexArrays$factory() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.nal();
  }, null);
}
function glBindVertexArray$factory() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.xai();
  }, null);
}
function glDrawArraysInstanced$factory_0() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.qai();
  }, null);
}
function glDrawElementsInstanced$factory_0() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.rai();
  }, null);
}
function glVertexAttribDivisor$factory_0() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.sai();
  }, null);
}
function glTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.zai();
  }, null);
}
function glTexImage2D$factory_0() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.zah();
  }, null);
}
function glTexParameteri$factory_0() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.aai();
  }, null);
}
function glTexParameterf$factory_0() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.aaj();
  }, null);
}
function glTexParameterfv$factory_0() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.baj();
  }, null);
}
function glTexParameteriv$factory_0() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.caj();
  }, null);
}
function glStencilOp$factory_0() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.xah();
  }, null);
}
function glStencilMask$factory_0() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.vah();
  }, null);
}
function glReadPixels$factory_0() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.daj();
  }, null);
}
function glStencilFunc$factory_0() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.tah();
  }, null);
}
function glScissor$factory_0() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.rah();
  }, null);
}
function glPolygonOffset$factory_0() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.eaj();
  }, null);
}
function glPixelStorei$factory_0() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.pah();
  }, null);
}
function glLineWidth$factory_0() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.faj();
  }, null);
}
function glGetTexParameterfv$factory_0() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.gaj();
  }, null);
}
function glGetTexParameteriv$factory_0() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.haj();
  }, null);
}
function glGetError$factory_0() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.iah();
  }, null);
}
function glGetFloatv$factory_0() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.iaj();
  }, null);
}
function glGetIntegerv$factory_0() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.jah();
  }, null);
}
function glGetBooleanv$factory_0() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.jaj();
  }, null);
}
function glGenTextures$factory_0() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.gah();
  }, null);
}
function glDepthRange$factory_0() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.kaj();
  }, null);
}
function glDepthRangef$factory_0() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.rag();
  }, null);
}
function glClearDepth$factory_0() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.laj();
  }, null);
}
function glClearDepthf$factory_0() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.cag();
  }, null);
}
function glDrawArrays$factory_0() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.uag();
  }, null);
}
function glDrawElements$factory_0() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.vag();
  }, null);
}
function glFrontFace$factory_0() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.bah();
  }, null);
}
function glFinish$factory_0() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.maj();
  }, null);
}
function glFlush$factory_0() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.yag();
  }, null);
}
function glEnable$factory_0() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.wag();
  }, null);
}
function glIsEnabled$factory_0() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.naj();
  }, null);
}
function glDisable$factory_0() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.sag();
  }, null);
}
function glDepthMask$factory_0() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.qag();
  }, null);
}
function glDepthFunc$factory_0() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.pag();
  }, null);
}
function glDeleteTextures$factory_0() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.oag();
  }, null);
}
function glCullFace$factory_0() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.iag();
  }, null);
}
function glCopyTexImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.oaj();
  }, null);
}
function glCopyTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.paj();
  }, null);
}
function glColorMask$factory_0() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.eag();
  }, null);
}
function glClearStencil$factory_0() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.dag();
  }, null);
}
function glClearColor$factory_0() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.bag();
  }, null);
}
function glClear$factory_0() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.aag();
  }, null);
}
function glBindTexture$factory_0() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.vaf();
  }, null);
}
function glHint$factory_0() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.qaj();
  }, null);
}
function glViewport$factory_0() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.pai();
  }, null);
}
function glGetString$factory_0() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.nah();
  }, null);
}
function glGetStringi$factory_0() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.raj();
  }, null);
}
function glVertexAttribPointer$factory_0() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.oai();
  }, null);
}
function glVertexAttrib4fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.saj();
  }, null);
}
function glActiveTexture$factory_0() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.paf();
  }, null);
}
function glAttachShader$factory_0() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.qaf();
  }, null);
}
function glBindAttribLocation$factory_0() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.raf();
  }, null);
}
function glBindBuffer$factory_0() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.saf();
  }, null);
}
function glBindFramebuffer$factory_0() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.taf();
  }, null);
}
function glBindRenderbuffer$factory_0() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.uaf();
  }, null);
}
function glBlendColor$factory_0() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.taj();
  }, null);
}
function glBlendEquation$factory_0() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.uaj();
  }, null);
}
function glBlendEquationSeparate$factory_0() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.waf();
  }, null);
}
function glBlendFunc$factory_0() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.vaj();
  }, null);
}
function glBlendFuncSeparate$factory_0() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.xaf();
  }, null);
}
function glBufferData$factory_0() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.yaf();
  }, null);
}
function glBufferSubData$factory_0() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.zaf();
  }, null);
}
function glCheckFramebufferStatus$factory_0() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.waj();
  }, null);
}
function glCompileShader$factory_0() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.fag();
  }, null);
}
function glCompressedTexImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.xaj();
  }, null);
}
function glCompressedTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.yaj();
  }, null);
}
function glCreateProgram$factory_0() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.gag();
  }, null);
}
function glCreateShader$factory_0() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.hag();
  }, null);
}
function glDeleteBuffers$factory_0() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.jag();
  }, null);
}
function glDeleteFramebuffers$factory_0() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.kag();
  }, null);
}
function glDeleteProgram$factory_0() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.lag();
  }, null);
}
function glDeleteRenderbuffers$factory_0() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.mag();
  }, null);
}
function glDeleteShader$factory_0() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.nag();
  }, null);
}
function glDetachShader$factory_0() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.zaj();
  }, null);
}
function glDisableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.tag();
  }, null);
}
function glEnableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.xag();
  }, null);
}
function glFramebufferRenderbuffer$factory_0() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.zag();
  }, null);
}
function glFramebufferTexture2D$factory_0() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.aah();
  }, null);
}
function glGenBuffers$factory_0() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.cah();
  }, null);
}
function glGenerateMipmap$factory_0() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.dah();
  }, null);
}
function glGenFramebuffers$factory_0() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.eah();
  }, null);
}
function glGenRenderbuffers$factory_0() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.fah();
  }, null);
}
function glGetActiveAttrib$factory_0() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.aak();
  }, null);
}
function glGetActiveUniform$factory_0() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.bak();
  }, null);
}
function glGetAttachedShaders$factory_0() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.cak();
  }, null);
}
function glGetAttribLocation$factory_0() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.dak();
  }, null);
}
function glGetUniformLocation$factory_0() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.hah();
  }, null);
}
function glGetBufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.eak();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory_0() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.fak();
  }, null);
}
function glGetProgramInfoLog$factory_0() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.gak();
  }, null);
}
function glGetRenderbufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.hak();
  }, null);
}
function glGetProgramiv$factory_0() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.kah();
  }, null);
}
function glGetShaderiv$factory_0() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.lah();
  }, null);
}
function glGetShaderInfoLog$factory_0() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.mah();
  }, null);
}
function glGetShaderPrecisionFormat$factory_0() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.iak();
  }, null);
}
function glGetShaderSource$factory_0() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.jak();
  }, null);
}
function glGetUniformfv$factory_0() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.kak();
  }, null);
}
function glGetUniformiv$factory_0() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.lak();
  }, null);
}
function glGetVertexAttribfv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.mak();
  }, null);
}
function glGetVertexAttribiv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.nak();
  }, null);
}
function glGetVertexAttribPointerv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.oak();
  }, null);
}
function glIsBuffer$factory_0() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.pak();
  }, null);
}
function glIsFramebuffer$factory_0() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.qak();
  }, null);
}
function glIsProgram$factory_0() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.rak();
  }, null);
}
function glIsRenderbuffer$factory_0() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.sak();
  }, null);
}
function glIsTexture$factory_0() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.tak();
  }, null);
}
function glIsShader$factory_0() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.uak();
  }, null);
}
function glLinkProgram$factory_0() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.oah();
  }, null);
}
function glReleaseShaderCompiler$factory_0() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.vak();
  }, null);
}
function glRenderbufferStorage$factory_0() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.qah();
  }, null);
}
function glSampleCoverage$factory_0() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.wak();
  }, null);
}
function glShaderBinary$factory_0() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.xak();
  }, null);
}
function glShaderSource$factory_0() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.sah();
  }, null);
}
function glStencilFuncSeparate$factory_0() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.uah();
  }, null);
}
function glStencilMaskSeparate$factory_0() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.wah();
  }, null);
}
function glStencilOpSeparate$factory_0() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.yah();
  }, null);
}
function glUniform1f$factory_0() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.yak();
  }, null);
}
function glUniform2f$factory_0() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.zak();
  }, null);
}
function glUniform3f$factory_0() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.aal();
  }, null);
}
function glUniform4f$factory_0() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.bal();
  }, null);
}
function glUniform1i$factory_0() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.cai();
  }, null);
}
function glUniform2i$factory_0() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.cal();
  }, null);
}
function glUniform3i$factory_0() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.dal();
  }, null);
}
function glUniform4i$factory_0() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.eal();
  }, null);
}
function glUniform1fv$factory_0() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.bai();
  }, null);
}
function glUniform2fv$factory_0() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.eai();
  }, null);
}
function glUniform3fv$factory_0() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.gai();
  }, null);
}
function glUniform4fv$factory_0() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.iai();
  }, null);
}
function glUniform1iv$factory_0() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.dai();
  }, null);
}
function glUniform2iv$factory_0() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.fai();
  }, null);
}
function glUniform3iv$factory_0() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.hai();
  }, null);
}
function glUniform4iv$factory_0() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.jai();
  }, null);
}
function glUniformMatrix2fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.kai();
  }, null);
}
function glUniformMatrix3fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.lai();
  }, null);
}
function glUniformMatrix4fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.mai();
  }, null);
}
function glUseProgram$factory_0() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.nai();
  }, null);
}
function glValidateProgram$factory_0() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.fal();
  }, null);
}
function glVertexAttrib1f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.gal();
  }, null);
}
function glVertexAttrib2f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.hal();
  }, null);
}
function glVertexAttrib3f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.ial();
  }, null);
}
function glVertexAttrib4f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.jal();
  }, null);
}
function glVertexAttrib1fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.kal();
  }, null);
}
function glVertexAttrib2fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.lal();
  }, null);
}
function glVertexAttrib3fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.mal();
  }, null);
}
function glBindBufferRange$factory_0() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.tai();
  }, null);
}
function glGetUniformBlockIndex$factory_0() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.uai();
  }, null);
}
function glUniformBlockBinding$factory_0() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.vai();
  }, null);
}
function glGenVertexArrays$factory_0() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.wai();
  }, null);
}
function glDeleteVertexArrays$factory_0() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.nal();
  }, null);
}
function glBindVertexArray$factory_0() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.xai();
  }, null);
}
var properties_initialized_SDL_kt_s4ko39;
function _init_properties_SDL_kt__pqu7sn() {
  if (!properties_initialized_SDL_kt_s4ko39) {
    properties_initialized_SDL_kt_s4ko39 = true;
    SDLPath$delegate = lazy(SDLPath$delegate$lambda);
  }
}
var AGOpenglFactory_instance;
function AGOpenglFactory_getInstance() {
  return AGOpenglFactory_instance;
}
function get_korgwCanvasQuery() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.getValue' call
  var this_0 = korgwCanvasQuery$delegate;
  korgwCanvasQuery$factory();
  return this_0.w1();
}
var korgwCanvasQuery$delegate;
function jsObject(pairs) {
  _init_properties_GlExt_kt__oxmdm();
  var out = jsEmptyObject();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var k = _destruct__k2r9zo.em();
    var v = _destruct__k2r9zo.fm();
    if (!(v == null)) {
      out[k] = v;
    }
  }
  return out;
}
function jsEmptyObject() {
  _init_properties_GlExt_kt__oxmdm();
  return {};
}
function AGDefaultCanvas() {
  _init_properties_GlExt_kt__oxmdm();
  var tmp0_safe_receiver = get_korgwCanvasQuery();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGDefaultCanvas.<anonymous>' call
    var tmp_0 = document.querySelector(tmp0_safe_receiver);
    tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp_2 = document.createElement('canvas');
    tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function AGWebgl(config, canvas) {
  canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.also' call
  var this_0 = AGOpengl.f8s(new KmlGlJsCanvas(canvas, jsObject([to('premultipliedAlpha', false), to('alpha', false), to('stencil', true), to('antialias', config.d8h_1)])));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.gl.AGWebgl.<anonymous>' call
  // Inline function 'kotlin.js.asDynamic' call
  window.ag = this_0;
  canvas.addEventListener('webglcontextlost', AGWebgl$lambda, false);
  canvas.addEventListener('webglcontextrestored', AGWebgl$lambda_0(this_0), false);
  return this_0;
}
function get_isCanvasCreatedAndHandled() {
  _init_properties_GlExt_kt__oxmdm();
  return get_korgwCanvasQuery() == null;
}
function korgwCanvasQuery$delegate$lambda() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return window.korgwCanvasQuery;
}
function AGWebgl$lambda(e) {
  _init_properties_GlExt_kt__oxmdm();
  e.preventDefault();
  return Unit_instance;
}
function AGWebgl$lambda_0($ag) {
  return function (e) {
    $ag.w83();
    return Unit_instance;
  };
}
function korgwCanvasQuery$factory() {
  return getPropertyCallableRef('korgwCanvasQuery', 0, KProperty0, function () {
    return get_korgwCanvasQuery();
  }, null);
}
var properties_initialized_GlExt_kt_6pmiss;
function _init_properties_GlExt_kt__oxmdm() {
  if (!properties_initialized_GlExt_kt_6pmiss) {
    properties_initialized_GlExt_kt_6pmiss = true;
    korgwCanvasQuery$delegate = lazy(korgwCanvasQuery$delegate$lambda);
  }
}
function alloc(_this__u8e3s4, $this) {
  if (_this__u8e3s4 === null)
    return 0;
  // Inline function 'kotlin.js.asDynamic' call
  if (_this__u8e3s4.id === undefined) {
    if ($this.cap_1.j1()) {
      // Inline function 'kotlin.error' call
      var message = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
      throw IllegalStateException.h5(toString(message));
    }
    var index = $this.cap_1.j3($this.cap_1.g1() - 1 | 0);
    $this.bap_1[index] = _this__u8e3s4;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.id = index;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.id;
}
function get_2(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = $this.bap_1[_this__u8e3s4];
  } else {
    tmp = null;
  }
  return tmp;
}
function free(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = $this.bap_1[_this__u8e3s4];
    // Inline function 'kotlin.collections.plusAssign' call
    $this.cap_1.h(_this__u8e3s4);
    $this.bap_1[_this__u8e3s4] = null;
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function KmlGlJsCanvas$extensions$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.aap_1.getSupportedExtensions();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toSet_0(tmp);
  };
}
function KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.aap_1.getExtension('OES_texture_float_linear') != null || this$0.aap_1.getExtension('OES_texture_float') != null || this$0.zao_1 >= 2;
  };
}
function extensions$factory() {
  return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
    return receiver.a7b();
  }, null);
}
function get_KorgeReloadInternal() {
  _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
  return KorgeReloadInternal;
}
var KorgeReloadInternal;
var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
  if (!properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
    properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
    KorgeReloadInternal = new KorgeReloadInternal$1();
  }
}
function CreateDefaultGameWindow(config) {
  return Companion_getInstance_3().b24() ? DenoJsGameWindow.wax(VOID, config) : Companion_getInstance_3().a24() ? NodeJsGameWindow.bav() : BrowserCanvasJsGameWindow.pas();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp0_safe_receiver = $this.jb0_1.mas_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = cancelAndJoin(tmp0_safe_receiver, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  window.close();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.kb0_1($this.lb0_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onResized($this) {
  $this.das_1 = null;
  if (get_isCanvasCreatedAndHandled()) {
    var scale = $this.u9w().ya3(window.innerWidth, window.innerHeight, $this.n9x());
    var canvasWidth = numberToInt(window.innerWidth * scale);
    var canvasHeight = numberToInt(window.innerHeight * scale);
    $this.aas_1.width = canvasWidth;
    $this.aas_1.height = canvasHeight;
    $this.aas_1.style.position = 'absolute';
    $this.aas_1.style.left = '0';
    $this.aas_1.style.right = '0';
    $this.aas_1.style.width = '' + window.innerWidth + 'px';
    $this.aas_1.style.height = '' + window.innerHeight + 'px';
    $this.ias_1 = scale;
  } else {
    $this.ias_1 = $this.aas_1.width / $this.aas_1.clientWidth;
  }
  $this.aa6(0, 0, $this.aas_1.width, $this.aas_1.height);
}
function keyEvent($this, me) {
  var tmp;
  switch (me.key) {
    case '0':
      tmp = Key_N0_getInstance();
      break;
    case '1':
      tmp = Key_N1_getInstance();
      break;
    case '2':
      tmp = Key_N2_getInstance();
      break;
    case '3':
      tmp = Key_N3_getInstance();
      break;
    case '4':
      tmp = Key_N4_getInstance();
      break;
    case '5':
      tmp = Key_N5_getInstance();
      break;
    case '6':
      tmp = Key_N6_getInstance();
      break;
    case '7':
      tmp = Key_N7_getInstance();
      break;
    case '8':
      tmp = Key_N8_getInstance();
      break;
    case '9':
      tmp = Key_N9_getInstance();
      break;
    case 'a':
      tmp = Key_A_getInstance();
      break;
    case 'b':
      tmp = Key_B_getInstance();
      break;
    case 'c':
      tmp = Key_C_getInstance();
      break;
    case 'd':
      tmp = Key_D_getInstance();
      break;
    case 'e':
      tmp = Key_E_getInstance();
      break;
    case 'f':
      tmp = Key_F_getInstance();
      break;
    case 'g':
      tmp = Key_G_getInstance();
      break;
    case 'h':
      tmp = Key_H_getInstance();
      break;
    case 'i':
      tmp = Key_I_getInstance();
      break;
    case 'j':
      tmp = Key_J_getInstance();
      break;
    case 'k':
      tmp = Key_K_getInstance();
      break;
    case 'l':
      tmp = Key_L_getInstance();
      break;
    case 'm':
      tmp = Key_M_getInstance();
      break;
    case 'n':
      tmp = Key_N_getInstance();
      break;
    case 'o':
      tmp = Key_O_getInstance();
      break;
    case 'p':
      tmp = Key_P_getInstance();
      break;
    case 'q':
      tmp = Key_Q_getInstance();
      break;
    case 'r':
      tmp = Key_R_getInstance();
      break;
    case 's':
      tmp = Key_S_getInstance();
      break;
    case 't':
      tmp = Key_T_getInstance();
      break;
    case 'u':
      tmp = Key_U_getInstance();
      break;
    case 'v':
      tmp = Key_V_getInstance();
      break;
    case 'w':
      tmp = Key_W_getInstance();
      break;
    case 'x':
      tmp = Key_X_getInstance();
      break;
    case 'y':
      tmp = Key_Y_getInstance();
      break;
    case 'z':
      tmp = Key_Z_getInstance();
      break;
    case 'F1':
      tmp = Key_F1_getInstance();
      break;
    case 'F2':
      tmp = Key_F2_getInstance();
      break;
    case 'F3':
      tmp = Key_F3_getInstance();
      break;
    case 'F4':
      tmp = Key_F4_getInstance();
      break;
    case 'F5':
      tmp = Key_F5_getInstance();
      break;
    case 'F6':
      tmp = Key_F6_getInstance();
      break;
    case 'F7':
      tmp = Key_F7_getInstance();
      break;
    case 'F8':
      tmp = Key_F8_getInstance();
      break;
    case 'F9':
      tmp = Key_F9_getInstance();
      break;
    case 'F10':
      tmp = Key_F10_getInstance();
      break;
    case 'F11':
      tmp = Key_F11_getInstance();
      break;
    case 'F12':
      tmp = Key_F12_getInstance();
      break;
    case 'F13':
      tmp = Key_F13_getInstance();
      break;
    case 'F14':
      tmp = Key_F14_getInstance();
      break;
    case 'F15':
      tmp = Key_F15_getInstance();
      break;
    case 'F16':
      tmp = Key_F16_getInstance();
      break;
    case 'F17':
      tmp = Key_F17_getInstance();
      break;
    case 'F18':
      tmp = Key_F18_getInstance();
      break;
    case 'F19':
      tmp = Key_F19_getInstance();
      break;
    case 'F20':
      tmp = Key_F20_getInstance();
      break;
    case 'F21':
      tmp = Key_F21_getInstance();
      break;
    case 'F22':
      tmp = Key_F22_getInstance();
      break;
    case 'F23':
      tmp = Key_F23_getInstance();
      break;
    case 'F24':
      tmp = Key_F24_getInstance();
      break;
    case 'F25':
      tmp = Key_F25_getInstance();
      break;
    case '+':
      tmp = Key_PLUS_getInstance();
      break;
    case '-':
      tmp = Key_MINUS_getInstance();
      break;
    case "'":
      tmp = Key_APOSTROPHE_getInstance();
      break;
    case '"':
      tmp = Key_QUOTE_getInstance();
      break;
    default:
      var tmp_0;
      switch (me.code) {
        case 'MetaLeft':
          tmp_0 = Companion_getInstance_34().p82();
          break;
        case 'MetaRight':
          tmp_0 = Companion_getInstance_34().q82();
          break;
        case 'ShiftLeft':
          tmp_0 = Companion_getInstance_34().l82();
          break;
        case 'ShiftRight':
          tmp_0 = Companion_getInstance_34().m82();
          break;
        case 'ControlLeft':
          tmp_0 = Companion_getInstance_34().j82();
          break;
        case 'ControlRight':
          tmp_0 = Companion_getInstance_34().k82();
          break;
        case 'AltLeft':
          tmp_0 = Companion_getInstance_34().n82();
          break;
        case 'AltRight':
          tmp_0 = Companion_getInstance_34().o82();
          break;
        case 'Space':
          tmp_0 = Key_SPACE_getInstance();
          break;
        case 'ArrowUp':
          tmp_0 = Key_UP_getInstance();
          break;
        case 'ArrowDown':
          tmp_0 = Key_DOWN_getInstance();
          break;
        case 'ArrowLeft':
          tmp_0 = Key_LEFT_getInstance();
          break;
        case 'ArrowRight':
          tmp_0 = Key_RIGHT_getInstance();
          break;
        case 'PageUp':
          tmp_0 = Key_PAGE_UP_getInstance();
          break;
        case 'PageDown':
          tmp_0 = Key_PAGE_DOWN_getInstance();
          break;
        case 'Home':
          tmp_0 = Key_HOME_getInstance();
          break;
        case 'End':
          tmp_0 = Key_END_getInstance();
          break;
        case 'Enter':
          tmp_0 = Key_ENTER_getInstance();
          break;
        case 'Escape':
          tmp_0 = Key_ESCAPE_getInstance();
          break;
        case 'Backspace':
          tmp_0 = Key_BACKSPACE_getInstance();
          break;
        case 'Delete':
          tmp_0 = Key_DELETE_getInstance();
          break;
        case 'Insert':
          tmp_0 = Key_INSERT_getInstance();
          break;
        case 'Period':
          tmp_0 = Key_PERIOD_getInstance();
          break;
        case 'Comma':
          tmp_0 = Key_COMMA_getInstance();
          break;
        case 'Semicolon':
          tmp_0 = Key_SEMICOLON_getInstance();
          break;
        case 'Slash':
          tmp_0 = Key_SLASH_getInstance();
          break;
        case 'Tab':
          tmp_0 = Key_TAB_getInstance();
          break;
        default:
          // Inline function 'kotlin.js.asDynamic' call

          if (window.korgwShowUnsupportedKeys) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = CoroutineKey_getInstance().ga1_1;
            var level = Level_INFO_getInstance();
            var tmp_1;
            if (this_0.q46(level)) {
              // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.keyEvent.<anonymous>' call
              var tmp$ret$1 = 'Unsupported key key=' + me.key + ', code=' + me.code;
              this_0.r46(level, tmp$ret$1);
              tmp_1 = Unit_instance;
            }
          }

          tmp_0 = Key_UNKNOWN_getInstance();
          break;
      }

      tmp = tmp_0;
      break;
  }
  var key = tmp;
  $this.l7v(invoke_0($this.ca2_1, BrowserCanvasJsGameWindow$keyEvent$lambda(me, key)));
  if (key.equals(Key_TAB_getInstance()) || key.t82()) {
    me.preventDefault();
  }
}
function touchEvent($this, e, type) {
  var canvasBounds = $this.aas_1.getBoundingClientRect();
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.event.TouchBuilder.frame' call
  var this_0 = $this.jas_1;
  this_0.e80_1 = Mode_JS_getInstance();
  this_0.f80(type, false);
  try {
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
    var inductionVariable = 0;
    var last = e.touches.length;
    if (inductionVariable < last)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = e.touches.item(n);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var touch = tmp;
        var touchId = touch.identifier;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
        var tmp_0 = (touch.clientX - canvasBounds.left) * $this.ias_1;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
        var tmp$ret$1 = (touch.clientY - canvasBounds.top) * $this.ias_1;
        var tmp_1 = Vector2D.m3q(tmp_0, tmp$ret$1);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_elvis_lhs = touch.force;
        this_0.i80(touchId, tmp_1, tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs, Kind_FINGER_getInstance());
      }
       while (inductionVariable < last);
  }finally {
    this_0.g80();
  }
  var this_1 = this_0.d80_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
  $this.l7v(this_1);
}
function mouseEvent($this, e, type, pressingType) {
  var canvasBounds = $this.aas_1.getBoundingClientRect();
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
  var tmp$ret$0 = (e.clientX - canvasBounds.left) * $this.ias_1;
  var tx = numberToInt(tmp$ret$0);
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
  var tmp$ret$1 = (e.clientY - canvasBounds.top) * $this.ias_1;
  var ty = numberToInt(tmp$ret$1);
  invoke_0($this.da2_1, BrowserCanvasJsGameWindow$mouseEvent$lambda(e, pressingType, type, tx, ty));
  if (!$this.mb0() || type.equals(Type_SCROLL_getInstance())) {
    $this.l7v($this.da2_1);
  }
}
function mouseEvent$default($this, e, type, pressingType, $super) {
  pressingType = pressingType === VOID ? type : pressingType;
  return mouseEvent($this, e, type, pressingType);
}
function *_generator_loop__qll5p8_0($this, entry, $completion) {
  var tmp = $this;
  var tmp_0 = $this.za3($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.mas_1 = launchImmediately(tmp_0, BrowserCanvasJsGameWindow$loop$slambda_0(entry, $this));
  _get_jsFrame__gugpar($this)(0.0);
  return Unit_instance;
}
function _get_jsFrame__gugpar($this) {
  var tmp = $this.nas_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('jsFrame');
  }
}
function BrowserCanvasJsGameWindow$keyEvent$lambda($me, $key) {
  return function ($this$keyEvent) {
    var tmp = $this$keyEvent;
    var tmp_0;
    switch ($me.type) {
      case 'keydown':
        tmp_0 = Type_DOWN_getInstance();
        break;
      case 'keyup':
        tmp_0 = Type_UP_getInstance();
        break;
      case 'keypress':
        tmp_0 = Type_TYPE_getInstance();
        break;
      default:
        var message = 'Unsupported event type ' + $me.type;
        throw IllegalStateException.h5(toString(message));
    }
    tmp.q7w_1 = tmp_0;
    $this$keyEvent.r7w_1 = 0;
    $this$keyEvent.t7w_1 = $me.keyCode;
    $this$keyEvent.s7w_1 = $key;
    $this$keyEvent.v7w_1 = $me.shiftKey;
    $this$keyEvent.w7w_1 = $me.ctrlKey;
    $this$keyEvent.x7w_1 = $me.altKey;
    $this$keyEvent.y7w_1 = $me.metaKey;
    $this$keyEvent.u7w_1 = numberToChar($me.charCode);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$mouseEvent$lambda($e, $pressingType, $type, $tx, $ty) {
  return function ($this$mouseEvent) {
    $this$mouseEvent.h7x_1 = !($e.buttons === 0) ? $pressingType : $type;
    $this$mouseEvent.u7x_1 = false;
    $this$mouseEvent.i7x_1 = 0;
    $this$mouseEvent.j7x_1 = $tx;
    $this$mouseEvent.k7x_1 = $ty;
    $this$mouseEvent.l7x_1 = Companion_getInstance_35().h1($e.button);
    $this$mouseEvent.m7x_1 = $e.buttons;
    $this$mouseEvent.q7x_1 = $e.shiftKey;
    $this$mouseEvent.r7x_1 = $e.ctrlKey;
    $this$mouseEvent.s7x_1 = $e.altKey;
    $this$mouseEvent.t7x_1 = $e.metaKey;
    var tmp;
    if ($type.equals(Type_SCROLL_getInstance())) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var we = $e;
      var tmp0_subject = we.deltaMode;
      var mode = tmp0_subject === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
      var sensitivity = 0.05;
      $this$mouseEvent.a7y(mode, we.deltaX * sensitivity, we.deltaY * sensitivity, we.deltaZ * sensitivity);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$close$slambda_0(this$0) {
  var i = new BrowserCanvasJsGameWindow$close$slambda(this$0);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new BrowserCanvasJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$lambda(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_SCROLL_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_0(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_ENTER_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_1(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_2(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_3(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_4(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_5(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_UP_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_6(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_DOWN_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_7(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_CLICK_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_8(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_START_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_9(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_MOVE_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_10(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_END_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_11(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_12(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_13(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_14(this$0) {
  return function (it) {
    onResized(this$0);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_15(this$0) {
  return function (it) {
    return this$0.fa6(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_16(this$0) {
  return function (it) {
    return this$0.fa6(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_17(this$0) {
  return function (it) {
    return this$0.fa6(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_18(it) {
  it.preventDefault();
  return Unit_instance;
}
function BrowserCanvasJsGameWindow$lambda_19(this$0) {
  return function (it) {
    return this$0.fa6(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_20(this$0) {
  return function (it) {
    return this$0.fa6(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_21(this$0) {
  return function (it) {
    it.preventDefault();
    this$0.fa6(Type_END_getInstance(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = until(0, items.length);
    var destination = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = this_0.f2_1;
    var last = this_0.g2_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<anonymous>.<anonymous>' call
        // Inline function 'org.w3c.dom.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = items[element];
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getAsFile();
        var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : toVfs(tmp1_safe_receiver);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver_0);
        }
      }
       while (!(element === last));
    var files = destination;
    return this$0.fa6(Type_DROP_getInstance(), files);
  };
}
function BrowserCanvasJsGameWindow$lambda_22(this$0) {
  return function (step) {
    window.requestAnimationFrame(_get_jsFrame__gugpar(this$0));
    this$0.aa4();
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.pb0_1($this.qb0_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_loop__qll5p8_1($this, entry, $completion) {
  var tmp = $this.za3($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  launchImmediately(tmp, DenoJsGameWindow$loop$slambda_0(entry, $this));
  var tmp_0 = get_jsGlobalThis();
  tmp_0.setInterval(DenoJsGameWindow$loop$lambda($this), 16);
  return Unit_instance;
}
function DenoJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new DenoJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function DenoJsGameWindow$loop$lambda(this$0) {
  return function () {
    this$0.oao();
    this$0.aa4();
    this$0.pao();
    return Unit_instance;
  };
}
//region block: post-declaration
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, AutoCloseable]);
initMetadataForClass(BaseEventLoop, 'BaseEventLoop', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncEventLoop, 'SyncEventLoop', SyncEventLoop);
protoOf(Listener).q21 = cancel;
initMetadataForClass(Listener, 'Listener', VOID, VOID, [CloseableCancellable]);
initMetadataForClass(ListenerNode, 'ListenerNode');
initMetadataForInterface(EventListener, 'EventListener');
protoOf(BaseEventListener).k7v = dispatch$default;
protoOf(BaseEventListener).m7v = onEvents;
protoOf(BaseEventListener).n7v = dispatchDown;
protoOf(BaseEventListener).o7v = dispatchUp;
initMetadataForClass(BaseEventListener, 'BaseEventListener', BaseEventListener.y7u, VOID, [EventListener]);
initMetadataForClass(EventResult, 'EventResult', EventResult);
initMetadataForCompanion(Companion);
initMetadataForClass(Event, 'Event');
initMetadataForClass(TypedEvent, 'TypedEvent');
initMetadataForClass(PauseEvent, 'PauseEvent', PauseEvent);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ResumeEvent, 'ResumeEvent', ResumeEvent);
initMetadataForCompanion(Companion_1);
initMetadataForClass(StopEvent, 'StopEvent', StopEvent);
initMetadataForCompanion(Companion_2);
initMetadataForClass(DestroyEvent, 'DestroyEvent', DestroyEvent);
initMetadataForClass(RenderEvent, 'RenderEvent', RenderEvent);
initMetadataForCompanion(Companion_3);
initMetadataForClass(InitEvent, 'InitEvent', InitEvent);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(DisposeEvent, 'DisposeEvent', DisposeEvent);
initMetadataForCompanion(Companion_6);
initMetadataForClass(FullScreenEvent, 'FullScreenEvent', FullScreenEvent);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ReshapeEvent, 'ReshapeEvent', ReshapeEvent);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Type, 'Type');
initMetadataForClass(KeyEvent, 'KeyEvent', KeyEvent);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Type_0, 'Type');
initMetadataForClass(ScrollDeltaMode, 'ScrollDeltaMode');
initMetadataForClass(MouseEvent, 'MouseEvent', MouseEvent);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Type_1, 'Type');
initMetadataForClass(GestureEvent, 'GestureEvent', GestureEvent);
initMetadataForCompanion(Companion_11);
initMetadataForClass(Type_2, 'Type');
initMetadataForClass(DropFileEvent, 'DropFileEvent', DropFileEvent);
initMetadataForClass(StopPropagatingException, 'StopPropagatingException', StopPropagatingException.r7y);
initMetadataForClass(Status, 'Status');
initMetadataForClass(Kind, 'Kind');
initMetadataForCompanion(Companion_12);
initMetadataForClass(Touch, 'Touch', Touch);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Type_3, 'Type');
initMetadataForCompanion(Companion_14);
initMetadataForClass(TouchEvent, 'TouchEvent', TouchEvent);
initMetadataForClass(Mode, 'Mode');
initMetadataForClass(TouchBuilder, 'TouchBuilder', TouchBuilder);
initMetadataForClass(GamepadInfoEmitter, 'GamepadInfoEmitter');
initMetadataForClass(BatteryStatus, 'BatteryStatus');
initMetadataForCompanion(Companion_15);
initMetadataForClass(GamepadInfo, 'GamepadInfo', GamepadInfo);
initMetadataForCompanion(Companion_16);
initMetadataForClass(GamePadUpdateEvent, 'GamePadUpdateEvent', GamePadUpdateEvent);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Type_4, 'Type');
initMetadataForClass(GamePadConnectionEvent, 'GamePadConnectionEvent', GamePadConnectionEvent);
initMetadataForCompanion(Companion_18);
initMetadataForClass(GameButton, 'GameButton');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Key, 'Key');
initMetadataForCompanion(Companion_20);
initMetadataForClass(MouseButton, 'MouseButton');
initMetadataForCompanion(Companion_21);
initMetadataForInterface(AGFeatures, 'AGFeatures');
protoOf(AG).c84 = get_parentFeatures;
protoOf(AG).d84 = get_isUniformBuffersSupported;
protoOf(AG).e84 = get_isVertexArraysSupported;
initMetadataForClass(AG, 'AG', VOID, VOID, [AGFeatures]);
initMetadataForClass(Immutable, 'Immutable', Immutable, VOID, [AGFeatures]);
initMetadataForClass(AGObject, 'AGObject', AGObject, VOID, [AutoCloseable]);
initMetadataForClass(AGBuffer, 'AGBuffer', AGBuffer);
initMetadataForCompanion(Companion_22);
initMetadataForClass(AGTextureUnits, 'AGTextureUnits', AGTextureUnits.n86);
initMetadataForCompanion(Companion_23);
initMetadataForClass(AGFrameBuffer, 'AGFrameBuffer', AGFrameBuffer.u83, VOID, [AutoCloseable]);
initMetadataForClass(AGTexture, 'AGTexture', AGTexture, VOID, [AGObject, AutoCloseable]);
initMetadataForClass(AGFrameBufferBase, 'AGFrameBufferBase');
initMetadataForCompanion(Companion_24);
initMetadataForInterface(AGNativeObject, 'AGNativeObject');
initMetadataForClass(BufferCache, 'BufferCache', BufferCache);
initMetadataForClass(AGProgramWithUniforms, 'AGProgramWithUniforms');
initMetadataForClass(AGVertexArrayObject, 'AGVertexArrayObject');
initMetadataForClass(AGVertexData, 'AGVertexData', AGVertexData);
initMetadataForCompanion(Companion_25);
initMetadataForCompanion(Companion_26);
initMetadataForCompanion(Companion_27);
initMetadataForClass(AGBlending, 'AGBlending');
initMetadataForCompanion(Companion_28);
initMetadataForClass(AGScissor, 'AGScissor');
initMetadataForCompanion(Companion_29);
initMetadataForObject(AGFinish, 'AGFinish');
initMetadataForClass(AGClear, 'AGClear');
initMetadataForCompanion(Companion_30);
initMetadataForClass(AGStencilReference, 'AGStencilReference');
initMetadataForCompanion(Companion_31);
initMetadataForClass(AGStencilOpFunc, 'AGStencilOpFunc');
initMetadataForCompanion(Companion_32);
initMetadataForCompanion(Companion_33);
initMetadataForCompanion(Companion_34);
initMetadataForClass(AGBatch, 'AGBatch');
initMetadataForCompanion(Companion_35);
initMetadataForClass(AGTextureTargetKind, 'AGTextureTargetKind');
initMetadataForCompanion(Companion_36);
initMetadataForClass(AGWrapMode, 'AGWrapMode');
initMetadataForCompanion(Companion_37);
initMetadataForClass(AGBlendFactor, 'AGBlendFactor');
initMetadataForCompanion(Companion_38);
initMetadataForClass(AGBlendEquation, 'AGBlendEquation');
initMetadataForCompanion(Companion_39);
initMetadataForCompanion(Companion_40);
initMetadataForClass(AGStencilOp, 'AGStencilOp');
initMetadataForCompanion(Companion_41);
initMetadataForClass(AGCompareMode, 'AGCompareMode');
initMetadataForCompanion(Companion_42);
initMetadataForClass(AGMultiBatch, 'AGMultiBatch');
initMetadataForClass(AGConfig, 'AGConfig', AGConfig);
initMetadataForClass(AGBufferKind, 'AGBufferKind');
initMetadataForClass(AGStats, 'AGStats', AGStats);
initMetadataForClass(UniformBlock, 'UniformBlock');
initMetadataForObject(ProjViewUB, 'ProjViewUB');
initMetadataForObject(DefaultShaders, 'DefaultShaders');
initMetadataForInterface(VarTypeAccessor, 'VarTypeAccessor');
initMetadataForInterface(ExpressionBuilder, 'ExpressionBuilder');
protoOf(Builder).u8l = get_Float1;
protoOf(Builder).r96 = get_Float2;
protoOf(Builder).s96 = get_Float4;
protoOf(Builder).o8k = get_out;
protoOf(Builder).w8k = texture2D;
protoOf(Builder).h95 = TERNARY;
protoOf(Builder).v8l = abs;
protoOf(Builder).i95 = clamp;
protoOf(Builder).j95 = min;
protoOf(Builder).k95 = max_0;
protoOf(Builder).l95 = fwidth;
protoOf(Builder).m95 = mix;
protoOf(Builder).n95 = length;
protoOf(Builder).r8k = get_lit;
protoOf(Builder).s8k = vec4;
protoOf(Builder).u8k = get_1;
protoOf(Builder).w8l = get_x;
protoOf(Builder).x8l = get_y;
protoOf(Builder).y8k = get_a;
protoOf(Builder).o95 = unaryMinus;
protoOf(Builder).y8l = minus_0;
protoOf(Builder).p95 = minus_1;
protoOf(Builder).z8l = plus_2;
protoOf(Builder).q95 = plus_3;
protoOf(Builder).r95 = plus_4;
protoOf(Builder).p8k = times;
protoOf(Builder).s95 = times_0;
protoOf(Builder).a8l = div;
protoOf(Builder).a8m = eq;
protoOf(Builder).b8m = le;
protoOf(Builder).c8m = gt;
protoOf(Builder).t95 = gt_0;
initMetadataForClass(Builder, 'Builder', Builder.b8l, VOID, [VarTypeAccessor, ExpressionBuilder]);
initMetadataForInterface(IDefaultShaders, 'IDefaultShaders');
protoOf(ProgramBuilderDefault).v8k = get_u_Tex;
protoOf(ProgramBuilderDefault).e8i = get_u_ProjMat;
protoOf(ProgramBuilderDefault).f8i = get_u_ViewMat;
protoOf(ProgramBuilderDefault).q8k = get_a_Pos;
protoOf(ProgramBuilderDefault).i8k = get_a_Tex;
protoOf(ProgramBuilderDefault).n8k = get_a_Col;
protoOf(ProgramBuilderDefault).h8k = get_v_Tex;
protoOf(ProgramBuilderDefault).m8k = get_v_Col;
protoOf(ProgramBuilderDefault).z8k = get_t_Temp0;
initMetadataForClass(ProgramBuilderDefault, 'ProgramBuilderDefault', ProgramBuilderDefault.g8k, VOID, [Builder, IDefaultShaders]);
initMetadataForClass(GLVAO, 'GLVAO');
initMetadataForClass(ShaderException, 'ShaderException');
initMetadataForClass(TextureUnitParams, 'TextureUnitParams');
initMetadataForClass(AGOpengl, 'AGOpengl');
initMetadataForClass(GLGlobalState, 'GLGlobalState');
initMetadataForClass(GLBaseObject, 'GLBaseObject', VOID, VOID, [AGNativeObject]);
initMetadataForClass(GLBaseProgram, 'GLBaseProgram');
initMetadataForClass(GLBuffer, 'GLBuffer');
initMetadataForClass(GLTexture, 'GLTexture');
initMetadataForClass(GLFrameBuffer, 'GLFrameBuffer');
initMetadataForClass(GLProgramInfo, 'GLProgramInfo');
initMetadataForObject(GLShaderCompiler, 'GLShaderCompiler');
initMetadataForClass(AGDummy, 'AGDummy', AGDummy.a8w);
initMetadataForClass(AGBaseLog, 'AGBaseLog', AGBaseLog.u8w);
initMetadataForClass(AGPrint, 'AGPrint', AGPrint.k8w);
initMetadataForClass(Kind_0, 'Kind');
initMetadataForCompanion(Companion_43);
initMetadataForClass(UniformBlocksBuffersRef, 'UniformBlocksBuffersRef');
initMetadataForClass(Gen, 'Gen');
initMetadataForClass(Operand, 'Operand');
initMetadataForClass(OperandWithArray, 'OperandWithArray');
initMetadataForClass(Variable, 'Variable');
initMetadataForClass(VariableWithOffset, 'VariableWithOffset');
initMetadataForClass(TypedUniform, 'TypedUniform');
initMetadataForCompanion(Companion_44);
initMetadataForClass(UniformBlockBuffer, 'UniformBlockBuffer');
initMetadataForClass(UBLayoutBuilder, 'UBLayoutBuilder', UBLayoutBuilder);
initMetadataForClass(UniformsRef, 'UniformsRef');
initMetadataForCompanion(Companion_45);
initMetadataForClass(GLVariant, 'GLVariant');
initMetadataForClass(Visitor, 'Visitor');
initMetadataForClass(GlobalsProgramVisitor, 'GlobalsProgramVisitor', GlobalsProgramVisitor);
initMetadataForCompanion(Companion_46);
initMetadataForClass(Result, 'Result');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(BaseGlslGenerator, 'BaseGlslGenerator');
protoOf(GlslGenerator).s91 = precToString;
protoOf(GlslGenerator).t91 = typeToString;
protoOf(GlslGenerator).u91 = get_arrayDecl;
protoOf(GlslGenerator).r91 = get_IN;
protoOf(GlslGenerator).w91 = get_OUT;
protoOf(GlslGenerator).v91 = get_UNIFORM;
initMetadataForClass(GlslGenerator, 'GlslGenerator', VOID, VOID, [BaseGlslGenerator]);
initMetadataForCompanion(Companion_47);
initMetadataForClass(GlslConfig, 'GlslConfig');
protoOf(GlslBodyGenerator).t91 = typeToString;
initMetadataForClass(GlslBodyGenerator, 'GlslBodyGenerator', VOID, VOID, [Visitor, BaseGlslGenerator]);
initMetadataForClass(ProgramLayout, 'ProgramLayout', VOID, VOID, [Iterable]);
initMetadataForClass(Attribute, 'Attribute');
initMetadataForClass(Stm, 'Stm');
initMetadataForClass(Stms, 'Stms');
initMetadataForClass(Set, 'Set');
initMetadataForClass(Return, 'Return');
initMetadataForObject(Break, 'Break');
initMetadataForObject(Continue, 'Continue');
initMetadataForObject(Discard, 'Discard');
initMetadataForClass(If, 'If');
initMetadataForClass(ForSimple, 'ForSimple');
initMetadataForClass(Raw, 'Raw');
initMetadataForClass(FuncBuilder, 'FuncBuilder');
initMetadataForClass(FuncDeclGetter, 'FuncDeclGetter');
initMetadataForClass(FuncProvider, 'FuncProvider');
initMetadataForClass(Program$Builder$_funcs$1);
initMetadataForClass(Ternary, 'Ternary');
initMetadataForClass(Unop, 'Unop');
initMetadataForClass(Binop, 'Binop');
initMetadataForClass(IntLiteral, 'IntLiteral');
initMetadataForClass(FloatLiteral, 'FloatLiteral');
initMetadataForClass(BoolLiteral, 'BoolLiteral');
initMetadataForClass(Vector, 'Vector');
initMetadataForClass(Swizzle, 'Swizzle');
initMetadataForClass(ArrayAccess, 'ArrayAccess');
initMetadataForClass(BaseFunc, 'BaseFunc');
initMetadataForClass(Func, 'Func');
initMetadataForClass(CustomFunc, 'CustomFunc');
initMetadataForInterface(FuncRef, 'FuncRef');
initMetadataForClass(BuilderContext, 'BuilderContext', BuilderContext);
initMetadataForClass(Program, 'Program', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Shader, 'Shader');
initMetadataForClass(Varying, 'Varying');
initMetadataForObject(Output, 'Output');
initMetadataForClass(Provider, 'Provider');
initMetadataForClass(Sampler, 'Sampler');
initMetadataForClass(SamplerVarType, 'SamplerVarType');
initMetadataForClass(Uniform, 'Uniform');
initMetadataForCompanion(Companion_48);
initMetadataForClass(VarType, 'VarType');
initMetadataForClass(Precision, 'Precision');
initMetadataForClass(Temp, 'Temp');
initMetadataForClass(FuncDecl, 'FuncDecl', VOID, VOID, [FuncRef]);
initMetadataForClass(VarKind, 'VarKind');
initMetadataForClass(UniformInProgram, 'UniformInProgram');
initMetadataForClass(Arg, 'Arg');
initMetadataForClass(ShaderType, 'ShaderType');
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(ContextInfo, 'ContextInfo', ContextInfo);
initMetadataForCompanion(Companion_49);
protoOf(KmlGl).c84 = get_parentFeatures;
protoOf(KmlGl).d84 = get_isUniformBuffersSupported;
protoOf(KmlGl).e84 = get_isVertexArraysSupported;
initMetadataForClass(KmlGl, 'KmlGl', KmlGl, VOID, [AGFeatures]);
initMetadataForClass(KmlGlContext, 'KmlGlContext', VOID, VOID, [AutoCloseable]);
initMetadataForClass(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', KorgeReloadInternalImpl);
initMetadataForClass(ReloadClassContext, 'ReloadClassContext');
initMetadataForObject(KorgeReload, 'KorgeReload');
initMetadataForCompanion(Companion_50);
initMetadataForCompanion(Companion_51);
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(InputKeys, 'InputKeys', InputKeys);
initMetadataForCompanion(Companion_52);
initMetadataForClass(Input, 'Input', Input);
initMetadataForObject(DefaultViewport, 'DefaultViewport');
initMetadataForCompanion(Companion_53);
initMetadataForClass(Props, 'Props', Props, VOID, [KtMutableMap]);
initMetadataForClass(Entry, 'Entry', Entry);
initMetadataForClass(AgAutoFreeManager, 'AgAutoFreeManager', AgAutoFreeManager, VOID, [AutoCloseable]);
initMetadataForClass(BitmapTextureInfo, 'BitmapTextureInfo', BitmapTextureInfo);
initMetadataForClass(AgBitmapTextureManager, 'AgBitmapTextureManager', VOID, VOID, [AutoCloseable]);
initMetadataForClass(AgBufferManager, 'AgBufferManager');
initMetadataForClass(BatchBuffers, 'BatchBuffers', BatchBuffers);
initMetadataForCompanion(Companion_54);
initMetadataForClass(BatchBuilder2D, 'BatchBuilder2D');
initMetadataForInterface(BoundsProvider, 'BoundsProvider');
protoOf(Base).q9v = get_virtualLeft;
protoOf(Base).r9v = get_virtualTop;
protoOf(Base).s9v = get_virtualRight;
protoOf(Base).t9v = get_virtualBottom;
protoOf(Base).u9v = get_windowToGlobalScaleAvg;
protoOf(Base).v9v = windowToGlobalCoords;
initMetadataForClass(Base, 'Base', Base, VOID, [BoundsProvider]);
initMetadataForCompanion(Companion_55);
initMetadataForClass(LineRenderBatcher, 'LineRenderBatcher');
initMetadataForClass(FlushKind, 'FlushKind');
initMetadataForInterface(DeviceDimensionsProvider, 'DeviceDimensionsProvider');
initMetadataForClass(RenderContext, 'RenderContext', VOID, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, AutoCloseable]);
initMetadataForClass(RenderContext2D, 'RenderContext2D');
initMetadataForObject(SDFShaders, 'SDFShaders');
initMetadataForClass(TextureBase, 'TextureBase', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_56);
initMetadataForClass(TexturedVertexArray, 'TexturedVertexArray');
initMetadataForClass(ShrinkableTexturedVertexArray, 'ShrinkableTexturedVertexArray');
initMetadataForClass(ResourcesRoot, 'ResourcesRoot', ResourcesRoot, VOID, [InjectorDependency], [1]);
initMetadataForClass(Counter, 'Counter');
initMetadataForClass(RCollection, 'RCollection', RCollection);
initMetadataForClass(Stats, 'Stats', Stats);
initMetadataForClass(V2, 'V2');
protoOf(DEFAULT).n9x = get_devicePixelRatio;
protoOf(DEFAULT).o9x = get_pixelsPerInch;
protoOf(DEFAULT).p9x = get_pixelsPerLogicalInchRatio;
protoOf(DEFAULT).x9w = get_computedPixelRatio;
initMetadataForObject(DEFAULT, 'DEFAULT', VOID, VOID, [DeviceDimensionsProvider]);
initMetadataForClass(Impl, 'Impl', Impl);
initMetadataForCompanion(Companion_57);
initMetadataForClass(Cursor, 'Cursor');
initMetadataForClass(MenuItem, 'MenuItem');
initMetadataForObject(CoroutineKey, 'CoroutineKey');
initMetadataForClass(Quality, 'Quality');
initMetadataForLambda(GameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(_no_name_provided__qut3iv);
protoOf(GameWindow).n9x = get_devicePixelRatio;
protoOf(GameWindow).o9x = get_pixelsPerInch;
protoOf(GameWindow).p9x = get_pixelsPerLogicalInchRatio;
protoOf(GameWindow).x9w = get_computedPixelRatio;
protoOf(GameWindow).ud = get;
protoOf(GameWindow).do = fold;
protoOf(GameWindow).co = minusKey;
protoOf(GameWindow).eo = plus_1;
initMetadataForClass(GameWindow, 'GameWindow', GameWindow.ha4, VOID, [BaseEventListener, DeviceDimensionsProvider, Element], [0, 1]);
initMetadataForCompanion(Companion_58);
initMetadataForClass(GameWindowCreationConfig, 'GameWindowCreationConfig', GameWindowCreationConfig);
initMetadataForClass(TimedTask_0, 'TimedTask');
initMetadataForCompanion(Companion_59);
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0_0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(GameWindowCoroutineDispatcher, 'GameWindowCoroutineDispatcher', GameWindowCoroutineDispatcher.va4, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForClass(SyncEventLoopCoroutineDispatcher, 'SyncEventLoopCoroutineDispatcher', SyncEventLoopCoroutineDispatcher.ka4, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForCompanion(Companion_60);
initMetadataForClass(UpdateEvent, 'UpdateEvent', UpdateEvent);
initMetadataForCompanion(Companion_61);
initMetadataForClass(SDL, 'SDL', SDL.qa8);
initMetadataForClass(KmlGlOpenGL, 'KmlGlOpenGL', KmlGlOpenGL);
initMetadataForCompanion(Companion_62);
initMetadataForClass(OpenGL, 'OpenGL', OpenGL.haf);
initMetadataForClass(SDLGameWindow$ag$1);
initMetadataForClass(SDLGameWindow, 'SDLGameWindow', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(Size3D, 'Size3D');
initMetadataForObject(AGOpenglFactory, 'AGOpenglFactory');
initMetadataForClass(KmlGlJsCanvas, 'KmlGlJsCanvas');
initMetadataForClass(WebGLExtension, 'WebGLExtension');
initMetadataForClass(KorgeReloadInternal$1);
initMetadataForClass(JsGameWindow, 'JsGameWindow', JsGameWindow.ib0, VOID, VOID, [0, 1]);
initMetadataForClass(NodeJsGameWindow, 'NodeJsGameWindow', NodeJsGameWindow.bav, VOID, VOID, [0, 1]);
initMetadataForLambda(BrowserCanvasJsGameWindow$close$slambda, VOID, VOID, [0]);
initMetadataForLambda(BrowserCanvasJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(BrowserCanvasJsGameWindow, 'BrowserCanvasJsGameWindow', BrowserCanvasJsGameWindow.pas, VOID, VOID, [1, 0]);
initMetadataForLambda(DenoJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(DenoJsGameWindow, 'DenoJsGameWindow', DenoJsGameWindow.wax, VOID, VOID, [1, 0]);
initMetadataForClass(DialogInterfaceJs, 'DialogInterfaceJs', DialogInterfaceJs, VOID, VOID, [1, 2, 4]);
//endregion
//region block: init
Companion_instance_8 = new Companion();
Companion_instance_9 = new Companion_0();
Companion_instance_10 = new Companion_1();
Companion_instance_11 = new Companion_2();
Companion_instance_14 = new Companion_5();
Companion_instance_15 = new Companion_6();
Companion_instance_16 = new Companion_7();
Companion_instance_23 = new Companion_14();
Companion_instance_24 = new Companion_15();
Companion_instance_25 = new Companion_16();
Companion_instance_31 = new Companion_22();
Companion_instance_32 = new Companion_23();
AGFinish_instance = new AGFinish();
Companion_instance_48 = new Companion_39();
Companion_instance_53 = new Companion_44();
Companion_instance_54 = new Companion_45();
Companion_instance_57 = new Companion_48();
Companion_instance_58 = new Companion_49();
Companion_instance_59 = new Companion_50();
debugBmpFontOrNull = null;
Companion_instance_61 = new Companion_52();
Companion_instance_62 = new Companion_53();
DEFAULT_instance = new DEFAULT();
GLOBAL_CHECK_GL = false;
Companion_instance_69 = new Companion_60();
korgwJvmEngine = null;
Companion_instance_70 = new Companion_61();
Companion_instance_71 = new Companion_62();
AGOpenglFactory_instance = new AGOpenglFactory();
//endregion
//region block: exports
export {
  Size3D as Size3D,
};
export {
  Key_F12_getInstance as Key_F12_getInstance20smmrbslhgku,
  Key_F1_getInstance as Key_F1_getInstance2uvuzswotma1m,
  Key_F2_getInstance as Key_F2_getInstance1jn8oxhxnia83,
  Key_F3_getInstance as Key_F3_getInstance3auitqeii852j,
  Key_F4_getInstance as Key_F4_getInstance295yi03sykfc2,
  Key_F7_getInstance as Key_F7_getInstance1fxfgbmldwoq6,
  Key_L_getInstance as Key_L_getInstancelc2peppmic9p,
  Key_P_getInstance as Key_P_getInstance1l15tff0scujt,
  Key_S_getInstance as Key_S_getInstance3a623w26n65ct,
  Type_DOWN_getInstance as Type_DOWN_getInstance3w3upujzs6x5,
  Type_TYPE_getInstance as Type_TYPE_getInstance3kl3gtiytkq1p,
  Type_UP_getInstance as Type_UP_getInstance2onpl7vaj0n6f,
  MouseButton_LEFT_getInstance as MouseButton_LEFT_getInstance2pxjdxrpl68c5,
  Type_DOWN_getInstance_0 as Type_DOWN_getInstance1zas01g4tazis,
  Type_DRAG_getInstance as Type_DRAG_getInstance1oyczma3u1sfi,
  Type_UP_getInstance_0 as Type_UP_getInstance1azeslmnft6l5,
  Kind_MOUSE_getInstance as Kind_MOUSE_getInstance104tc4m897tyy,
  Status_ADD_getInstance as Status_ADD_getInstance22apyg5ct4px7,
  Status_KEEP_getInstance as Status_KEEP_getInstance3tj4183qdgyi5,
  Status_REMOVE_getInstance as Status_REMOVE_getInstance19drpw6lfvon8,
  Type_END_getInstance_0 as Type_END_getInstance3ekhp9k4xqwsb,
  Type_MOVE_getInstance_0 as Type_MOVE_getInstanceavavmobr5nzz,
  Type_START_getInstance_0 as Type_START_getInstance27oonvh9zpi1o,
  Cursor_DEFAULT_getInstance as Cursor_DEFAULT_getInstancemdqrzfwu4c9e,
  Quality_PERFORMANCE_getInstance as Quality_PERFORMANCE_getInstance2edcjnp9auwx5,
  debugBmpFont as debugBmpFont2i7i2ml66o1iy,
  configureLoggerFromProperties as configureLoggerFromProperties2zy8apzr93pqp,
  Companion_instance_11 as Companion_instance99w5lpdgjzr4,
  Companion_getInstance_26 as Companion_getInstance18y91gyxi2z7,
  Companion_getInstance_32 as Companion_getInstanceok0yphc67vv6,
  Companion_instance_25 as Companion_instancekcgdgz2aik3h,
  Companion_getInstance_25 as Companion_getInstance2ckr5i14ndxro,
  Companion_getInstance_23 as Companion_getInstance1wltq3fgn1avz,
  Companion_getInstance_24 as Companion_getInstancekjblelnta22u,
  Companion_instance_8 as Companion_instance2ovjg7lp6gfg7,
  Companion_instance_16 as Companion_instance12t49ingjwxzt,
  Companion_instance_9 as Companion_instance3i2v9jzzqvdkl,
  Companion_instance_10 as Companion_instancef7estul0zruo,
  Companion_getInstance_28 as Companion_getInstance6ryfwvwg9trm,
  Companion_getInstance_43 as Companion_getInstance23l94gq35u9ye,
  ProjViewUB_getInstance as ProjViewUB_getInstance2c14wyrj73xek,
  Companion_getInstance_66 as Companion_getInstance1ifu77pbb1si2,
  DefaultViewport_getInstance as DefaultViewport_getInstance3ta8638tkh0q1,
  Companion_getInstance_69 as Companion_getInstance1dp345vz250gb,
  SDFShaders_getInstance as SDFShaders_getInstance2aqc6fv2u457r,
  Companion_getInstance_71 as Companion_getInstance2vwksse73neff,
  KorgeReload_getInstance as KorgeReload_getInstance1jsrcs9uzp4z9,
  Companion_instance_59 as Companion_instance7uo85wjiqj61,
  Companion_instance_69 as Companion_instanceyamrbth4pjfq,
  CoroutineKey_getInstance as CoroutineKey_getInstance2jikmq30sknr8,
  BaseEventListener as BaseEventListener6clplq3qhf9k,
  EventResult as EventResult1qajuo9ssrvv5,
  Event as Eventnral6s6c3h27,
  KeyEvent as KeyEvent3kdv2rq8w0dew,
  MouseEvent as MouseEventmt8xebywpdp9,
  ReshapeEvent as ReshapeEvent3137ki3m95agm,
  StopPropagatingException as StopPropagatingException3fryyzw9pc422,
  TouchEvent as TouchEvent37l81isz00qgj,
  AGPrint as AGPrint2do8iynklt71b,
  FragmentShader as FragmentShader2u3ycaqbgbmdi,
  AGScissor as AGScissor1lpa42gfyr1p2,
  AG as AG35f0xk1ko87rh,
  ProgramBuilderDefault as ProgramBuilderDefault3573mhybddt0b,
  drawText as drawText2ld6eqw3mc9xd,
  Input as Input3ljaq07eyi73v,
  get_BB_MAX_TEXTURES as get_BB_MAX_TEXTURES19x2awozztfc7,
  Base as Basef4lqzcfsxjhi,
  BoundsProvider as BoundsProvideri69utw6h2duh,
  RenderContext as RenderContext3l27as458i66g,
  ShrinkableTexturedVertexArray as ShrinkableTexturedVertexArray2dp7296cmttgp,
  get_TEXTURED_ARRAY_QUAD_INDICES as get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz,
  TEXTURED_ARRAY_quadIndices as TEXTURED_ARRAY_quadIndices1vrv67jygypre,
  TextureBase as TextureBase31xvoisoo1pp7,
  TexturedVertexArray as TexturedVertexArrayt1cf0uhgxqi1,
  Texture as Texture2obedkmljq67n,
  Texture_1 as Texture39uvj3jju6ujd,
  get_debugLineRenderContext as get_debugLineRenderContext3s3h9yq8a0rtj,
  ResourcesRoot as ResourcesRoot36ooexy6oq69y,
  Stats as Statslnkcsgem8jjl,
  V2 as V22su20mpwty0v0,
  _interpolateRatio as _interpolateRatio2cj6ldbl0g6ae,
  UpdateEvent as UpdateEvent2wwv3f0im2cby,
  CreateDefaultGameWindow as CreateDefaultGameWindow1l94icsbq4y8h,
  DeviceDimensionsProvider as DeviceDimensionsProvider22igvmdnpe2w1,
  GameWindowCreationConfig as GameWindowCreationConfigbzmga8g39et1,
  GameWindow as GameWindow35197f3hcbh1b,
  configure as configure1a7py4k2lj4vi,
};
//endregion
